// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23636f83%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%232eb85c%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e55353%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e55353%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.75%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.9%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 21, 0.5%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 21, 0.7%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 21, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27%23fff%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.5%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27%238a93a2%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%280, 0, 21, 0.5%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27%23768192%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Oxygen:wght@300;400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * CoreUI - HTML, CSS, and JavaScript UI Components Library
 * @version v3.3.0
 * @link https://coreui.io/
 * Copyright (c) 2020 creativeLabs Łukasz Holeczek
 * License MIT  (https://coreui.io/license/)
 */
:root {
  --primary: #321fdb;
  --secondary: #ced2d8;
  --success: #2eb85c;
  --info: #39f;
  --warning: #f9b115;
  --danger: #e55353;
  --light: #ebedef;
  --dark: #636f83;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --breakpoint-xxl: 1400px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

.c-app {
  --primary: #321fdb;
  --secondary: #ced2d8;
  --success: #2eb85c;
  --info: #39f;
  --warning: #f9b115;
  --danger: #e55353;
  --light: #ebedef;
  --dark: #636f83;
  color: #3c4b64;
  background-color: #ebedef;
  --color: #3c4b64; }

*,
*::before,
*::after {
  box-sizing: border-box; }

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 21, 0); }

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block; }

body {
  margin: 0;
  overflow-x: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  color: #3c4b64;
  background-color: #ebedef; }

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important; }

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible; }

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 700; }

dd {
  margin-bottom: .5rem; }
  html:not([dir="rtl"]) dd {
    margin-left: 0; }
  *[dir="rtl"] dd {
    margin-right: 0; }

blockquote {
  margin: 0 0 1rem; }

b,
strong {
  font-weight: bolder; }

small {
  font-size: 80%; }

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  text-decoration: none;
  background-color: transparent;
  color: #321fdb; }
  @media (hover: hover), (-ms-high-contrast: none) {
    a:hover {
      text-decoration: underline;
      color: #321fdb; } }

a:not([href]) {
  color: inherit;
  text-decoration: none; }
  @media (hover: hover), (-ms-high-contrast: none) {
    a:not([href]):hover {
      color: inherit;
      text-decoration: none; } }

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em; }

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar; }

figure {
  margin: 0 0 1rem; }

img {
  vertical-align: middle;
  border-style: none; }

svg {
  overflow: hidden;
  vertical-align: middle; }

table {
  border-collapse: collapse; }

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #768192;
  text-align: left;
  caption-side: bottom; }

th {
  text-align: inherit; }

label {
  display: inline-block;
  margin-bottom: 0.5rem; }

button {
  border-radius: 0; }

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
input {
  overflow: visible; }

button,
select {
  text-transform: none; }

[role="button"] {
  cursor: pointer; }

select {
  word-wrap: normal; }

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }

button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  cursor: pointer; }

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none; }

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0; }

textarea {
  overflow: auto;
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal; }

progress {
  vertical-align: baseline; }

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto; }

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none; }

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

summary {
  display: list-item;
  cursor: pointer; }

template {
  display: none; }

[hidden] {
  display: none !important; }

.ps {
  overflow: hidden !important;
  touch-action: auto;
  -ms-overflow-style: none;
  overflow-anchor: none; }

.ps__rail-x {
  position: absolute;
  bottom: 0;
  display: none;
  height: 15px;
  opacity: 0;
  transition: background-color .2s linear, opacity .2s linear; }

.ps__rail-y {
  position: absolute;
  display: none;
  width: 15px;
  opacity: 0;
  transition: background-color .2s linear, opacity .2s linear; }
  html:not([dir="rtl"]) .ps__rail-y {
    right: 0; }
  *[dir="rtl"] .ps__rail-y {
    left: 0; }

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent; }

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: .6; }

.ps__rail-x:hover,
.ps__rail-y:hover,
.ps__rail-x:focus,
.ps__rail-y:focus {
  background-color: #eee;
  opacity: .9; }

/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  position: absolute;
  bottom: 2px;
  height: 6px;
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color .2s linear, height .2s ease-in-out; }

.ps__thumb-y {
  position: absolute;
  width: 6px;
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color .2s linear, width .2s ease-in-out; }
  html:not([dir="rtl"]) .ps__thumb-y {
    right: 2px; }
  *[dir="rtl"] .ps__thumb-y {
    left: 2px; }

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x {
  height: 11px;
  background-color: #999; }

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y {
  width: 11px;
  background-color: #999; }

@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important; } }

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important; } }

.tippy-box[data-animation='fade'][data-state='hidden'] {
  opacity: 0; }

.tippy-box[data-theme~='cpopover'] {
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.76562rem;
  word-wrap: break-word;
  background-clip: padding-box;
  border: 1px solid;
  border-radius: 0.3rem;
  background-color: #fff;
  border-color: rgba(0, 0, 21, 0.2); }
  .tippy-box[data-theme~='cpopover'] > .tippy-content {
    max-width: auto;
    padding: 0;
    color: #000;
    color: initial;
    text-align: left;
    text-align: initial;
    background-color: transparent;
    background-color: initial;
    border-radius: 0;
    border-radius: initial; }
  .tippy-box[data-theme~='cpopover'] > .tippy-arrow {
    position: absolute;
    display: block;
    color: transparent; }
    .tippy-box[data-theme~='cpopover'] > .tippy-arrow::before, .tippy-box[data-theme~='cpopover'] > .tippy-arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid; }
  .tippy-box[data-theme~='cpopover'][data-placement^='top'] > .tippy-arrow, .tippy-box[data-theme~='cpopover'][data-placement^='bottom'] > .tippy-arrow {
    width: 1.6rem;
    height: 0.5rem;
    padding: 0 0.3rem; }
    .tippy-box[data-theme~='cpopover'][data-placement^='top'] > .tippy-arrow::before, .tippy-box[data-theme~='cpopover'][data-placement^='bottom'] > .tippy-arrow::before {
      left: auto; }
  .tippy-box[data-theme~='cpopover'][data-placement^='right'] > .tippy-arrow, .tippy-box[data-theme~='cpopover'][data-placement^='left'] > .tippy-arrow {
    width: 0.5rem;
    height: 1.6rem;
    padding: 0.3rem 0;
    margin: 0; }
  .tippy-box[data-theme~='cpopover'][data-placement^='top'] > .tippy-arrow {
    bottom: calc(-0.5rem - 1px); }
    .tippy-box[data-theme~='cpopover'][data-placement^='top'] > .tippy-arrow::before {
      bottom: 0;
      border-width: 0.5rem 0.5rem 0;
      border-top-color: rgba(0, 0, 21, 0.25); }
    .tippy-box[data-theme~='cpopover'][data-placement^='top'] > .tippy-arrow::after {
      bottom: 1px;
      border-width: 0.5rem 0.5rem 0;
      border-top-color: #fff; }
  .tippy-box[data-theme~='cpopover'][data-placement^='bottom'] > .tippy-arrow {
    top: calc(-0.5rem - 1px); }
    .tippy-box[data-theme~='cpopover'][data-placement^='bottom'] > .tippy-arrow::before {
      top: 0;
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: rgba(0, 0, 21, 0.25); }
    .tippy-box[data-theme~='cpopover'][data-placement^='bottom'] > .tippy-arrow::after {
      top: 1px;
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: #fff; }
  .tippy-box[data-theme~='cpopover'][data-placement^='left'] > .tippy-arrow {
    right: calc(-0.5rem - 1px); }
    .tippy-box[data-theme~='cpopover'][data-placement^='left'] > .tippy-arrow::before {
      right: 0;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: rgba(0, 0, 21, 0.25); }
    .tippy-box[data-theme~='cpopover'][data-placement^='left'] > .tippy-arrow::after {
      right: 1px;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: #fff; }
  .tippy-box[data-theme~='cpopover'][data-placement^='right'] > .tippy-arrow {
    left: calc(-0.5rem - 1px); }
    .tippy-box[data-theme~='cpopover'][data-placement^='right'] > .tippy-arrow::before {
      left: 0;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: rgba(0, 0, 21, 0.25); }
    .tippy-box[data-theme~='cpopover'][data-placement^='right'] > .tippy-arrow::after {
      left: 1px;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: #fff; }

.tippy-iOS {
  cursor: pointer !important;
  -webkit-tap-highlight-color: transparent; }

[data-tippy-root] {
  max-width: calc(100vw - 10px); }

.tippy-box {
  position: relative;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.76562rem;
  word-wrap: break-word;
  outline: 0;
  transition-property: transform, visibility, opacity; }
  .tippy-box[data-placement^='top'] > .tippy-arrow {
    bottom: 0; }
    .tippy-box[data-placement^='top'] > .tippy-arrow::before {
      bottom: -0.4rem;
      left: 0;
      border-width: 0.4rem 0.4rem 0;
      border-top-color: currentColor;
      border-top-color: initial; }
  .tippy-box[data-placement^='bottom'] > .tippy-arrow {
    top: 0; }
    .tippy-box[data-placement^='bottom'] > .tippy-arrow::before {
      top: -0.4rem;
      left: 0;
      border-width: 0 0.4rem 0.4rem;
      border-bottom-color: currentColor;
      border-bottom-color: initial; }
  .tippy-box[data-placement^='left'] > .tippy-arrow {
    right: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .tippy-box[data-placement^='left'] > .tippy-arrow::before {
      right: -0.4rem;
      border-width: 0.4rem 0 0.4rem 0.4rem;
      border-left-color: currentColor;
      border-left-color: initial; }
  .tippy-box[data-placement^='right'] > .tippy-arrow {
    left: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .tippy-box[data-placement^='right'] > .tippy-arrow::before {
      left: -0.4rem;
      border-width: 0.4rem 0.4rem 0.4rem 0;
      border-right-color: currentColor;
      border-right-color: initial; }
  .tippy-box[data-inertia][data-state='visible'] {
    transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11); }

.tippy-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
  color: #000015; }
  .tippy-arrow::before {
    position: absolute;
    display: block;
    content: "";
    border-color: transparent;
    border-style: solid; }

.tippy-content {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000015;
  border-radius: 0.25rem; }

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem; }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 700; }

html:not([dir="rtl"]) .alert-dismissible {
  padding-right: 3.8125rem; }

*[dir="rtl"] .alert-dismissible {
  padding-left: 3.8125rem; }

.alert-dismissible .close {
  position: absolute;
  top: 0;
  padding: 0.75rem 1.25rem;
  color: inherit; }
  html:not([dir="rtl"]) .alert-dismissible .close {
    right: 0; }
  *[dir="rtl"] .alert-dismissible .close {
    left: 0; }

.alert-primary {
  color: #1a107c;
  background-color: #d6d2f8;
  border-color: #c6c0f5; }
  .alert-primary hr {
    border-top-color: #b2aaf2; }
  .alert-primary .alert-link {
    color: #110a4f; }

.alert-secondary {
  color: #6b6d7a;
  background-color: #f5f6f7;
  border-color: #f1f2f4; }
  .alert-secondary hr {
    border-top-color: #e3e5e9; }
  .alert-secondary .alert-link {
    color: #53555f; }

.alert-success {
  color: #18603a;
  background-color: #d5f1de;
  border-color: #c4ebd1; }
  .alert-success hr {
    border-top-color: #b1e5c2; }
  .alert-success .alert-link {
    color: #0e3721; }

.alert-info {
  color: #1b508f;
  background-color: #d6ebff;
  border-color: #c6e2ff; }
  .alert-info hr {
    border-top-color: #add5ff; }
  .alert-info .alert-link {
    color: #133864; }

.alert-warning {
  color: #815c15;
  background-color: #feefd0;
  border-color: #fde9bd; }
  .alert-warning hr {
    border-top-color: #fce1a4; }
  .alert-warning .alert-link {
    color: #553d0e; }

.alert-danger {
  color: #772b35;
  background-color: #fadddd;
  border-color: #f8cfcf; }
  .alert-danger hr {
    border-top-color: #f5b9b9; }
  .alert-danger .alert-link {
    color: #521d24; }

.alert-light {
  color: #7a7b86;
  background-color: #fbfbfc;
  border-color: #f9fafb; }
  .alert-light hr {
    border-top-color: #eaedf1; }
  .alert-light .alert-link {
    color: #62626b; }

.alert-dark {
  color: #333a4e;
  background-color: #e0e2e6;
  border-color: #d3d7dc; }
  .alert-dark hr {
    border-top-color: #c5cad1; }
  .alert-dark .alert-link {
    color: #1f232f; }

.c-avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50em;
  width: 36px;
  height: 36px;
  font-size: 14.4px; }
  .c-avatar .c-avatar-status {
    width: 10px;
    height: 10px; }

.c-avatar-img {
  width: 100%;
  height: auto;
  border-radius: 50em; }

.c-avatar-status {
  position: absolute;
  bottom: 0;
  display: block;
  border: 1px solid #fff;
  border-radius: 50em; }
  html:not([dir="rtl"]) .c-avatar-status {
    right: 0; }
  *[dir="rtl"] .c-avatar-status {
    left: 0; }

.c-avatar-sm {
  width: 24px;
  height: 24px;
  font-size: 9.6px; }
  .c-avatar-sm .c-avatar-status {
    width: 8px;
    height: 8px; }

.c-avatar-lg {
  width: 48px;
  height: 48px;
  font-size: 19.2px; }
  .c-avatar-lg .c-avatar-status {
    width: 12px;
    height: 12px; }

.c-avatar-xl {
  width: 64px;
  height: 64px;
  font-size: 25.6px; }
  .c-avatar-xl .c-avatar-status {
    width: 14px;
    height: 14px; }

.c-avatars-stack {
  display: flex; }
  .c-avatars-stack .c-avatar {
    margin-right: -18px;
    transition: margin-right 0.3s; }
    .c-avatars-stack .c-avatar:hover {
      margin-right: 0; }
  .c-avatars-stack .c-avatar-sm {
    margin-right: -12px; }
  .c-avatars-stack .c-avatar-lg {
    margin-right: -24px; }
  .c-avatars-stack .c-avatar-xl {
    margin-right: -32px; }

.c-avatar-rounded {
  border-radius: 0.25rem; }

.c-avatar-square {
  border-radius: 0; }

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .badge {
      transition: none; } }
  a.badge:hover, a.badge:focus {
    text-decoration: none; }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem; }

.badge-primary {
  color: #fff;
  background-color: #321fdb; }
  a.badge-primary:hover, a.badge-primary:focus {
    color: #fff;
    background-color: #2819ae; }
  a.badge-primary:focus, a.badge-primary.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.5); }

.badge-secondary {
  color: #4f5d73;
  background-color: #ced2d8; }
  a.badge-secondary:hover, a.badge-secondary:focus {
    color: #4f5d73;
    background-color: #b2b8c1; }
  a.badge-secondary:focus, a.badge-secondary.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(206, 210, 216, 0.5); }

.badge-success {
  color: #fff;
  background-color: #2eb85c; }
  a.badge-success:hover, a.badge-success:focus {
    color: #fff;
    background-color: #248f48; }
  a.badge-success:focus, a.badge-success.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.5); }

.badge-info {
  color: #fff;
  background-color: #39f; }
  a.badge-info:hover, a.badge-info:focus {
    color: #fff;
    background-color: #0080ff; }
  a.badge-info:focus, a.badge-info.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(51, 153, 255, 0.5); }

.badge-warning {
  color: #4f5d73;
  background-color: #f9b115; }
  a.badge-warning:hover, a.badge-warning:focus {
    color: #4f5d73;
    background-color: #d69405; }
  a.badge-warning:focus, a.badge-warning.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(249, 177, 21, 0.5); }

.badge-danger {
  color: #fff;
  background-color: #e55353; }
  a.badge-danger:hover, a.badge-danger:focus {
    color: #fff;
    background-color: #de2727; }
  a.badge-danger:focus, a.badge-danger.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.5); }

.badge-light {
  color: #4f5d73;
  background-color: #ebedef; }
  a.badge-light:hover, a.badge-light:focus {
    color: #4f5d73;
    background-color: #cfd4d8; }
  a.badge-light:focus, a.badge-light.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(235, 237, 239, 0.5); }

.badge-dark {
  color: #fff;
  background-color: #636f83; }
  a.badge-dark:hover, a.badge-dark:focus {
    color: #fff;
    background-color: #4d5666; }
  a.badge-dark:focus, a.badge-dark.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(99, 111, 131, 0.5); }

html:not([dir="rtl"]) .breadcrumb-menu {
  margin-left: auto; }

html:not([dir="rtl"]) .breadcrumb-menu {
  margin-right: auto; }

.breadcrumb-menu::before {
  display: none; }

.breadcrumb-menu .btn-group {
  vertical-align: top; }

.breadcrumb-menu .btn {
  padding: 0 0.75rem;
  vertical-align: top;
  border: 0;
  color: #768192; }
  .breadcrumb-menu .btn:hover, .breadcrumb-menu .btn.active {
    color: #3c4b64;
    background: transparent; }

.breadcrumb-menu .show .btn {
  color: #3c4b64;
  background: transparent; }

.breadcrumb-menu .dropdown-menu {
  min-width: 180px;
  line-height: 1.5; }

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  list-style: none;
  border-radius: 0;
  border-bottom: 1px solid;
  background-color: transparent;
  border-color: #d8dbe0; }

.breadcrumb-item {
  display: flex; }
  html:not([dir="rtl"]) .breadcrumb-item + .breadcrumb-item {
    padding-left: 0.5rem; }
  *[dir="rtl"] .breadcrumb-item + .breadcrumb-item {
    padding-right: 0.5rem; }
  .breadcrumb-item + .breadcrumb-item::before {
    display: inline-block;
    color: #8a93a2;
    content: "/"; }
    html:not([dir="rtl"]) .breadcrumb-item + .breadcrumb-item::before {
      padding-right: 0.5rem; }
    *[dir="rtl"] .breadcrumb-item + .breadcrumb-item::before {
      padding-left: 0.5rem; }
  .breadcrumb-item + .breadcrumb-item:hover::before {
    text-decoration: underline; }
  .breadcrumb-item + .breadcrumb-item:hover::before {
    text-decoration: none; }
  .breadcrumb-item.active {
    color: #8a93a2; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 1 1 auto; }
    @media (hover: hover), (-ms-high-contrast: none) {
      .btn-group > .btn:hover,
      .btn-group-vertical > .btn:hover {
        z-index: 1; } }
    .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
    .btn-group-vertical > .btn:focus,
    .btn-group-vertical > .btn:active,
    .btn-group-vertical > .btn.active {
      z-index: 1; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

html:not([dir="rtl"]) .btn-group > .btn:not(:first-child), html:not([dir="rtl"])
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px; }

*[dir="rtl"] .btn-group > .btn:not(:first-child), *[dir="rtl"]
.btn-group > .btn-group:not(:first-child) {
  margin-right: -1px; }

html:not([dir="rtl"]) .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
html:not([dir="rtl"]) .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

html:not([dir="rtl"]) .btn-group > .btn:not(:first-child),
html:not([dir="rtl"]) .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

*[dir="rtl"] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
*[dir="rtl"] .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

*[dir="rtl"] .btn-group > .btn:not(:first-child),
*[dir="rtl"] .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  html:not([dir="rtl"]) .dropdown-toggle-split::after, html:not([dir="rtl"])
  .dropup .dropdown-toggle-split::after, html:not([dir="rtl"])
  .dropright .dropdown-toggle-split::after {
    margin-left: 0; }
  *[dir="rtl"] .dropdown-toggle-split::after, *[dir="rtl"]
  .dropup .dropdown-toggle-split::after, *[dir="rtl"]
  .dropright .dropdown-toggle-split::after {
    margin-right: 0; }
  html:not([dir="rtl"]) .dropleft .dropdown-toggle-split::before {
    margin-right: 0; }
  *[dir="rtl"] .dropleft .dropdown-toggle-split::before {
    margin-left: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical > .btn,
  .btn-group-vertical > .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) {
    margin-top: -1px; }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0; }
  .btn-group-toggle > .btn input[type="radio"],
  .btn-group-toggle > .btn input[type="checkbox"],
  .btn-group-toggle > .btn-group > .btn input[type="radio"],
  .btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none; }

.btn {
  display: inline-block;
  font-weight: 400;
  color: #3c4b64;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  .btn i,
  .btn .c-icon {
    width: 0.875rem;
    height: 0.875rem;
    margin: 0.21875rem 0; }
  @media (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn:hover {
      color: #3c4b64;
      text-decoration: none; } }
  .btn:focus, .btn.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25); }
  .btn.disabled, .btn:disabled {
    opacity: 0.65; }
  .btn:not(:disabled):not(.disabled) {
    cursor: pointer; }
  .btn i,
  .btn .c-icon {
    height: 0.875rem;
    margin: 0.21875rem 0; }

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none; }

.btn-primary {
  color: #fff;
  background-color: #321fdb;
  border-color: #321fdb; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-primary:hover {
      color: #fff;
      background-color: #2a1ab9;
      border-color: #2819ae; } }
  .btn-primary:focus, .btn-primary.focus {
    color: #fff;
    background-color: #2a1ab9;
    border-color: #2819ae;
    box-shadow: 0 0 0 0.2rem rgba(81, 65, 224, 0.5); }
  .btn-primary.disabled, .btn-primary:disabled {
    color: #fff;
    background-color: #321fdb;
    border-color: #321fdb; }
  .btn-primary:not(:disabled):not(.disabled):active,
  .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #2819ae;
    border-color: #2517a3; }
    .btn-primary:not(:disabled):not(.disabled):active:focus,
    .show > .btn-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(81, 65, 224, 0.5); }
  .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #2819ae;
    border-color: #2517a3; }
    .show > .btn-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(81, 65, 224, 0.5); }

.btn-secondary {
  color: #4f5d73;
  background-color: #ced2d8;
  border-color: #ced2d8; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-secondary:hover {
      color: #4f5d73;
      background-color: #b9bec7;
      border-color: #b2b8c1; } }
  .btn-secondary:focus, .btn-secondary.focus {
    color: #4f5d73;
    background-color: #b9bec7;
    border-color: #b2b8c1;
    box-shadow: 0 0 0 0.2rem rgba(187, 192, 201, 0.5); }
  .btn-secondary.disabled, .btn-secondary:disabled {
    color: #4f5d73;
    background-color: #ced2d8;
    border-color: #ced2d8; }
  .btn-secondary:not(:disabled):not(.disabled):active,
  .show > .btn-secondary.dropdown-toggle {
    color: #4f5d73;
    background-color: #b2b8c1;
    border-color: #abb1bc; }
    .btn-secondary:not(:disabled):not(.disabled):active:focus,
    .show > .btn-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(187, 192, 201, 0.5); }
  .show > .btn-secondary.dropdown-toggle {
    color: #4f5d73;
    background-color: #b2b8c1;
    border-color: #abb1bc; }
    .show > .btn-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(187, 192, 201, 0.5); }

.btn-success {
  color: #fff;
  background-color: #2eb85c;
  border-color: #2eb85c; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-success:hover {
      color: #fff;
      background-color: #26994d;
      border-color: #248f48; } }
  .btn-success:focus, .btn-success.focus {
    color: #fff;
    background-color: #26994d;
    border-color: #248f48;
    box-shadow: 0 0 0 0.2rem rgba(77, 195, 116, 0.5); }
  .btn-success.disabled, .btn-success:disabled {
    color: #fff;
    background-color: #2eb85c;
    border-color: #2eb85c; }
  .btn-success:not(:disabled):not(.disabled):active,
  .show > .btn-success.dropdown-toggle {
    color: #fff;
    background-color: #248f48;
    border-color: #218543; }
    .btn-success:not(:disabled):not(.disabled):active:focus,
    .show > .btn-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(77, 195, 116, 0.5); }
  .show > .btn-success.dropdown-toggle {
    color: #fff;
    background-color: #248f48;
    border-color: #218543; }
    .show > .btn-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(77, 195, 116, 0.5); }

.btn-info {
  color: #fff;
  background-color: #39f;
  border-color: #39f; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-info:hover {
      color: #fff;
      background-color: #0d86ff;
      border-color: #0080ff; } }
  .btn-info:focus, .btn-info.focus {
    color: #fff;
    background-color: #0d86ff;
    border-color: #0080ff;
    box-shadow: 0 0 0 0.2rem rgba(82, 168, 255, 0.5); }
  .btn-info.disabled, .btn-info:disabled {
    color: #fff;
    background-color: #39f;
    border-color: #39f; }
  .btn-info:not(:disabled):not(.disabled):active,
  .show > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #0080ff;
    border-color: #0079f2; }
    .btn-info:not(:disabled):not(.disabled):active:focus,
    .show > .btn-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(82, 168, 255, 0.5); }
  .show > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #0080ff;
    border-color: #0079f2; }
    .show > .btn-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(82, 168, 255, 0.5); }

.btn-warning {
  color: #4f5d73;
  background-color: #f9b115;
  border-color: #f9b115; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-warning:hover {
      color: #4f5d73;
      background-color: #e29c06;
      border-color: #d69405; } }
  .btn-warning:focus, .btn-warning.focus {
    color: #4f5d73;
    background-color: #e29c06;
    border-color: #d69405;
    box-shadow: 0 0 0 0.2rem rgba(224, 164, 35, 0.5); }
  .btn-warning.disabled, .btn-warning:disabled {
    color: #4f5d73;
    background-color: #f9b115;
    border-color: #f9b115; }
  .btn-warning:not(:disabled):not(.disabled):active,
  .show > .btn-warning.dropdown-toggle {
    color: #4f5d73;
    background-color: #d69405;
    border-color: #c98b05; }
    .btn-warning:not(:disabled):not(.disabled):active:focus,
    .show > .btn-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(224, 164, 35, 0.5); }
  .show > .btn-warning.dropdown-toggle {
    color: #4f5d73;
    background-color: #d69405;
    border-color: #c98b05; }
    .show > .btn-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(224, 164, 35, 0.5); }

.btn-danger {
  color: #fff;
  background-color: #e55353;
  border-color: #e55353; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-danger:hover {
      color: #fff;
      background-color: #e03232;
      border-color: #de2727; } }
  .btn-danger:focus, .btn-danger.focus {
    color: #fff;
    background-color: #e03232;
    border-color: #de2727;
    box-shadow: 0 0 0 0.2rem rgba(233, 109, 109, 0.5); }
  .btn-danger.disabled, .btn-danger:disabled {
    color: #fff;
    background-color: #e55353;
    border-color: #e55353; }
  .btn-danger:not(:disabled):not(.disabled):active,
  .show > .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #de2727;
    border-color: #d82121; }
    .btn-danger:not(:disabled):not(.disabled):active:focus,
    .show > .btn-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(233, 109, 109, 0.5); }
  .show > .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #de2727;
    border-color: #d82121; }
    .show > .btn-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(233, 109, 109, 0.5); }

.btn-light {
  color: #4f5d73;
  background-color: #ebedef;
  border-color: #ebedef; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-light:hover {
      color: #4f5d73;
      background-color: #d6dade;
      border-color: #cfd4d8; } }
  .btn-light:focus, .btn-light.focus {
    color: #4f5d73;
    background-color: #d6dade;
    border-color: #cfd4d8;
    box-shadow: 0 0 0 0.2rem rgba(212, 215, 220, 0.5); }
  .btn-light.disabled, .btn-light:disabled {
    color: #4f5d73;
    background-color: #ebedef;
    border-color: #ebedef; }
  .btn-light:not(:disabled):not(.disabled):active,
  .show > .btn-light.dropdown-toggle {
    color: #4f5d73;
    background-color: #cfd4d8;
    border-color: #c8cdd3; }
    .btn-light:not(:disabled):not(.disabled):active:focus,
    .show > .btn-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(212, 215, 220, 0.5); }
  .show > .btn-light.dropdown-toggle {
    color: #4f5d73;
    background-color: #cfd4d8;
    border-color: #c8cdd3; }
    .show > .btn-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(212, 215, 220, 0.5); }

.btn-dark {
  color: #fff;
  background-color: #636f83;
  border-color: #636f83; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-dark:hover {
      color: #fff;
      background-color: #535d6d;
      border-color: #4d5666; } }
  .btn-dark:focus, .btn-dark.focus {
    color: #fff;
    background-color: #535d6d;
    border-color: #4d5666;
    box-shadow: 0 0 0 0.2rem rgba(122, 133, 150, 0.5); }
  .btn-dark.disabled, .btn-dark:disabled {
    color: #fff;
    background-color: #636f83;
    border-color: #636f83; }
  .btn-dark:not(:disabled):not(.disabled):active,
  .show > .btn-dark.dropdown-toggle {
    color: #fff;
    background-color: #4d5666;
    border-color: #48505f; }
    .btn-dark:not(:disabled):not(.disabled):active:focus,
    .show > .btn-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(122, 133, 150, 0.5); }
  .show > .btn-dark.dropdown-toggle {
    color: #fff;
    background-color: #4d5666;
    border-color: #48505f; }
    .show > .btn-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(122, 133, 150, 0.5); }

.btn-transparent {
  color: rgba(255, 255, 255, 0.8); }
  .btn-transparent:hover {
    color: white; }

.btn-outline-primary {
  color: #321fdb;
  border-color: #321fdb; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-outline-primary:hover {
      color: #fff;
      background-color: #321fdb;
      border-color: #321fdb; } }
  .btn-outline-primary:focus, .btn-outline-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.5); }
  .btn-outline-primary.disabled, .btn-outline-primary:disabled {
    color: #321fdb;
    background-color: transparent; }
  .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #321fdb;
    border-color: #321fdb; }
    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.5); }
  .show > .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #321fdb;
    border-color: #321fdb; }
    .show > .btn-outline-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.5); }

.btn-outline-secondary {
  color: #ced2d8;
  border-color: #ced2d8; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-outline-secondary:hover {
      color: #4f5d73;
      background-color: #ced2d8;
      border-color: #ced2d8; } }
  .btn-outline-secondary:focus, .btn-outline-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(206, 210, 216, 0.5); }
  .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
    color: #ced2d8;
    background-color: transparent; }
  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active {
    color: #4f5d73;
    background-color: #ced2d8;
    border-color: #ced2d8; }
    .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(206, 210, 216, 0.5); }
  .show > .btn-outline-secondary.dropdown-toggle {
    color: #4f5d73;
    background-color: #ced2d8;
    border-color: #ced2d8; }
    .show > .btn-outline-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(206, 210, 216, 0.5); }

.btn-outline-success {
  color: #2eb85c;
  border-color: #2eb85c; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-outline-success:hover {
      color: #fff;
      background-color: #2eb85c;
      border-color: #2eb85c; } }
  .btn-outline-success:focus, .btn-outline-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.5); }
  .btn-outline-success.disabled, .btn-outline-success:disabled {
    color: #2eb85c;
    background-color: transparent; }
  .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #2eb85c;
    border-color: #2eb85c; }
    .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.5); }
  .show > .btn-outline-success.dropdown-toggle {
    color: #fff;
    background-color: #2eb85c;
    border-color: #2eb85c; }
    .show > .btn-outline-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.5); }

.btn-outline-info {
  color: #39f;
  border-color: #39f; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-outline-info:hover {
      color: #fff;
      background-color: #39f;
      border-color: #39f; } }
  .btn-outline-info:focus, .btn-outline-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(51, 153, 255, 0.5); }
  .btn-outline-info.disabled, .btn-outline-info:disabled {
    color: #39f;
    background-color: transparent; }
  .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #39f;
    border-color: #39f; }
    .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(51, 153, 255, 0.5); }
  .show > .btn-outline-info.dropdown-toggle {
    color: #fff;
    background-color: #39f;
    border-color: #39f; }
    .show > .btn-outline-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(51, 153, 255, 0.5); }

.btn-outline-warning {
  color: #f9b115;
  border-color: #f9b115; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-outline-warning:hover {
      color: #4f5d73;
      background-color: #f9b115;
      border-color: #f9b115; } }
  .btn-outline-warning:focus, .btn-outline-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(249, 177, 21, 0.5); }
  .btn-outline-warning.disabled, .btn-outline-warning:disabled {
    color: #f9b115;
    background-color: transparent; }
  .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active {
    color: #4f5d73;
    background-color: #f9b115;
    border-color: #f9b115; }
    .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(249, 177, 21, 0.5); }
  .show > .btn-outline-warning.dropdown-toggle {
    color: #4f5d73;
    background-color: #f9b115;
    border-color: #f9b115; }
    .show > .btn-outline-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(249, 177, 21, 0.5); }

.btn-outline-danger {
  color: #e55353;
  border-color: #e55353; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-outline-danger:hover {
      color: #fff;
      background-color: #e55353;
      border-color: #e55353; } }
  .btn-outline-danger:focus, .btn-outline-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.5); }
  .btn-outline-danger.disabled, .btn-outline-danger:disabled {
    color: #e55353;
    background-color: transparent; }
  .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #e55353;
    border-color: #e55353; }
    .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.5); }
  .show > .btn-outline-danger.dropdown-toggle {
    color: #fff;
    background-color: #e55353;
    border-color: #e55353; }
    .show > .btn-outline-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.5); }

.btn-outline-light {
  color: #ebedef;
  border-color: #ebedef; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-outline-light:hover {
      color: #4f5d73;
      background-color: #ebedef;
      border-color: #ebedef; } }
  .btn-outline-light:focus, .btn-outline-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(235, 237, 239, 0.5); }
  .btn-outline-light.disabled, .btn-outline-light:disabled {
    color: #ebedef;
    background-color: transparent; }
  .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active {
    color: #4f5d73;
    background-color: #ebedef;
    border-color: #ebedef; }
    .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(235, 237, 239, 0.5); }
  .show > .btn-outline-light.dropdown-toggle {
    color: #4f5d73;
    background-color: #ebedef;
    border-color: #ebedef; }
    .show > .btn-outline-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(235, 237, 239, 0.5); }

.btn-outline-dark {
  color: #636f83;
  border-color: #636f83; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-outline-dark:hover {
      color: #fff;
      background-color: #636f83;
      border-color: #636f83; } }
  .btn-outline-dark:focus, .btn-outline-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(99, 111, 131, 0.5); }
  .btn-outline-dark.disabled, .btn-outline-dark:disabled {
    color: #636f83;
    background-color: transparent; }
  .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #636f83;
    border-color: #636f83; }
    .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(99, 111, 131, 0.5); }
  .show > .btn-outline-dark.dropdown-toggle {
    color: #fff;
    background-color: #636f83;
    border-color: #636f83; }
    .show > .btn-outline-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(99, 111, 131, 0.5); }

.btn-link {
  font-weight: 400;
  color: #321fdb;
  text-decoration: none; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-link:hover {
      color: #231698;
      text-decoration: underline; } }
  .btn-link:focus, .btn-link.focus {
    text-decoration: underline; }
  .btn-link:disabled, .btn-link.disabled {
    color: #8a93a2;
    pointer-events: none; }

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  line-height: 1.5;
  border-radius: 0.3rem; }
  .btn-lg i, .btn-group-lg > .btn i,
  .btn-lg .c-icon,
  .btn-group-lg > .btn .c-icon {
    width: 1.09375rem;
    height: 1.09375rem;
    margin: 0.27344rem 0; }

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.76562rem;
  line-height: 1.5;
  border-radius: 0.2rem; }
  .btn-sm i, .btn-group-sm > .btn i,
  .btn-sm .c-icon,
  .btn-group-sm > .btn .c-icon {
    width: 0.76562rem;
    height: 0.76562rem;
    margin: 0.19141rem 0; }

.btn-block {
  display: block;
  width: 100%; }
  .btn-block + .btn-block {
    margin-top: 0.5rem; }

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%; }

.btn-pill {
  border-radius: 50em; }

.btn-square {
  border-radius: 0; }

.btn-ghost-primary {
  color: #321fdb;
  background-color: transparent;
  background-image: none;
  border-color: transparent; }
  .btn-ghost-primary:hover {
    color: #fff;
    background-color: #321fdb;
    border-color: #321fdb; }
  .btn-ghost-primary:focus, .btn-ghost-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.5); }
  .btn-ghost-primary.disabled, .btn-ghost-primary:disabled {
    color: #321fdb;
    background-color: transparent;
    border-color: transparent; }
  .btn-ghost-primary:not(:disabled):not(.disabled):active, .btn-ghost-primary:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #321fdb;
    border-color: #321fdb; }
    .btn-ghost-primary:not(:disabled):not(.disabled):active:focus, .btn-ghost-primary:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.5); }
  .show > .btn-ghost-primary.dropdown-toggle {
    color: #fff;
    background-color: #321fdb;
    border-color: #321fdb; }
    .show > .btn-ghost-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.5); }

.btn-ghost-secondary {
  color: #ced2d8;
  background-color: transparent;
  background-image: none;
  border-color: transparent; }
  .btn-ghost-secondary:hover {
    color: #4f5d73;
    background-color: #ced2d8;
    border-color: #ced2d8; }
  .btn-ghost-secondary:focus, .btn-ghost-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(206, 210, 216, 0.5); }
  .btn-ghost-secondary.disabled, .btn-ghost-secondary:disabled {
    color: #ced2d8;
    background-color: transparent;
    border-color: transparent; }
  .btn-ghost-secondary:not(:disabled):not(.disabled):active, .btn-ghost-secondary:not(:disabled):not(.disabled).active {
    color: #4f5d73;
    background-color: #ced2d8;
    border-color: #ced2d8; }
    .btn-ghost-secondary:not(:disabled):not(.disabled):active:focus, .btn-ghost-secondary:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(206, 210, 216, 0.5); }
  .show > .btn-ghost-secondary.dropdown-toggle {
    color: #4f5d73;
    background-color: #ced2d8;
    border-color: #ced2d8; }
    .show > .btn-ghost-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(206, 210, 216, 0.5); }

.btn-ghost-success {
  color: #2eb85c;
  background-color: transparent;
  background-image: none;
  border-color: transparent; }
  .btn-ghost-success:hover {
    color: #fff;
    background-color: #2eb85c;
    border-color: #2eb85c; }
  .btn-ghost-success:focus, .btn-ghost-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.5); }
  .btn-ghost-success.disabled, .btn-ghost-success:disabled {
    color: #2eb85c;
    background-color: transparent;
    border-color: transparent; }
  .btn-ghost-success:not(:disabled):not(.disabled):active, .btn-ghost-success:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #2eb85c;
    border-color: #2eb85c; }
    .btn-ghost-success:not(:disabled):not(.disabled):active:focus, .btn-ghost-success:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.5); }
  .show > .btn-ghost-success.dropdown-toggle {
    color: #fff;
    background-color: #2eb85c;
    border-color: #2eb85c; }
    .show > .btn-ghost-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.5); }

.btn-ghost-info {
  color: #39f;
  background-color: transparent;
  background-image: none;
  border-color: transparent; }
  .btn-ghost-info:hover {
    color: #fff;
    background-color: #39f;
    border-color: #39f; }
  .btn-ghost-info:focus, .btn-ghost-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(51, 153, 255, 0.5); }
  .btn-ghost-info.disabled, .btn-ghost-info:disabled {
    color: #39f;
    background-color: transparent;
    border-color: transparent; }
  .btn-ghost-info:not(:disabled):not(.disabled):active, .btn-ghost-info:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #39f;
    border-color: #39f; }
    .btn-ghost-info:not(:disabled):not(.disabled):active:focus, .btn-ghost-info:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(51, 153, 255, 0.5); }
  .show > .btn-ghost-info.dropdown-toggle {
    color: #fff;
    background-color: #39f;
    border-color: #39f; }
    .show > .btn-ghost-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(51, 153, 255, 0.5); }

.btn-ghost-warning {
  color: #f9b115;
  background-color: transparent;
  background-image: none;
  border-color: transparent; }
  .btn-ghost-warning:hover {
    color: #4f5d73;
    background-color: #f9b115;
    border-color: #f9b115; }
  .btn-ghost-warning:focus, .btn-ghost-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(249, 177, 21, 0.5); }
  .btn-ghost-warning.disabled, .btn-ghost-warning:disabled {
    color: #f9b115;
    background-color: transparent;
    border-color: transparent; }
  .btn-ghost-warning:not(:disabled):not(.disabled):active, .btn-ghost-warning:not(:disabled):not(.disabled).active {
    color: #4f5d73;
    background-color: #f9b115;
    border-color: #f9b115; }
    .btn-ghost-warning:not(:disabled):not(.disabled):active:focus, .btn-ghost-warning:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(249, 177, 21, 0.5); }
  .show > .btn-ghost-warning.dropdown-toggle {
    color: #4f5d73;
    background-color: #f9b115;
    border-color: #f9b115; }
    .show > .btn-ghost-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(249, 177, 21, 0.5); }

.btn-ghost-danger {
  color: #e55353;
  background-color: transparent;
  background-image: none;
  border-color: transparent; }
  .btn-ghost-danger:hover {
    color: #fff;
    background-color: #e55353;
    border-color: #e55353; }
  .btn-ghost-danger:focus, .btn-ghost-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.5); }
  .btn-ghost-danger.disabled, .btn-ghost-danger:disabled {
    color: #e55353;
    background-color: transparent;
    border-color: transparent; }
  .btn-ghost-danger:not(:disabled):not(.disabled):active, .btn-ghost-danger:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #e55353;
    border-color: #e55353; }
    .btn-ghost-danger:not(:disabled):not(.disabled):active:focus, .btn-ghost-danger:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.5); }
  .show > .btn-ghost-danger.dropdown-toggle {
    color: #fff;
    background-color: #e55353;
    border-color: #e55353; }
    .show > .btn-ghost-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.5); }

.btn-ghost-light {
  color: #ebedef;
  background-color: transparent;
  background-image: none;
  border-color: transparent; }
  .btn-ghost-light:hover {
    color: #4f5d73;
    background-color: #ebedef;
    border-color: #ebedef; }
  .btn-ghost-light:focus, .btn-ghost-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(235, 237, 239, 0.5); }
  .btn-ghost-light.disabled, .btn-ghost-light:disabled {
    color: #ebedef;
    background-color: transparent;
    border-color: transparent; }
  .btn-ghost-light:not(:disabled):not(.disabled):active, .btn-ghost-light:not(:disabled):not(.disabled).active {
    color: #4f5d73;
    background-color: #ebedef;
    border-color: #ebedef; }
    .btn-ghost-light:not(:disabled):not(.disabled):active:focus, .btn-ghost-light:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(235, 237, 239, 0.5); }
  .show > .btn-ghost-light.dropdown-toggle {
    color: #4f5d73;
    background-color: #ebedef;
    border-color: #ebedef; }
    .show > .btn-ghost-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(235, 237, 239, 0.5); }

.btn-ghost-dark {
  color: #636f83;
  background-color: transparent;
  background-image: none;
  border-color: transparent; }
  .btn-ghost-dark:hover {
    color: #fff;
    background-color: #636f83;
    border-color: #636f83; }
  .btn-ghost-dark:focus, .btn-ghost-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(99, 111, 131, 0.5); }
  .btn-ghost-dark.disabled, .btn-ghost-dark:disabled {
    color: #636f83;
    background-color: transparent;
    border-color: transparent; }
  .btn-ghost-dark:not(:disabled):not(.disabled):active, .btn-ghost-dark:not(:disabled):not(.disabled).active {
    color: #fff;
    background-color: #636f83;
    border-color: #636f83; }
    .btn-ghost-dark:not(:disabled):not(.disabled):active:focus, .btn-ghost-dark:not(:disabled):not(.disabled).active:focus {
      box-shadow: 0 0 0 0.2rem rgba(99, 111, 131, 0.5); }
  .show > .btn-ghost-dark.dropdown-toggle {
    color: #fff;
    background-color: #636f83;
    border-color: #636f83; }
    .show > .btn-ghost-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(99, 111, 131, 0.5); }

.btn-facebook {
  color: #fff;
  background-color: #3b5998;
  border-color: #3b5998; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-facebook:hover {
      color: #fff;
      background-color: #30497c;
      border-color: #2d4373; } }
  .btn-facebook:focus, .btn-facebook.focus {
    color: #fff;
    background-color: #30497c;
    border-color: #2d4373;
    box-shadow: 0 0 0 0.2rem rgba(88, 114, 167, 0.5); }
  .btn-facebook.disabled, .btn-facebook:disabled {
    color: #fff;
    background-color: #3b5998;
    border-color: #3b5998; }
  .btn-facebook:not(:disabled):not(.disabled):active,
  .show > .btn-facebook.dropdown-toggle {
    color: #fff;
    background-color: #2d4373;
    border-color: #293e6a; }
    .btn-facebook:not(:disabled):not(.disabled):active:focus,
    .show > .btn-facebook.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(88, 114, 167, 0.5); }
  .show > .btn-facebook.dropdown-toggle {
    color: #fff;
    background-color: #2d4373;
    border-color: #293e6a; }
    .show > .btn-facebook.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(88, 114, 167, 0.5); }

.btn-twitter {
  color: #fff;
  background-color: #00aced;
  border-color: #00aced; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-twitter:hover {
      color: #fff;
      background-color: #0090c7;
      border-color: #0087ba; } }
  .btn-twitter:focus, .btn-twitter.focus {
    color: #fff;
    background-color: #0090c7;
    border-color: #0087ba;
    box-shadow: 0 0 0 0.2rem rgba(38, 184, 240, 0.5); }
  .btn-twitter.disabled, .btn-twitter:disabled {
    color: #fff;
    background-color: #00aced;
    border-color: #00aced; }
  .btn-twitter:not(:disabled):not(.disabled):active,
  .show > .btn-twitter.dropdown-toggle {
    color: #fff;
    background-color: #0087ba;
    border-color: #007ead; }
    .btn-twitter:not(:disabled):not(.disabled):active:focus,
    .show > .btn-twitter.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(38, 184, 240, 0.5); }
  .show > .btn-twitter.dropdown-toggle {
    color: #fff;
    background-color: #0087ba;
    border-color: #007ead; }
    .show > .btn-twitter.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(38, 184, 240, 0.5); }

.btn-linkedin {
  color: #fff;
  background-color: #4875b4;
  border-color: #4875b4; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-linkedin:hover {
      color: #fff;
      background-color: #3d6399;
      border-color: #395d90; } }
  .btn-linkedin:focus, .btn-linkedin.focus {
    color: #fff;
    background-color: #3d6399;
    border-color: #395d90;
    box-shadow: 0 0 0 0.2rem rgba(99, 138, 191, 0.5); }
  .btn-linkedin.disabled, .btn-linkedin:disabled {
    color: #fff;
    background-color: #4875b4;
    border-color: #4875b4; }
  .btn-linkedin:not(:disabled):not(.disabled):active,
  .show > .btn-linkedin.dropdown-toggle {
    color: #fff;
    background-color: #395d90;
    border-color: #365786; }
    .btn-linkedin:not(:disabled):not(.disabled):active:focus,
    .show > .btn-linkedin.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(99, 138, 191, 0.5); }
  .show > .btn-linkedin.dropdown-toggle {
    color: #fff;
    background-color: #395d90;
    border-color: #365786; }
    .show > .btn-linkedin.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(99, 138, 191, 0.5); }

.btn-flickr {
  color: #fff;
  background-color: #ff0084;
  border-color: #ff0084; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-flickr:hover {
      color: #fff;
      background-color: #d90070;
      border-color: #cc006a; } }
  .btn-flickr:focus, .btn-flickr.focus {
    color: #fff;
    background-color: #d90070;
    border-color: #cc006a;
    box-shadow: 0 0 0 0.2rem rgba(255, 38, 150, 0.5); }
  .btn-flickr.disabled, .btn-flickr:disabled {
    color: #fff;
    background-color: #ff0084;
    border-color: #ff0084; }
  .btn-flickr:not(:disabled):not(.disabled):active,
  .show > .btn-flickr.dropdown-toggle {
    color: #fff;
    background-color: #cc006a;
    border-color: #bf0063; }
    .btn-flickr:not(:disabled):not(.disabled):active:focus,
    .show > .btn-flickr.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 38, 150, 0.5); }
  .show > .btn-flickr.dropdown-toggle {
    color: #fff;
    background-color: #cc006a;
    border-color: #bf0063; }
    .show > .btn-flickr.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 38, 150, 0.5); }

.btn-tumblr {
  color: #fff;
  background-color: #32506d;
  border-color: #32506d; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-tumblr:hover {
      color: #fff;
      background-color: #263d53;
      border-color: #22364a; } }
  .btn-tumblr:focus, .btn-tumblr.focus {
    color: #fff;
    background-color: #263d53;
    border-color: #22364a;
    box-shadow: 0 0 0 0.2rem rgba(81, 106, 131, 0.5); }
  .btn-tumblr.disabled, .btn-tumblr:disabled {
    color: #fff;
    background-color: #32506d;
    border-color: #32506d; }
  .btn-tumblr:not(:disabled):not(.disabled):active,
  .show > .btn-tumblr.dropdown-toggle {
    color: #fff;
    background-color: #22364a;
    border-color: #1e3041; }
    .btn-tumblr:not(:disabled):not(.disabled):active:focus,
    .show > .btn-tumblr.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(81, 106, 131, 0.5); }
  .show > .btn-tumblr.dropdown-toggle {
    color: #fff;
    background-color: #22364a;
    border-color: #1e3041; }
    .show > .btn-tumblr.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(81, 106, 131, 0.5); }

.btn-xing {
  color: #fff;
  background-color: #026466;
  border-color: #026466; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-xing:hover {
      color: #fff;
      background-color: #013f40;
      border-color: #013334; } }
  .btn-xing:focus, .btn-xing.focus {
    color: #fff;
    background-color: #013f40;
    border-color: #013334;
    box-shadow: 0 0 0 0.2rem rgba(40, 123, 125, 0.5); }
  .btn-xing.disabled, .btn-xing:disabled {
    color: #fff;
    background-color: #026466;
    border-color: #026466; }
  .btn-xing:not(:disabled):not(.disabled):active,
  .show > .btn-xing.dropdown-toggle {
    color: #fff;
    background-color: #013334;
    border-color: #012727; }
    .btn-xing:not(:disabled):not(.disabled):active:focus,
    .show > .btn-xing.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(40, 123, 125, 0.5); }
  .show > .btn-xing.dropdown-toggle {
    color: #fff;
    background-color: #013334;
    border-color: #012727; }
    .show > .btn-xing.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(40, 123, 125, 0.5); }

.btn-github {
  color: #fff;
  background-color: #4183c4;
  border-color: #4183c4; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-github:hover {
      color: #fff;
      background-color: #3570aa;
      border-color: #3269a0; } }
  .btn-github:focus, .btn-github.focus {
    color: #fff;
    background-color: #3570aa;
    border-color: #3269a0;
    box-shadow: 0 0 0 0.2rem rgba(94, 150, 205, 0.5); }
  .btn-github.disabled, .btn-github:disabled {
    color: #fff;
    background-color: #4183c4;
    border-color: #4183c4; }
  .btn-github:not(:disabled):not(.disabled):active,
  .show > .btn-github.dropdown-toggle {
    color: #fff;
    background-color: #3269a0;
    border-color: #2f6397; }
    .btn-github:not(:disabled):not(.disabled):active:focus,
    .show > .btn-github.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(94, 150, 205, 0.5); }
  .show > .btn-github.dropdown-toggle {
    color: #fff;
    background-color: #3269a0;
    border-color: #2f6397; }
    .show > .btn-github.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(94, 150, 205, 0.5); }

.btn-stack-overflow {
  color: #fff;
  background-color: #fe7a15;
  border-color: #fe7a15; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-stack-overflow:hover {
      color: #fff;
      background-color: #ec6701;
      border-color: #df6101; } }
  .btn-stack-overflow:focus, .btn-stack-overflow.focus {
    color: #fff;
    background-color: #ec6701;
    border-color: #df6101;
    box-shadow: 0 0 0 0.2rem rgba(254, 142, 56, 0.5); }
  .btn-stack-overflow.disabled, .btn-stack-overflow:disabled {
    color: #fff;
    background-color: #fe7a15;
    border-color: #fe7a15; }
  .btn-stack-overflow:not(:disabled):not(.disabled):active,
  .show > .btn-stack-overflow.dropdown-toggle {
    color: #fff;
    background-color: #df6101;
    border-color: #d25c01; }
    .btn-stack-overflow:not(:disabled):not(.disabled):active:focus,
    .show > .btn-stack-overflow.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(254, 142, 56, 0.5); }
  .show > .btn-stack-overflow.dropdown-toggle {
    color: #fff;
    background-color: #df6101;
    border-color: #d25c01; }
    .show > .btn-stack-overflow.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(254, 142, 56, 0.5); }

.btn-youtube {
  color: #fff;
  background-color: #b00;
  border-color: #b00; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-youtube:hover {
      color: #fff;
      background-color: #950000;
      border-color: #880000; } }
  .btn-youtube:focus, .btn-youtube.focus {
    color: #fff;
    background-color: #950000;
    border-color: #880000;
    box-shadow: 0 0 0 0.2rem rgba(197, 38, 38, 0.5); }
  .btn-youtube.disabled, .btn-youtube:disabled {
    color: #fff;
    background-color: #b00;
    border-color: #b00; }
  .btn-youtube:not(:disabled):not(.disabled):active,
  .show > .btn-youtube.dropdown-toggle {
    color: #fff;
    background-color: #880000;
    border-color: #7b0000; }
    .btn-youtube:not(:disabled):not(.disabled):active:focus,
    .show > .btn-youtube.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(197, 38, 38, 0.5); }
  .show > .btn-youtube.dropdown-toggle {
    color: #fff;
    background-color: #880000;
    border-color: #7b0000; }
    .show > .btn-youtube.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(197, 38, 38, 0.5); }

.btn-dribbble {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-dribbble:hover {
      color: #fff;
      background-color: #e62a72;
      border-color: #e51e6b; } }
  .btn-dribbble:focus, .btn-dribbble.focus {
    color: #fff;
    background-color: #e62a72;
    border-color: #e51e6b;
    box-shadow: 0 0 0 0.2rem rgba(237, 103, 155, 0.5); }
  .btn-dribbble.disabled, .btn-dribbble:disabled {
    color: #fff;
    background-color: #ea4c89;
    border-color: #ea4c89; }
  .btn-dribbble:not(:disabled):not(.disabled):active,
  .show > .btn-dribbble.dropdown-toggle {
    color: #fff;
    background-color: #e51e6b;
    border-color: #dc1a65; }
    .btn-dribbble:not(:disabled):not(.disabled):active:focus,
    .show > .btn-dribbble.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(237, 103, 155, 0.5); }
  .show > .btn-dribbble.dropdown-toggle {
    color: #fff;
    background-color: #e51e6b;
    border-color: #dc1a65; }
    .show > .btn-dribbble.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(237, 103, 155, 0.5); }

.btn-instagram {
  color: #fff;
  background-color: #517fa4;
  border-color: #517fa4; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-instagram:hover {
      color: #fff;
      background-color: #446b8a;
      border-color: #406582; } }
  .btn-instagram:focus, .btn-instagram.focus {
    color: #fff;
    background-color: #446b8a;
    border-color: #406582;
    box-shadow: 0 0 0 0.2rem rgba(107, 146, 178, 0.5); }
  .btn-instagram.disabled, .btn-instagram:disabled {
    color: #fff;
    background-color: #517fa4;
    border-color: #517fa4; }
  .btn-instagram:not(:disabled):not(.disabled):active,
  .show > .btn-instagram.dropdown-toggle {
    color: #fff;
    background-color: #406582;
    border-color: #3c5e79; }
    .btn-instagram:not(:disabled):not(.disabled):active:focus,
    .show > .btn-instagram.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(107, 146, 178, 0.5); }
  .show > .btn-instagram.dropdown-toggle {
    color: #fff;
    background-color: #406582;
    border-color: #3c5e79; }
    .show > .btn-instagram.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(107, 146, 178, 0.5); }

.btn-pinterest {
  color: #fff;
  background-color: #cb2027;
  border-color: #cb2027; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-pinterest:hover {
      color: #fff;
      background-color: #aa1b21;
      border-color: #9f191f; } }
  .btn-pinterest:focus, .btn-pinterest.focus {
    color: #fff;
    background-color: #aa1b21;
    border-color: #9f191f;
    box-shadow: 0 0 0 0.2rem rgba(211, 65, 71, 0.5); }
  .btn-pinterest.disabled, .btn-pinterest:disabled {
    color: #fff;
    background-color: #cb2027;
    border-color: #cb2027; }
  .btn-pinterest:not(:disabled):not(.disabled):active,
  .show > .btn-pinterest.dropdown-toggle {
    color: #fff;
    background-color: #9f191f;
    border-color: #94171c; }
    .btn-pinterest:not(:disabled):not(.disabled):active:focus,
    .show > .btn-pinterest.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(211, 65, 71, 0.5); }
  .show > .btn-pinterest.dropdown-toggle {
    color: #fff;
    background-color: #9f191f;
    border-color: #94171c; }
    .show > .btn-pinterest.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(211, 65, 71, 0.5); }

.btn-vk {
  color: #fff;
  background-color: #45668e;
  border-color: #45668e; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-vk:hover {
      color: #fff;
      background-color: #385474;
      border-color: #344d6c; } }
  .btn-vk:focus, .btn-vk.focus {
    color: #fff;
    background-color: #385474;
    border-color: #344d6c;
    box-shadow: 0 0 0 0.2rem rgba(97, 125, 159, 0.5); }
  .btn-vk.disabled, .btn-vk:disabled {
    color: #fff;
    background-color: #45668e;
    border-color: #45668e; }
  .btn-vk:not(:disabled):not(.disabled):active,
  .show > .btn-vk.dropdown-toggle {
    color: #fff;
    background-color: #344d6c;
    border-color: #304763; }
    .btn-vk:not(:disabled):not(.disabled):active:focus,
    .show > .btn-vk.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(97, 125, 159, 0.5); }
  .show > .btn-vk.dropdown-toggle {
    color: #fff;
    background-color: #344d6c;
    border-color: #304763; }
    .show > .btn-vk.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(97, 125, 159, 0.5); }

.btn-yahoo {
  color: #fff;
  background-color: #400191;
  border-color: #400191; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-yahoo:hover {
      color: #fff;
      background-color: #2f016b;
      border-color: #2a015e; } }
  .btn-yahoo:focus, .btn-yahoo.focus {
    color: #fff;
    background-color: #2f016b;
    border-color: #2a015e;
    box-shadow: 0 0 0 0.2rem rgba(93, 39, 162, 0.5); }
  .btn-yahoo.disabled, .btn-yahoo:disabled {
    color: #fff;
    background-color: #400191;
    border-color: #400191; }
  .btn-yahoo:not(:disabled):not(.disabled):active,
  .show > .btn-yahoo.dropdown-toggle {
    color: #fff;
    background-color: #2a015e;
    border-color: #240152; }
    .btn-yahoo:not(:disabled):not(.disabled):active:focus,
    .show > .btn-yahoo.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(93, 39, 162, 0.5); }
  .show > .btn-yahoo.dropdown-toggle {
    color: #fff;
    background-color: #2a015e;
    border-color: #240152; }
    .show > .btn-yahoo.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(93, 39, 162, 0.5); }

.btn-behance {
  color: #fff;
  background-color: #1769ff;
  border-color: #1769ff; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-behance:hover {
      color: #fff;
      background-color: #0055f0;
      border-color: #0050e3; } }
  .btn-behance:focus, .btn-behance.focus {
    color: #fff;
    background-color: #0055f0;
    border-color: #0050e3;
    box-shadow: 0 0 0 0.2rem rgba(58, 128, 255, 0.5); }
  .btn-behance.disabled, .btn-behance:disabled {
    color: #fff;
    background-color: #1769ff;
    border-color: #1769ff; }
  .btn-behance:not(:disabled):not(.disabled):active,
  .show > .btn-behance.dropdown-toggle {
    color: #fff;
    background-color: #0050e3;
    border-color: #004cd6; }
    .btn-behance:not(:disabled):not(.disabled):active:focus,
    .show > .btn-behance.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(58, 128, 255, 0.5); }
  .show > .btn-behance.dropdown-toggle {
    color: #fff;
    background-color: #0050e3;
    border-color: #004cd6; }
    .show > .btn-behance.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(58, 128, 255, 0.5); }

.btn-reddit {
  color: #fff;
  background-color: #ff4500;
  border-color: #ff4500; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-reddit:hover {
      color: #fff;
      background-color: #d93b00;
      border-color: #cc3700; } }
  .btn-reddit:focus, .btn-reddit.focus {
    color: #fff;
    background-color: #d93b00;
    border-color: #cc3700;
    box-shadow: 0 0 0 0.2rem rgba(255, 97, 38, 0.5); }
  .btn-reddit.disabled, .btn-reddit:disabled {
    color: #fff;
    background-color: #ff4500;
    border-color: #ff4500; }
  .btn-reddit:not(:disabled):not(.disabled):active,
  .show > .btn-reddit.dropdown-toggle {
    color: #fff;
    background-color: #cc3700;
    border-color: #bf3400; }
    .btn-reddit:not(:disabled):not(.disabled):active:focus,
    .show > .btn-reddit.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 97, 38, 0.5); }
  .show > .btn-reddit.dropdown-toggle {
    color: #fff;
    background-color: #cc3700;
    border-color: #bf3400; }
    .show > .btn-reddit.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 97, 38, 0.5); }

.btn-vimeo {
  color: #4f5d73;
  background-color: #aad450;
  border-color: #aad450; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .btn-vimeo:hover {
      color: #4f5d73;
      background-color: #9bcc32;
      border-color: #93c130; } }
  .btn-vimeo:focus, .btn-vimeo.focus {
    color: #4f5d73;
    background-color: #9bcc32;
    border-color: #93c130;
    box-shadow: 0 0 0 0.2rem rgba(156, 194, 85, 0.5); }
  .btn-vimeo.disabled, .btn-vimeo:disabled {
    color: #4f5d73;
    background-color: #aad450;
    border-color: #aad450; }
  .btn-vimeo:not(:disabled):not(.disabled):active,
  .show > .btn-vimeo.dropdown-toggle {
    color: #4f5d73;
    background-color: #93c130;
    border-color: #8bb72d; }
    .btn-vimeo:not(:disabled):not(.disabled):active:focus,
    .show > .btn-vimeo.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(156, 194, 85, 0.5); }
  .show > .btn-vimeo.dropdown-toggle {
    color: #4f5d73;
    background-color: #93c130;
    border-color: #8bb72d; }
    .show > .btn-vimeo.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(156, 194, 85, 0.5); }

.c-callout {
  position: relative;
  padding: 0 1rem;
  margin: 1rem 0;
  border-radius: 0.25rem; }
  html:not([dir="rtl"]) .c-callout {
    border-left: 4px solid #d8dbe0; }
  *[dir="rtl"] .c-callout {
    border-right: 4px solid #d8dbe0; }

.c-callout-bordered {
  border: 1px solid #d8dbe0;
  border-left-width: 4px; }

.c-callout code {
  border-radius: 0.25rem; }

.c-callout h4 {
  margin-top: 0;
  margin-bottom: .25rem; }

.c-callout p:last-child {
  margin-bottom: 0; }

.c-callout + .c-callout {
  margin-top: -0.25rem; }

html:not([dir="rtl"]) .c-callout-primary {
  border-left-color: #321fdb; }

*[dir="rtl"] .c-callout-primary {
  border-right-color: #321fdb; }

.c-callout-primary h4 {
  color: #321fdb; }

html:not([dir="rtl"]) .c-callout-secondary {
  border-left-color: #ced2d8; }

*[dir="rtl"] .c-callout-secondary {
  border-right-color: #ced2d8; }

.c-callout-secondary h4 {
  color: #ced2d8; }

html:not([dir="rtl"]) .c-callout-success {
  border-left-color: #2eb85c; }

*[dir="rtl"] .c-callout-success {
  border-right-color: #2eb85c; }

.c-callout-success h4 {
  color: #2eb85c; }

html:not([dir="rtl"]) .c-callout-info {
  border-left-color: #39f; }

*[dir="rtl"] .c-callout-info {
  border-right-color: #39f; }

.c-callout-info h4 {
  color: #39f; }

html:not([dir="rtl"]) .c-callout-warning {
  border-left-color: #f9b115; }

*[dir="rtl"] .c-callout-warning {
  border-right-color: #f9b115; }

.c-callout-warning h4 {
  color: #f9b115; }

html:not([dir="rtl"]) .c-callout-danger {
  border-left-color: #e55353; }

*[dir="rtl"] .c-callout-danger {
  border-right-color: #e55353; }

.c-callout-danger h4 {
  color: #e55353; }

html:not([dir="rtl"]) .c-callout-light {
  border-left-color: #ebedef; }

*[dir="rtl"] .c-callout-light {
  border-right-color: #ebedef; }

.c-callout-light h4 {
  color: #ebedef; }

html:not([dir="rtl"]) .c-callout-dark {
  border-left-color: #636f83; }

*[dir="rtl"] .c-callout-dark {
  border-right-color: #636f83; }

.c-callout-dark h4 {
  color: #636f83; }

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-bottom: 1.5rem;
  word-wrap: break-word;
  background-clip: border-box;
  border: 1px solid;
  border-radius: 0.25rem;
  background-color: #fff;
  border-color: #d8dbe0; }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group {
    border-top: inherit;
    border-bottom: inherit; }
    .card > .list-group:first-child {
      border-top-width: 0;
      border-top-left-radius: calc(0.25rem - 1px);
      border-top-right-radius: calc(0.25rem - 1px); }
    .card > .list-group:last-child {
      border-bottom-width: 0;
      border-bottom-right-radius: calc(0.25rem - 1px);
      border-bottom-left-radius: calc(0.25rem - 1px); }
  .card.drag,
  .card .drag {
    cursor: move; }

.card[class^="bg-"],
.card[class*=" bg-"] {
  border-color: rgba(0, 0, 0, 0.125); }
  .card[class^="bg-"] .card-header,
  .card[class*=" bg-"] .card-header {
    background-color: rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.125); }

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem; }

.card-title {
  margin-bottom: 0.75rem; }

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0; }

.card-text:last-child {
  margin-bottom: 0; }

@media (hover: hover), (-ms-high-contrast: none) {
  .card-link:hover {
    text-decoration: none; } }

html:not([dir="rtl"]) .card-link + .card-link {
  margin-left: 1.25rem; }

*[dir="rtl"] .card-link + .card-link {
  margin-right: 1.25rem; }

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-bottom: 1px solid;
  background-color: #fff;
  border-color: #d8dbe0; }
  .card-header:first-child {
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0; }
  .card-header + .list-group .list-group-item:first-child {
    border-top: 0; }
  .card-header .c-chart-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%; }

.card-footer {
  padding: 0.75rem 1.25rem;
  border-top: 1px solid;
  background-color: #fff;
  border-color: #d8dbe0; }
  .card-footer:last-child {
    border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px); }

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0; }

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem; }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem; }

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%; }

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px); }

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px); }

.card-deck .card {
  margin-bottom: 15px; }

@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px; }
    .card-deck .card {
      flex: 1 0;
      margin-right: 15px;
      margin-bottom: 0;
      margin-left: 15px; } }

.card-group > .card {
  margin-bottom: 15px; }

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap; }
    .card-group > .card {
      flex: 1 0;
      margin-bottom: 0; }
      html:not([dir="rtl"]) .card-group > .card + .card {
        margin-left: 0;
        border-left: 0; }
      *[dir="rtl"] .card-group > .card + .card {
        margin-right: 0;
        border-right: 0; }
      .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-top,
        .card-group > .card:not(:last-child) .card-header {
          border-top-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-bottom,
        .card-group > .card:not(:last-child) .card-footer {
          border-bottom-right-radius: 0; }
      .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-top,
        .card-group > .card:not(:first-child) .card-header {
          border-top-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-bottom,
        .card-group > .card:not(:first-child) .card-footer {
          border-bottom-left-radius: 0; } }

.card-columns .card {
  margin-bottom: 0.75rem; }

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1; }
    .card-columns .card {
      display: inline-block;
      width: 100%; } }

.accordion > .card {
  overflow: hidden; }
  .accordion > .card:not(:last-of-type) {
    border-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .accordion > .card:not(:first-of-type) {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }
  .accordion > .card > .card-header {
    border-radius: 0;
    margin-bottom: -1px; }

.card-placeholder {
  background: rgba(0, 0, 21, 0.025);
  border: 1px dashed #c4c9d0; }

.card-header-icon-bg {
  display: inline-block;
  width: 2.8125rem;
  padding: 0.75rem 0;
  margin: -0.75rem 1.25rem -0.75rem -1.25rem;
  line-height: inherit;
  color: #3c4b64;
  text-align: center;
  background: transparent;
  border-right: 1px solid;
  border-right: #d8dbe0; }

.card-header-actions {
  display: inline-block; }
  html:not([dir="rtl"]) .card-header-actions {
    float: right;
    margin-right: -0.25rem; }
  *[dir="rtl"] .card-header-actions {
    float: left;
    margin-left: -0.25rem; }

.card-header-action {
  padding: 0 0.25rem;
  color: #8a93a2; }
  .card-header-action:hover {
    color: #3c4b64;
    text-decoration: none; }

.card-accent-primary {
  border-top: 2px solid #321fdb !important; }

.card-accent-secondary {
  border-top: 2px solid #ced2d8 !important; }

.card-accent-success {
  border-top: 2px solid #2eb85c !important; }

.card-accent-info {
  border-top: 2px solid #39f !important; }

.card-accent-warning {
  border-top: 2px solid #f9b115 !important; }

.card-accent-danger {
  border-top: 2px solid #e55353 !important; }

.card-accent-light {
  border-top: 2px solid #ebedef !important; }

.card-accent-dark {
  border-top: 2px solid #636f83 !important; }

.card-full {
  margin-top: -1rem;
  margin-right: -15px;
  margin-left: -15px;
  border: 0;
  border-bottom: 1px solid #d8dbe0; }

@media (min-width: 576px) {
  .card-columns.cols-2 {
    column-count: 2; } }

.carousel {
  position: relative; }

.carousel.pointer-event {
  touch-action: pan-y; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: ""; }

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%); }

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%); }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none; }

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1; }

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-right {
      transition: none; } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none; } }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50% / 100% 100%; }

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none; }
  html:not([dir="rtl"]) .carousel-indicators {
    padding-left: 0; }
  *[dir="rtl"] .carousel-indicators {
    padding-right: 0; }
  .carousel-indicators li {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: .5;
    transition: opacity 0.6s ease; }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators li {
        transition: none; } }
  .carousel-indicators .active {
    opacity: 1; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center; }

.c-chart-wrapper canvas {
  width: 100%; }

base-chart.chart {
  display: block; }

canvas {
  -webkit-user-select: none;
          user-select: none; }

.close {
  float: right;
  font-size: 1.3125rem;
  font-weight: 700;
  line-height: 1;
  opacity: .5;
  color: #000015;
  text-shadow: 0 1px 0 #fff; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .close:hover {
      text-decoration: none;
      color: #000015; } }
  .close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
    opacity: .75; }

button.close {
  padding: 0;
  background-color: transparent;
  border: 0; }

a.close.disabled {
  pointer-events: none; }

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #4f5d73;
  border-radius: 0.2rem; }
  kbd kbd {
    padding: 0;
    font-size: 100%;
    font-weight: 700; }

pre {
  display: block;
  font-size: 87.5%;
  color: #4f5d73; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll; }

.custom-control {
  position: relative;
  display: block;
  min-height: 1.3125rem; }
  html:not([dir="rtl"]) .custom-control {
    padding-left: 1.5rem; }
  *[dir="rtl"] .custom-control {
    padding-right: 1.5rem; }

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem; }

.custom-control-input {
  position: absolute;
  z-index: -1;
  width: 1rem;
  height: 1.15625rem;
  opacity: 0; }
  html:not([dir="rtl"]) .custom-control-input {
    left: 0; }
  *[dir="rtl"] .custom-control-input {
    right: 0; }
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #321fdb;
    background-color: #321fdb; }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25); }
  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: #958bef; }
  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
    color: #fff;
    background-color: #beb8f5;
    border-color: #beb8f5; }
  .custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
    color: #8a93a2; }
    .custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
      background-color: #d8dbe0; }

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top; }
  .custom-control-label::before {
    position: absolute;
    top: 0.15625rem;
    display: block;
    width: 1rem;
    height: 1rem;
    pointer-events: none;
    content: "";
    border: solid 1px;
    background-color: #fff;
    border-color: #9da5b1; }
    html:not([dir="rtl"]) .custom-control-label::before {
      left: -1.5rem; }
    *[dir="rtl"] .custom-control-label::before {
      right: -1.5rem; }
  .custom-control-label::after {
    position: absolute;
    top: 0.15625rem;
    display: block;
    width: 1rem;
    height: 1rem;
    content: "";
    background: no-repeat 50% / 50% 50%; }
    html:not([dir="rtl"]) .custom-control-label::after {
      left: -1.5rem; }
    *[dir="rtl"] .custom-control-label::after {
      right: -1.5rem; }

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem; }

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #321fdb;
  background-color: #321fdb; }

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(50, 31, 219, 0.5); }

.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(50, 31, 219, 0.5); }

.custom-radio .custom-control-label::before {
  border-radius: 50%; }

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(50, 31, 219, 0.5); }

html:not([dir="rtl"]) .custom-switch {
  padding-left: 2.25rem; }

*[dir="rtl"] .custom-switch {
  padding-right: 2.25rem; }

.custom-switch .custom-control-label::before {
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem; }
  html:not([dir="rtl"]) .custom-switch .custom-control-label::before {
    left: -2.25rem; }
  *[dir="rtl"] .custom-switch .custom-control-label::before {
    right: -2.25rem; }

.custom-switch .custom-control-label::after {
  top: calc(0.15625rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #9da5b1;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: #9da5b1; }
  html:not([dir="rtl"]) .custom-switch .custom-control-label::after {
    left: calc(-2.25rem + 2px); }
  *[dir="rtl"] .custom-switch .custom-control-label::after {
    right: calc(-2.25rem + 2px); }
  @media (prefers-reduced-motion: reduce) {
    .custom-switch .custom-control-label::after {
      transition: none; } }

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem); }

.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(50, 31, 219, 0.5); }

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  vertical-align: middle;
  border: 1px solid;
  border-radius: 0.25rem;
  -webkit-appearance: none;
          appearance: none;
  color: #768192;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat right 0.75rem center/8px 10px;
  border-color: #d8dbe0; }
  .custom-select:focus {
    border-color: #958bef;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25); }
    .custom-select:focus::-ms-value {
      color: #768192;
      background-color: #fff; }
  .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    background-image: none; }
    html:not([dir="rtl"]) .custom-select[multiple], html:not([dir="rtl"]) .custom-select[size]:not([size="1"]) {
      padding-right: 0.75rem; }
    *[dir="rtl"] .custom-select[multiple], *[dir="rtl"] .custom-select[size]:not([size="1"]) {
      padding-left: 0.75rem; }
  .custom-select:disabled {
    color: #8a93a2;
    background-color: #d8dbe0; }
  .custom-select::-ms-expand {
    display: none; }
  .custom-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #768192; }

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.76562rem; }
  html:not([dir="rtl"]) .custom-select-sm {
    padding-left: 0.5rem; }
  *[dir="rtl"] .custom-select-sm {
    padding-right: 0.5rem; }

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 1.09375rem; }
  html:not([dir="rtl"]) .custom-select-lg {
    padding-left: 1rem; }
  *[dir="rtl"] .custom-select-lg {
    padding-right: 1rem; }

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0; }

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  opacity: 0; }
  .custom-file-input:focus ~ .custom-file-label {
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
    border-color: #958bef; }
  .custom-file-input[disabled] ~ .custom-file-label,
  .custom-file-input:disabled ~ .custom-file-label {
    background-color: #d8dbe0; }
  .custom-file-input:lang(en) ~ .custom-file-label::after {
    content: "Browse"; }
  .custom-file-input ~ .custom-file-label[data-browse]::after {
    content: attr(data-browse); }

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 0.25rem;
  color: #768192;
  background-color: #fff;
  border-color: #d8dbe0; }
  .custom-file-label::after {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(1.5em + 0.75rem);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    content: "Browse";
    border-left: inherit;
    border-radius: 0 0.25rem 0.25rem 0;
    color: #768192;
    background-color: #ebedef; }
    html:not([dir="rtl"]) .custom-file-label::after {
      right: 0; }
    *[dir="rtl"] .custom-file-label::after {
      left: 0; }

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
          appearance: none; }
  .custom-range:focus {
    outline: none; }
    .custom-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #ebedef, 0 0 0 0.2rem rgba(50, 31, 219, 0.25); }
    .custom-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #ebedef, 0 0 0 0.2rem rgba(50, 31, 219, 0.25); }
    .custom-range:focus::-ms-thumb {
      box-shadow: 0 0 0 1px #ebedef, 0 0 0 0.2rem rgba(50, 31, 219, 0.25); }
  .custom-range::-moz-focus-outer {
    border: 0; }
  .custom-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    background-color: #321fdb;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    -webkit-appearance: none;
            appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none; } }
    .custom-range::-webkit-slider-thumb:active {
      background-color: #beb8f5; }
  .custom-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    border-color: transparent;
    border-radius: 1rem;
    background-color: #c4c9d0; }
  .custom-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #321fdb;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none; } }
    .custom-range::-moz-range-thumb:active {
      background-color: #beb8f5; }
  .custom-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #c4c9d0;
    border-color: transparent;
    border-radius: 1rem; }
  .custom-range::-ms-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: 0;
    margin-right: 0.2rem;
    margin-left: 0.2rem;
    background-color: #321fdb;
    border: 0;
    border-radius: 1rem;
    -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-ms-thumb {
        -ms-transition: none;
        transition: none; } }
    .custom-range::-ms-thumb:active {
      background-color: #beb8f5; }
  .custom-range::-ms-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: transparent;
    border-color: transparent;
    border-width: 0.5rem; }
  .custom-range::-ms-fill-lower {
    background-color: #c4c9d0;
    border-radius: 1rem; }
  .custom-range::-ms-fill-upper {
    margin-right: 15px;
    background-color: #c4c9d0;
    border-radius: 1rem; }
  .custom-range:disabled::-webkit-slider-thumb {
    background-color: #9da5b1; }
  .custom-range:disabled::-webkit-slider-runnable-track {
    cursor: default; }
  .custom-range:disabled::-moz-range-thumb {
    background-color: #9da5b1; }
  .custom-range:disabled::-moz-range-track {
    cursor: default; }
  .custom-range:disabled::-ms-thumb {
    background-color: #9da5b1; }

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .custom-control-label::before,
    .custom-file-label,
    .custom-select {
      transition: none; } }

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative; }

.dropdown-toggle {
  white-space: nowrap; }
  .dropdown-toggle::after {
    display: inline-block;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent; }
    html:not([dir="rtl"]) .dropdown-toggle::after {
      margin-left: 0.255em; }
    *[dir="rtl"] .dropdown-toggle::after {
      margin-right: 0.255em; }
  html:not([dir="rtl"]) .dropdown-toggle:empty::after {
    margin-left: 0; }
  *[dir="rtl"] .dropdown-toggle:empty::after {
    margin-right: 0; }

.dropdown-menu {
  position: absolute;
  top: 100%;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  font-size: 0.875rem;
  text-align: left;
  list-style: none;
  background-clip: padding-box;
  border: 1px solid;
  border-radius: 0.25rem;
  color: #3c4b64;
  background-color: #fff;
  border-color: #d8dbe0; }

.c-header .dropdown-menu,
.navbar .dropdown-menu,
[data-display^="static"] ~ .dropdown-menu {
  margin: 0.125rem 0 0; }

html:not([dir="rtl"]) .c-header .dropdown-menu-left, html:not([dir="rtl"])
.navbar .dropdown-menu-left, html:not([dir="rtl"])
[data-display^="static"] ~ .dropdown-menu-left {
  right: auto;
  left: 0; }

*[dir="rtl"] .c-header .dropdown-menu-left, *[dir="rtl"]
.navbar .dropdown-menu-left, *[dir="rtl"]
[data-display^="static"] ~ .dropdown-menu-left {
  right: 0;
  left: auto; }

html:not([dir="rtl"]) .c-header .dropdown-menu-right, html:not([dir="rtl"])
.navbar .dropdown-menu-right, html:not([dir="rtl"])
[data-display^="static"] ~ .dropdown-menu-right {
  right: 0;
  left: auto; }

*[dir="rtl"] .c-header .dropdown-menu-right, *[dir="rtl"]
.navbar .dropdown-menu-right, *[dir="rtl"]
[data-display^="static"] ~ .dropdown-menu-right {
  right: auto;
  left: 0; }

@media (min-width: 576px) {
  html:not([dir="rtl"]) .c-header .dropdown-menu-sm-left, html:not([dir="rtl"])
  .navbar .dropdown-menu-sm-left, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-sm-left {
    right: auto;
    left: 0; }
  *[dir="rtl"] .c-header .dropdown-menu-sm-left, *[dir="rtl"]
  .navbar .dropdown-menu-sm-left, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-sm-left {
    right: 0;
    left: auto; }
  html:not([dir="rtl"]) .c-header .dropdown-menu-sm-right, html:not([dir="rtl"])
  .navbar .dropdown-menu-sm-right, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-sm-right {
    right: 0;
    left: auto; }
  *[dir="rtl"] .c-header .dropdown-menu-sm-right, *[dir="rtl"]
  .navbar .dropdown-menu-sm-right, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-sm-right {
    right: auto;
    left: 0; } }

@media (min-width: 768px) {
  html:not([dir="rtl"]) .c-header .dropdown-menu-md-left, html:not([dir="rtl"])
  .navbar .dropdown-menu-md-left, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-md-left {
    right: auto;
    left: 0; }
  *[dir="rtl"] .c-header .dropdown-menu-md-left, *[dir="rtl"]
  .navbar .dropdown-menu-md-left, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-md-left {
    right: 0;
    left: auto; }
  html:not([dir="rtl"]) .c-header .dropdown-menu-md-right, html:not([dir="rtl"])
  .navbar .dropdown-menu-md-right, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-md-right {
    right: 0;
    left: auto; }
  *[dir="rtl"] .c-header .dropdown-menu-md-right, *[dir="rtl"]
  .navbar .dropdown-menu-md-right, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-md-right {
    right: auto;
    left: 0; } }

@media (min-width: 992px) {
  html:not([dir="rtl"]) .c-header .dropdown-menu-lg-left, html:not([dir="rtl"])
  .navbar .dropdown-menu-lg-left, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-lg-left {
    right: auto;
    left: 0; }
  *[dir="rtl"] .c-header .dropdown-menu-lg-left, *[dir="rtl"]
  .navbar .dropdown-menu-lg-left, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-lg-left {
    right: 0;
    left: auto; }
  html:not([dir="rtl"]) .c-header .dropdown-menu-lg-right, html:not([dir="rtl"])
  .navbar .dropdown-menu-lg-right, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-lg-right {
    right: 0;
    left: auto; }
  *[dir="rtl"] .c-header .dropdown-menu-lg-right, *[dir="rtl"]
  .navbar .dropdown-menu-lg-right, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-lg-right {
    right: auto;
    left: 0; } }

@media (min-width: 1200px) {
  html:not([dir="rtl"]) .c-header .dropdown-menu-xl-left, html:not([dir="rtl"])
  .navbar .dropdown-menu-xl-left, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-xl-left {
    right: auto;
    left: 0; }
  *[dir="rtl"] .c-header .dropdown-menu-xl-left, *[dir="rtl"]
  .navbar .dropdown-menu-xl-left, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-xl-left {
    right: 0;
    left: auto; }
  html:not([dir="rtl"]) .c-header .dropdown-menu-xl-right, html:not([dir="rtl"])
  .navbar .dropdown-menu-xl-right, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-xl-right {
    right: 0;
    left: auto; }
  *[dir="rtl"] .c-header .dropdown-menu-xl-right, *[dir="rtl"]
  .navbar .dropdown-menu-xl-right, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-xl-right {
    right: auto;
    left: 0; } }

@media (min-width: 1400px) {
  html:not([dir="rtl"]) .c-header .dropdown-menu-xxl-left, html:not([dir="rtl"])
  .navbar .dropdown-menu-xxl-left, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-xxl-left {
    right: auto;
    left: 0; }
  *[dir="rtl"] .c-header .dropdown-menu-xxl-left, *[dir="rtl"]
  .navbar .dropdown-menu-xxl-left, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-xxl-left {
    right: 0;
    left: auto; }
  html:not([dir="rtl"]) .c-header .dropdown-menu-xxl-right, html:not([dir="rtl"])
  .navbar .dropdown-menu-xxl-right, html:not([dir="rtl"])
  [data-display^="static"] ~ .dropdown-menu-xxl-right {
    right: 0;
    left: auto; }
  *[dir="rtl"] .c-header .dropdown-menu-xxl-right, *[dir="rtl"]
  .navbar .dropdown-menu-xxl-right, *[dir="rtl"]
  [data-display^="static"] ~ .dropdown-menu-xxl-right {
    right: auto;
    left: 0; } }

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem; }

.dropup .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent; }
  html:not([dir="rtl"]) .dropup .dropdown-toggle::after {
    margin-left: 0.255em; }
  *[dir="rtl"] .dropup .dropdown-toggle::after {
    margin-right: 0.255em; }

html:not([dir="rtl"]) .dropup .dropdown-toggle:empty::after {
  margin-left: 0; }

*[dir="rtl"] .dropup .dropdown-toggle:empty::after {
  margin-right: 0; }

.dropright .dropdown-menu {
  top: 0;
  margin-top: 0; }
  html:not([dir="rtl"]) .dropright .dropdown-menu {
    right: auto;
    left: 100%;
    margin-left: 0.125rem; }
  *[dir="rtl"] .dropright .dropdown-menu {
    right: 100%;
    left: auto;
    margin-right: 0.125rem; }

.dropright .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid; }
  html:not([dir="rtl"]) .dropright .dropdown-toggle::after {
    margin-left: 0.255em; }
  *[dir="rtl"] .dropright .dropdown-toggle::after {
    margin-right: 0.255em; }

html:not([dir="rtl"]) .dropright .dropdown-toggle:empty::after {
  margin-left: 0; }

*[dir="rtl"] .dropright .dropdown-toggle:empty::after {
  margin-right: 0; }

.dropright .dropdown-toggle::after {
  vertical-align: 0; }

.dropleft .dropdown-menu {
  top: 0;
  margin-top: 0; }
  html:not([dir="rtl"]) .dropleft .dropdown-menu {
    right: 100%;
    left: auto;
    margin-right: 0.125rem; }
  *[dir="rtl"] .dropleft .dropdown-menu {
    right: auto;
    left: 100%;
    margin-left: 0.125rem; }

.dropleft .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: ""; }
  html:not([dir="rtl"]) .dropleft .dropdown-toggle::after {
    margin-left: 0.255em; }
  *[dir="rtl"] .dropleft .dropdown-toggle::after {
    margin-right: 0.255em; }

.dropleft .dropdown-toggle::after {
  display: none; }

.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent; }

html:not([dir="rtl"]) .dropleft .dropdown-toggle:empty::after {
  margin-left: 0; }

*[dir="rtl"] .dropleft .dropdown-toggle:empty::after {
  margin-right: 0; }

.dropleft .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #d8dbe0; }

.dropdown-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1.25rem;
  clear: both;
  font-weight: 400;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  color: #4f5d73; }
  .dropdown-item:hover, .dropdown-item:focus {
    text-decoration: none;
    color: #455164;
    background-color: #ebedef; }
  .dropdown-item.active, .dropdown-item:active {
    text-decoration: none;
    color: #fff;
    background-color: #321fdb; }
  .dropdown-item.disabled, .dropdown-item:disabled {
    pointer-events: none;
    background-color: transparent;
    color: #8a93a2; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: 0.5rem 1.25rem;
  margin-bottom: 0;
  font-size: 0.76562rem;
  white-space: nowrap;
  color: #8a93a2; }

.dropdown-item-text {
  display: block;
  padding: 0.5rem 1.25rem;
  color: #4f5d73; }

.c-footer {
  display: flex;
  flex: 0 0 50px;
  flex-wrap: wrap;
  align-items: center;
  height: 50px;
  padding: 0 1rem; }
  .c-footer[class*="bg-"] {
    border-color: rgba(0, 0, 21, 0.1); }
  .c-footer.c-footer-fixed {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030; }

.c-footer.c-footer-dark {
  color: #fff;
  background: #636f83; }

.c-footer {
  color: #3c4b64;
  background: #ebedef;
  border-top: 1px solid #d8dbe0; }

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid;
  color: #768192;
  background-color: #fff;
  border-color: #d8dbe0;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control::-ms-expand {
    background-color: transparent;
    border: 0; }
  .form-control:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #768192; }
  .form-control:focus {
    color: #768192;
    background-color: #fff;
    border-color: #958bef;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25); }
  .form-control::placeholder {
    color: #8a93a2;
    opacity: 1; }
  .form-control:disabled, .form-control[readonly] {
    background-color: #d8dbe0;
    opacity: 1; }

input[type="date"].form-control,
input[type="time"].form-control,
input[type="datetime-local"].form-control,
input[type="month"].form-control {
  -webkit-appearance: none;
          appearance: none; }

select.form-control:focus::-ms-value {
  color: #768192;
  background-color: #fff; }

select.form-control option {
  background-color: inherit; }

.form-control-file,
.form-control-range {
  display: block;
  width: 100%; }

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.09375rem;
  line-height: 1.5; }

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.76562rem;
  line-height: 1.5; }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
  color: #3c4b64; }
  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.76562rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

select.form-control[size], select.form-control[multiple] {
  height: auto; }

textarea.form-control {
  height: auto; }

.form-group {
  margin-bottom: 1rem; }

.form-text {
  display: block;
  margin-top: 0.25rem; }

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px; }
  .form-row > .col,
  .form-row > [class*="col-"] {
    padding-right: 5px;
    padding-left: 5px; }

.form-check {
  position: relative;
  display: block; }
  html:not([dir="rtl"]) .form-check {
    padding-left: 1.25rem; }
  *[dir="rtl"] .form-check {
    padding-right: 1.25rem; }

.form-check-input {
  position: absolute;
  margin-top: 0.3rem; }
  html:not([dir="rtl"]) .form-check-input {
    margin-left: -1.25rem; }
  *[dir="rtl"] .form-check-input {
    margin-right: -1.25rem; }
  .form-check-input[disabled] ~ .form-check-label,
  .form-check-input:disabled ~ .form-check-label {
    color: #768192; }

.form-check-label {
  margin-bottom: 0; }

.form-check-inline {
  display: inline-flex;
  align-items: center; }
  html:not([dir="rtl"]) .form-check-inline {
    padding-left: 0;
    margin-right: 0.75rem; }
  *[dir="rtl"] .form-check-inline {
    padding-right: 0;
    margin-left: 0.75rem; }
  .form-check-inline .form-check-input {
    position: static;
    margin-top: 0; }
    html:not([dir="rtl"]) .form-check-inline .form-check-input {
      margin-right: 0.3125rem;
      margin-left: 0; }
    *[dir="rtl"] .form-check-inline .form-check-input {
      margin-right: 0;
      margin-left: 0.3125rem; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #2eb85c; }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.76562rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(46, 184, 92, 0.9);
  border-radius: 0.25rem; }

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #2eb85c;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  html:not([dir="rtl"]) .was-validated .form-control:valid, html:not([dir="rtl"]) .form-control.is-valid {
    padding-right: calc(1.5em + 0.75rem); }
  *[dir="rtl"] .was-validated .form-control:valid, *[dir="rtl"] .form-control.is-valid {
    padding-left: calc(1.5em + 0.75rem); }
  html:not([dir="rtl"]) .was-validated .form-control:valid, html:not([dir="rtl"]) .form-control.is-valid {
    background-position: right calc(0.375em + 0.1875rem) center; }
  *[dir="rtl"] .was-validated .form-control:valid, *[dir="rtl"] .form-control.is-valid {
    background-position: left calc(0.375em + 0.1875rem) center; }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
    border-color: #2eb85c;
    box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.25); }

html:not([dir="rtl"]) .was-validated textarea.form-control:valid, html:not([dir="rtl"]) textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

*[dir="rtl"] .was-validated textarea.form-control:valid, *[dir="rtl"] textarea.form-control.is-valid {
  padding-left: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem); }

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #2eb85c;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_6___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  html:not([dir="rtl"]) .was-validated .custom-select:valid, html:not([dir="rtl"]) .custom-select.is-valid {
    padding-right: calc(0.75em + 2.3125rem); }
  *[dir="rtl"] .was-validated .custom-select:valid, *[dir="rtl"] .custom-select.is-valid {
    padding-left: calc(0.75em + 2.3125rem); }
  .was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
    border-color: #2eb85c;
    box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.25); }

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #2eb85c; }

.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #2eb85c; }
  .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
    border-color: #2eb85c; }

.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #48d176;
  background-color: #48d176; }

.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.25); }

.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #2eb85c; }

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #2eb85c; }

.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #2eb85c;
  box-shadow: 0 0 0 0.2rem rgba(46, 184, 92, 0.25); }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #e55353; }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.76562rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(229, 83, 83, 0.9);
  border-radius: 0.25rem; }

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #e55353;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  html:not([dir="rtl"]) .was-validated .form-control:invalid, html:not([dir="rtl"]) .form-control.is-invalid {
    padding-right: calc(1.5em + 0.75rem); }
  *[dir="rtl"] .was-validated .form-control:invalid, *[dir="rtl"] .form-control.is-invalid {
    padding-left: calc(1.5em + 0.75rem); }
  html:not([dir="rtl"]) .was-validated .form-control:invalid, html:not([dir="rtl"]) .form-control.is-invalid {
    background-position: right calc(0.375em + 0.1875rem) center; }
  *[dir="rtl"] .was-validated .form-control:invalid, *[dir="rtl"] .form-control.is-invalid {
    background-position: left calc(0.375em + 0.1875rem) center; }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: #e55353;
    box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.25); }

html:not([dir="rtl"]) .was-validated textarea.form-control:invalid, html:not([dir="rtl"]) textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

*[dir="rtl"] .was-validated textarea.form-control:invalid, *[dir="rtl"] textarea.form-control.is-invalid {
  padding-left: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem); }

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #e55353;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_7___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  html:not([dir="rtl"]) .was-validated .custom-select:invalid, html:not([dir="rtl"]) .custom-select.is-invalid {
    padding-right: calc(0.75em + 2.3125rem); }
  *[dir="rtl"] .was-validated .custom-select:invalid, *[dir="rtl"] .custom-select.is-invalid {
    padding-left: calc(0.75em + 2.3125rem); }
  .was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
    border-color: #e55353;
    box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.25); }

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #e55353; }

.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #e55353; }
  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
    border-color: #e55353; }

.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #ec7f7f;
  background-color: #ec7f7f; }

.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.25); }

.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #e55353; }

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #e55353; }

.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #e55353;
  box-shadow: 0 0 0 0.2rem rgba(229, 83, 83, 0.25); }

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center; }
  .form-inline .form-check {
    width: 100%; }
  @media (min-width: 576px) {
    .form-inline label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0; }
    .form-inline .form-group {
      display: flex;
      flex: 0 0 auto;
      flex-flow: row wrap;
      align-items: center;
      margin-bottom: 0; }
    .form-inline .form-control {
      display: inline-block;
      width: auto;
      vertical-align: middle; }
    .form-inline .form-control-plaintext {
      display: inline-block; }
    .form-inline .input-group,
    .form-inline .custom-select {
      width: auto; }
    .form-inline .form-check {
      display: flex;
      align-items: center;
      justify-content: center;
      width: auto; }
      html:not([dir="rtl"]) .form-inline .form-check {
        padding-left: 0; }
      *[dir="rtl"] .form-inline .form-check {
        padding-right: 0; }
    .form-inline .form-check-input {
      position: relative;
      flex-shrink: 0;
      margin-top: 0; }
      html:not([dir="rtl"]) .form-inline .form-check-input {
        margin-right: 0.25rem;
        margin-left: 0; }
      *[dir="rtl"] .form-inline .form-check-input {
        margin-right: 0;
        margin-left: 0.25rem; }
    .form-inline .custom-control {
      align-items: center;
      justify-content: center; }
    .form-inline .custom-control-label {
      margin-bottom: 0; } }

.form-control-color {
  max-width: 3rem;
  padding: 0.375rem; }

.form-control-color::-moz-color-swatch {
  border-radius: 0.25rem; }

.form-control-color::-webkit-color-swatch {
  border-radius: 0.25rem; }

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto; }
  @media (min-width: 576px) {
    .container {
      max-width: 540px; } }
  @media (min-width: 768px) {
    .container {
      max-width: 720px; } }
  @media (min-width: 992px) {
    .container {
      max-width: 960px; } }
  @media (min-width: 1200px) {
    .container {
      max-width: 1140px; } }
  @media (min-width: 1400px) {
    .container {
      max-width: 1320px; } }

.container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px; } }

@media (min-width: 1400px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
    max-width: 1320px; } }

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px; }

.no-gutters {
  margin-right: 0;
  margin-left: 0; }
  .no-gutters > .col,
  .no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0; }

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto, .col-xxl-1, .col-xxl-2, .col-xxl-3, .col-xxl-4, .col-xxl-5, .col-xxl-6, .col-xxl-7, .col-xxl-8, .col-xxl-9, .col-xxl-10, .col-xxl-11, .col-xxl-12, .col-xxl,
.col-xxl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px; }

.col {
  flex-basis: 0;
  flex-grow: 1;
  min-width: 0;
  max-width: 100%; }

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%; }

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%; }

.row-cols-3 > * {
  flex: 0 0 33.33333%;
  max-width: 33.33333%; }

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%; }

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%; }

.row-cols-6 > * {
  flex: 0 0 16.66667%;
  max-width: 16.66667%; }

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%; }

.col-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%; }

.col-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%; }

.col-3 {
  flex: 0 0 25%;
  max-width: 25%; }

.col-4 {
  flex: 0 0 33.33333%;
  max-width: 33.33333%; }

.col-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%; }

.col-6 {
  flex: 0 0 50%;
  max-width: 50%; }

.col-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%; }

.col-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%; }

.col-9 {
  flex: 0 0 75%;
  max-width: 75%; }

.col-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%; }

.col-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%; }

.col-12 {
  flex: 0 0 100%;
  max-width: 100%; }

.order-first {
  order: -1; }

.order-last {
  order: 13; }

.order-0 {
  order: 0; }

.order-1 {
  order: 1; }

.order-2 {
  order: 2; }

.order-3 {
  order: 3; }

.order-4 {
  order: 4; }

.order-5 {
  order: 5; }

.order-6 {
  order: 6; }

.order-7 {
  order: 7; }

.order-8 {
  order: 8; }

.order-9 {
  order: 9; }

.order-10 {
  order: 10; }

.order-11 {
  order: 11; }

.order-12 {
  order: 12; }

.offset-1 {
  margin-left: 8.33333%; }

.offset-2 {
  margin-left: 16.66667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.33333%; }

.offset-5 {
  margin-left: 41.66667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.33333%; }

.offset-8 {
  margin-left: 66.66667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.33333%; }

.offset-11 {
  margin-left: 91.66667%; }

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%; }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-sm-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-sm-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-sm-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-sm-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-sm-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-sm-first {
    order: -1; }
  .order-sm-last {
    order: 13; }
  .order-sm-0 {
    order: 0; }
  .order-sm-1 {
    order: 1; }
  .order-sm-2 {
    order: 2; }
  .order-sm-3 {
    order: 3; }
  .order-sm-4 {
    order: 4; }
  .order-sm-5 {
    order: 5; }
  .order-sm-6 {
    order: 6; }
  .order-sm-7 {
    order: 7; }
  .order-sm-8 {
    order: 8; }
  .order-sm-9 {
    order: 9; }
  .order-sm-10 {
    order: 10; }
  .order-sm-11 {
    order: 11; }
  .order-sm-12 {
    order: 12; }
  .offset-sm-0 {
    margin-left: 0; }
  .offset-sm-1 {
    margin-left: 8.33333%; }
  .offset-sm-2 {
    margin-left: 16.66667%; }
  .offset-sm-3 {
    margin-left: 25%; }
  .offset-sm-4 {
    margin-left: 33.33333%; }
  .offset-sm-5 {
    margin-left: 41.66667%; }
  .offset-sm-6 {
    margin-left: 50%; }
  .offset-sm-7 {
    margin-left: 58.33333%; }
  .offset-sm-8 {
    margin-left: 66.66667%; }
  .offset-sm-9 {
    margin-left: 75%; }
  .offset-sm-10 {
    margin-left: 83.33333%; }
  .offset-sm-11 {
    margin-left: 91.66667%; } }

@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%; }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-md-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-md-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-md-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-md-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-md-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-md-first {
    order: -1; }
  .order-md-last {
    order: 13; }
  .order-md-0 {
    order: 0; }
  .order-md-1 {
    order: 1; }
  .order-md-2 {
    order: 2; }
  .order-md-3 {
    order: 3; }
  .order-md-4 {
    order: 4; }
  .order-md-5 {
    order: 5; }
  .order-md-6 {
    order: 6; }
  .order-md-7 {
    order: 7; }
  .order-md-8 {
    order: 8; }
  .order-md-9 {
    order: 9; }
  .order-md-10 {
    order: 10; }
  .order-md-11 {
    order: 11; }
  .order-md-12 {
    order: 12; }
  .offset-md-0 {
    margin-left: 0; }
  .offset-md-1 {
    margin-left: 8.33333%; }
  .offset-md-2 {
    margin-left: 16.66667%; }
  .offset-md-3 {
    margin-left: 25%; }
  .offset-md-4 {
    margin-left: 33.33333%; }
  .offset-md-5 {
    margin-left: 41.66667%; }
  .offset-md-6 {
    margin-left: 50%; }
  .offset-md-7 {
    margin-left: 58.33333%; }
  .offset-md-8 {
    margin-left: 66.66667%; }
  .offset-md-9 {
    margin-left: 75%; }
  .offset-md-10 {
    margin-left: 83.33333%; }
  .offset-md-11 {
    margin-left: 91.66667%; } }

@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%; }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-lg-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-lg-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-lg-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-lg-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-lg-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-lg-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-lg-first {
    order: -1; }
  .order-lg-last {
    order: 13; }
  .order-lg-0 {
    order: 0; }
  .order-lg-1 {
    order: 1; }
  .order-lg-2 {
    order: 2; }
  .order-lg-3 {
    order: 3; }
  .order-lg-4 {
    order: 4; }
  .order-lg-5 {
    order: 5; }
  .order-lg-6 {
    order: 6; }
  .order-lg-7 {
    order: 7; }
  .order-lg-8 {
    order: 8; }
  .order-lg-9 {
    order: 9; }
  .order-lg-10 {
    order: 10; }
  .order-lg-11 {
    order: 11; }
  .order-lg-12 {
    order: 12; }
  .offset-lg-0 {
    margin-left: 0; }
  .offset-lg-1 {
    margin-left: 8.33333%; }
  .offset-lg-2 {
    margin-left: 16.66667%; }
  .offset-lg-3 {
    margin-left: 25%; }
  .offset-lg-4 {
    margin-left: 33.33333%; }
  .offset-lg-5 {
    margin-left: 41.66667%; }
  .offset-lg-6 {
    margin-left: 50%; }
  .offset-lg-7 {
    margin-left: 58.33333%; }
  .offset-lg-8 {
    margin-left: 66.66667%; }
  .offset-lg-9 {
    margin-left: 75%; }
  .offset-lg-10 {
    margin-left: 83.33333%; }
  .offset-lg-11 {
    margin-left: 91.66667%; } }

@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%; }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-xl-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-xl-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-xl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-xl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-xl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-xl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-xl-first {
    order: -1; }
  .order-xl-last {
    order: 13; }
  .order-xl-0 {
    order: 0; }
  .order-xl-1 {
    order: 1; }
  .order-xl-2 {
    order: 2; }
  .order-xl-3 {
    order: 3; }
  .order-xl-4 {
    order: 4; }
  .order-xl-5 {
    order: 5; }
  .order-xl-6 {
    order: 6; }
  .order-xl-7 {
    order: 7; }
  .order-xl-8 {
    order: 8; }
  .order-xl-9 {
    order: 9; }
  .order-xl-10 {
    order: 10; }
  .order-xl-11 {
    order: 11; }
  .order-xl-12 {
    order: 12; }
  .offset-xl-0 {
    margin-left: 0; }
  .offset-xl-1 {
    margin-left: 8.33333%; }
  .offset-xl-2 {
    margin-left: 16.66667%; }
  .offset-xl-3 {
    margin-left: 25%; }
  .offset-xl-4 {
    margin-left: 33.33333%; }
  .offset-xl-5 {
    margin-left: 41.66667%; }
  .offset-xl-6 {
    margin-left: 50%; }
  .offset-xl-7 {
    margin-left: 58.33333%; }
  .offset-xl-8 {
    margin-left: 66.66667%; }
  .offset-xl-9 {
    margin-left: 75%; }
  .offset-xl-10 {
    margin-left: 83.33333%; }
  .offset-xl-11 {
    margin-left: 91.66667%; } }

@media (min-width: 1400px) {
  .col-xxl {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%; }
  .row-cols-xxl-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-xxl-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-xxl-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-xxl-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-xxl-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-xxl-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-xxl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-xxl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-xxl-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-xxl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-xxl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-xxl-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-xxl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-xxl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-xxl-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-xxl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-xxl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-xxl-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-xxl-first {
    order: -1; }
  .order-xxl-last {
    order: 13; }
  .order-xxl-0 {
    order: 0; }
  .order-xxl-1 {
    order: 1; }
  .order-xxl-2 {
    order: 2; }
  .order-xxl-3 {
    order: 3; }
  .order-xxl-4 {
    order: 4; }
  .order-xxl-5 {
    order: 5; }
  .order-xxl-6 {
    order: 6; }
  .order-xxl-7 {
    order: 7; }
  .order-xxl-8 {
    order: 8; }
  .order-xxl-9 {
    order: 9; }
  .order-xxl-10 {
    order: 10; }
  .order-xxl-11 {
    order: 11; }
  .order-xxl-12 {
    order: 12; }
  .offset-xxl-0 {
    margin-left: 0; }
  .offset-xxl-1 {
    margin-left: 8.33333%; }
  .offset-xxl-2 {
    margin-left: 16.66667%; }
  .offset-xxl-3 {
    margin-left: 25%; }
  .offset-xxl-4 {
    margin-left: 33.33333%; }
  .offset-xxl-5 {
    margin-left: 41.66667%; }
  .offset-xxl-6 {
    margin-left: 50%; }
  .offset-xxl-7 {
    margin-left: 58.33333%; }
  .offset-xxl-8 {
    margin-left: 66.66667%; }
  .offset-xxl-9 {
    margin-left: 75%; }
  .offset-xxl-10 {
    margin-left: 83.33333%; }
  .offset-xxl-11 {
    margin-left: 91.66667%; } }

.row.row-equal {
  padding-right: 7.5px;
  padding-left: 7.5px;
  margin-right: -15px;
  margin-left: -15px; }
  .row.row-equal [class*="col-"] {
    padding-right: 7.5px;
    padding-left: 7.5px; }

.main .container-fluid, .main .container-sm, .main .container-md, .main .container-lg, .main .container-xl, .main .container-xxl {
  padding: 0 30px; }

.c-header {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-shrink: 0;
  min-height: 56px; }
  .c-header[class*="bg-"] {
    border-color: rgba(0, 0, 21, 0.1); }
  .c-header.c-header-fixed {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1029; }
  .c-header .c-subheader {
    border-bottom: 0; }

.c-header-brand {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-height: 56px;
  transition: width 0.3s; }
  .c-header-brand.c-header-brand-center {
    position: absolute;
    top: 56px;
    transform: translate(-50%, -100%); }
    html:not([dir="rtl"]) .c-header-brand.c-header-brand-center {
      left: 50%; }
    *[dir="rtl"] .c-header-brand.c-header-brand-center {
      right: 50%; }
  @media (max-width: 575.98px) {
    .c-header-brand.c-header-brand-xs-down-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-xs-down-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-xs-down-center {
        right: 50%; } }
  .c-header-brand.c-header-brand-xs-up-center {
    position: absolute;
    top: 56px;
    transform: translate(-50%, -100%); }
    html:not([dir="rtl"]) .c-header-brand.c-header-brand-xs-up-center {
      left: 50%; }
    *[dir="rtl"] .c-header-brand.c-header-brand-xs-up-center {
      right: 50%; }
  @media (max-width: 767.98px) {
    .c-header-brand.c-header-brand-sm-down-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-sm-down-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-sm-down-center {
        right: 50%; } }
  @media (min-width: 576px) {
    .c-header-brand.c-header-brand-sm-up-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-sm-up-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-sm-up-center {
        right: 50%; } }
  @media (max-width: 991.98px) {
    .c-header-brand.c-header-brand-md-down-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-md-down-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-md-down-center {
        right: 50%; } }
  @media (min-width: 768px) {
    .c-header-brand.c-header-brand-md-up-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-md-up-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-md-up-center {
        right: 50%; } }
  @media (max-width: 1199.98px) {
    .c-header-brand.c-header-brand-lg-down-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-lg-down-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-lg-down-center {
        right: 50%; } }
  @media (min-width: 992px) {
    .c-header-brand.c-header-brand-lg-up-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-lg-up-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-lg-up-center {
        right: 50%; } }
  @media (max-width: 1399.98px) {
    .c-header-brand.c-header-brand-xl-down-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-xl-down-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-xl-down-center {
        right: 50%; } }
  @media (min-width: 1200px) {
    .c-header-brand.c-header-brand-xl-up-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-xl-up-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-xl-up-center {
        right: 50%; } }
  .c-header-brand.c-header-brand-xxl-down-center {
    position: absolute;
    top: 56px;
    transform: translate(-50%, -100%); }
    html:not([dir="rtl"]) .c-header-brand.c-header-brand-xxl-down-center {
      left: 50%; }
    *[dir="rtl"] .c-header-brand.c-header-brand-xxl-down-center {
      right: 50%; }
  @media (min-width: 1400px) {
    .c-header-brand.c-header-brand-xxl-up-center {
      position: absolute;
      top: 56px;
      transform: translate(-50%, -100%); }
      html:not([dir="rtl"]) .c-header-brand.c-header-brand-xxl-up-center {
        left: 50%; }
      *[dir="rtl"] .c-header-brand.c-header-brand-xxl-up-center {
        right: 50%; } }

.c-header-toggler {
  min-width: 50px;
  font-size: 1.09375rem;
  background-color: transparent;
  border: 0;
  border-radius: 0.25rem; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .c-header-toggler:hover {
      color: #3c4b64;
      text-decoration: none; } }
  .c-header-toggler:focus, .c-header-toggler.focus {
    outline: 0; }
  .c-header-toggler:not(:disabled):not(.c-disabled) {
    cursor: pointer; }

.c-header-toggler-icon {
  display: block;
  height: 1.36719rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%; }

.c-header-nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 56px;
  padding: 0;
  margin-bottom: 0;
  list-style: none; }
  .c-header-nav .c-header-nav-item {
    position: relative; }
  .c-header-nav .c-header-nav-btn {
    background-color: transparent;
    border: 1px solid transparent; }
    @media (hover: hover), (-ms-high-contrast: none) {
      .c-header-nav .c-header-nav-btn:hover {
        text-decoration: none; } }
    .c-header-nav .c-header-nav-btn:focus, .c-header-nav .c-header-nav-btn.focus {
      outline: 0; }
  .c-header-nav .c-header-nav-link,
  .c-header-nav .c-header-nav-btn {
    display: flex;
    align-items: center;
    padding-right: 0.5rem;
    padding-left: 0.5rem; }
    .c-header-nav .c-header-nav-link .badge,
    .c-header-nav .c-header-nav-btn .badge {
      position: absolute;
      top: 50%;
      margin-top: -16px; }
      html:not([dir="rtl"]) .c-header-nav .c-header-nav-link .badge, html:not([dir="rtl"])
      .c-header-nav .c-header-nav-btn .badge {
        left: 50%;
        margin-left: 0; }
      *[dir="rtl"] .c-header-nav .c-header-nav-link .badge, *[dir="rtl"]
      .c-header-nav .c-header-nav-btn .badge {
        right: 50%;
        margin-right: 0; }
    .c-header-nav .c-header-nav-link:hover,
    .c-header-nav .c-header-nav-btn:hover {
      text-decoration: none; }
  .c-header-nav .dropdown-item {
    min-width: 180px; }

.c-header.c-header-dark {
  background: #3c4b64;
  border-bottom: 1px solid #636f83; }
  .c-header.c-header-dark .c-subheader {
    margin-top: -1px;
    border-top: 1px solid #636f83; }
  .c-header.c-header-dark .c-header-brand {
    color: #fff;
    background-color: transparent; }
    .c-header.c-header-dark .c-header-brand:hover, .c-header.c-header-dark .c-header-brand:focus {
      color: #fff; }
  .c-header.c-header-dark .c-header-nav .c-header-nav-link,
  .c-header.c-header-dark .c-header-nav .c-header-nav-btn {
    color: rgba(255, 255, 255, 0.75); }
    .c-header.c-header-dark .c-header-nav .c-header-nav-link:hover, .c-header.c-header-dark .c-header-nav .c-header-nav-link:focus,
    .c-header.c-header-dark .c-header-nav .c-header-nav-btn:hover,
    .c-header.c-header-dark .c-header-nav .c-header-nav-btn:focus {
      color: rgba(255, 255, 255, 0.9); }
    .c-header.c-header-dark .c-header-nav .c-header-nav-link.c-disabled,
    .c-header.c-header-dark .c-header-nav .c-header-nav-btn.c-disabled {
      color: rgba(255, 255, 255, 0.25); }
  .c-header.c-header-dark .c-header-nav .c-show > .c-header-nav-link,
  .c-header.c-header-dark .c-header-nav .c-active > .c-header-nav-link,
  .c-header.c-header-dark .c-header-nav .c-header-nav-link.c-show,
  .c-header.c-header-dark .c-header-nav .c-header-nav-link.c-active {
    color: #fff; }
  .c-header.c-header-dark .c-header-toggler {
    color: rgba(255, 255, 255, 0.75);
    border-color: rgba(255, 255, 255, 0.1); }
  .c-header.c-header-dark .c-header-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); }
    .c-header.c-header-dark .c-header-toggler-icon:hover {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___}); }
  .c-header.c-header-dark .c-header-text {
    color: rgba(255, 255, 255, 0.75); }
    .c-header.c-header-dark .c-header-text a {
      color: #fff; }
      .c-header.c-header-dark .c-header-text a:hover, .c-header.c-header-dark .c-header-text a:focus {
        color: #fff; }

.c-header {
  background: #fff;
  border-bottom: 1px solid #d8dbe0; }
  .c-header .c-subheader {
    margin-top: -1px;
    border-top: 1px solid #d8dbe0; }
  .c-header .c-header-brand {
    color: #4f5d73;
    background-color: transparent; }
    .c-header .c-header-brand:hover, .c-header .c-header-brand:focus {
      color: #3a4555; }
  .c-header .c-header-nav .c-header-nav-link,
  .c-header .c-header-nav .c-header-nav-btn {
    color: rgba(0, 0, 21, 0.5); }
    .c-header .c-header-nav .c-header-nav-link:hover, .c-header .c-header-nav .c-header-nav-link:focus,
    .c-header .c-header-nav .c-header-nav-btn:hover,
    .c-header .c-header-nav .c-header-nav-btn:focus {
      color: rgba(0, 0, 21, 0.7); }
    .c-header .c-header-nav .c-header-nav-link.c-disabled,
    .c-header .c-header-nav .c-header-nav-btn.c-disabled {
      color: rgba(0, 0, 21, 0.3); }
  .c-header .c-header-nav .c-show > .c-header-nav-link,
  .c-header .c-header-nav .c-active > .c-header-nav-link,
  .c-header .c-header-nav .c-header-nav-link.c-show,
  .c-header .c-header-nav .c-header-nav-link.c-active {
    color: rgba(0, 0, 21, 0.9); }
  .c-header .c-header-toggler {
    color: rgba(0, 0, 21, 0.5);
    border-color: rgba(0, 0, 21, 0.1); }
  .c-header .c-header-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___}); }
    .c-header .c-header-toggler-icon:hover {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___}); }
  .c-header .c-header-text {
    color: rgba(0, 0, 21, 0.5); }
    .c-header .c-header-text a {
      color: rgba(0, 0, 21, 0.9); }
      .c-header .c-header-text a:hover, .c-header .c-header-text a:focus {
        color: rgba(0, 0, 21, 0.9); }

.c-icon {
  display: inline-block;
  color: inherit;
  text-align: center;
  fill: currentColor; }
  .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size) {
    width: 1rem;
    height: 1rem;
    font-size: 1rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-2xl {
      width: 2rem;
      height: 2rem;
      font-size: 2rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-3xl {
      width: 3rem;
      height: 3rem;
      font-size: 3rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-4xl {
      width: 4rem;
      height: 4rem;
      font-size: 4rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-5xl {
      width: 5rem;
      height: 5rem;
      font-size: 5rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-6xl {
      width: 6rem;
      height: 6rem;
      font-size: 6rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-7xl {
      width: 7rem;
      height: 7rem;
      font-size: 7rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-8xl {
      width: 8rem;
      height: 8rem;
      font-size: 8rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-9xl {
      width: 9rem;
      height: 9rem;
      font-size: 9rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-xl {
      width: 1.5rem;
      height: 1.5rem;
      font-size: 1.5rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-lg {
      width: 1.25rem;
      height: 1.25rem;
      font-size: 1.25rem; }
    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size).c-icon-sm {
      width: 0.875rem;
      height: 0.875rem;
      font-size: 0.875rem; }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-control-plaintext,
  .input-group > .custom-select,
  .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    margin-bottom: 0; }
    html:not([dir="rtl"]) .input-group > .form-control + .form-control, html:not([dir="rtl"])
    .input-group > .form-control + .custom-select, html:not([dir="rtl"])
    .input-group > .form-control + .custom-file, html:not([dir="rtl"])
    .input-group > .form-control-plaintext + .form-control, html:not([dir="rtl"])
    .input-group > .form-control-plaintext + .custom-select, html:not([dir="rtl"])
    .input-group > .form-control-plaintext + .custom-file, html:not([dir="rtl"])
    .input-group > .custom-select + .form-control, html:not([dir="rtl"])
    .input-group > .custom-select + .custom-select, html:not([dir="rtl"])
    .input-group > .custom-select + .custom-file, html:not([dir="rtl"])
    .input-group > .custom-file + .form-control, html:not([dir="rtl"])
    .input-group > .custom-file + .custom-select, html:not([dir="rtl"])
    .input-group > .custom-file + .custom-file {
      margin-left: -1px; }
    *[dir="rtl"] .input-group > .form-control + .form-control, *[dir="rtl"]
    .input-group > .form-control + .custom-select, *[dir="rtl"]
    .input-group > .form-control + .custom-file, *[dir="rtl"]
    .input-group > .form-control-plaintext + .form-control, *[dir="rtl"]
    .input-group > .form-control-plaintext + .custom-select, *[dir="rtl"]
    .input-group > .form-control-plaintext + .custom-file, *[dir="rtl"]
    .input-group > .custom-select + .form-control, *[dir="rtl"]
    .input-group > .custom-select + .custom-select, *[dir="rtl"]
    .input-group > .custom-select + .custom-file, *[dir="rtl"]
    .input-group > .custom-file + .form-control, *[dir="rtl"]
    .input-group > .custom-file + .custom-select, *[dir="rtl"]
    .input-group > .custom-file + .custom-file {
      margin-right: -1px; }
  .input-group > .form-control:focus,
  .input-group > .custom-select:focus,
  .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
    z-index: 3; }
  .input-group > .custom-file .custom-file-input:focus {
    z-index: 4; }
  html:not([dir="rtl"]) .input-group > .form-control:not(:last-child), html:not([dir="rtl"])
  .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  *[dir="rtl"] .input-group > .form-control:not(:last-child), *[dir="rtl"]
  .input-group > .custom-select:not(:last-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }
  html:not([dir="rtl"]) .input-group > .form-control:not(:first-child), html:not([dir="rtl"])
  .input-group > .custom-select:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }
  *[dir="rtl"] .input-group > .form-control:not(:first-child), *[dir="rtl"]
  .input-group > .custom-select:not(:first-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .input-group > .custom-file {
    display: flex;
    align-items: center; }
    html:not([dir="rtl"]) .input-group > .custom-file:not(:last-child) .custom-file-label, html:not([dir="rtl"])
    .input-group > .custom-file:not(:last-child) .custom-file-label::after {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0; }
    *[dir="rtl"] .input-group > .custom-file:not(:last-child) .custom-file-label, *[dir="rtl"]
    .input-group > .custom-file:not(:last-child) .custom-file-label::after {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0; }
    html:not([dir="rtl"]) .input-group > .custom-file:not(:first-child) .custom-file-label {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0; }
    *[dir="rtl"] .input-group > .custom-file:not(:first-child) .custom-file-label {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0; }

.input-group-prepend,
.input-group-append {
  display: flex; }
  .input-group-prepend .btn,
  .input-group-append .btn {
    position: relative;
    z-index: 2; }
    .input-group-prepend .btn:focus,
    .input-group-append .btn:focus {
      z-index: 3; }
  html:not([dir="rtl"]) .input-group-prepend .btn + .btn, html:not([dir="rtl"])
  .input-group-prepend .btn + .input-group-text, html:not([dir="rtl"])
  .input-group-prepend .input-group-text + .input-group-text, html:not([dir="rtl"])
  .input-group-prepend .input-group-text + .btn, html:not([dir="rtl"])
  .input-group-append .btn + .btn, html:not([dir="rtl"])
  .input-group-append .btn + .input-group-text, html:not([dir="rtl"])
  .input-group-append .input-group-text + .input-group-text, html:not([dir="rtl"])
  .input-group-append .input-group-text + .btn {
    margin-left: -1px; }
  *[dir="rtl"] .input-group-prepend .btn + .btn, *[dir="rtl"]
  .input-group-prepend .btn + .input-group-text, *[dir="rtl"]
  .input-group-prepend .input-group-text + .input-group-text, *[dir="rtl"]
  .input-group-prepend .input-group-text + .btn, *[dir="rtl"]
  .input-group-append .btn + .btn, *[dir="rtl"]
  .input-group-append .btn + .input-group-text, *[dir="rtl"]
  .input-group-append .input-group-text + .input-group-text, *[dir="rtl"]
  .input-group-append .input-group-text + .btn {
    margin-right: -1px; }

.input-group-prepend {
  white-space: nowrap;
  vertical-align: middle; }
  html:not([dir="rtl"]) .input-group-prepend {
    margin-right: -1px; }
  *[dir="rtl"] .input-group-prepend {
    margin-left: -1px; }

.input-group-append {
  white-space: nowrap;
  vertical-align: middle; }
  html:not([dir="rtl"]) .input-group-append {
    margin-left: -1px; }
  *[dir="rtl"] .input-group-append {
    margin-right: -1px; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  white-space: nowrap;
  border: 1px solid;
  border-radius: 0.25rem;
  color: #768192;
  background-color: #ebedef;
  border-color: #d8dbe0; }
  .input-group-text input[type="radio"],
  .input-group-text input[type="checkbox"] {
    margin-top: 0; }

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px); }

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px); }

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.76562rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

html:not([dir="rtl"]) .input-group-lg > .custom-select, html:not([dir="rtl"])
.input-group-sm > .custom-select {
  padding-right: 1.75rem; }

*[dir="rtl"] .input-group-lg > .custom-select, *[dir="rtl"]
.input-group-sm > .custom-select {
  padding-left: 1.75rem; }

html:not([dir="rtl"]) .input-group > .input-group-prepend > .btn, html:not([dir="rtl"])
.input-group > .input-group-prepend > .input-group-text, html:not([dir="rtl"])
.input-group > .input-group-append:not(:last-child) > .btn, html:not([dir="rtl"])
.input-group > .input-group-append:not(:last-child) > .input-group-text, html:not([dir="rtl"])
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle), html:not([dir="rtl"])
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

*[dir="rtl"] .input-group > .input-group-prepend > .btn, *[dir="rtl"]
.input-group > .input-group-prepend > .input-group-text, *[dir="rtl"]
.input-group > .input-group-append:not(:last-child) > .btn, *[dir="rtl"]
.input-group > .input-group-append:not(:last-child) > .input-group-text, *[dir="rtl"]
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle), *[dir="rtl"]
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

html:not([dir="rtl"]) .input-group > .input-group-append > .btn, html:not([dir="rtl"])
.input-group > .input-group-append > .input-group-text, html:not([dir="rtl"])
.input-group > .input-group-prepend:not(:first-child) > .btn, html:not([dir="rtl"])
.input-group > .input-group-prepend:not(:first-child) > .input-group-text, html:not([dir="rtl"])
.input-group > .input-group-prepend:first-child > .btn:not(:first-child), html:not([dir="rtl"])
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

*[dir="rtl"] .input-group > .input-group-append > .btn, *[dir="rtl"]
.input-group > .input-group-append > .input-group-text, *[dir="rtl"]
.input-group > .input-group-prepend:not(:first-child) > .btn, *[dir="rtl"]
.input-group > .input-group-prepend:not(:first-child) > .input-group-text, *[dir="rtl"]
.input-group > .input-group-prepend:first-child > .btn:not(:first-child), *[dir="rtl"]
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: #ebedef;
  border: 1px solid #c4c9d0;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 90%;
  color: #8a93a2; }

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  border-radius: 0.3rem;
  background-color: #d8dbe0; }
  @media (min-width: 576px) {
    .jumbotron {
      padding: 4rem 2rem; } }

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0; }

.list-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  border-radius: 0.25rem; }
  html:not([dir="rtl"]) .list-group {
    padding-left: 0; }
  *[dir="rtl"] .list-group {
    padding-right: 0; }

.list-group-item-action {
  width: 100%;
  text-align: inherit;
  color: #768192; }
  .list-group-item-action:hover, .list-group-item-action:focus {
    z-index: 1;
    text-decoration: none;
    color: #768192;
    background-color: #ebedef; }
  .list-group-item-action:active {
    color: #3c4b64;
    background-color: #d8dbe0; }

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  border: 1px solid;
  background-color: inherit;
  border-color: rgba(0, 0, 21, 0.125); }
  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit; }
  .list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit; }
  .list-group-item.disabled, .list-group-item:disabled {
    pointer-events: none;
    color: #8a93a2;
    background-color: inherit; }
  .list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #321fdb;
    border-color: #321fdb; }
  .list-group-item + .list-group-item {
    border-top-width: 0; }
    .list-group-item + .list-group-item.active {
      margin-top: -1px;
      border-top-width: 1px; }

.list-group-horizontal {
  flex-direction: row; }
  .list-group-horizontal .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0; }
  .list-group-horizontal .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0; }
  .list-group-horizontal .list-group-item.active {
    margin-top: 0; }
  .list-group-horizontal .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0; }
    .list-group-horizontal .list-group-item + .list-group-item.active {
      margin-left: -1px;
      border-left-width: 1px; }

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row; }
    .list-group-horizontal-sm .list-group-item:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-right-radius: 0; }
    .list-group-horizontal-sm .list-group-item:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-sm .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-sm .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-sm .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row; }
    .list-group-horizontal-md .list-group-item:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-right-radius: 0; }
    .list-group-horizontal-md .list-group-item:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-md .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-md .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-md .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row; }
    .list-group-horizontal-lg .list-group-item:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-right-radius: 0; }
    .list-group-horizontal-lg .list-group-item:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-lg .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-lg .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-lg .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row; }
    .list-group-horizontal-xl .list-group-item:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-right-radius: 0; }
    .list-group-horizontal-xl .list-group-item:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xl .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xl .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-xl .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row; }
    .list-group-horizontal-xxl .list-group-item:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-right-radius: 0; }
    .list-group-horizontal-xxl .list-group-item:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xxl .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xxl .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-xxl .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

.list-group-flush {
  border-radius: 0; }
  .list-group-flush > .list-group-item {
    border-width: 0 0 1px; }
    .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0; }

.list-group-item-primary {
  color: #1a107c;
  background-color: #c6c0f5; }
  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
    color: #1a107c;
    background-color: #b2aaf2; }
  .list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #1a107c;
    border-color: #1a107c; }

.list-group-item-secondary {
  color: #6b6d7a;
  background-color: #f1f2f4; }
  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
    color: #6b6d7a;
    background-color: #e3e5e9; }
  .list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #6b6d7a;
    border-color: #6b6d7a; }

.list-group-item-success {
  color: #18603a;
  background-color: #c4ebd1; }
  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
    color: #18603a;
    background-color: #b1e5c2; }
  .list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #18603a;
    border-color: #18603a; }

.list-group-item-info {
  color: #1b508f;
  background-color: #c6e2ff; }
  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
    color: #1b508f;
    background-color: #add5ff; }
  .list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #1b508f;
    border-color: #1b508f; }

.list-group-item-warning {
  color: #815c15;
  background-color: #fde9bd; }
  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
    color: #815c15;
    background-color: #fce1a4; }
  .list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #815c15;
    border-color: #815c15; }

.list-group-item-danger {
  color: #772b35;
  background-color: #f8cfcf; }
  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
    color: #772b35;
    background-color: #f5b9b9; }
  .list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #772b35;
    border-color: #772b35; }

.list-group-item-light {
  color: #7a7b86;
  background-color: #f9fafb; }
  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
    color: #7a7b86;
    background-color: #eaedf1; }
  .list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #7a7b86;
    border-color: #7a7b86; }

.list-group-item-dark {
  color: #333a4e;
  background-color: #d3d7dc; }
  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
    color: #333a4e;
    background-color: #c5cad1; }
  .list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #333a4e;
    border-color: #333a4e; }

.list-group-accent .list-group-item {
  margin-bottom: 1px;
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-radius: 0; }
  .list-group-accent .list-group-item.list-group-item-divider {
    position: relative; }
    .list-group-accent .list-group-item.list-group-item-divider::before {
      position: absolute;
      bottom: -1px;
      width: 90%;
      height: 1px;
      content: "";
      background-color: rgba(0, 0, 21, 0.125); }
      html:not([dir="rtl"]) .list-group-accent .list-group-item.list-group-item-divider::before {
        left: 5%; }
      *[dir="rtl"] .list-group-accent .list-group-item.list-group-item-divider::before {
        right: 5%; }

.list-group-accent .list-group-item-accent-primary {
  border-left: 4px solid #321fdb; }

.list-group-accent .list-group-item-accent-secondary {
  border-left: 4px solid #ced2d8; }

.list-group-accent .list-group-item-accent-success {
  border-left: 4px solid #2eb85c; }

.list-group-accent .list-group-item-accent-info {
  border-left: 4px solid #39f; }

.list-group-accent .list-group-item-accent-warning {
  border-left: 4px solid #f9b115; }

.list-group-accent .list-group-item-accent-danger {
  border-left: 4px solid #e55353; }

.list-group-accent .list-group-item-accent-light {
  border-left: 4px solid #ebedef; }

.list-group-accent .list-group-item-accent-dark {
  border-left: 4px solid #636f83; }

.media {
  display: flex;
  align-items: flex-start; }

.media-body {
  flex: 1 1; }

.modal-open {
  overflow: hidden; }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto; }

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -50px); }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: none; }
  .modal.modal-static .modal-dialog {
    transform: scale(1.02); }

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem); }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 1rem);
    overflow: hidden; }
  .modal-dialog-scrollable .modal-header,
  .modal-dialog-scrollable .modal-footer {
    flex-shrink: 0; }
  .modal-dialog-scrollable .modal-body {
    overflow-y: auto; }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem); }
  .modal-dialog-centered::before {
    display: block;
    height: calc(100vh - 1rem);
    height: min-content;
    content: ""; }
  .modal-dialog-centered.modal-dialog-scrollable {
    flex-direction: column;
    justify-content: center;
    height: 100%; }
    .modal-dialog-centered.modal-dialog-scrollable .modal-content {
      max-height: none; }
    .modal-dialog-centered.modal-dialog-scrollable::before {
      content: none; }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-clip: padding-box;
  border: 1px solid;
  border-radius: 0.3rem;
  outline: 0;
  background-color: #fff;
  border-color: rgba(0, 0, 21, 0.2); }

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000015; }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: 0.5; }

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  border-color: #d8dbe0; }
  .modal-header .close {
    padding: 1rem 1rem; }
    html:not([dir="rtl"]) .modal-header .close {
      margin: -1rem -1rem -1rem auto; }
    *[dir="rtl"] .modal-header .close {
      margin: -1rem auto -1rem -1rem; }

.modal-title {
  margin-bottom: 0;
  line-height: 1.5; }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem; }

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
  border-color: #d8dbe0; }
  .modal-footer > * {
    margin: 0.25rem; }

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll; }

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto; }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem); }
    .modal-dialog-scrollable .modal-content {
      max-height: calc(100vh - 3.5rem); }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem); }
    .modal-dialog-centered::before {
      height: calc(100vh - 3.5rem);
      height: min-content; }
  .modal-sm {
    max-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px; } }

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px; } }

.modal-primary .modal-content {
  border-color: #321fdb; }

.modal-primary .modal-header {
  color: #fff;
  background-color: #321fdb; }

.modal-secondary .modal-content {
  border-color: #ced2d8; }

.modal-secondary .modal-header {
  color: #fff;
  background-color: #ced2d8; }

.modal-success .modal-content {
  border-color: #2eb85c; }

.modal-success .modal-header {
  color: #fff;
  background-color: #2eb85c; }

.modal-info .modal-content {
  border-color: #39f; }

.modal-info .modal-header {
  color: #fff;
  background-color: #39f; }

.modal-warning .modal-content {
  border-color: #f9b115; }

.modal-warning .modal-header {
  color: #fff;
  background-color: #f9b115; }

.modal-danger .modal-content {
  border-color: #e55353; }

.modal-danger .modal-header {
  color: #fff;
  background-color: #e55353; }

.modal-light .modal-content {
  border-color: #ebedef; }

.modal-light .modal-header {
  color: #fff;
  background-color: #ebedef; }

.modal-dark .modal-content {
  border-color: #636f83; }

.modal-dark .modal-header {
  color: #fff;
  background-color: #636f83; }

.nav {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  list-style: none; }
  html:not([dir="rtl"]) .nav {
    padding-left: 0; }
  *[dir="rtl"] .nav {
    padding-right: 0; }

.nav-link {
  display: block;
  padding: 0.5rem 1rem; }
  .nav-link:hover, .nav-link:focus {
    text-decoration: none; }
  .nav-link.disabled {
    color: #8a93a2;
    pointer-events: none;
    cursor: default;
    color: #8a93a2; }

.nav-tabs {
  border-bottom: 1px solid;
  border-color: #c4c9d0; }
  .nav-tabs .nav-item {
    margin-bottom: -1px; }
  .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem; }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      border-color: #d8dbe0 #d8dbe0 #c4c9d0; }
    .nav-tabs .nav-link.disabled {
      background-color: transparent;
      border-color: transparent;
      color: #8a93a2; }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    background-color: #ebedef;
    border-color: #c4c9d0 #c4c9d0 #ebedef; }
  .nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-tabs-boxed .nav-tabs {
  border: 0; }
  .nav-tabs-boxed .nav-tabs .nav-link.active {
    background-color: #fff;
    border-bottom-color: #fff; }

.nav-tabs-boxed .tab-content {
  padding: 0.75rem 1.25rem;
  border: 1px solid;
  border-radius: 0 0.25rem 0.25rem 0.25rem;
  color: #768192;
  background-color: #fff;
  border-color: #d8dbe0; }

.nav-tabs-boxed.nav-tabs-boxed-top-right .nav-tabs {
  justify-content: flex-end; }

.nav-tabs-boxed.nav-tabs-boxed-top-right .tab-content {
  border-radius: 0.25rem 0 0.25rem 0.25rem; }

.nav-tabs-boxed.nav-tabs-boxed-left, .nav-tabs-boxed.nav-tabs-boxed-right {
  display: flex; }
  .nav-tabs-boxed.nav-tabs-boxed-left .nav-item, .nav-tabs-boxed.nav-tabs-boxed-right .nav-item {
    z-index: 1;
    flex-grow: 1;
    margin-bottom: 0; }

*[dir="rtl"] .nav-tabs-boxed.nav-tabs-boxed-left {
  flex-direction: row-reverse; }

.nav-tabs-boxed.nav-tabs-boxed-left .nav-item {
  margin-right: -1px; }

.nav-tabs-boxed.nav-tabs-boxed-left .nav-link {
  border-radius: 0.25rem 0 0 0.25rem; }
  .nav-tabs-boxed.nav-tabs-boxed-left .nav-link.active {
    border-color: #d8dbe0 #fff #d8dbe0 #d8dbe0; }

html:not([dir="rtl"]) .nav-tabs-boxed.nav-tabs-boxed-right {
  flex-direction: row-reverse; }

*[dir="rtl"] .nav-tabs-boxed.nav-tabs-boxed-right {
  flex-direction: row; }

html:not([dir="rtl"]) .nav-tabs-boxed.nav-tabs-boxed-right .nav-item {
  margin-left: -1px; }

*[dir="rtl"] .nav-tabs-boxed.nav-tabs-boxed-right .nav-item {
  margin-right: -1px; }

.nav-tabs-boxed.nav-tabs-boxed-right .nav-link {
  border-radius: 0 0.25rem 0.25rem 0; }
  .nav-tabs-boxed.nav-tabs-boxed-right .nav-link.active {
    border-color: #d8dbe0 #d8dbe0 #d8dbe0 #fff; }

.nav-tabs-boxed.nav-tabs-boxed-right .tab-content {
  border-radius: 0.25rem 0 0.25rem 0.25rem; }

.nav-pills .nav-link {
  border-radius: 0.25rem; }

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #321fdb; }

.nav-underline {
  border-bottom: 2px solid;
  border-color: #c4c9d0; }
  .nav-underline .nav-item {
    margin-bottom: -2px; }
  .nav-underline .nav-link {
    border: 0;
    border-bottom: 2px solid transparent; }
  .nav-underline .nav-link.active,
  .nav-underline .show > .nav-link {
    background: transparent; }

.nav-underline-primary .nav-link.active,
.nav-underline-primary .show > .nav-link {
  color: #321fdb;
  border-color: #321fdb; }

.nav-underline-secondary .nav-link.active,
.nav-underline-secondary .show > .nav-link {
  color: #ced2d8;
  border-color: #ced2d8; }

.nav-underline-success .nav-link.active,
.nav-underline-success .show > .nav-link {
  color: #2eb85c;
  border-color: #2eb85c; }

.nav-underline-info .nav-link.active,
.nav-underline-info .show > .nav-link {
  color: #39f;
  border-color: #39f; }

.nav-underline-warning .nav-link.active,
.nav-underline-warning .show > .nav-link {
  color: #f9b115;
  border-color: #f9b115; }

.nav-underline-danger .nav-link.active,
.nav-underline-danger .show > .nav-link {
  color: #e55353;
  border-color: #e55353; }

.nav-underline-light .nav-link.active,
.nav-underline-light .show > .nav-link {
  color: #ebedef;
  border-color: #ebedef; }

.nav-underline-dark .nav-link.active,
.nav-underline-dark .show > .nav-link {
  color: #636f83;
  border-color: #636f83; }

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.c-sidebar .nav-tabs:first-child .nav-link,
.c-sidebar .c-sidebar-close + .nav-tabs .nav-link {
  display: flex;
  align-items: center;
  height: 56px;
  padding-top: 0;
  padding-bottom: 0; }

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem; }
  .navbar .container,
  .navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl, .navbar .container-xxl {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  display: inline-block;
  padding-top: 0.33594rem;
  padding-bottom: 0.33594rem;
  margin-right: 1rem;
  font-size: 1.09375rem;
  line-height: inherit;
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    text-decoration: none; }

.navbar-nav {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  list-style: none; }
  html:not([dir="rtl"]) .navbar-nav {
    padding-left: 0; }
  *[dir="rtl"] .navbar-nav {
    padding-right: 0; }
  .navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0; }
  .navbar-nav .dropdown-menu {
    position: static;
    float: none; }

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem; }

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center; }

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.09375rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem; }
  .navbar-toggler:hover, .navbar-toggler:focus {
    text-decoration: none; }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%; }

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl, .navbar-expand-sm > .container-xxl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-sm > .container,
    .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl, .navbar-expand-sm > .container-xxl {
      flex-wrap: nowrap; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; } }

@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl, .navbar-expand-md > .container-xxl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-md > .container,
    .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl, .navbar-expand-md > .container-xxl {
      flex-wrap: nowrap; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; } }

@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl, .navbar-expand-lg > .container-xxl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-lg > .container,
    .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl, .navbar-expand-lg > .container-xxl {
      flex-wrap: nowrap; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; } }

@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl, .navbar-expand-xl > .container-xxl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-xl > .container,
    .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl, .navbar-expand-xl > .container-xxl {
      flex-wrap: nowrap; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; } }

@media (max-width: 1399.98px) {
  .navbar-expand-xxl > .container,
  .navbar-expand-xxl > .container-fluid, .navbar-expand-xxl > .container-sm, .navbar-expand-xxl > .container-md, .navbar-expand-xxl > .container-lg, .navbar-expand-xxl > .container-xl, .navbar-expand-xxl > .container-xxl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-xxl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-xxl > .container,
    .navbar-expand-xxl > .container-fluid, .navbar-expand-xxl > .container-sm, .navbar-expand-xxl > .container-md, .navbar-expand-xxl > .container-lg, .navbar-expand-xxl > .container-xl, .navbar-expand-xxl > .container-xxl {
      flex-wrap: nowrap; }
    .navbar-expand-xxl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xxl .navbar-toggler {
      display: none; } }

.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl, .navbar-expand > .container-xxl {
    padding-right: 0;
    padding-left: 0; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: 0.5rem;
      padding-left: 0.5rem; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl, .navbar-expand > .container-xxl {
    flex-wrap: nowrap; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }

.navbar.navbar-dark .navbar-brand {
  color: #fff; }
  .navbar.navbar-dark .navbar-brand:hover, .navbar.navbar-dark .navbar-brand:focus {
    color: #fff; }

.navbar.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5); }
  .navbar.navbar-dark .navbar-nav .nav-link:hover, .navbar.navbar-dark .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.75); }
  .navbar.navbar-dark .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25); }

.navbar.navbar-dark .navbar-nav .show > .nav-link,
.navbar.navbar-dark .navbar-nav .active > .nav-link,
.navbar.navbar-dark .navbar-nav .nav-link.show,
.navbar.navbar-dark .navbar-nav .nav-link.active {
  color: #fff; }

.navbar.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1); }

.navbar.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); }

.navbar.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5); }
  .navbar.navbar-dark .navbar-text a {
    color: #fff; }
    .navbar.navbar-dark .navbar-text a:hover, .navbar.navbar-dark .navbar-text a:focus {
      color: #fff; }

.navbar.navbar-light .navbar-brand {
  color: rgba(0, 0, 21, 0.9); }
  .navbar.navbar-light .navbar-brand:hover, .navbar.navbar-light .navbar-brand:focus {
    color: rgba(0, 0, 21, 0.9); }

.navbar.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 21, 0.5); }
  .navbar.navbar-light .navbar-nav .nav-link:hover, .navbar.navbar-light .navbar-nav .nav-link:focus {
    color: rgba(0, 0, 21, 0.7); }
  .navbar.navbar-light .navbar-nav .nav-link.disabled {
    color: rgba(0, 0, 21, 0.3); }

.navbar.navbar-light .navbar-nav .show > .nav-link,
.navbar.navbar-light .navbar-nav .active > .nav-link,
.navbar.navbar-light .navbar-nav .nav-link.show,
.navbar.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 21, 0.9); }

.navbar.navbar-light .navbar-toggler {
  color: rgba(0, 0, 21, 0.5);
  border-color: rgba(0, 0, 21, 0.1); }

.navbar.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___}); }

.navbar.navbar-light .navbar-text {
  color: rgba(0, 0, 21, 0.5); }
  .navbar.navbar-light .navbar-text a {
    color: rgba(0, 0, 21, 0.9); }
    .navbar.navbar-light .navbar-text a:hover, .navbar.navbar-light .navbar-text a:focus {
      color: rgba(0, 0, 21, 0.9); }

.pagination {
  display: flex;
  list-style: none;
  border-radius: 0.25rem; }
  html:not([dir="rtl"]) .pagination {
    padding-left: 0; }
  *[dir="rtl"] .pagination {
    padding-right: 0; }

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  line-height: 1.25;
  border: 1px solid;
  color: #321fdb;
  background-color: #fff;
  border-color: #d8dbe0; }
  html:not([dir="rtl"]) .page-link {
    margin-left: -1px; }
  *[dir="rtl"] .page-link {
    margin-right: -1px; }
  .page-link:hover {
    z-index: 2;
    text-decoration: none;
    color: #231698;
    background-color: #d8dbe0;
    border-color: #c4c9d0; }
  .page-link:focus {
    z-index: 3;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25); }

html:not([dir="rtl"]) .page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem; }

*[dir="rtl"] .page-item:first-child .page-link {
  margin-right: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem; }

html:not([dir="rtl"]) .page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem; }

*[dir="rtl"] .page-item:last-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem; }

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #321fdb;
  border-color: #321fdb; }

.page-item.disabled .page-link {
  pointer-events: none;
  cursor: auto;
  color: #8a93a2;
  background-color: #fff;
  border-color: #c4c9d0; }

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.09375rem;
  line-height: 1.5; }

html:not([dir="rtl"]) .pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem; }

*[dir="rtl"] .pagination-lg .page-item:first-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem; }

html:not([dir="rtl"]) .pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem; }

*[dir="rtl"] .pagination-lg .page-item:last-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem; }

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.76562rem;
  line-height: 1.5; }

html:not([dir="rtl"]) .pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem; }

*[dir="rtl"] .pagination-sm .page-item:first-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem; }

html:not([dir="rtl"]) .pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem; }

*[dir="rtl"] .pagination-sm .page-item:last-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem; }

.popover {
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.76562rem;
  word-wrap: break-word;
  background-clip: padding-box;
  border: 1px solid;
  border-radius: 0.3rem;
  background-color: #fff;
  border-color: rgba(0, 0, 21, 0.2); }
  .popover .popover-arrow {
    position: absolute;
    display: block; }
    .popover .popover-arrow::before, .popover .popover-arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid; }

.popover[data-popper-placement^="top"] .popover-arrow,
.popover[data-popper-placement^="bottom"] .popover-arrow {
  width: 1.6rem;
  height: 0.5rem;
  padding: 0 0.3rem; }

.popover[data-popper-placement^="right"] .popover-arrow,
.popover[data-popper-placement^="left"] .popover-arrow {
  width: 0.5rem;
  height: 1.6rem;
  padding: 0.3rem 0;
  margin: 0; }

.popover[data-popper-placement^="top"] {
  margin-bottom: 0.5rem !important; }
  .popover[data-popper-placement^="top"] > .popover-arrow {
    bottom: calc(-0.5rem - 1px); }
    .popover[data-popper-placement^="top"] > .popover-arrow::before {
      bottom: 0;
      border-width: 0.5rem 0.5rem 0;
      border-top-color: rgba(0, 0, 21, 0.25); }
    .popover[data-popper-placement^="top"] > .popover-arrow::after {
      bottom: 1px;
      border-width: 0.5rem 0.5rem 0;
      border-top-color: #fff; }

.popover[data-popper-placement^="right"] {
  margin-left: 0.5rem !important; }
  .popover[data-popper-placement^="right"] > .popover-arrow {
    left: calc(-0.5rem - 1px); }
    .popover[data-popper-placement^="right"] > .popover-arrow::before {
      left: 0;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: rgba(0, 0, 21, 0.25); }
    .popover[data-popper-placement^="right"] > .popover-arrow::after {
      left: 1px;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: #fff; }

.popover[data-popper-placement^="bottom"] {
  margin-top: 0.5rem !important; }
  .popover[data-popper-placement^="bottom"] > .popover-arrow {
    top: calc(-0.5rem - 1px); }
    .popover[data-popper-placement^="bottom"] > .popover-arrow::before {
      top: 0;
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: rgba(0, 0, 21, 0.25); }
    .popover[data-popper-placement^="bottom"] > .popover-arrow::after {
      top: 1px;
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: #fff; }
  .popover[data-popper-placement^="bottom"] .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: 1rem;
    margin-left: -0.5rem;
    content: "";
    border-bottom: 1px solid;
    border-bottom-color: #f7f7f7; }

.popover[data-popper-placement^="left"] {
  margin-left: 0.5rem !important; }
  .popover[data-popper-placement^="left"] > .popover-arrow {
    right: calc(-0.5rem - 1px); }
    .popover[data-popper-placement^="left"] > .popover-arrow::before {
      right: 0;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: rgba(0, 0, 21, 0.25); }
    .popover[data-popper-placement^="left"] > .popover-arrow::after {
      right: 1px;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: #fff; }

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  border-bottom: 1px solid;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  background-color: #f7f7f7;
  border-bottom-color: #ebebeb; }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #3c4b64; }

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0; }
  to {
    background-position: 0 0; } }

.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.65625rem;
  border-radius: 0.25rem;
  background-color: #ebedef; }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  transition: width 0.6s ease;
  color: #fff;
  background-color: #321fdb; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem; }

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
      animation: none; } }

.progress-xs {
  height: 4px; }

.progress-sm {
  height: 8px; }

.progress.progress-white {
  background-color: rgba(255, 255, 255, 0.2); }
  .progress.progress-white .progress-bar {
    background-color: #fff; }

.progress-group {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem; }

.progress-group-prepend {
  flex: 0 0 100px;
  align-self: center; }

.progress-group-icon {
  font-size: 1.09375rem; }
  html:not([dir="rtl"]) .progress-group-icon {
    margin: 0 1rem 0 0.25rem; }
  *[dir="rtl"] .progress-group-icon {
    margin: 0 0.25rem 0 1rem; }

.progress-group-text {
  font-size: 0.76562rem;
  color: #768192; }

.progress-group-header {
  display: flex;
  flex-basis: 100%;
  align-items: flex-end;
  margin-bottom: 0.25rem; }

.progress-group-bars {
  flex-grow: 1;
  align-self: center; }
  .progress-group-bars .progress:not(:last-child) {
    margin-bottom: 2px; }

.progress-group-header + .progress-group-bars {
  flex-basis: 100%; }

.c-sidebar {
  position: relative;
  display: flex;
  flex: 0 0 256px;
  flex-direction: column;
  order: -1;
  width: 256px;
  padding: 0;
  box-shadow: none; }
  .c-sidebar.c-sidebar-right {
    order: 99; }
  @media (max-width: 991.98px) {
    .c-sidebar {
      --is-mobile: true;
      position: fixed;
      top: 0;
      bottom: 0;
      z-index: 1031; }
      html:not([dir="rtl"]) .c-sidebar:not(.c-sidebar-right) {
        left: 0; }
      html:not([dir="rtl"]) .c-sidebar.c-sidebar-right {
        right: 0; }
      *[dir="rtl"] .c-sidebar:not(.c-sidebar-right) {
        right: 0; }
      *[dir="rtl"] .c-sidebar.c-sidebar-right {
        left: 0; } }
  html:not([dir="rtl"]) .c-sidebar:not(.c-sidebar-right) {
    margin-left: -256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-right {
    margin-right: -256px; }
  *[dir="rtl"] .c-sidebar:not(.c-sidebar-right) {
    margin-right: -256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-right {
    margin-left: -256px; }
  .c-sidebar[class*="bg-"] {
    border-color: rgba(0, 0, 21, 0.1); }
  .c-sidebar.c-sidebar-sm {
    flex: 0 0 192px;
    width: 192px; }
    html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm:not(.c-sidebar-right) {
      margin-left: -192px; }
    html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm.c-sidebar-right {
      margin-right: -192px; }
    *[dir="rtl"] .c-sidebar.c-sidebar-sm:not(.c-sidebar-right) {
      margin-right: -192px; }
    *[dir="rtl"] .c-sidebar.c-sidebar-sm.c-sidebar-right {
      margin-left: -192px; }
  .c-sidebar.c-sidebar-lg {
    flex: 0 0 320px;
    width: 320px; }
    html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg:not(.c-sidebar-right) {
      margin-left: -320px; }
    html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg.c-sidebar-right {
      margin-right: -320px; }
    *[dir="rtl"] .c-sidebar.c-sidebar-lg:not(.c-sidebar-right) {
      margin-right: -320px; }
    *[dir="rtl"] .c-sidebar.c-sidebar-lg.c-sidebar-right {
      margin-left: -320px; }
  .c-sidebar.c-sidebar-xl {
    flex: 0 0 384px;
    width: 384px; }
    html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl:not(.c-sidebar-right) {
      margin-left: -384px; }
    html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl.c-sidebar-right {
      margin-right: -384px; }
    *[dir="rtl"] .c-sidebar.c-sidebar-xl:not(.c-sidebar-right) {
      margin-right: -384px; }
    *[dir="rtl"] .c-sidebar.c-sidebar-xl.c-sidebar-right {
      margin-left: -384px; }
  @media (min-width: 992px) {
    .c-sidebar.c-sidebar-fixed {
      position: fixed;
      top: 0;
      bottom: 0;
      z-index: 1030; }
      html:not([dir="rtl"]) .c-sidebar.c-sidebar-fixed:not(.c-sidebar-right) {
        left: 0; }
      html:not([dir="rtl"]) .c-sidebar.c-sidebar-fixed.c-sidebar-right {
        right: 0; }
      *[dir="rtl"] .c-sidebar.c-sidebar-fixed:not(.c-sidebar-right) {
        right: 0; }
      *[dir="rtl"] .c-sidebar.c-sidebar-fixed.c-sidebar-right {
        left: 0; } }
  .c-sidebar.c-sidebar-overlaid {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1032; }
    html:not([dir="rtl"]) .c-sidebar.c-sidebar-overlaid:not(.c-sidebar-right) {
      left: 0; }
    html:not([dir="rtl"]) .c-sidebar.c-sidebar-overlaid.c-sidebar-right {
      right: 0; }
    *[dir="rtl"] .c-sidebar.c-sidebar-overlaid:not(.c-sidebar-right) {
      right: 0; }
    *[dir="rtl"] .c-sidebar.c-sidebar-overlaid.c-sidebar-right {
      left: 0; }

.c-sidebar-close {
  position: absolute;
  width: 56px;
  height: 56px;
  background: transparent;
  border: 0; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .c-sidebar-close:hover {
      text-decoration: none; } }
  .c-sidebar-close:focus, .c-sidebar-close.focus {
    outline: 0; }
  html:not([dir="rtl"]) .c-sidebar-close {
    right: 0; }
  *[dir="rtl"] .c-sidebar-close {
    left: 0; }

.c-sidebar-brand {
  display: flex;
  flex: 0 0 56px;
  align-items: center;
  justify-content: center; }
  .c-sidebar-brand .c-sidebar-brand-minimized {
    display: none; }

.c-sidebar-header {
  flex: 0 0 auto;
  padding: 0.75rem 1rem;
  text-align: center;
  transition: 0.3s; }

.c-sidebar-nav {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 0;
  margin-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none; }
  .c-sidebar-nav.ps {
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none; }
    .c-sidebar-nav.ps::-webkit-scrollbar {
      width: 0 !important; }

.c-sidebar-nav-title {
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  font-size: 80%;
  font-weight: 700;
  text-transform: uppercase;
  transition: 0.3s; }

.c-sidebar-nav-divider {
  height: 10px;
  transition: height 0.3s; }

.c-sidebar-nav-item {
  width: inherit; }

.c-sidebar-nav-link, .c-sidebar-nav-dropdown-toggle {
  display: flex;
  flex: 1 1;
  align-items: center;
  padding: 0.8445rem 1rem;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.3s, color 0.3s; }
  html:not([dir="rtl"]) .c-sidebar-nav-link .badge, html:not([dir="rtl"]) .c-sidebar-nav-dropdown-toggle .badge {
    margin-left: auto; }
  *[dir="rtl"] .c-sidebar-nav-link .badge, *[dir="rtl"] .c-sidebar-nav-dropdown-toggle .badge {
    margin-right: auto; }
  .c-sidebar-nav-link.c-disabled, .c-disabled.c-sidebar-nav-dropdown-toggle {
    cursor: default; }
  @media (hover: hover), (-ms-high-contrast: none) {
    .c-sidebar-nav-link:hover, .c-sidebar-nav-dropdown-toggle:hover {
      text-decoration: none; } }

.c-sidebar-nav-icon {
  flex: 0 0 56px;
  height: 1.09375rem;
  font-size: 1.09375rem;
  text-align: center;
  transition: 0.3s;
  fill: currentColor; }
  html:not([dir="rtl"]) .c-sidebar-nav-icon:first-child {
    margin-left: -1rem; }
  *[dir="rtl"] .c-sidebar-nav-icon:first-child {
    margin-right: -1rem; }

.c-sidebar-nav-dropdown {
  position: relative;
  transition: background 0.3s ease-in-out; }
  .c-sidebar-nav-dropdown.c-show > .c-sidebar-nav-dropdown-items {
    max-height: 1500px; }
  html:not([dir="rtl"]) .c-sidebar-nav-dropdown.c-show > .c-sidebar-nav-dropdown-toggle::after {
    transform: rotate(-90deg); }
  *[dir="rtl"] .c-sidebar-nav-dropdown.c-show > .c-sidebar-nav-dropdown-toggle::after {
    transform: rotate(270deg); }
  .c-sidebar-nav-dropdown.c-show + .c-sidebar-nav-dropdown.c-show {
    margin-top: 1px; }

.c-sidebar-nav-dropdown-toggle {
  cursor: pointer; }
  .c-sidebar-nav-dropdown-toggle::after {
    display: block;
    flex: 0 1 8px;
    height: 8px;
    content: "";
    background-repeat: no-repeat;
    background-position: center;
    transition: transform 0.3s; }
    html:not([dir="rtl"]) .c-sidebar-nav-dropdown-toggle::after {
      margin-left: auto; }
    *[dir="rtl"] .c-sidebar-nav-dropdown-toggle::after {
      margin-right: auto;
      transform: rotate(180deg); }
  html:not([dir="rtl"]) .c-sidebar-nav-dropdown-toggle .badge {
    margin-right: 1rem; }
  *[dir="rtl"] .c-sidebar-nav-dropdown-toggle .badge {
    margin-left: 1rem; }

.c-sidebar-nav-dropdown-items {
  max-height: 0;
  padding: 0;
  overflow-y: hidden;
  list-style: none;
  transition: max-height 0.3s ease-in-out; }
  html:not([dir="rtl"]) .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, html:not([dir="rtl"]) .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
    padding-left: 56px; }
  *[dir="rtl"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, *[dir="rtl"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
    padding-right: 56px; }
  html:not([dir="rtl"]) .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, html:not([dir="rtl"]) .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    margin-left: -56px; }
  *[dir="rtl"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, *[dir="rtl"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    margin-right: -56px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-left: 64px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-right: 64px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-left: -56px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-right: -56px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-left: 72px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-right: 72px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-left: -56px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-right: -56px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-left: 80px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-right: 80px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-left: -56px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-right: -56px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-left: 88px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-right: 88px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-left: -56px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-right: -56px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-left: 96px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
  padding-right: 96px; }

html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, html:not([dir="rtl"]) .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-left: -56px; }

*[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-link .c-sidebar-nav-icon, *[dir="rtl"] .c-sidebar-nav[data-indentation="true"] .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
  margin-right: -56px; }

.c-sidebar-nav-label {
  display: flex;
  padding: 0.21113rem 1rem;
  transition: 0.3s; }
  .c-sidebar-nav-label:hover {
    text-decoration: none; }
  .c-sidebar-nav-label .c-sidebar-nav-icon {
    margin-top: 1px; }

.c-sidebar-footer {
  flex: 0 0 auto;
  padding: 0.75rem 1rem;
  transition: 0.3s; }

.c-sidebar-minimizer {
  display: flex;
  flex: 0 0 50px;
  justify-content: flex-end;
  width: inherit;
  padding: 0;
  cursor: pointer;
  border: 0; }
  @media (max-width: 991.98px) {
    .c-sidebar-minimizer {
      display: none; } }
  .c-sidebar-minimizer::before {
    display: block;
    width: 50px;
    height: 50px;
    content: "";
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12.5px;
    transition: 0.3s; }
    *[dir="rtl"] .c-sidebar-minimizer::before {
      transform: rotate(180deg); }
  .c-sidebar-minimizer:focus, .c-sidebar-minimizer.c-focus {
    outline: 0; }
  .c-sidebar-right .c-sidebar-minimizer {
    justify-content: flex-start; }
    html:not([dir="rtl"]) .c-sidebar-right .c-sidebar-minimizer::before {
      transform: rotate(-180deg); }
    *[dir="rtl"] .c-sidebar-right .c-sidebar-minimizer::before {
      transform: rotate(0deg); }

@media (max-width: 991.98px) {
  .c-sidebar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1030;
    width: 100vw;
    height: 100vh;
    background-color: #000015;
    transition: 0.3s; }
    .c-sidebar-backdrop.c-fade {
      opacity: 0; }
    .c-sidebar-backdrop.c-show {
      opacity: 0.5; } }

@media (min-width: 992px) {
  .c-sidebar-minimized {
    z-index: 1031;
    flex: 0 0 56px; }
    .c-sidebar-minimized.c-sidebar-fixed {
      z-index: 1031;
      width: 56px; }
    html:not([dir="rtl"]) .c-sidebar-minimized:not(.c-sidebar-right) {
      margin-left: -56px; }
    *[dir="rtl"] .c-sidebar-minimized:not(.c-sidebar-right) {
      margin-right: -56px; }
    html:not([dir="rtl"]) .c-sidebar-minimized.c-sidebar-right {
      margin-right: -56px; }
    html:not([dir="rtl"]) .c-sidebar-minimized.c-sidebar-right {
      margin-left: -56px; }
    .c-sidebar-minimized .c-sidebar-brand-full {
      display: none; }
    .c-sidebar-minimized .c-sidebar-brand-minimized {
      display: block; }
    .c-sidebar-minimized .c-sidebar-nav {
      padding-bottom: 50px;
      overflow: visible; }
    .c-sidebar-minimized .c-d-minimized-none,
    .c-sidebar-minimized .c-sidebar-nav-divider,
    .c-sidebar-minimized .c-sidebar-nav-label,
    .c-sidebar-minimized .c-sidebar-nav-title,
    .c-sidebar-minimized .c-sidebar-footer,
    .c-sidebar-minimized .c-sidebar-form,
    .c-sidebar-minimized .c-sidebar-header {
      height: 0;
      padding: 0;
      margin: 0;
      visibility: hidden;
      opacity: 0; }
    .c-sidebar-minimized .c-sidebar-minimizer {
      position: fixed;
      bottom: 0;
      width: inherit; }
      html:not([dir="rtl"]) .c-sidebar-minimized .c-sidebar-minimizer::before {
        transform: rotate(-180deg); }
      *[dir="rtl"] .c-sidebar-minimized .c-sidebar-minimizer::before {
        transform: rotate(0deg); }
    html:not([dir="rtl"]) .c-sidebar-minimized.c-sidebar-right .c-sidebar-minimizer::before {
      transform: rotate(0deg); }
    *[dir="rtl"] .c-sidebar-minimized.c-sidebar-right .c-sidebar-minimizer::before {
      transform: rotate(180deg); }
    html:not([dir="rtl"]) .c-sidebar-minimized.c-sidebar-right .c-sidebar-nav > .c-sidebar-nav-item:hover, html:not([dir="rtl"])
    .c-sidebar-minimized.c-sidebar-right .c-sidebar-nav > .c-sidebar-nav-dropdown:hover {
      margin-left: -256px; }
    *[dir="rtl"] .c-sidebar-minimized.c-sidebar-right .c-sidebar-nav > .c-sidebar-nav-item:hover, *[dir="rtl"]
    .c-sidebar-minimized.c-sidebar-right .c-sidebar-nav > .c-sidebar-nav-dropdown:hover {
      margin-right: -256px; }
    .c-sidebar-minimized .c-sidebar-nav-link, .c-sidebar-minimized .c-sidebar-nav-dropdown-toggle,
    .c-sidebar-minimized .c-sidebar-nav-dropdown-toggle {
      overflow: hidden;
      white-space: nowrap;
      border-left: 0; }
      .c-sidebar-minimized .c-sidebar-nav-link:hover, .c-sidebar-minimized .c-sidebar-nav-dropdown-toggle:hover,
      .c-sidebar-minimized .c-sidebar-nav-dropdown-toggle:hover {
        width: 312px; }
    .c-sidebar-minimized .c-sidebar-nav-dropdown-toggle::after {
      display: none; }
    .c-sidebar-minimized .c-sidebar-nav-dropdown-items .c-sidebar-nav-link, .c-sidebar-minimized .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown-toggle {
      width: 256px; }
    .c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown {
      position: relative; }
      .c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown > .c-sidebar-nav-dropdown-items {
        display: none; }
        .c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown > .c-sidebar-nav-dropdown-items .c-sidebar-nav-dropdown:not(.c-show) > .c-sidebar-nav-dropdown-items {
          display: none; }
      .c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown .c-sidebar-nav-dropdown-items {
        max-height: 1500px; }
      .c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown:hover {
        width: 312px;
        overflow: visible; }
        .c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown:hover > .c-sidebar-nav-dropdown-items {
          position: absolute;
          display: inline; }
          html:not([dir="rtl"]) .c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown:hover > .c-sidebar-nav-dropdown-items {
            left: 56px; }
          *[dir="rtl"] .c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown:hover > .c-sidebar-nav-dropdown-items {
            right: 56px; }
    html:not([dir="rtl"]) .c-sidebar-minimized.c-sidebar-right > .c-sidebar-nav-dropdown:hover > .c-sidebar-nav-dropdown-items {
      left: 0; }
    *[dir="rtl"] .c-sidebar-minimized.c-sidebar-right > .c-sidebar-nav-dropdown:hover > .c-sidebar-nav-dropdown-items {
      right: 0; } }

html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right), html:not([dir="rtl"])
.c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
  margin-left: 0; }

*[dir="rtl"] .c-sidebar.c-sidebar-show:not(.c-sidebar-right), *[dir="rtl"]
.c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
  margin-right: 0; }

@media (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; } }

html:not([dir="rtl"]) .c-sidebar.c-sidebar-show.c-sidebar-right, html:not([dir="rtl"])
.c-sidebar.c-sidebar-show.c-sidebar-right {
  margin-right: 0; }

*[dir="rtl"] .c-sidebar.c-sidebar-show.c-sidebar-right, *[dir="rtl"]
.c-sidebar.c-sidebar-show.c-sidebar-right {
  margin-left: 0; }

@media (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; } }

@media (min-width: 576px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right), html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-left: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right), *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-right: 0; } }

@media (min-width: 576px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; } }

@media (min-width: 576px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show.c-sidebar-right, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-right: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show.c-sidebar-right, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-left: 0; } }

@media (min-width: 576px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-sm-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; } }

@media (min-width: 768px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right), html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-left: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right), *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-right: 0; } }

@media (min-width: 768px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; } }

@media (min-width: 768px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show.c-sidebar-right, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-right: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show.c-sidebar-right, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-left: 0; } }

@media (min-width: 768px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-md-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; } }

@media (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right), html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-left: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right), *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-right: 0; } }

@media (min-width: 992px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; } }

@media (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show.c-sidebar-right, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-right: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show.c-sidebar-right, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-left: 0; } }

@media (min-width: 992px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-lg-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; } }

@media (min-width: 1200px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right), html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-left: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right), *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-right: 0; } }

@media (min-width: 1200px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; } }

@media (min-width: 1200px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show.c-sidebar-right, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-right: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show.c-sidebar-right, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-left: 0; } }

@media (min-width: 1200px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; } }

@media (min-width: 1400px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right), html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-left: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right), *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    margin-right: 0; } }

@media (min-width: 1400px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; } }

@media (min-width: 1400px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show.c-sidebar-right, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-right: 0; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show.c-sidebar-right, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right {
    margin-left: 0; } }

@media (min-width: 1400px) and (min-width: 992px) {
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-right: 256px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed ~ .c-wrapper {
    margin-left: 256px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-right: 192px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-sm ~ .c-wrapper {
    margin-left: 192px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-right: 320px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-lg ~ .c-wrapper {
    margin-left: 320px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-right: 384px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-xl ~ .c-wrapper {
    margin-left: 384px; }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, html:not([dir="rtl"])
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-right: 56px; }
  *[dir="rtl"] .c-sidebar.c-sidebar-xxl-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper, *[dir="rtl"]
  .c-sidebar.c-sidebar-show.c-sidebar-right.c-sidebar-fixed.c-sidebar-minimized ~ .c-wrapper {
    margin-left: 56px; } }

.c-sidebar {
  color: #fff;
  background: #3c4b64; }
  *[dir="rtl"] .c-sidebar.c-sidebar-right {
    border: 0; }
  .c-sidebar .c-sidebar-close {
    color: #fff; }
  .c-sidebar .c-sidebar-brand {
    color: #fff;
    background: rgba(0, 0, 21, 0.2); }
  .c-sidebar .c-sidebar-header {
    background: rgba(0, 0, 21, 0.2); }
  .c-sidebar .c-sidebar-form .c-form-control {
    color: #fff;
    background: rgba(0, 0, 21, 0.1);
    border: 0; }
    .c-sidebar .c-sidebar-form .c-form-control::placeholder {
      color: rgba(255, 255, 255, 0.7); }
  .c-sidebar .c-sidebar-nav-title {
    color: rgba(255, 255, 255, 0.6); }
  .c-sidebar .c-sidebar-nav-link, .c-sidebar .c-sidebar-nav-dropdown-toggle {
    color: rgba(255, 255, 255, 0.8);
    background: transparent; }
    .c-sidebar .c-sidebar-nav-link .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
      color: rgba(255, 255, 255, 0.5); }
    .c-sidebar .c-sidebar-nav-link.c-active, .c-sidebar .c-active.c-sidebar-nav-dropdown-toggle {
      color: #fff;
      background: rgba(255, 255, 255, 0.05); }
      .c-sidebar .c-sidebar-nav-link.c-active .c-sidebar-nav-icon, .c-sidebar .c-active.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
        color: #fff; }
    .c-sidebar .c-sidebar-nav-link:focus, .c-sidebar .c-sidebar-nav-dropdown-toggle:focus {
      outline: none; }
    @media (hover: hover), (-ms-high-contrast: none) {
      .c-sidebar .c-sidebar-nav-link:hover, .c-sidebar .c-sidebar-nav-dropdown-toggle:hover {
        color: #fff;
        background: #321fdb; }
        .c-sidebar .c-sidebar-nav-link:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
          color: #fff; }
        .c-sidebar .c-sidebar-nav-link:hover.c-sidebar-nav-dropdown-toggle::after, .c-sidebar :hover.c-sidebar-nav-dropdown-toggle::after {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); } }
    .c-sidebar .c-sidebar-nav-link.c-disabled, .c-sidebar .c-disabled.c-sidebar-nav-dropdown-toggle {
      color: #b3b3b3;
      background: transparent; }
      .c-sidebar .c-sidebar-nav-link.c-disabled .c-sidebar-nav-icon, .c-sidebar .c-disabled.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
        color: rgba(255, 255, 255, 0.5); }
      .c-sidebar .c-sidebar-nav-link.c-disabled:hover, .c-sidebar .c-disabled.c-sidebar-nav-dropdown-toggle:hover {
        color: #b3b3b3; }
        .c-sidebar .c-sidebar-nav-link.c-disabled:hover .c-sidebar-nav-icon, .c-sidebar .c-disabled.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
          color: rgba(255, 255, 255, 0.5); }
        .c-sidebar .c-sidebar-nav-link.c-disabled:hover.c-sidebar-nav-dropdown-toggle::after, .c-sidebar .c-disabled:hover.c-sidebar-nav-dropdown-toggle::after {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); }
  .c-sidebar .c-sidebar-nav-dropdown-toggle {
    position: relative; }
    .c-sidebar .c-sidebar-nav-dropdown-toggle::after {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___}); }
  .c-sidebar .c-sidebar-nav-dropdown.c-show {
    background: rgba(0, 0, 0, 0.2); }
    .c-sidebar .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link, .c-sidebar .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-dropdown-toggle {
      color: #fff; }
      .c-sidebar .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link.c-disabled, .c-sidebar .c-sidebar-nav-dropdown.c-show .c-disabled.c-sidebar-nav-dropdown-toggle {
        color: #b3b3b3;
        background: transparent; }
        .c-sidebar .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link.c-disabled:hover, .c-sidebar .c-sidebar-nav-dropdown.c-show .c-disabled.c-sidebar-nav-dropdown-toggle:hover {
          color: #b3b3b3; }
          .c-sidebar .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link.c-disabled:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-dropdown.c-show .c-disabled.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
            color: rgba(255, 255, 255, 0.5); }
  .c-sidebar .c-sidebar-nav-label {
    color: rgba(255, 255, 255, 0.6); }
    .c-sidebar .c-sidebar-nav-label:hover {
      color: #fff; }
    .c-sidebar .c-sidebar-nav-label .c-sidebar-nav-icon {
      color: rgba(255, 255, 255, 0.5); }
  .c-sidebar .c-progress {
    background-color: #596f94 !important; }
  .c-sidebar .c-sidebar-footer {
    background: rgba(0, 0, 21, 0.2); }
  .c-sidebar .c-sidebar-minimizer {
    background-color: rgba(0, 0, 21, 0.2); }
    .c-sidebar .c-sidebar-minimizer::before {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___}); }
    .c-sidebar .c-sidebar-minimizer:focus, .c-sidebar .c-sidebar-minimizer.c-focus {
      outline: 0; }
    .c-sidebar .c-sidebar-minimizer:hover {
      background-color: rgba(0, 0, 0, 0.3); }
      .c-sidebar .c-sidebar-minimizer:hover::before {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); }
  .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-link, .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-dropdown-toggle {
    background: #321fdb; }
    .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-link .c-sidebar-nav-icon, .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
      color: #fff; }
    .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-link.c-disabled, .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-disabled.c-sidebar-nav-dropdown-toggle {
      background: #3c4b64; }
      .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-link.c-disabled .c-sidebar-nav-icon, .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-disabled.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
        color: rgba(255, 255, 255, 0.5); }
  .c-sidebar.c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown > .c-sidebar-nav-dropdown-items {
    background: #3c4b64; }
  .c-sidebar.c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown:hover {
    background: #321fdb; }

.c-sidebar.c-sidebar-light {
  color: #3c4b64;
  background: #fff;
  border-right: 1px solid rgba(159, 167, 179, 0.5); }
  html:not([dir="rtl"]) .c-sidebar.c-sidebar-light.c-sidebar-right {
    border-right: 0;
    border-left: 1px solid rgba(159, 167, 179, 0.5); }
  *[dir="rtl"] .c-sidebar.c-sidebar-light {
    border-right: 0;
    border-left: 1px solid rgba(159, 167, 179, 0.5); }
    *[dir="rtl"] .c-sidebar.c-sidebar-light.c-sidebar-right {
      border: 0;
      border-right: 1px solid rgba(159, 167, 179, 0.5); }
  .c-sidebar.c-sidebar-light .c-sidebar-close {
    color: #3c4b64; }
  .c-sidebar.c-sidebar-light .c-sidebar-brand {
    color: #fff;
    background: #321fdb; }
  .c-sidebar.c-sidebar-light .c-sidebar-header {
    background: rgba(0, 0, 21, 0.2); }
  .c-sidebar.c-sidebar-light .c-sidebar-form .c-form-control {
    color: #fff;
    background: rgba(0, 0, 21, 0.1);
    border: 0; }
    .c-sidebar.c-sidebar-light .c-sidebar-form .c-form-control::placeholder {
      color: rgba(255, 255, 255, 0.7); }
  .c-sidebar.c-sidebar-light .c-sidebar-nav-title {
    color: rgba(0, 0, 21, 0.4); }
  .c-sidebar.c-sidebar-light .c-sidebar-nav-link, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown-toggle {
    color: rgba(0, 0, 21, 0.8);
    background: transparent; }
    .c-sidebar.c-sidebar-light .c-sidebar-nav-link .c-sidebar-nav-icon, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
      color: rgba(0, 0, 21, 0.5); }
    .c-sidebar.c-sidebar-light .c-sidebar-nav-link.c-active, .c-sidebar.c-sidebar-light .c-active.c-sidebar-nav-dropdown-toggle {
      color: rgba(0, 0, 21, 0.8);
      background: rgba(0, 0, 21, 0.05); }
      .c-sidebar.c-sidebar-light .c-sidebar-nav-link.c-active .c-sidebar-nav-icon, .c-sidebar.c-sidebar-light .c-active.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
        color: #321fdb; }
    .c-sidebar.c-sidebar-light .c-sidebar-nav-link:focus, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown-toggle:focus {
      outline: none; }
    @media (hover: hover), (-ms-high-contrast: none) {
      .c-sidebar.c-sidebar-light .c-sidebar-nav-link:hover, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown-toggle:hover {
        color: #fff;
        background: #321fdb; }
        .c-sidebar.c-sidebar-light .c-sidebar-nav-link:hover .c-sidebar-nav-icon, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
          color: #fff; }
        .c-sidebar.c-sidebar-light .c-sidebar-nav-link:hover.c-sidebar-nav-dropdown-toggle::after, .c-sidebar.c-sidebar-light :hover.c-sidebar-nav-dropdown-toggle::after {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); } }
    .c-sidebar.c-sidebar-light .c-sidebar-nav-link.c-disabled, .c-sidebar.c-sidebar-light .c-disabled.c-sidebar-nav-dropdown-toggle {
      color: #b3b3b3;
      background: transparent; }
      .c-sidebar.c-sidebar-light .c-sidebar-nav-link.c-disabled .c-sidebar-nav-icon, .c-sidebar.c-sidebar-light .c-disabled.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
        color: rgba(0, 0, 21, 0.5); }
      .c-sidebar.c-sidebar-light .c-sidebar-nav-link.c-disabled:hover, .c-sidebar.c-sidebar-light .c-disabled.c-sidebar-nav-dropdown-toggle:hover {
        color: #b3b3b3; }
        .c-sidebar.c-sidebar-light .c-sidebar-nav-link.c-disabled:hover .c-sidebar-nav-icon, .c-sidebar.c-sidebar-light .c-disabled.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
          color: rgba(0, 0, 21, 0.5); }
        .c-sidebar.c-sidebar-light .c-sidebar-nav-link.c-disabled:hover.c-sidebar-nav-dropdown-toggle::after, .c-sidebar.c-sidebar-light .c-disabled:hover.c-sidebar-nav-dropdown-toggle::after {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); }
  .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown-toggle {
    position: relative; }
    .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown-toggle::after {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}); }
  .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown.c-show {
    background: rgba(0, 0, 0, 0.05); }
    .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-dropdown-toggle {
      color: rgba(0, 0, 21, 0.8); }
      .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link.c-disabled, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown.c-show .c-disabled.c-sidebar-nav-dropdown-toggle {
        color: #b3b3b3;
        background: transparent; }
        .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link.c-disabled:hover, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown.c-show .c-disabled.c-sidebar-nav-dropdown-toggle:hover {
          color: #b3b3b3; }
          .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown.c-show .c-sidebar-nav-link.c-disabled:hover .c-sidebar-nav-icon, .c-sidebar.c-sidebar-light .c-sidebar-nav-dropdown.c-show .c-disabled.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
            color: rgba(0, 0, 21, 0.5); }
  .c-sidebar.c-sidebar-light .c-sidebar-nav-label {
    color: rgba(0, 0, 21, 0.4); }
    .c-sidebar.c-sidebar-light .c-sidebar-nav-label:hover {
      color: #3c4b64; }
    .c-sidebar.c-sidebar-light .c-sidebar-nav-label .c-sidebar-nav-icon {
      color: rgba(0, 0, 21, 0.5); }
  .c-sidebar.c-sidebar-light .c-sidebar-footer {
    background: rgba(0, 0, 21, 0.2); }
  .c-sidebar.c-sidebar-light .c-sidebar-minimizer {
    background-color: rgba(0, 0, 0, 0.05); }
    .c-sidebar.c-sidebar-light .c-sidebar-minimizer::before {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___}); }
    .c-sidebar.c-sidebar-light .c-sidebar-minimizer:focus, .c-sidebar.c-sidebar-light .c-sidebar-minimizer.c-focus {
      outline: 0; }
    .c-sidebar.c-sidebar-light .c-sidebar-minimizer:hover {
      background-color: rgba(0, 0, 0, 0.1); }
      .c-sidebar.c-sidebar-light .c-sidebar-minimizer:hover::before {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); }
  .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-link, .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-dropdown-toggle {
    background: #321fdb; }
    .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-link .c-sidebar-nav-icon, .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
      color: #fff; }
    .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-link.c-disabled, .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-disabled.c-sidebar-nav-dropdown-toggle {
      background: #fff; }
      .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-link.c-disabled .c-sidebar-nav-icon, .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-disabled.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
        color: rgba(0, 0, 21, 0.5); }
  .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown > .c-sidebar-nav-dropdown-items {
    background: #fff; }
  .c-sidebar.c-sidebar-light.c-sidebar-minimized .c-sidebar-nav > .c-sidebar-nav-dropdown:hover {
    background: #321fdb; }

.c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-primary, .c-sidebar .c-sidebar-nav-link-primary.c-sidebar-nav-dropdown-toggle {
  background: #321fdb; }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-primary .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-primary.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    color: rgba(255, 255, 255, 0.7); }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-primary:hover, .c-sidebar .c-sidebar-nav-link-primary.c-sidebar-nav-dropdown-toggle:hover {
    background: #2d1cc5; }
    .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-primary:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-primary.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
      color: #fff; }

.c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-secondary, .c-sidebar .c-sidebar-nav-link-secondary.c-sidebar-nav-dropdown-toggle {
  background: #ced2d8; }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-secondary .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-secondary.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    color: rgba(255, 255, 255, 0.7); }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-secondary:hover, .c-sidebar .c-sidebar-nav-link-secondary.c-sidebar-nav-dropdown-toggle:hover {
    background: #c0c5cd; }
    .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-secondary:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-secondary.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
      color: #fff; }

.c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-success, .c-sidebar .c-sidebar-nav-link-success.c-sidebar-nav-dropdown-toggle {
  background: #2eb85c; }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-success .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-success.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    color: rgba(255, 255, 255, 0.7); }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-success:hover, .c-sidebar .c-sidebar-nav-link-success.c-sidebar-nav-dropdown-toggle:hover {
    background: #29a452; }
    .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-success:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-success.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
      color: #fff; }

.c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-info, .c-sidebar .c-sidebar-nav-link-info.c-sidebar-nav-dropdown-toggle {
  background: #39f; }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-info .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-info.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    color: rgba(255, 255, 255, 0.7); }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-info:hover, .c-sidebar .c-sidebar-nav-link-info.c-sidebar-nav-dropdown-toggle:hover {
    background: #1a8cff; }
    .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-info:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-info.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
      color: #fff; }

.c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-warning, .c-sidebar .c-sidebar-nav-link-warning.c-sidebar-nav-dropdown-toggle {
  background: #f9b115; }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-warning .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-warning.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    color: rgba(255, 255, 255, 0.7); }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-warning:hover, .c-sidebar .c-sidebar-nav-link-warning.c-sidebar-nav-dropdown-toggle:hover {
    background: #eea506; }
    .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-warning:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-warning.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
      color: #fff; }

.c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-danger, .c-sidebar .c-sidebar-nav-link-danger.c-sidebar-nav-dropdown-toggle {
  background: #e55353; }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-danger .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-danger.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    color: rgba(255, 255, 255, 0.7); }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-danger:hover, .c-sidebar .c-sidebar-nav-link-danger.c-sidebar-nav-dropdown-toggle:hover {
    background: #e23d3d; }
    .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-danger:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-danger.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
      color: #fff; }

.c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-light, .c-sidebar .c-sidebar-nav-link-light.c-sidebar-nav-dropdown-toggle {
  background: #ebedef; }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-light .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-light.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    color: rgba(255, 255, 255, 0.7); }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-light:hover, .c-sidebar .c-sidebar-nav-link-light.c-sidebar-nav-dropdown-toggle:hover {
    background: #dde0e4; }
    .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-light:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-light.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
      color: #fff; }

.c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-dark, .c-sidebar .c-sidebar-nav-link-dark.c-sidebar-nav-dropdown-toggle {
  background: #636f83; }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-dark .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-dark.c-sidebar-nav-dropdown-toggle .c-sidebar-nav-icon {
    color: rgba(255, 255, 255, 0.7); }
  .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-dark:hover, .c-sidebar .c-sidebar-nav-link-dark.c-sidebar-nav-dropdown-toggle:hover {
    background: #586374; }
    .c-sidebar .c-sidebar-nav-link.c-sidebar-nav-link-dark:hover .c-sidebar-nav-icon, .c-sidebar .c-sidebar-nav-link-dark.c-sidebar-nav-dropdown-toggle:hover .c-sidebar-nav-icon {
      color: #fff; }

@keyframes spinner-border {
  to {
    transform: rotate(360deg); } }

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite; }

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em; }

@keyframes spinner-grow {
  0% {
    transform: scale(0); }
  50% {
    opacity: 1;
    transform: none; } }

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: spinner-grow .75s linear infinite; }

.spinner-grow-sm {
  width: 1rem;
  height: 1rem; }

.c-subheader {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  min-height: 48px; }
  .c-subheader[class*="bg-"] {
    border-color: rgba(0, 0, 21, 0.1); }
  .c-subheader.c-subheader-fixed {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1030; }

.c-subheader-nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 48px;
  padding: 0;
  margin-bottom: 0;
  list-style: none; }
  .c-subheader-nav .c-subheader-nav-item {
    position: relative; }
  .c-subheader-nav .c-subheader-nav-btn {
    background-color: transparent;
    border: 1px solid transparent; }
  .c-subheader-nav .c-subheader-nav-link,
  .c-subheader-nav .c-subheader-nav-btn {
    display: flex;
    align-items: center;
    padding-right: 0.5rem;
    padding-left: 0.5rem; }
    .c-subheader-nav .c-subheader-nav-link .badge,
    .c-subheader-nav .c-subheader-nav-btn .badge {
      position: absolute;
      top: 50%;
      margin-top: -16px; }
      html:not([dir="rtl"]) .c-subheader-nav .c-subheader-nav-link .badge, html:not([dir="rtl"])
      .c-subheader-nav .c-subheader-nav-btn .badge {
        left: 50%;
        margin-left: 0; }
      *[dir="rtl"] .c-subheader-nav .c-subheader-nav-link .badge, *[dir="rtl"]
      .c-subheader-nav .c-subheader-nav-btn .badge {
        right: 50%;
        margin-right: 0; }
    .c-subheader-nav .c-subheader-nav-link:hover,
    .c-subheader-nav .c-subheader-nav-btn:hover {
      text-decoration: none; }

.c-subheader.c-subheader-dark {
  background: #3c4b64;
  border-bottom: 1px solid #636f83; }
  .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-link,
  .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-btn {
    color: rgba(255, 255, 255, 0.75); }
    .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-link:hover, .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-link:focus,
    .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-btn:hover,
    .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-btn:focus {
      color: rgba(255, 255, 255, 0.9); }
    .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-link.c-disabled,
    .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-btn.c-disabled {
      color: rgba(255, 255, 255, 0.25); }
  .c-subheader.c-subheader-dark .c-subheader-nav .c-show > .c-subheader-nav-link,
  .c-subheader.c-subheader-dark .c-subheader-nav .c-active > .c-subheader-nav-link,
  .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-link.c-show,
  .c-subheader.c-subheader-dark .c-subheader-nav .c-subheader-nav-link.c-active {
    color: #fff; }
  .c-subheader.c-subheader-dark .c-subheader-text {
    color: rgba(255, 255, 255, 0.75); }
    .c-subheader.c-subheader-dark .c-subheader-text a {
      color: #fff; }
      .c-subheader.c-subheader-dark .c-subheader-text a:hover, .c-subheader.c-subheader-dark .c-subheader-text a:focus {
        color: #fff; }

.c-subheader {
  background: #fff;
  border-bottom: 1px solid #d8dbe0; }
  .c-subheader .c-subheader-nav .c-subheader-nav-link,
  .c-subheader .c-subheader-nav .c-subheader-nav-btn {
    color: rgba(0, 0, 21, 0.5); }
    .c-subheader .c-subheader-nav .c-subheader-nav-link:hover, .c-subheader .c-subheader-nav .c-subheader-nav-link:focus,
    .c-subheader .c-subheader-nav .c-subheader-nav-btn:hover,
    .c-subheader .c-subheader-nav .c-subheader-nav-btn:focus {
      color: rgba(0, 0, 21, 0.7); }
    .c-subheader .c-subheader-nav .c-subheader-nav-link.c-disabled,
    .c-subheader .c-subheader-nav .c-subheader-nav-btn.c-disabled {
      color: rgba(0, 0, 21, 0.3); }
  .c-subheader .c-subheader-nav .c-show > .c-subheader-nav-link,
  .c-subheader .c-subheader-nav .c-active > .c-subheader-nav-link,
  .c-subheader .c-subheader-nav .c-subheader-nav-link.c-show,
  .c-subheader .c-subheader-nav .c-subheader-nav-link.c-active {
    color: rgba(0, 0, 21, 0.9); }
  .c-subheader .c-subheader-text {
    color: rgba(0, 0, 21, 0.5); }
    .c-subheader .c-subheader-text a {
      color: rgba(0, 0, 21, 0.9); }
      .c-subheader .c-subheader-text a:hover, .c-subheader .c-subheader-text a:focus {
        color: rgba(0, 0, 21, 0.9); }

.c-switch {
  display: inline-block;
  width: 40px;
  height: 26px; }

.c-switch-input {
  position: absolute;
  z-index: -1;
  opacity: 0; }

.c-switch-slider {
  position: relative;
  display: block;
  height: inherit;
  cursor: pointer;
  border: 1px solid;
  transition: .15s ease-out;
  border-radius: 0.25rem;
  background-color: #fff;
  border-color: #d8dbe0; }
  .c-switch-slider::before {
    position: absolute;
    top: 2px;
    left: 2px;
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    content: "";
    background-color: #fff;
    border: 1px solid #d8dbe0;
    transition: .15s ease-out;
    border-radius: 0.125rem; }

.c-switch-input:checked ~ .c-switch-slider::before {
  transform: translateX(14px); }

.c-switch-input:focus ~ .c-switch-slider {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25); }

.c-switch-input:disabled ~ .c-switch-slider {
  cursor: not-allowed;
  opacity: .5; }

.c-switch-lg {
  width: 48px;
  height: 30px; }
  .c-switch-lg .c-switch-slider {
    font-size: 12px; }
    .c-switch-lg .c-switch-slider::before {
      width: 24px;
      height: 24px; }
    .c-switch-lg .c-switch-slider::after {
      font-size: 12px; }
  .c-switch-lg .c-switch-input:checked ~ .c-switch-slider::before {
    transform: translateX(18px); }

.c-switch-sm {
  width: 32px;
  height: 22px; }
  .c-switch-sm .c-switch-slider {
    font-size: 8px; }
    .c-switch-sm .c-switch-slider::before {
      width: 16px;
      height: 16px; }
    .c-switch-sm .c-switch-slider::after {
      font-size: 8px; }
  .c-switch-sm .c-switch-input:checked ~ .c-switch-slider::before {
    transform: translateX(10px); }

.c-switch-label {
  width: 48px; }
  .c-switch-label .c-switch-slider::before {
    z-index: 2; }
  .c-switch-label .c-switch-slider::after {
    position: absolute;
    top: 50%;
    z-index: 1;
    width: 50%;
    margin-top: -.5em;
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    color: #c4c9d0;
    text-align: center;
    text-transform: uppercase;
    content: attr(data-unchecked);
    transition: inherit; }
    html:not([dir="rtl"]) .c-switch-label .c-switch-slider::after {
      right: 1px; }
  .c-switch-label .c-switch-input:checked ~ .c-switch-slider::before {
    transform: translateX(22px); }
  .c-switch-label .c-switch-input:checked ~ .c-switch-slider::after {
    left: 1px;
    color: #fff;
    content: attr(data-checked); }
  .c-switch-label.c-switch-lg {
    width: 56px;
    height: 30px; }
    .c-switch-label.c-switch-lg .c-switch-slider {
      font-size: 12px; }
      .c-switch-label.c-switch-lg .c-switch-slider::before {
        width: 24px;
        height: 24px; }
      .c-switch-label.c-switch-lg .c-switch-slider::after {
        font-size: 12px; }
    .c-switch-label.c-switch-lg .c-switch-input:checked ~ .c-switch-slider::before {
      transform: translateX(26px); }
  .c-switch-label.c-switch-sm {
    width: 40px;
    height: 22px; }
    .c-switch-label.c-switch-sm .c-switch-slider {
      font-size: 8px; }
      .c-switch-label.c-switch-sm .c-switch-slider::before {
        width: 16px;
        height: 16px; }
      .c-switch-label.c-switch-sm .c-switch-slider::after {
        font-size: 8px; }
    .c-switch-label.c-switch-sm .c-switch-input:checked ~ .c-switch-slider::before {
      transform: translateX(18px); }

.c-switch[class*="-3d"] .c-switch-slider {
  background-color: #ebedef;
  border-radius: 50em; }
  .c-switch[class*="-3d"] .c-switch-slider::before {
    top: -1px;
    left: -1px;
    width: 26px;
    height: 26px;
    border: 0;
    border-radius: 50em;
    box-shadow: 0 2px 5px rgba(0, 0, 21, 0.3); }

.c-switch[class*="-3d"].c-switch-lg {
  width: 48px;
  height: 30px; }
  .c-switch[class*="-3d"].c-switch-lg .c-switch-slider::before {
    width: 30px;
    height: 30px; }
  .c-switch[class*="-3d"].c-switch-lg .c-switch-input:checked ~ .c-switch-slider::before {
    transform: translateX(18px); }

.c-switch[class*="-3d"].c-switch-sm {
  width: 32px;
  height: 22px; }
  .c-switch[class*="-3d"].c-switch-sm .c-switch-slider::before {
    width: 22px;
    height: 22px; }
  .c-switch[class*="-3d"].c-switch-sm .c-switch-input:checked ~ .c-switch-slider::before {
    transform: translateX(10px); }

.c-switch-primary .c-switch-input:checked + .c-switch-slider {
  background-color: #321fdb;
  border-color: #2819ae; }
  .c-switch-primary .c-switch-input:checked + .c-switch-slider::before {
    border-color: #2819ae; }

.c-switch-3d-primary .c-switch-input:checked + .c-switch-slider {
  background-color: #321fdb; }

.c-switch-outline-primary .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #321fdb; }
  .c-switch-outline-primary .c-switch-input:checked + .c-switch-slider::before {
    border-color: #321fdb; }
  .c-switch-outline-primary .c-switch-input:checked + .c-switch-slider::after {
    color: #321fdb; }

.c-switch-opposite-primary .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #321fdb; }
  .c-switch-opposite-primary .c-switch-input:checked + .c-switch-slider::before {
    background-color: #321fdb;
    border-color: #321fdb; }
  .c-switch-opposite-primary .c-switch-input:checked + .c-switch-slider::after {
    color: #321fdb; }

.c-switch-secondary .c-switch-input:checked + .c-switch-slider {
  background-color: #ced2d8;
  border-color: #b2b8c1; }
  .c-switch-secondary .c-switch-input:checked + .c-switch-slider::before {
    border-color: #b2b8c1; }

.c-switch-3d-secondary .c-switch-input:checked + .c-switch-slider {
  background-color: #ced2d8; }

.c-switch-outline-secondary .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #ced2d8; }
  .c-switch-outline-secondary .c-switch-input:checked + .c-switch-slider::before {
    border-color: #ced2d8; }
  .c-switch-outline-secondary .c-switch-input:checked + .c-switch-slider::after {
    color: #ced2d8; }

.c-switch-opposite-secondary .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #ced2d8; }
  .c-switch-opposite-secondary .c-switch-input:checked + .c-switch-slider::before {
    background-color: #ced2d8;
    border-color: #ced2d8; }
  .c-switch-opposite-secondary .c-switch-input:checked + .c-switch-slider::after {
    color: #ced2d8; }

.c-switch-success .c-switch-input:checked + .c-switch-slider {
  background-color: #2eb85c;
  border-color: #248f48; }
  .c-switch-success .c-switch-input:checked + .c-switch-slider::before {
    border-color: #248f48; }

.c-switch-3d-success .c-switch-input:checked + .c-switch-slider {
  background-color: #2eb85c; }

.c-switch-outline-success .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #2eb85c; }
  .c-switch-outline-success .c-switch-input:checked + .c-switch-slider::before {
    border-color: #2eb85c; }
  .c-switch-outline-success .c-switch-input:checked + .c-switch-slider::after {
    color: #2eb85c; }

.c-switch-opposite-success .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #2eb85c; }
  .c-switch-opposite-success .c-switch-input:checked + .c-switch-slider::before {
    background-color: #2eb85c;
    border-color: #2eb85c; }
  .c-switch-opposite-success .c-switch-input:checked + .c-switch-slider::after {
    color: #2eb85c; }

.c-switch-info .c-switch-input:checked + .c-switch-slider {
  background-color: #39f;
  border-color: #0080ff; }
  .c-switch-info .c-switch-input:checked + .c-switch-slider::before {
    border-color: #0080ff; }

.c-switch-3d-info .c-switch-input:checked + .c-switch-slider {
  background-color: #39f; }

.c-switch-outline-info .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #39f; }
  .c-switch-outline-info .c-switch-input:checked + .c-switch-slider::before {
    border-color: #39f; }
  .c-switch-outline-info .c-switch-input:checked + .c-switch-slider::after {
    color: #39f; }

.c-switch-opposite-info .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #39f; }
  .c-switch-opposite-info .c-switch-input:checked + .c-switch-slider::before {
    background-color: #39f;
    border-color: #39f; }
  .c-switch-opposite-info .c-switch-input:checked + .c-switch-slider::after {
    color: #39f; }

.c-switch-warning .c-switch-input:checked + .c-switch-slider {
  background-color: #f9b115;
  border-color: #d69405; }
  .c-switch-warning .c-switch-input:checked + .c-switch-slider::before {
    border-color: #d69405; }

.c-switch-3d-warning .c-switch-input:checked + .c-switch-slider {
  background-color: #f9b115; }

.c-switch-outline-warning .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #f9b115; }
  .c-switch-outline-warning .c-switch-input:checked + .c-switch-slider::before {
    border-color: #f9b115; }
  .c-switch-outline-warning .c-switch-input:checked + .c-switch-slider::after {
    color: #f9b115; }

.c-switch-opposite-warning .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #f9b115; }
  .c-switch-opposite-warning .c-switch-input:checked + .c-switch-slider::before {
    background-color: #f9b115;
    border-color: #f9b115; }
  .c-switch-opposite-warning .c-switch-input:checked + .c-switch-slider::after {
    color: #f9b115; }

.c-switch-danger .c-switch-input:checked + .c-switch-slider {
  background-color: #e55353;
  border-color: #de2727; }
  .c-switch-danger .c-switch-input:checked + .c-switch-slider::before {
    border-color: #de2727; }

.c-switch-3d-danger .c-switch-input:checked + .c-switch-slider {
  background-color: #e55353; }

.c-switch-outline-danger .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #e55353; }
  .c-switch-outline-danger .c-switch-input:checked + .c-switch-slider::before {
    border-color: #e55353; }
  .c-switch-outline-danger .c-switch-input:checked + .c-switch-slider::after {
    color: #e55353; }

.c-switch-opposite-danger .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #e55353; }
  .c-switch-opposite-danger .c-switch-input:checked + .c-switch-slider::before {
    background-color: #e55353;
    border-color: #e55353; }
  .c-switch-opposite-danger .c-switch-input:checked + .c-switch-slider::after {
    color: #e55353; }

.c-switch-light .c-switch-input:checked + .c-switch-slider {
  background-color: #ebedef;
  border-color: #cfd4d8; }
  .c-switch-light .c-switch-input:checked + .c-switch-slider::before {
    border-color: #cfd4d8; }

.c-switch-3d-light .c-switch-input:checked + .c-switch-slider {
  background-color: #ebedef; }

.c-switch-outline-light .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #ebedef; }
  .c-switch-outline-light .c-switch-input:checked + .c-switch-slider::before {
    border-color: #ebedef; }
  .c-switch-outline-light .c-switch-input:checked + .c-switch-slider::after {
    color: #ebedef; }

.c-switch-opposite-light .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #ebedef; }
  .c-switch-opposite-light .c-switch-input:checked + .c-switch-slider::before {
    background-color: #ebedef;
    border-color: #ebedef; }
  .c-switch-opposite-light .c-switch-input:checked + .c-switch-slider::after {
    color: #ebedef; }

.c-switch-dark .c-switch-input:checked + .c-switch-slider {
  background-color: #636f83;
  border-color: #4d5666; }
  .c-switch-dark .c-switch-input:checked + .c-switch-slider::before {
    border-color: #4d5666; }

.c-switch-3d-dark .c-switch-input:checked + .c-switch-slider {
  background-color: #636f83; }

.c-switch-outline-dark .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #636f83; }
  .c-switch-outline-dark .c-switch-input:checked + .c-switch-slider::before {
    border-color: #636f83; }
  .c-switch-outline-dark .c-switch-input:checked + .c-switch-slider::after {
    color: #636f83; }

.c-switch-opposite-dark .c-switch-input:checked + .c-switch-slider {
  background-color: inherit;
  border-color: #636f83; }
  .c-switch-opposite-dark .c-switch-input:checked + .c-switch-slider::before {
    background-color: #636f83;
    border-color: #636f83; }
  .c-switch-opposite-dark .c-switch-input:checked + .c-switch-slider::after {
    color: #636f83; }

.c-switch-pill .c-switch-slider {
  border-radius: 50em; }
  .c-switch-pill .c-switch-slider::before {
    border-radius: 50em; }

.c-switch-square .c-switch-slider {
  border-radius: 0; }
  .c-switch-square .c-switch-slider::before {
    border-radius: 0; }

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #3c4b64; }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid;
    border-top-color: #d8dbe0; }
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid;
    border-bottom-color: #d8dbe0; }
  .table tbody + tbody {
    border-top: 2px solid;
    border-top-color: #d8dbe0; }

.table-sm th,
.table-sm td {
  padding: 0.3rem; }

.table-bordered {
  border: 1px solid;
  border-color: #d8dbe0; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid;
    border-color: #d8dbe0; }
  .table-bordered thead th,
  .table-bordered thead td {
    border-bottom-width: 2px; }

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0; }

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 21, 0.05); }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover tbody tr:hover {
    color: #3c4b64;
    background-color: rgba(0, 0, 21, 0.075); } }

.table-primary,
.table-primary > th,
.table-primary > td {
  color: #4f5d73;
  background-color: #c6c0f5; }

.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #948bec; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-primary:hover {
    background-color: #b2aaf2; }
    .table-hover .table-primary:hover > td,
    .table-hover .table-primary:hover > th {
      background-color: #b2aaf2; } }

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  color: #4f5d73;
  background-color: #f1f2f4; }

.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #e6e8eb; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-secondary:hover {
    background-color: #e3e5e9; }
    .table-hover .table-secondary:hover > td,
    .table-hover .table-secondary:hover > th {
      background-color: #e3e5e9; } }

.table-success,
.table-success > th,
.table-success > td {
  color: #4f5d73;
  background-color: #c4ebd1; }

.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #92daaa; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-success:hover {
    background-color: #b1e5c2; }
    .table-hover .table-success:hover > td,
    .table-hover .table-success:hover > th {
      background-color: #b1e5c2; } }

.table-info,
.table-info > th,
.table-info > td {
  color: #4f5d73;
  background-color: #c6e2ff; }

.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #95caff; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-info:hover {
    background-color: #add5ff; }
    .table-hover .table-info:hover > td,
    .table-hover .table-info:hover > th {
      background-color: #add5ff; } }

.table-warning,
.table-warning > th,
.table-warning > td {
  color: #4f5d73;
  background-color: #fde9bd; }

.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #fcd685; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-warning:hover {
    background-color: #fce1a4; }
    .table-hover .table-warning:hover > td,
    .table-hover .table-warning:hover > th {
      background-color: #fce1a4; } }

.table-danger,
.table-danger > th,
.table-danger > td {
  color: #4f5d73;
  background-color: #f8cfcf; }

.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #f1a6a6; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-danger:hover {
    background-color: #f5b9b9; }
    .table-hover .table-danger:hover > td,
    .table-hover .table-danger:hover > th {
      background-color: #f5b9b9; } }

.table-light,
.table-light > th,
.table-light > td {
  color: #4f5d73;
  background-color: #f9fafb; }

.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #f5f6f7; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-light:hover {
    background-color: #eaedf1; }
    .table-hover .table-light:hover > td,
    .table-hover .table-light:hover > th {
      background-color: #eaedf1; } }

.table-dark,
.table-dark > th,
.table-dark > td {
  color: #4f5d73;
  background-color: #d3d7dc; }

.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #aeb4bf; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-dark:hover {
    background-color: #c5cad1; }
    .table-hover .table-dark:hover > td,
    .table-hover .table-dark:hover > th {
      background-color: #c5cad1; } }

.table-active,
.table-active > th,
.table-active > td {
  color: #4f5d73;
  background-color: #d8dbe0; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-active:hover {
    background-color: #caced5; }
    .table-hover .table-active:hover > td,
    .table-hover .table-active:hover > th {
      background-color: #caced5; } }

.table-selected,
.table-selected > th,
.table-selected > td {
  color: #4f5d73;
  background-color: #d8dbe0; }

.table-selected th,
.table-selected td,
.table-selected thead th,
.table-selected tbody + tbody {
  border-color: #d8dbe0; }

@media (hover: hover), (-ms-high-contrast: none) {
  .table-hover .table-selected:hover {
    background-color: #caced5; }
    .table-hover .table-selected:hover > td,
    .table-hover .table-selected:hover > th {
      background-color: #caced5; } }

.table tbody tr:focus {
  outline: 0;
  color: #3c4b64;
  background-color: rgba(0, 0, 21, 0.075); }

.table .thead-dark th {
  color: #fff;
  background-color: #636f83;
  border-color: #758297; }

.table .thead-light th {
  color: #768192;
  background-color: #d8dbe0;
  border-color: #d8dbe0; }

.table-dark {
  color: #fff;
  background-color: #636f83; }
  .table-dark th,
  .table-dark td,
  .table-dark thead th {
    border-color: #758297; }
  .table-dark.table-bordered {
    border: 0; }
  .table-dark.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(255, 255, 255, 0.05); }
  @media (hover: hover), (-ms-high-contrast: none) {
    .table-dark.table-hover tbody tr:hover {
      color: #fff;
      background-color: rgba(255, 255, 255, 0.075); } }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-sm > .table-bordered {
      border: 0; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-md > .table-bordered {
      border: 0; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-lg > .table-bordered {
      border: 0; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-xl > .table-bordered {
      border: 0; } }

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-xxl > .table-bordered {
      border: 0; } }

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }
  .table-responsive > .table-bordered {
    border: 0; }

.table-outline {
  border: 1px solid;
  border-color: #d8dbe0; }
  .table-outline td {
    vertical-align: middle; }

.table-align-middle td {
  vertical-align: middle; }

.table-clear td {
  border: 0; }

.toast {
  width: 350px;
  max-width: 350px;
  overflow: hidden;
  font-size: 0.875rem;
  background-clip: padding-box;
  border: 1px solid;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 21, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  opacity: 0;
  border-radius: 0.25rem;
  background-color: rgba(255, 255, 255, 0.85);
  border-color: rgba(0, 0, 21, 0.1); }
  .toast:not(:last-child) {
    margin-bottom: 0.75rem; }
  .toast.showing {
    opacity: 1; }
  .toast.show {
    display: block;
    opacity: 1; }
  .toast.hide {
    display: none; }

.toast-full {
  width: 100%;
  max-width: 100%; }

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  background-clip: padding-box;
  border-bottom: 1px solid;
  color: #8a93a2;
  background-color: rgba(255, 255, 255, 0.85);
  border-color: rgba(0, 0, 21, 0.05); }

.toast-body {
  padding: 0.75rem; }

.toaster {
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  padding: 0.25rem 0.5rem; }
  .toaster-top-full, .toaster-top-center, .toaster-top-right, .toaster-top-left, .toaster-bottom-full, .toaster-bottom-center, .toaster-bottom-right, .toaster-bottom-left {
    position: fixed;
    z-index: 1080;
    width: 350px; }
  .toaster-top-full, .toaster-top-center, .toaster-top-right, .toaster-top-left {
    top: 0; }
  .toaster-bottom-full, .toaster-bottom-center, .toaster-bottom-right, .toaster-bottom-left {
    bottom: 0;
    flex-direction: column; }
  .toaster-top-full, .toaster-bottom-full {
    width: auto; }
  .toaster-top-center, .toaster-bottom-center {
    left: 50%;
    transform: translateX(-50%); }
  .toaster-top-full, .toaster-bottom-full, .toaster-top-right, .toaster-bottom-right {
    right: 0; }
  .toaster-top-full, .toaster-bottom-full, .toaster-top-left, .toaster-bottom-left {
    left: 0; }
  .toaster .toast {
    width: 100%;
    max-width: 100%;
    margin-top: 0.125rem;
    margin-bottom: 0.125rem; }

.toast-primary {
  color: #fff;
  background-color: #321fdb;
  border-color: #2819ae; }
  .toast-primary .toast-header {
    color: #fff;
    background-color: #2d1cc5;
    border-color: #2819ae; }

.toast-secondary {
  color: #4f5d73;
  background-color: #ced2d8;
  border-color: #b2b8c1; }
  .toast-secondary .toast-header {
    color: #4f5d73;
    background-color: #c0c5cd;
    border-color: #b2b8c1; }

.toast-success {
  color: #fff;
  background-color: #2eb85c;
  border-color: #248f48; }
  .toast-success .toast-header {
    color: #fff;
    background-color: #29a452;
    border-color: #248f48; }

.toast-info {
  color: #fff;
  background-color: #39f;
  border-color: #0080ff; }
  .toast-info .toast-header {
    color: #fff;
    background-color: #1a8cff;
    border-color: #0080ff; }

.toast-warning {
  color: #4f5d73;
  background-color: #f9b115;
  border-color: #d69405; }
  .toast-warning .toast-header {
    color: #4f5d73;
    background-color: #eea506;
    border-color: #d69405; }

.toast-danger {
  color: #fff;
  background-color: #e55353;
  border-color: #de2727; }
  .toast-danger .toast-header {
    color: #fff;
    background-color: #e23d3d;
    border-color: #de2727; }

.toast-light {
  color: #4f5d73;
  background-color: #ebedef;
  border-color: #cfd4d8; }
  .toast-light .toast-header {
    color: #4f5d73;
    background-color: #dde0e4;
    border-color: #cfd4d8; }

.toast-dark {
  color: #fff;
  background-color: #636f83;
  border-color: #4d5666; }
  .toast-dark .toast-header {
    color: #fff;
    background-color: #586374;
    border-color: #4d5666; }

.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.76562rem;
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: 0.9; }
  .tooltip .tooltip-arrow {
    position: absolute;
    display: block; }
    .tooltip .tooltip-arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.tooltip[data-popper-placement^="top"],
.tooltip[data-popper-placement^="bottom"] {
  padding: 0.4rem 0; }
  .tooltip[data-popper-placement^="top"] .tooltip-arrow,
  .tooltip[data-popper-placement^="bottom"] .tooltip-arrow {
    width: 0.8rem;
    height: 0.4rem; }

.tooltip[data-popper-placement^="right"],
.tooltip[data-popper-placement^="left"] {
  padding: 0 0.4rem; }
  .tooltip[data-popper-placement^="right"] .tooltip-arrow,
  .tooltip[data-popper-placement^="left"] .tooltip-arrow {
    width: 0.4rem;
    height: 0.8rem; }

.tooltip[data-popper-placement^="top"] .tooltip-arrow {
  bottom: 0; }
  .tooltip[data-popper-placement^="top"] .tooltip-arrow::before {
    top: 0;
    border-width: 0.4rem 0.4rem 0;
    border-top-color: #000015; }

.tooltip[data-popper-placement^="right"] .tooltip-arrow {
  left: 0; }
  .tooltip[data-popper-placement^="right"] .tooltip-arrow::before {
    right: 0;
    border-width: 0.4rem 0.4rem 0.4rem 0;
    border-right-color: #000015; }


.tooltip[data-popper-placement^="bottom"] .tooltip-arrow {
  top: 0; }
  .tooltip[data-popper-placement^="bottom"] .tooltip-arrow::before {
    bottom: 0;
    border-width: 0 0.4rem 0.4rem;
    border-bottom-color: #000015; }


.tooltip[data-popper-placement^="left"] .tooltip-arrow {
  right: 0; }
  .tooltip[data-popper-placement^="left"] .tooltip-arrow::before {
    left: 0;
    border-width: 0.4rem 0 0.4rem 0.4rem;
    border-left-color: #000015; }

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000015;
  border-radius: 0.25rem; }

.fade {
  transition: opacity 0.15s linear; }
  @media (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }

@keyframes fadeIn {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }

.fade-in {
  animation-name: fadeIn;
  animation-duration: 1s; }

.c-wrapper {
  transition: margin 0.3s; }

.c-sidebar {
  transition: box-shadow 0.3s 0.15s, transform 0.3s, margin-left 0.3s, margin-right 0.3s, width 0.3s, z-index 0s ease 0.3s; }
  .c-sidebar.c-sidebar-unfoldable {
    transition: transform 0.3s, margin-left 0.3s, margin-right 0.3s, width 0.3s, z-index 0s ease 0s; }

.c-no-layout-transition .c-wrapper,
.c-no-layout-transition .c-sidebar {
  transition: none; }
  .c-no-layout-transition .c-wrapper .c-sidebar-header,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-title,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-divider,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-link,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-dropdown-toggle,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-icon,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-dropdown,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-dropdown-toggle,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-dropdown-toggle::after,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-dropdown-items,
  .c-no-layout-transition .c-wrapper .c-sidebar-nav-label,
  .c-no-layout-transition .c-wrapper .c-sidebar-footer,
  .c-no-layout-transition .c-wrapper .c-sidebar-minimizer,
  .c-no-layout-transition .c-sidebar .c-sidebar-header,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-title,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-divider,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-link,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-dropdown-toggle,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-icon,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-dropdown,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-dropdown-toggle,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-dropdown-toggle::after,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-dropdown-items,
  .c-no-layout-transition .c-sidebar .c-sidebar-nav-label,
  .c-no-layout-transition .c-sidebar .c-sidebar-footer,
  .c-no-layout-transition .c-sidebar .c-sidebar-minimizer {
    transition: none; }

.c-no-transition {
  transition: none; }

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2; }

h1, .h1 {
  font-size: 2.1875rem; }

h2, .h2 {
  font-size: 1.75rem; }

h3, .h3 {
  font-size: 1.53125rem; }

h4, .h4 {
  font-size: 1.3125rem; }

h5, .h5 {
  font-size: 1.09375rem; }

h6, .h6 {
  font-size: 0.875rem; }

.lead {
  font-size: 1.09375rem;
  font-weight: 300; }

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2; }

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2; }

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2; }

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2; }

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid;
  border-color: rgba(0, 0, 21, 0.2); }

.c-vr {
  width: 1px;
  background-color: rgba(0, 0, 21, 0.2); }

small,
.small {
  font-size: 80%;
  font-weight: 400; }

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3; }

.list-unstyled {
  list-style: none; }
  html:not([dir="rtl"]) .list-unstyled {
    padding-left: 0; }
  *[dir="rtl"] .list-unstyled {
    padding-right: 0; }

.list-inline {
  list-style: none; }
  html:not([dir="rtl"]) .list-inline {
    padding-left: 0; }
  *[dir="rtl"] .list-inline {
    padding-right: 0; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 90%;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.09375rem; }

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #8a93a2; }
  .blockquote-footer::before {
    content: "\\2014\\00A0"; }

.c-app {
  display: flex;
  flex-direction: row;
  min-height: 100vh; }

@media all and (-ms-high-contrast: none) {
  html {
    display: flex;
    flex-direction: column; } }

.c-wrapper {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-width: 0;
  min-height: 100vh; }
  .c-wrapper:not(.c-wrapper-fluid) .c-subheader-fixed {
    position: relative; }
  .c-wrapper:not(.c-wrapper-fluid) .c-header-fixed {
    position: sticky;
    top: 0; }
    @media all and (-ms-high-contrast: none) {
      .c-wrapper:not(.c-wrapper-fluid) .c-header-fixed {
        position: fixed;
        margin: inherit; }
        .c-wrapper:not(.c-wrapper-fluid) .c-header-fixed ~ .c-body {
          margin-top: 104px; } }
  .c-wrapper:not(.c-wrapper-fluid) .c-footer-fixed {
    position: sticky;
    bottom: 0; }
    @media all and (-ms-high-contrast: none) {
      .c-wrapper:not(.c-wrapper-fluid) .c-footer-fixed {
        position: fixed;
        margin: inherit; }
        .c-wrapper:not(.c-wrapper-fluid) .c-footer-fixed ~ .c-body {
          margin-bottom: 49px; } }
  .c-wrapper:not(.c-wrapper-fluid) .c-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1; }
  .c-wrapper.c-wrapper-fluid {
    min-height: 100vh; }
    .c-wrapper.c-wrapper-fluid .c-header-fixed {
      margin: inherit; }

.c-main {
  flex-basis: auto;
  flex-shrink: 0;
  flex-grow: 1;
  min-width: 0;
  padding-top: 2rem; }
  @media (min-width: 768px) {
    .c-main > .container-fluid, .c-main > .container-sm, .c-main > .container-md, .c-main > .container-lg, .c-main > .container-xl, .c-main > .container-xxl {
      padding-right: 30px;
      padding-left: 30px; } }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.bg-primary {
  background-color: #321fdb !important; }

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #2819ae !important; }

.bg-secondary {
  background-color: #ced2d8 !important; }

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #b2b8c1 !important; }

.bg-success {
  background-color: #2eb85c !important; }

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #248f48 !important; }

.bg-info {
  background-color: #39f !important; }

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #0080ff !important; }

.bg-warning {
  background-color: #f9b115 !important; }

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #d69405 !important; }

.bg-danger {
  background-color: #e55353 !important; }

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #de2727 !important; }

.bg-light {
  background-color: #ebedef !important; }

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #cfd4d8 !important; }

.bg-dark {
  background-color: #636f83 !important; }

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #4d5666 !important; }

.bg-gradient-primary {
  background: #1f1498 !important;
  background: linear-gradient(45deg, #321fdb 0%, #1f1498 100%) !important;
  border-color: #1f1498 !important; }

.bg-gradient-secondary {
  background: #fff !important;
  background: linear-gradient(45deg, #c8d2dc 0%, #fff 100%) !important;
  border-color: #fff !important; }

.bg-gradient-success {
  background: #1b9e3e !important;
  background: linear-gradient(45deg, #2eb85c 0%, #1b9e3e 100%) !important;
  border-color: #1b9e3e !important; }

.bg-gradient-info {
  background: #2982cc !important;
  background: linear-gradient(45deg, #39f 0%, #2982cc 100%) !important;
  border-color: #2982cc !important; }

.bg-gradient-warning {
  background: #f6960b !important;
  background: linear-gradient(45deg, #f9b115 0%, #f6960b 100%) !important;
  border-color: #f6960b !important; }

.bg-gradient-danger {
  background: #d93737 !important;
  background: linear-gradient(45deg, #e55353 0%, #d93737 100%) !important;
  border-color: #d93737 !important; }

.bg-gradient-light {
  background: #fff !important;
  background: linear-gradient(45deg, #e3e8ed 0%, #fff 100%) !important;
  border-color: #fff !important; }

.bg-gradient-dark {
  background: #212333 !important;
  background: linear-gradient(45deg, #3c4b64 0%, #212333 100%) !important;
  border-color: #212333 !important; }

.bg-white {
  background-color: #fff !important; }

.bg-transparent {
  background-color: transparent !important; }

[class^="bg-"] {
  color: #fff; }

.bg-facebook {
  background-color: #3b5998 !important; }

a.bg-facebook:hover, a.bg-facebook:focus,
button.bg-facebook:hover,
button.bg-facebook:focus {
  background-color: #2d4373 !important; }

.bg-twitter {
  background-color: #00aced !important; }

a.bg-twitter:hover, a.bg-twitter:focus,
button.bg-twitter:hover,
button.bg-twitter:focus {
  background-color: #0087ba !important; }

.bg-linkedin {
  background-color: #4875b4 !important; }

a.bg-linkedin:hover, a.bg-linkedin:focus,
button.bg-linkedin:hover,
button.bg-linkedin:focus {
  background-color: #395d90 !important; }

.bg-flickr {
  background-color: #ff0084 !important; }

a.bg-flickr:hover, a.bg-flickr:focus,
button.bg-flickr:hover,
button.bg-flickr:focus {
  background-color: #cc006a !important; }

.bg-tumblr {
  background-color: #32506d !important; }

a.bg-tumblr:hover, a.bg-tumblr:focus,
button.bg-tumblr:hover,
button.bg-tumblr:focus {
  background-color: #22364a !important; }

.bg-xing {
  background-color: #026466 !important; }

a.bg-xing:hover, a.bg-xing:focus,
button.bg-xing:hover,
button.bg-xing:focus {
  background-color: #013334 !important; }

.bg-github {
  background-color: #4183c4 !important; }

a.bg-github:hover, a.bg-github:focus,
button.bg-github:hover,
button.bg-github:focus {
  background-color: #3269a0 !important; }

.bg-stack-overflow {
  background-color: #fe7a15 !important; }

a.bg-stack-overflow:hover, a.bg-stack-overflow:focus,
button.bg-stack-overflow:hover,
button.bg-stack-overflow:focus {
  background-color: #df6101 !important; }

.bg-youtube {
  background-color: #b00 !important; }

a.bg-youtube:hover, a.bg-youtube:focus,
button.bg-youtube:hover,
button.bg-youtube:focus {
  background-color: #880000 !important; }

.bg-dribbble {
  background-color: #ea4c89 !important; }

a.bg-dribbble:hover, a.bg-dribbble:focus,
button.bg-dribbble:hover,
button.bg-dribbble:focus {
  background-color: #e51e6b !important; }

.bg-instagram {
  background-color: #517fa4 !important; }

a.bg-instagram:hover, a.bg-instagram:focus,
button.bg-instagram:hover,
button.bg-instagram:focus {
  background-color: #406582 !important; }

.bg-pinterest {
  background-color: #cb2027 !important; }

a.bg-pinterest:hover, a.bg-pinterest:focus,
button.bg-pinterest:hover,
button.bg-pinterest:focus {
  background-color: #9f191f !important; }

.bg-vk {
  background-color: #45668e !important; }

a.bg-vk:hover, a.bg-vk:focus,
button.bg-vk:hover,
button.bg-vk:focus {
  background-color: #344d6c !important; }

.bg-yahoo {
  background-color: #400191 !important; }

a.bg-yahoo:hover, a.bg-yahoo:focus,
button.bg-yahoo:hover,
button.bg-yahoo:focus {
  background-color: #2a015e !important; }

.bg-behance {
  background-color: #1769ff !important; }

a.bg-behance:hover, a.bg-behance:focus,
button.bg-behance:hover,
button.bg-behance:focus {
  background-color: #0050e3 !important; }

.bg-reddit {
  background-color: #ff4500 !important; }

a.bg-reddit:hover, a.bg-reddit:focus,
button.bg-reddit:hover,
button.bg-reddit:focus {
  background-color: #cc3700 !important; }

.bg-vimeo {
  background-color: #aad450 !important; }

a.bg-vimeo:hover, a.bg-vimeo:focus,
button.bg-vimeo:hover,
button.bg-vimeo:focus {
  background-color: #93c130 !important; }

.bg-gray-100 {
  background-color: #ebedef !important; }

a.bg-gray-100:hover, a.bg-gray-100:focus,
button.bg-gray-100:hover,
button.bg-gray-100:focus {
  background-color: #cfd4d8 !important; }

.bg-gray-200 {
  background-color: #d8dbe0 !important; }

a.bg-gray-200:hover, a.bg-gray-200:focus,
button.bg-gray-200:hover,
button.bg-gray-200:focus {
  background-color: #bcc1c9 !important; }

.bg-gray-300 {
  background-color: #c4c9d0 !important; }

a.bg-gray-300:hover, a.bg-gray-300:focus,
button.bg-gray-300:hover,
button.bg-gray-300:focus {
  background-color: #a8afb9 !important; }

.bg-gray-400 {
  background-color: #b1b7c1 !important; }

a.bg-gray-400:hover, a.bg-gray-400:focus,
button.bg-gray-400:hover,
button.bg-gray-400:focus {
  background-color: #959daa !important; }

.bg-gray-500 {
  background-color: #9da5b1 !important; }

a.bg-gray-500:hover, a.bg-gray-500:focus,
button.bg-gray-500:hover,
button.bg-gray-500:focus {
  background-color: #818b9a !important; }

.bg-gray-600 {
  background-color: #8a93a2 !important; }

a.bg-gray-600:hover, a.bg-gray-600:focus,
button.bg-gray-600:hover,
button.bg-gray-600:focus {
  background-color: #6e798b !important; }

.bg-gray-700 {
  background-color: #768192 !important; }

a.bg-gray-700:hover, a.bg-gray-700:focus,
button.bg-gray-700:hover,
button.bg-gray-700:focus {
  background-color: #5e6877 !important; }

.bg-gray-800 {
  background-color: #636f83 !important; }

a.bg-gray-800:hover, a.bg-gray-800:focus,
button.bg-gray-800:hover,
button.bg-gray-800:focus {
  background-color: #4d5666 !important; }

.bg-gray-900 {
  background-color: #4f5d73 !important; }

a.bg-gray-900:hover, a.bg-gray-900:focus,
button.bg-gray-900:hover,
button.bg-gray-900:focus {
  background-color: #3a4555 !important; }

.bg-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem; }

.border {
  border: 1px solid #d8dbe0 !important; }

.border-top {
  border-top: 1px solid #d8dbe0 !important; }

.border-right {
  border-right: 1px solid #d8dbe0 !important; }

.border-bottom {
  border-bottom: 1px solid #d8dbe0 !important; }

.border-left {
  border-left: 1px solid #d8dbe0 !important; }

.border-0 {
  border: 0 !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-right-0 {
  border-right: 0 !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-left-0 {
  border-left: 0 !important; }

.border-primary {
  border: 1px solid !important;
  border-color: #321fdb !important; }

.border-secondary {
  border: 1px solid !important;
  border-color: #ced2d8 !important; }

.border-success {
  border: 1px solid !important;
  border-color: #2eb85c !important; }

.border-info {
  border: 1px solid !important;
  border-color: #39f !important; }

.border-warning {
  border: 1px solid !important;
  border-color: #f9b115 !important; }

.border-danger {
  border: 1px solid !important;
  border-color: #e55353 !important; }

.border-light {
  border: 1px solid !important;
  border-color: #ebedef !important; }

.border-dark {
  border: 1px solid !important;
  border-color: #636f83 !important; }

.border-white {
  border-color: #fff !important; }

.rounded-sm {
  border-radius: 0.2rem !important; }

.rounded {
  border-radius: 0.25rem !important; }

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important; }

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important; }

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important; }

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important; }

.rounded-lg {
  border-radius: 0.3rem !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-pill {
  border-radius: 50rem !important; }

.rounded-0 {
  border-radius: 0 !important; }

.b-a-0 {
  border: 0 !important; }

.b-t-0 {
  border-top: 0 !important; }

.b-r-0 {
  border-right: 0 !important; }

.b-b-0 {
  border-bottom: 0 !important; }

.b-l-0 {
  border-left: 0 !important; }

.b-a-1 {
  border: 1px solid #d8dbe0; }

.b-t-1 {
  border-top: 1px solid #d8dbe0; }

.b-r-1 {
  border-right: 1px solid #d8dbe0; }

.b-b-1 {
  border-bottom: 1px solid #d8dbe0; }

.b-l-1 {
  border-left: 1px solid #d8dbe0; }

.b-a-2 {
  border: 2px solid #d8dbe0; }

.b-t-2 {
  border-top: 2px solid #d8dbe0; }

.b-r-2 {
  border-right: 2px solid #d8dbe0; }

.b-b-2 {
  border-bottom: 2px solid #d8dbe0; }

.b-l-2 {
  border-left: 2px solid #d8dbe0; }

.content-center {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  text-align: center; }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.d-none {
  display: none !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 768px) {
  .d-md-none {
    display: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 1400px) {
  .d-xxl-none {
    display: none !important; }
  .d-xxl-inline {
    display: inline !important; }
  .d-xxl-inline-block {
    display: inline-block !important; }
  .d-xxl-block {
    display: block !important; }
  .d-xxl-table {
    display: table !important; }
  .d-xxl-table-row {
    display: table-row !important; }
  .d-xxl-table-cell {
    display: table-cell !important; }
  .d-xxl-flex {
    display: flex !important; }
  .d-xxl-inline-flex {
    display: inline-flex !important; } }

@media (max-width: 575.98px) {
  .d-down-none {
    display: none !important; } }

@media (max-width: 767.98px) {
  .d-sm-down-none {
    display: none !important; } }

@media (max-width: 991.98px) {
  .d-md-down-none {
    display: none !important; } }

@media (max-width: 1199.98px) {
  .d-lg-down-none {
    display: none !important; } }

@media (max-width: 1399.98px) {
  .d-xl-down-none {
    display: none !important; } }

.d-xxl-down-none {
  display: none !important; }

.c-default-theme .c-d-default-none {
  display: none !important; }

@media print {
  .d-print-none {
    display: none !important; }
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; } }

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden; }
  .embed-responsive::before {
    display: block;
    content: ""; }
  .embed-responsive .embed-responsive-item,
  .embed-responsive iframe,
  .embed-responsive embed,
  .embed-responsive object,
  .embed-responsive video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0; }

.embed-responsive-21by9::before {
  padding-top: 42.85714%; }

.embed-responsive-16by9::before {
  padding-top: 56.25%; }

.embed-responsive-4by3::before {
  padding-top: 75%; }

.embed-responsive-1by1::before {
  padding-top: 100%; }

.embed-responsive-21by9::before {
  padding-top: 42.85714%; }

.embed-responsive-16by9::before {
  padding-top: 56.25%; }

.embed-responsive-4by3::before {
  padding-top: 75%; }

.embed-responsive-1by1::before {
  padding-top: 100%; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-sm-fill {
    flex: 1 1 auto !important; }
  .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; } }

@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-md-fill {
    flex: 1 1 auto !important; }
  .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; } }

@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-lg-fill {
    flex: 1 1 auto !important; }
  .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; } }

@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-xl-fill {
    flex: 1 1 auto !important; }
  .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; } }

@media (min-width: 1400px) {
  .flex-xxl-row {
    flex-direction: row !important; }
  .flex-xxl-column {
    flex-direction: column !important; }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xxl-wrap {
    flex-wrap: wrap !important; }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-xxl-fill {
    flex: 1 1 auto !important; }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-xxl-start {
    justify-content: flex-start !important; }
  .justify-content-xxl-end {
    justify-content: flex-end !important; }
  .justify-content-xxl-center {
    justify-content: center !important; }
  .justify-content-xxl-between {
    justify-content: space-between !important; }
  .justify-content-xxl-around {
    justify-content: space-around !important; }
  .align-items-xxl-start {
    align-items: flex-start !important; }
  .align-items-xxl-end {
    align-items: flex-end !important; }
  .align-items-xxl-center {
    align-items: center !important; }
  .align-items-xxl-baseline {
    align-items: baseline !important; }
  .align-items-xxl-stretch {
    align-items: stretch !important; }
  .align-content-xxl-start {
    align-content: flex-start !important; }
  .align-content-xxl-end {
    align-content: flex-end !important; }
  .align-content-xxl-center {
    align-content: center !important; }
  .align-content-xxl-between {
    align-content: space-between !important; }
  .align-content-xxl-around {
    align-content: space-around !important; }
  .align-content-xxl-stretch {
    align-content: stretch !important; }
  .align-self-xxl-auto {
    align-self: auto !important; }
  .align-self-xxl-start {
    align-self: flex-start !important; }
  .align-self-xxl-end {
    align-self: flex-end !important; }
  .align-self-xxl-center {
    align-self: center !important; }
  .align-self-xxl-baseline {
    align-self: baseline !important; }
  .align-self-xxl-stretch {
    align-self: stretch !important; } }

html:not([dir="rtl"]) .float-left {
  float: left !important; }

*[dir="rtl"] .float-left {
  float: right !important; }

html:not([dir="rtl"]) .float-right {
  float: right !important; }

*[dir="rtl"] .float-right {
  float: left !important; }

.float-none {
  float: none !important; }

@media (min-width: 576px) {
  html:not([dir="rtl"]) .float-sm-left {
    float: left !important; }
  *[dir="rtl"] .float-sm-left {
    float: right !important; }
  html:not([dir="rtl"]) .float-sm-right {
    float: right !important; }
  *[dir="rtl"] .float-sm-right {
    float: left !important; }
  .float-sm-none {
    float: none !important; } }

@media (min-width: 768px) {
  html:not([dir="rtl"]) .float-md-left {
    float: left !important; }
  *[dir="rtl"] .float-md-left {
    float: right !important; }
  html:not([dir="rtl"]) .float-md-right {
    float: right !important; }
  *[dir="rtl"] .float-md-right {
    float: left !important; }
  .float-md-none {
    float: none !important; } }

@media (min-width: 992px) {
  html:not([dir="rtl"]) .float-lg-left {
    float: left !important; }
  *[dir="rtl"] .float-lg-left {
    float: right !important; }
  html:not([dir="rtl"]) .float-lg-right {
    float: right !important; }
  *[dir="rtl"] .float-lg-right {
    float: left !important; }
  .float-lg-none {
    float: none !important; } }

@media (min-width: 1200px) {
  html:not([dir="rtl"]) .float-xl-left {
    float: left !important; }
  *[dir="rtl"] .float-xl-left {
    float: right !important; }
  html:not([dir="rtl"]) .float-xl-right {
    float: right !important; }
  *[dir="rtl"] .float-xl-right {
    float: left !important; }
  .float-xl-none {
    float: none !important; } }

@media (min-width: 1400px) {
  html:not([dir="rtl"]) .float-xxl-left {
    float: left !important; }
  *[dir="rtl"] .float-xxl-left {
    float: right !important; }
  html:not([dir="rtl"]) .float-xxl-right {
    float: right !important; }
  *[dir="rtl"] .float-xxl-right {
    float: left !important; }
  .float-xxl-none {
    float: none !important; } }

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important; }

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important; }

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: sticky !important; }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020; } }

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal; }

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075) !important; }

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15) !important; }

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 21, 0.175) !important; }

.shadow-none {
  box-shadow: none !important; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.mh-100 {
  max-height: 100% !important; }

.min-vw-100 {
  min-width: 100vw !important; }

.min-vh-100 {
  min-height: 100vh !important; }

.vw-100 {
  width: 100vw !important; }

.vh-100 {
  height: 100vh !important; }

.m-0 {
  margin: 0 !important; }

.mt-0,
.my-0 {
  margin-top: 0 !important; }

.mr-0,
.mx-0 {
  margin-right: 0 !important; }

.mb-0,
.my-0 {
  margin-bottom: 0 !important; }

.ml-0,
.mx-0 {
  margin-left: 0 !important; }

html:not([dir="rtl"]) .mfs-0 {
  margin-left: 0 !important; }

*[dir="rtl"] .mfs-0 {
  margin-right: 0 !important; }

html:not([dir="rtl"]) .mfe-0 {
  margin-right: 0 !important; }

*[dir="rtl"] .mfe-0 {
  margin-left: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.mt-1,
.my-1 {
  margin-top: 0.25rem !important; }

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important; }

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important; }

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important; }

html:not([dir="rtl"]) .mfs-1 {
  margin-left: 0.25rem !important; }

*[dir="rtl"] .mfs-1 {
  margin-right: 0.25rem !important; }

html:not([dir="rtl"]) .mfe-1 {
  margin-right: 0.25rem !important; }

*[dir="rtl"] .mfe-1 {
  margin-left: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.mt-2,
.my-2 {
  margin-top: 0.5rem !important; }

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important; }

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important; }

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important; }

html:not([dir="rtl"]) .mfs-2 {
  margin-left: 0.5rem !important; }

*[dir="rtl"] .mfs-2 {
  margin-right: 0.5rem !important; }

html:not([dir="rtl"]) .mfe-2 {
  margin-right: 0.5rem !important; }

*[dir="rtl"] .mfe-2 {
  margin-left: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.mt-3,
.my-3 {
  margin-top: 1rem !important; }

.mr-3,
.mx-3 {
  margin-right: 1rem !important; }

.mb-3,
.my-3 {
  margin-bottom: 1rem !important; }

.ml-3,
.mx-3 {
  margin-left: 1rem !important; }

html:not([dir="rtl"]) .mfs-3 {
  margin-left: 1rem !important; }

*[dir="rtl"] .mfs-3 {
  margin-right: 1rem !important; }

html:not([dir="rtl"]) .mfe-3 {
  margin-right: 1rem !important; }

*[dir="rtl"] .mfe-3 {
  margin-left: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.mt-4,
.my-4 {
  margin-top: 1.5rem !important; }

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important; }

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important; }

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important; }

html:not([dir="rtl"]) .mfs-4 {
  margin-left: 1.5rem !important; }

*[dir="rtl"] .mfs-4 {
  margin-right: 1.5rem !important; }

html:not([dir="rtl"]) .mfe-4 {
  margin-right: 1.5rem !important; }

*[dir="rtl"] .mfe-4 {
  margin-left: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.mt-5,
.my-5 {
  margin-top: 3rem !important; }

.mr-5,
.mx-5 {
  margin-right: 3rem !important; }

.mb-5,
.my-5 {
  margin-bottom: 3rem !important; }

.ml-5,
.mx-5 {
  margin-left: 3rem !important; }

html:not([dir="rtl"]) .mfs-5 {
  margin-left: 3rem !important; }

*[dir="rtl"] .mfs-5 {
  margin-right: 3rem !important; }

html:not([dir="rtl"]) .mfe-5 {
  margin-right: 3rem !important; }

*[dir="rtl"] .mfe-5 {
  margin-left: 3rem !important; }

.p-0 {
  padding: 0 !important; }

.pt-0,
.py-0 {
  padding-top: 0 !important; }

.pr-0,
.px-0 {
  padding-right: 0 !important; }

.pb-0,
.py-0 {
  padding-bottom: 0 !important; }

.pl-0,
.px-0 {
  padding-left: 0 !important; }

html:not([dir="rtl"]) .pfs-0 {
  padding-left: 0 !important; }

*[dir="rtl"] .pfs-0 {
  padding-right: 0 !important; }

html:not([dir="rtl"]) .pfe-0 {
  padding-right: 0 !important; }

*[dir="rtl"] .pfe-0 {
  padding-left: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.pt-1,
.py-1 {
  padding-top: 0.25rem !important; }

.pr-1,
.px-1 {
  padding-right: 0.25rem !important; }

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important; }

.pl-1,
.px-1 {
  padding-left: 0.25rem !important; }

html:not([dir="rtl"]) .pfs-1 {
  padding-left: 0.25rem !important; }

*[dir="rtl"] .pfs-1 {
  padding-right: 0.25rem !important; }

html:not([dir="rtl"]) .pfe-1 {
  padding-right: 0.25rem !important; }

*[dir="rtl"] .pfe-1 {
  padding-left: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.pt-2,
.py-2 {
  padding-top: 0.5rem !important; }

.pr-2,
.px-2 {
  padding-right: 0.5rem !important; }

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important; }

.pl-2,
.px-2 {
  padding-left: 0.5rem !important; }

html:not([dir="rtl"]) .pfs-2 {
  padding-left: 0.5rem !important; }

*[dir="rtl"] .pfs-2 {
  padding-right: 0.5rem !important; }

html:not([dir="rtl"]) .pfe-2 {
  padding-right: 0.5rem !important; }

*[dir="rtl"] .pfe-2 {
  padding-left: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.pt-3,
.py-3 {
  padding-top: 1rem !important; }

.pr-3,
.px-3 {
  padding-right: 1rem !important; }

.pb-3,
.py-3 {
  padding-bottom: 1rem !important; }

.pl-3,
.px-3 {
  padding-left: 1rem !important; }

html:not([dir="rtl"]) .pfs-3 {
  padding-left: 1rem !important; }

*[dir="rtl"] .pfs-3 {
  padding-right: 1rem !important; }

html:not([dir="rtl"]) .pfe-3 {
  padding-right: 1rem !important; }

*[dir="rtl"] .pfe-3 {
  padding-left: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.pt-4,
.py-4 {
  padding-top: 1.5rem !important; }

.pr-4,
.px-4 {
  padding-right: 1.5rem !important; }

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important; }

.pl-4,
.px-4 {
  padding-left: 1.5rem !important; }

html:not([dir="rtl"]) .pfs-4 {
  padding-left: 1.5rem !important; }

*[dir="rtl"] .pfs-4 {
  padding-right: 1.5rem !important; }

html:not([dir="rtl"]) .pfe-4 {
  padding-right: 1.5rem !important; }

*[dir="rtl"] .pfe-4 {
  padding-left: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.pt-5,
.py-5 {
  padding-top: 3rem !important; }

.pr-5,
.px-5 {
  padding-right: 3rem !important; }

.pb-5,
.py-5 {
  padding-bottom: 3rem !important; }

.pl-5,
.px-5 {
  padding-left: 3rem !important; }

html:not([dir="rtl"]) .pfs-5 {
  padding-left: 3rem !important; }

*[dir="rtl"] .pfs-5 {
  padding-right: 3rem !important; }

html:not([dir="rtl"]) .pfe-5 {
  padding-right: 3rem !important; }

*[dir="rtl"] .pfe-5 {
  padding-left: 3rem !important; }

.m-n1 {
  margin: -0.25rem !important; }

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important; }

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important; }

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important; }

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important; }

html:not([dir="rtl"]) .mfs-n1 {
  margin-left: -0.25rem !important; }

*[dir="rtl"] .mfs-n1 {
  margin-right: -0.25rem !important; }

html:not([dir="rtl"]) .mfe-n1 {
  margin-right: -0.25rem !important; }

*[dir="rtl"] .mfe-n1 {
  margin-left: -0.25rem !important; }

.m-n2 {
  margin: -0.5rem !important; }

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important; }

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important; }

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important; }

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important; }

html:not([dir="rtl"]) .mfs-n2 {
  margin-left: -0.5rem !important; }

*[dir="rtl"] .mfs-n2 {
  margin-right: -0.5rem !important; }

html:not([dir="rtl"]) .mfe-n2 {
  margin-right: -0.5rem !important; }

*[dir="rtl"] .mfe-n2 {
  margin-left: -0.5rem !important; }

.m-n3 {
  margin: -1rem !important; }

.mt-n3,
.my-n3 {
  margin-top: -1rem !important; }

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important; }

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important; }

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important; }

html:not([dir="rtl"]) .mfs-n3 {
  margin-left: -1rem !important; }

*[dir="rtl"] .mfs-n3 {
  margin-right: -1rem !important; }

html:not([dir="rtl"]) .mfe-n3 {
  margin-right: -1rem !important; }

*[dir="rtl"] .mfe-n3 {
  margin-left: -1rem !important; }

.m-n4 {
  margin: -1.5rem !important; }

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important; }

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important; }

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important; }

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important; }

html:not([dir="rtl"]) .mfs-n4 {
  margin-left: -1.5rem !important; }

*[dir="rtl"] .mfs-n4 {
  margin-right: -1.5rem !important; }

html:not([dir="rtl"]) .mfe-n4 {
  margin-right: -1.5rem !important; }

*[dir="rtl"] .mfe-n4 {
  margin-left: -1.5rem !important; }

.m-n5 {
  margin: -3rem !important; }

.mt-n5,
.my-n5 {
  margin-top: -3rem !important; }

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important; }

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important; }

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important; }

html:not([dir="rtl"]) .mfs-n5 {
  margin-left: -3rem !important; }

*[dir="rtl"] .mfs-n5 {
  margin-right: -3rem !important; }

html:not([dir="rtl"]) .mfe-n5 {
  margin-right: -3rem !important; }

*[dir="rtl"] .mfe-n5 {
  margin-left: -3rem !important; }

.m-auto {
  margin: auto !important; }

.mt-auto,
.my-auto {
  margin-top: auto !important; }

.mr-auto,
.mx-auto {
  margin-right: auto !important; }

.mb-auto,
.my-auto {
  margin-bottom: auto !important; }

.ml-auto,
.mx-auto {
  margin-left: auto !important; }

html:not([dir="rtl"]) .mfs-auto {
  margin-left: auto !important; }

*[dir="rtl"] .mfs-auto {
  margin-right: auto !important; }

html:not([dir="rtl"]) .mfe-auto {
  margin-right: auto !important; }

*[dir="rtl"] .mfe-auto {
  margin-left: auto !important; }

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important; }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important; }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important; }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important; }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .mfs-sm-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .mfs-sm-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .mfe-sm-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .mfe-sm-0 {
    margin-left: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important; }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important; }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important; }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .mfs-sm-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .mfs-sm-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .mfe-sm-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .mfe-sm-1 {
    margin-left: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important; }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important; }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important; }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .mfs-sm-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .mfs-sm-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .mfe-sm-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .mfe-sm-2 {
    margin-left: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important; }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important; }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important; }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .mfs-sm-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .mfs-sm-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .mfe-sm-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .mfe-sm-3 {
    margin-left: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important; }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important; }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important; }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .mfs-sm-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .mfs-sm-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .mfe-sm-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .mfe-sm-4 {
    margin-left: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important; }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important; }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important; }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .mfs-sm-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .mfs-sm-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .mfe-sm-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .mfe-sm-5 {
    margin-left: 3rem !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important; }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important; }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important; }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pfs-sm-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .pfs-sm-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .pfe-sm-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pfe-sm-0 {
    padding-left: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important; }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important; }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pfs-sm-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .pfs-sm-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .pfe-sm-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pfe-sm-1 {
    padding-left: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important; }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important; }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pfs-sm-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .pfs-sm-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .pfe-sm-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pfe-sm-2 {
    padding-left: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important; }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important; }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important; }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pfs-sm-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .pfs-sm-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .pfe-sm-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pfe-sm-3 {
    padding-left: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important; }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important; }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pfs-sm-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .pfs-sm-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .pfe-sm-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pfe-sm-4 {
    padding-left: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important; }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important; }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important; }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important; }
  html:not([dir="rtl"]) .pfs-sm-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .pfs-sm-5 {
    padding-right: 3rem !important; }
  html:not([dir="rtl"]) .pfe-sm-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pfe-sm-5 {
    padding-left: 3rem !important; }
  .m-sm-n1 {
    margin: -0.25rem !important; }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important; }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important; }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important; }
  html:not([dir="rtl"]) .mfs-sm-n1 {
    margin-left: -0.25rem !important; }
  *[dir="rtl"] .mfs-sm-n1 {
    margin-right: -0.25rem !important; }
  html:not([dir="rtl"]) .mfe-sm-n1 {
    margin-right: -0.25rem !important; }
  *[dir="rtl"] .mfe-sm-n1 {
    margin-left: -0.25rem !important; }
  .m-sm-n2 {
    margin: -0.5rem !important; }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important; }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important; }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important; }
  html:not([dir="rtl"]) .mfs-sm-n2 {
    margin-left: -0.5rem !important; }
  *[dir="rtl"] .mfs-sm-n2 {
    margin-right: -0.5rem !important; }
  html:not([dir="rtl"]) .mfe-sm-n2 {
    margin-right: -0.5rem !important; }
  *[dir="rtl"] .mfe-sm-n2 {
    margin-left: -0.5rem !important; }
  .m-sm-n3 {
    margin: -1rem !important; }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important; }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important; }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important; }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important; }
  html:not([dir="rtl"]) .mfs-sm-n3 {
    margin-left: -1rem !important; }
  *[dir="rtl"] .mfs-sm-n3 {
    margin-right: -1rem !important; }
  html:not([dir="rtl"]) .mfe-sm-n3 {
    margin-right: -1rem !important; }
  *[dir="rtl"] .mfe-sm-n3 {
    margin-left: -1rem !important; }
  .m-sm-n4 {
    margin: -1.5rem !important; }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important; }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important; }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important; }
  html:not([dir="rtl"]) .mfs-sm-n4 {
    margin-left: -1.5rem !important; }
  *[dir="rtl"] .mfs-sm-n4 {
    margin-right: -1.5rem !important; }
  html:not([dir="rtl"]) .mfe-sm-n4 {
    margin-right: -1.5rem !important; }
  *[dir="rtl"] .mfe-sm-n4 {
    margin-left: -1.5rem !important; }
  .m-sm-n5 {
    margin: -3rem !important; }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important; }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important; }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important; }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important; }
  html:not([dir="rtl"]) .mfs-sm-n5 {
    margin-left: -3rem !important; }
  *[dir="rtl"] .mfs-sm-n5 {
    margin-right: -3rem !important; }
  html:not([dir="rtl"]) .mfe-sm-n5 {
    margin-right: -3rem !important; }
  *[dir="rtl"] .mfe-sm-n5 {
    margin-left: -3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important; }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important; }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important; }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important; }
  html:not([dir="rtl"]) .mfs-sm-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .mfs-sm-auto {
    margin-right: auto !important; }
  html:not([dir="rtl"]) .mfe-sm-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .mfe-sm-auto {
    margin-left: auto !important; } }

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important; }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important; }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important; }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important; }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .mfs-md-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .mfs-md-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .mfe-md-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .mfe-md-0 {
    margin-left: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important; }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important; }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important; }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .mfs-md-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .mfs-md-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .mfe-md-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .mfe-md-1 {
    margin-left: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important; }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important; }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important; }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .mfs-md-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .mfs-md-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .mfe-md-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .mfe-md-2 {
    margin-left: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important; }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important; }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important; }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .mfs-md-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .mfs-md-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .mfe-md-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .mfe-md-3 {
    margin-left: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important; }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important; }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important; }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .mfs-md-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .mfs-md-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .mfe-md-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .mfe-md-4 {
    margin-left: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important; }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important; }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important; }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .mfs-md-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .mfs-md-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .mfe-md-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .mfe-md-5 {
    margin-left: 3rem !important; }
  .p-md-0 {
    padding: 0 !important; }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important; }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important; }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important; }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pfs-md-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .pfs-md-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .pfe-md-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pfe-md-0 {
    padding-left: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important; }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important; }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important; }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pfs-md-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .pfs-md-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .pfe-md-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pfe-md-1 {
    padding-left: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important; }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important; }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important; }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pfs-md-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .pfs-md-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .pfe-md-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pfe-md-2 {
    padding-left: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important; }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important; }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important; }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pfs-md-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .pfs-md-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .pfe-md-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pfe-md-3 {
    padding-left: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important; }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important; }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important; }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pfs-md-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .pfs-md-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .pfe-md-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pfe-md-4 {
    padding-left: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important; }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important; }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important; }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important; }
  html:not([dir="rtl"]) .pfs-md-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .pfs-md-5 {
    padding-right: 3rem !important; }
  html:not([dir="rtl"]) .pfe-md-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pfe-md-5 {
    padding-left: 3rem !important; }
  .m-md-n1 {
    margin: -0.25rem !important; }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important; }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important; }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important; }
  html:not([dir="rtl"]) .mfs-md-n1 {
    margin-left: -0.25rem !important; }
  *[dir="rtl"] .mfs-md-n1 {
    margin-right: -0.25rem !important; }
  html:not([dir="rtl"]) .mfe-md-n1 {
    margin-right: -0.25rem !important; }
  *[dir="rtl"] .mfe-md-n1 {
    margin-left: -0.25rem !important; }
  .m-md-n2 {
    margin: -0.5rem !important; }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important; }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important; }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important; }
  html:not([dir="rtl"]) .mfs-md-n2 {
    margin-left: -0.5rem !important; }
  *[dir="rtl"] .mfs-md-n2 {
    margin-right: -0.5rem !important; }
  html:not([dir="rtl"]) .mfe-md-n2 {
    margin-right: -0.5rem !important; }
  *[dir="rtl"] .mfe-md-n2 {
    margin-left: -0.5rem !important; }
  .m-md-n3 {
    margin: -1rem !important; }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important; }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important; }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important; }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important; }
  html:not([dir="rtl"]) .mfs-md-n3 {
    margin-left: -1rem !important; }
  *[dir="rtl"] .mfs-md-n3 {
    margin-right: -1rem !important; }
  html:not([dir="rtl"]) .mfe-md-n3 {
    margin-right: -1rem !important; }
  *[dir="rtl"] .mfe-md-n3 {
    margin-left: -1rem !important; }
  .m-md-n4 {
    margin: -1.5rem !important; }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important; }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important; }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important; }
  html:not([dir="rtl"]) .mfs-md-n4 {
    margin-left: -1.5rem !important; }
  *[dir="rtl"] .mfs-md-n4 {
    margin-right: -1.5rem !important; }
  html:not([dir="rtl"]) .mfe-md-n4 {
    margin-right: -1.5rem !important; }
  *[dir="rtl"] .mfe-md-n4 {
    margin-left: -1.5rem !important; }
  .m-md-n5 {
    margin: -3rem !important; }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important; }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important; }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important; }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important; }
  html:not([dir="rtl"]) .mfs-md-n5 {
    margin-left: -3rem !important; }
  *[dir="rtl"] .mfs-md-n5 {
    margin-right: -3rem !important; }
  html:not([dir="rtl"]) .mfe-md-n5 {
    margin-right: -3rem !important; }
  *[dir="rtl"] .mfe-md-n5 {
    margin-left: -3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important; }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important; }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important; }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important; }
  html:not([dir="rtl"]) .mfs-md-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .mfs-md-auto {
    margin-right: auto !important; }
  html:not([dir="rtl"]) .mfe-md-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .mfe-md-auto {
    margin-left: auto !important; } }

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important; }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important; }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important; }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important; }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .mfs-lg-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .mfs-lg-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .mfe-lg-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .mfe-lg-0 {
    margin-left: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important; }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important; }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important; }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .mfs-lg-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .mfs-lg-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .mfe-lg-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .mfe-lg-1 {
    margin-left: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important; }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important; }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important; }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .mfs-lg-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .mfs-lg-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .mfe-lg-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .mfe-lg-2 {
    margin-left: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important; }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important; }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important; }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .mfs-lg-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .mfs-lg-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .mfe-lg-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .mfe-lg-3 {
    margin-left: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important; }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important; }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important; }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .mfs-lg-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .mfs-lg-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .mfe-lg-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .mfe-lg-4 {
    margin-left: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important; }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important; }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important; }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .mfs-lg-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .mfs-lg-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .mfe-lg-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .mfe-lg-5 {
    margin-left: 3rem !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important; }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important; }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important; }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pfs-lg-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .pfs-lg-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .pfe-lg-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pfe-lg-0 {
    padding-left: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important; }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important; }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pfs-lg-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .pfs-lg-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .pfe-lg-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pfe-lg-1 {
    padding-left: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important; }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important; }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pfs-lg-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .pfs-lg-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .pfe-lg-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pfe-lg-2 {
    padding-left: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important; }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important; }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important; }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pfs-lg-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .pfs-lg-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .pfe-lg-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pfe-lg-3 {
    padding-left: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important; }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important; }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pfs-lg-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .pfs-lg-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .pfe-lg-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pfe-lg-4 {
    padding-left: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important; }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important; }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important; }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important; }
  html:not([dir="rtl"]) .pfs-lg-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .pfs-lg-5 {
    padding-right: 3rem !important; }
  html:not([dir="rtl"]) .pfe-lg-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pfe-lg-5 {
    padding-left: 3rem !important; }
  .m-lg-n1 {
    margin: -0.25rem !important; }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important; }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important; }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important; }
  html:not([dir="rtl"]) .mfs-lg-n1 {
    margin-left: -0.25rem !important; }
  *[dir="rtl"] .mfs-lg-n1 {
    margin-right: -0.25rem !important; }
  html:not([dir="rtl"]) .mfe-lg-n1 {
    margin-right: -0.25rem !important; }
  *[dir="rtl"] .mfe-lg-n1 {
    margin-left: -0.25rem !important; }
  .m-lg-n2 {
    margin: -0.5rem !important; }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important; }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important; }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important; }
  html:not([dir="rtl"]) .mfs-lg-n2 {
    margin-left: -0.5rem !important; }
  *[dir="rtl"] .mfs-lg-n2 {
    margin-right: -0.5rem !important; }
  html:not([dir="rtl"]) .mfe-lg-n2 {
    margin-right: -0.5rem !important; }
  *[dir="rtl"] .mfe-lg-n2 {
    margin-left: -0.5rem !important; }
  .m-lg-n3 {
    margin: -1rem !important; }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important; }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important; }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important; }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important; }
  html:not([dir="rtl"]) .mfs-lg-n3 {
    margin-left: -1rem !important; }
  *[dir="rtl"] .mfs-lg-n3 {
    margin-right: -1rem !important; }
  html:not([dir="rtl"]) .mfe-lg-n3 {
    margin-right: -1rem !important; }
  *[dir="rtl"] .mfe-lg-n3 {
    margin-left: -1rem !important; }
  .m-lg-n4 {
    margin: -1.5rem !important; }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important; }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important; }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important; }
  html:not([dir="rtl"]) .mfs-lg-n4 {
    margin-left: -1.5rem !important; }
  *[dir="rtl"] .mfs-lg-n4 {
    margin-right: -1.5rem !important; }
  html:not([dir="rtl"]) .mfe-lg-n4 {
    margin-right: -1.5rem !important; }
  *[dir="rtl"] .mfe-lg-n4 {
    margin-left: -1.5rem !important; }
  .m-lg-n5 {
    margin: -3rem !important; }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important; }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important; }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important; }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important; }
  html:not([dir="rtl"]) .mfs-lg-n5 {
    margin-left: -3rem !important; }
  *[dir="rtl"] .mfs-lg-n5 {
    margin-right: -3rem !important; }
  html:not([dir="rtl"]) .mfe-lg-n5 {
    margin-right: -3rem !important; }
  *[dir="rtl"] .mfe-lg-n5 {
    margin-left: -3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important; }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important; }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important; }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important; }
  html:not([dir="rtl"]) .mfs-lg-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .mfs-lg-auto {
    margin-right: auto !important; }
  html:not([dir="rtl"]) .mfe-lg-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .mfe-lg-auto {
    margin-left: auto !important; } }

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important; }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important; }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important; }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important; }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .mfs-xl-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .mfs-xl-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .mfe-xl-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .mfe-xl-0 {
    margin-left: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important; }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important; }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important; }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .mfs-xl-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .mfs-xl-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .mfe-xl-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .mfe-xl-1 {
    margin-left: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important; }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important; }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important; }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .mfs-xl-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .mfs-xl-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .mfe-xl-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .mfe-xl-2 {
    margin-left: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important; }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important; }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important; }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .mfs-xl-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .mfs-xl-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .mfe-xl-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .mfe-xl-3 {
    margin-left: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important; }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important; }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important; }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .mfs-xl-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .mfs-xl-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .mfe-xl-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .mfe-xl-4 {
    margin-left: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important; }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important; }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important; }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .mfs-xl-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .mfs-xl-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .mfe-xl-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .mfe-xl-5 {
    margin-left: 3rem !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important; }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important; }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important; }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pfs-xl-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .pfs-xl-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .pfe-xl-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pfe-xl-0 {
    padding-left: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important; }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important; }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pfs-xl-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .pfs-xl-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .pfe-xl-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pfe-xl-1 {
    padding-left: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important; }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important; }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pfs-xl-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .pfs-xl-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .pfe-xl-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pfe-xl-2 {
    padding-left: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important; }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important; }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important; }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pfs-xl-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .pfs-xl-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .pfe-xl-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pfe-xl-3 {
    padding-left: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important; }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important; }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pfs-xl-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .pfs-xl-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .pfe-xl-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pfe-xl-4 {
    padding-left: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important; }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important; }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important; }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important; }
  html:not([dir="rtl"]) .pfs-xl-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .pfs-xl-5 {
    padding-right: 3rem !important; }
  html:not([dir="rtl"]) .pfe-xl-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pfe-xl-5 {
    padding-left: 3rem !important; }
  .m-xl-n1 {
    margin: -0.25rem !important; }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important; }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important; }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important; }
  html:not([dir="rtl"]) .mfs-xl-n1 {
    margin-left: -0.25rem !important; }
  *[dir="rtl"] .mfs-xl-n1 {
    margin-right: -0.25rem !important; }
  html:not([dir="rtl"]) .mfe-xl-n1 {
    margin-right: -0.25rem !important; }
  *[dir="rtl"] .mfe-xl-n1 {
    margin-left: -0.25rem !important; }
  .m-xl-n2 {
    margin: -0.5rem !important; }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important; }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important; }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important; }
  html:not([dir="rtl"]) .mfs-xl-n2 {
    margin-left: -0.5rem !important; }
  *[dir="rtl"] .mfs-xl-n2 {
    margin-right: -0.5rem !important; }
  html:not([dir="rtl"]) .mfe-xl-n2 {
    margin-right: -0.5rem !important; }
  *[dir="rtl"] .mfe-xl-n2 {
    margin-left: -0.5rem !important; }
  .m-xl-n3 {
    margin: -1rem !important; }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important; }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important; }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important; }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important; }
  html:not([dir="rtl"]) .mfs-xl-n3 {
    margin-left: -1rem !important; }
  *[dir="rtl"] .mfs-xl-n3 {
    margin-right: -1rem !important; }
  html:not([dir="rtl"]) .mfe-xl-n3 {
    margin-right: -1rem !important; }
  *[dir="rtl"] .mfe-xl-n3 {
    margin-left: -1rem !important; }
  .m-xl-n4 {
    margin: -1.5rem !important; }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important; }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important; }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important; }
  html:not([dir="rtl"]) .mfs-xl-n4 {
    margin-left: -1.5rem !important; }
  *[dir="rtl"] .mfs-xl-n4 {
    margin-right: -1.5rem !important; }
  html:not([dir="rtl"]) .mfe-xl-n4 {
    margin-right: -1.5rem !important; }
  *[dir="rtl"] .mfe-xl-n4 {
    margin-left: -1.5rem !important; }
  .m-xl-n5 {
    margin: -3rem !important; }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important; }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important; }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important; }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important; }
  html:not([dir="rtl"]) .mfs-xl-n5 {
    margin-left: -3rem !important; }
  *[dir="rtl"] .mfs-xl-n5 {
    margin-right: -3rem !important; }
  html:not([dir="rtl"]) .mfe-xl-n5 {
    margin-right: -3rem !important; }
  *[dir="rtl"] .mfe-xl-n5 {
    margin-left: -3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important; }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important; }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important; }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important; }
  html:not([dir="rtl"]) .mfs-xl-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .mfs-xl-auto {
    margin-right: auto !important; }
  html:not([dir="rtl"]) .mfe-xl-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .mfe-xl-auto {
    margin-left: auto !important; } }

@media (min-width: 1400px) {
  .m-xxl-0 {
    margin: 0 !important; }
  .mt-xxl-0,
  .my-xxl-0 {
    margin-top: 0 !important; }
  .mr-xxl-0,
  .mx-xxl-0 {
    margin-right: 0 !important; }
  .mb-xxl-0,
  .my-xxl-0 {
    margin-bottom: 0 !important; }
  .ml-xxl-0,
  .mx-xxl-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .mfs-xxl-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .mfs-xxl-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .mfe-xxl-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .mfe-xxl-0 {
    margin-left: 0 !important; }
  .m-xxl-1 {
    margin: 0.25rem !important; }
  .mt-xxl-1,
  .my-xxl-1 {
    margin-top: 0.25rem !important; }
  .mr-xxl-1,
  .mx-xxl-1 {
    margin-right: 0.25rem !important; }
  .mb-xxl-1,
  .my-xxl-1 {
    margin-bottom: 0.25rem !important; }
  .ml-xxl-1,
  .mx-xxl-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .mfs-xxl-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .mfe-xxl-1 {
    margin-left: 0.25rem !important; }
  .m-xxl-2 {
    margin: 0.5rem !important; }
  .mt-xxl-2,
  .my-xxl-2 {
    margin-top: 0.5rem !important; }
  .mr-xxl-2,
  .mx-xxl-2 {
    margin-right: 0.5rem !important; }
  .mb-xxl-2,
  .my-xxl-2 {
    margin-bottom: 0.5rem !important; }
  .ml-xxl-2,
  .mx-xxl-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .mfs-xxl-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .mfe-xxl-2 {
    margin-left: 0.5rem !important; }
  .m-xxl-3 {
    margin: 1rem !important; }
  .mt-xxl-3,
  .my-xxl-3 {
    margin-top: 1rem !important; }
  .mr-xxl-3,
  .mx-xxl-3 {
    margin-right: 1rem !important; }
  .mb-xxl-3,
  .my-xxl-3 {
    margin-bottom: 1rem !important; }
  .ml-xxl-3,
  .mx-xxl-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .mfs-xxl-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .mfe-xxl-3 {
    margin-left: 1rem !important; }
  .m-xxl-4 {
    margin: 1.5rem !important; }
  .mt-xxl-4,
  .my-xxl-4 {
    margin-top: 1.5rem !important; }
  .mr-xxl-4,
  .mx-xxl-4 {
    margin-right: 1.5rem !important; }
  .mb-xxl-4,
  .my-xxl-4 {
    margin-bottom: 1.5rem !important; }
  .ml-xxl-4,
  .mx-xxl-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .mfs-xxl-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .mfe-xxl-4 {
    margin-left: 1.5rem !important; }
  .m-xxl-5 {
    margin: 3rem !important; }
  .mt-xxl-5,
  .my-xxl-5 {
    margin-top: 3rem !important; }
  .mr-xxl-5,
  .mx-xxl-5 {
    margin-right: 3rem !important; }
  .mb-xxl-5,
  .my-xxl-5 {
    margin-bottom: 3rem !important; }
  .ml-xxl-5,
  .mx-xxl-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .mfs-xxl-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .mfe-xxl-5 {
    margin-left: 3rem !important; }
  .p-xxl-0 {
    padding: 0 !important; }
  .pt-xxl-0,
  .py-xxl-0 {
    padding-top: 0 !important; }
  .pr-xxl-0,
  .px-xxl-0 {
    padding-right: 0 !important; }
  .pb-xxl-0,
  .py-xxl-0 {
    padding-bottom: 0 !important; }
  .pl-xxl-0,
  .px-xxl-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pfs-xxl-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .pfs-xxl-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .pfe-xxl-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pfe-xxl-0 {
    padding-left: 0 !important; }
  .p-xxl-1 {
    padding: 0.25rem !important; }
  .pt-xxl-1,
  .py-xxl-1 {
    padding-top: 0.25rem !important; }
  .pr-xxl-1,
  .px-xxl-1 {
    padding-right: 0.25rem !important; }
  .pb-xxl-1,
  .py-xxl-1 {
    padding-bottom: 0.25rem !important; }
  .pl-xxl-1,
  .px-xxl-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pfs-xxl-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .pfs-xxl-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .pfe-xxl-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pfe-xxl-1 {
    padding-left: 0.25rem !important; }
  .p-xxl-2 {
    padding: 0.5rem !important; }
  .pt-xxl-2,
  .py-xxl-2 {
    padding-top: 0.5rem !important; }
  .pr-xxl-2,
  .px-xxl-2 {
    padding-right: 0.5rem !important; }
  .pb-xxl-2,
  .py-xxl-2 {
    padding-bottom: 0.5rem !important; }
  .pl-xxl-2,
  .px-xxl-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pfs-xxl-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .pfs-xxl-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .pfe-xxl-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pfe-xxl-2 {
    padding-left: 0.5rem !important; }
  .p-xxl-3 {
    padding: 1rem !important; }
  .pt-xxl-3,
  .py-xxl-3 {
    padding-top: 1rem !important; }
  .pr-xxl-3,
  .px-xxl-3 {
    padding-right: 1rem !important; }
  .pb-xxl-3,
  .py-xxl-3 {
    padding-bottom: 1rem !important; }
  .pl-xxl-3,
  .px-xxl-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pfs-xxl-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .pfs-xxl-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .pfe-xxl-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pfe-xxl-3 {
    padding-left: 1rem !important; }
  .p-xxl-4 {
    padding: 1.5rem !important; }
  .pt-xxl-4,
  .py-xxl-4 {
    padding-top: 1.5rem !important; }
  .pr-xxl-4,
  .px-xxl-4 {
    padding-right: 1.5rem !important; }
  .pb-xxl-4,
  .py-xxl-4 {
    padding-bottom: 1.5rem !important; }
  .pl-xxl-4,
  .px-xxl-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pfs-xxl-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .pfs-xxl-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .pfe-xxl-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pfe-xxl-4 {
    padding-left: 1.5rem !important; }
  .p-xxl-5 {
    padding: 3rem !important; }
  .pt-xxl-5,
  .py-xxl-5 {
    padding-top: 3rem !important; }
  .pr-xxl-5,
  .px-xxl-5 {
    padding-right: 3rem !important; }
  .pb-xxl-5,
  .py-xxl-5 {
    padding-bottom: 3rem !important; }
  .pl-xxl-5,
  .px-xxl-5 {
    padding-left: 3rem !important; }
  html:not([dir="rtl"]) .pfs-xxl-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .pfs-xxl-5 {
    padding-right: 3rem !important; }
  html:not([dir="rtl"]) .pfe-xxl-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pfe-xxl-5 {
    padding-left: 3rem !important; }
  .m-xxl-n1 {
    margin: -0.25rem !important; }
  .mt-xxl-n1,
  .my-xxl-n1 {
    margin-top: -0.25rem !important; }
  .mr-xxl-n1,
  .mx-xxl-n1 {
    margin-right: -0.25rem !important; }
  .mb-xxl-n1,
  .my-xxl-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-xxl-n1,
  .mx-xxl-n1 {
    margin-left: -0.25rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-n1 {
    margin-left: -0.25rem !important; }
  *[dir="rtl"] .mfs-xxl-n1 {
    margin-right: -0.25rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-n1 {
    margin-right: -0.25rem !important; }
  *[dir="rtl"] .mfe-xxl-n1 {
    margin-left: -0.25rem !important; }
  .m-xxl-n2 {
    margin: -0.5rem !important; }
  .mt-xxl-n2,
  .my-xxl-n2 {
    margin-top: -0.5rem !important; }
  .mr-xxl-n2,
  .mx-xxl-n2 {
    margin-right: -0.5rem !important; }
  .mb-xxl-n2,
  .my-xxl-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-xxl-n2,
  .mx-xxl-n2 {
    margin-left: -0.5rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-n2 {
    margin-left: -0.5rem !important; }
  *[dir="rtl"] .mfs-xxl-n2 {
    margin-right: -0.5rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-n2 {
    margin-right: -0.5rem !important; }
  *[dir="rtl"] .mfe-xxl-n2 {
    margin-left: -0.5rem !important; }
  .m-xxl-n3 {
    margin: -1rem !important; }
  .mt-xxl-n3,
  .my-xxl-n3 {
    margin-top: -1rem !important; }
  .mr-xxl-n3,
  .mx-xxl-n3 {
    margin-right: -1rem !important; }
  .mb-xxl-n3,
  .my-xxl-n3 {
    margin-bottom: -1rem !important; }
  .ml-xxl-n3,
  .mx-xxl-n3 {
    margin-left: -1rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-n3 {
    margin-left: -1rem !important; }
  *[dir="rtl"] .mfs-xxl-n3 {
    margin-right: -1rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-n3 {
    margin-right: -1rem !important; }
  *[dir="rtl"] .mfe-xxl-n3 {
    margin-left: -1rem !important; }
  .m-xxl-n4 {
    margin: -1.5rem !important; }
  .mt-xxl-n4,
  .my-xxl-n4 {
    margin-top: -1.5rem !important; }
  .mr-xxl-n4,
  .mx-xxl-n4 {
    margin-right: -1.5rem !important; }
  .mb-xxl-n4,
  .my-xxl-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-xxl-n4,
  .mx-xxl-n4 {
    margin-left: -1.5rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-n4 {
    margin-left: -1.5rem !important; }
  *[dir="rtl"] .mfs-xxl-n4 {
    margin-right: -1.5rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-n4 {
    margin-right: -1.5rem !important; }
  *[dir="rtl"] .mfe-xxl-n4 {
    margin-left: -1.5rem !important; }
  .m-xxl-n5 {
    margin: -3rem !important; }
  .mt-xxl-n5,
  .my-xxl-n5 {
    margin-top: -3rem !important; }
  .mr-xxl-n5,
  .mx-xxl-n5 {
    margin-right: -3rem !important; }
  .mb-xxl-n5,
  .my-xxl-n5 {
    margin-bottom: -3rem !important; }
  .ml-xxl-n5,
  .mx-xxl-n5 {
    margin-left: -3rem !important; }
  html:not([dir="rtl"]) .mfs-xxl-n5 {
    margin-left: -3rem !important; }
  *[dir="rtl"] .mfs-xxl-n5 {
    margin-right: -3rem !important; }
  html:not([dir="rtl"]) .mfe-xxl-n5 {
    margin-right: -3rem !important; }
  *[dir="rtl"] .mfe-xxl-n5 {
    margin-left: -3rem !important; }
  .m-xxl-auto {
    margin: auto !important; }
  .mt-xxl-auto,
  .my-xxl-auto {
    margin-top: auto !important; }
  .mr-xxl-auto,
  .mx-xxl-auto {
    margin-right: auto !important; }
  .mb-xxl-auto,
  .my-xxl-auto {
    margin-bottom: auto !important; }
  .ml-xxl-auto,
  .mx-xxl-auto {
    margin-left: auto !important; }
  html:not([dir="rtl"]) .mfs-xxl-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .mfs-xxl-auto {
    margin-right: auto !important; }
  html:not([dir="rtl"]) .mfe-xxl-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .mfe-xxl-auto {
    margin-left: auto !important; } }

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 21, 0); }

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important; }

.text-justify {
  text-align: justify !important; }

.text-wrap {
  white-space: normal !important; }

.text-nowrap {
  white-space: nowrap !important; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.text-left {
  text-align: left !important; }

.text-right {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important; }
  .text-sm-right {
    text-align: right !important; }
  .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important; }
  .text-md-right {
    text-align: right !important; }
  .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important; }
  .text-lg-right {
    text-align: right !important; }
  .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important; }
  .text-xl-right {
    text-align: right !important; }
  .text-xl-center {
    text-align: center !important; } }

@media (min-width: 1400px) {
  .text-xxl-left {
    text-align: left !important; }
  .text-xxl-right {
    text-align: right !important; }
  .text-xxl-center {
    text-align: center !important; } }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.font-weight-light {
  font-weight: 300 !important; }

.font-weight-lighter {
  font-weight: lighter !important; }

.font-weight-normal {
  font-weight: 400 !important; }

.font-weight-bold {
  font-weight: 700 !important; }

.font-weight-bolder {
  font-weight: bolder !important; }

.font-italic {
  font-style: italic !important; }

.text-white {
  color: #fff !important; }

.text-primary {
  color: #321fdb !important; }

a.text-primary:hover, a.text-primary:focus {
  color: #231698 !important; }

.text-secondary {
  color: #ced2d8 !important; }

a.text-secondary:hover, a.text-secondary:focus {
  color: #a3abb6 !important; }

.text-success {
  color: #2eb85c !important; }

a.text-success:hover, a.text-success:focus {
  color: #1f7b3d !important; }

.text-info {
  color: #39f !important; }

a.text-info:hover, a.text-info:focus {
  color: #0073e6 !important; }

.text-warning {
  color: #f9b115 !important; }

a.text-warning:hover, a.text-warning:focus {
  color: #bd8305 !important; }

.text-danger {
  color: #e55353 !important; }

a.text-danger:hover, a.text-danger:focus {
  color: #cd1f1f !important; }

.text-light {
  color: #ebedef !important; }

a.text-light:hover, a.text-light:focus {
  color: #c1c7cd !important; }

.text-dark {
  color: #636f83 !important; }

a.text-dark:hover, a.text-dark:focus {
  color: #424a57 !important; }

.text-body {
  color: #3c4b64 !important; }

.text-muted {
  color: #768192 !important; }

.text-black-50 {
  color: rgba(0, 0, 21, 0.5) !important; }

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important; }

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0; }

.text-decoration-none {
  text-decoration: none !important; }

.text-break {
  word-break: break-word !important;
  overflow-wrap: break-word !important; }

.text-reset {
  color: inherit !important; }

body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased; }

.font-xs {
  font-size: .75rem !important; }

.font-sm {
  font-size: .85rem !important; }

.font-lg {
  font-size: 1rem !important; }

.font-xl {
  font-size: 1.25rem !important; }

.font-2xl {
  font-size: 1.5rem !important; }

.font-3xl {
  font-size: 1.75rem !important; }

.font-4xl {
  font-size: 2rem !important; }

.font-5xl {
  font-size: 2.5rem !important; }

[class^="text-value"] {
  font-weight: 600; }

.text-value-xs {
  font-size: 0.65625rem; }

.text-value-sm {
  font-size: 0.74375rem; }

.text-value {
  font-size: 0.875rem; }

.text-value-lg {
  font-size: 1.3125rem; }

.text-value-xl {
  font-size: 1.53125rem; }

.text-white .text-muted {
  color: rgba(255, 255, 255, 0.6) !important; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

*[dir="rtl"] {
  direction: rtl;
  unicode-bidi: embed; }
  *[dir="rtl"] body {
    text-align: right; }

.ie-custom-properties {
  primary: #321fdb;
  secondary: #ced2d8;
  success: #2eb85c;
  info: #39f;
  warning: #f9b115;
  danger: #e55353;
  light: #ebedef;
  dark: #636f83;
  breakpoint-xs: 0;
  breakpoint-sm: 576px;
  breakpoint-md: 768px;
  breakpoint-lg: 992px;
  breakpoint-xl: 1200px;
  breakpoint-xxl: 1400px; }

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important; }
  a:not(.btn) {
    text-decoration: underline; }
  abbr[title]::after {
    content: " (" attr(title) ")"; }
  pre {
    white-space: pre-wrap !important; }
  pre,
  blockquote {
    border: 1px solid #9da5b1;
    page-break-inside: avoid; }
  thead {
    display: table-header-group; }
  tr,
  img {
    page-break-inside: avoid; }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3; }
  h2,
  h3 {
    page-break-after: avoid; }
  @page {
    size: a3; }
  body {
    min-width: 992px !important; }
  .container {
    min-width: 992px !important; }
  .navbar {
    display: none; }
  .badge {
    border: 1px solid #000015; }
  .table {
    border-collapse: collapse !important; }
    .table td,
    .table th {
      background-color: #fff !important; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #c4c9d0 !important; }
  .table-dark {
    color: inherit; }
    .table-dark th,
    .table-dark td,
    .table-dark thead th,
    .table-dark tbody + tbody {
      border-color: #d8dbe0; }
  .table .thead-dark th {
    color: inherit;
    border-color: #d8dbe0; } }

button:disabled {
  cursor: default; }

button.disabled {
  cursor: default; }

.btn-brand:not(:only-child) .c-icon {
  margin-top: 0 !important; }

.c-main {
  background: #000000; }

.c-header {
  background: #2c2c34;
  border-bottom: 0; }

.c-header .c-subheader {
  border-bottom: 0;
  background: #2c2c34;
  margin-top: -1px;
  border-top: 1px solid #000000; }

.c-header .c-header-nav .c-header-nav-link,
.c-header .c-header-nav .c-header-nav-btn {
  color: #f5eeee;
  text-align: center; }
  .c-header .c-header-nav .c-header-nav-link:hover,
  .c-header .c-header-nav .c-header-nav-btn:hover {
    color: #9be5ee;
    cursor: pointer;
    cursor: hand; }
  .c-header .c-header-nav .c-header-nav-link:focus,
  .c-header .c-header-nav .c-header-nav-btn:focus {
    color: #9be5ee; }

.c-subheader .c-subheader-nav .c-subheader-nav-link,
.c-subheader .c-subheader-nav .c-subheader-nav-btn {
  color: rgba(26, 228, 26, 0.75); }

.container {
  position: relative; }

.image {
  display: block;
  width: 100%; }

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-image: linear-gradient(to right, #46c7fe 0, #a069ff 51%, #46c7fe 100%); }

.container:hover .overlay {
  opacity: 0.8; }

.text {
  color: white;
  font-size: 13px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center; }

.passkey__modal__title {
  font-family: Inter;
  font-size: 22px;
  font-weight: 700;
  text-align: left;
  color: "#000000"; }

.passkey__title {
  font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  line-height: 21.78px;
  text-align: left;
  color: #1e1e1e; }

.passkey__subtitle {
  font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  line-height: 21.78px;
  text-align: left;
  color: #897c7c;
  padding-top: 49px; }

.passkey__modal__footer {
  border-top: none !important;
  display: flex;
  justify-content: center; }

.passkey__modal__btn--primary {
  background-color: #364ee8;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 59px;
  padding-right: 59px;
  color: #ffffff;
  font-family: Inter;
  font-weight: 500;
  font-size: 18px;
  border-radius: 8px; }
  .passkey__modal__btn--primary:hover {
    color: #ffffff; }

.passkey__modal__btn--secondary {
  border-radius: 8px;
  background-color: #d9d9d9;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 59px;
  padding-right: 59px;
  color: #897c7c;
  font-family: Inter;
  font-weight: 500;
  font-size: 18px; }
  .passkey__modal__btn--secondary:hover {
    color: #897c7c; }

@media (max-width: 767px) {
  .img-responsive {
    display: none; }
  .img-mobile-image {
    display: block !important; } }
`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./node_modules/@coreui/coreui/scss/coreui.scss","webpack://./node_modules/@coreui/coreui/scss/_root.scss","webpack://./node_modules/@coreui/coreui/scss/_app.scss","webpack://./node_modules/@coreui/coreui/scss/variables/_colors.scss","webpack://./node_modules/@coreui/coreui/scss/_reboot.scss","webpack://./node_modules/@coreui/coreui/scss/variables/_typography.scss","webpack://./node_modules/@coreui/coreui/scss/vendors/_rfs.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_ltr.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_rtl.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_links.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_hover.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_tables.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_buttons-forms.scss","webpack://./node_modules/@coreui/coreui/scss/vendors/_perfect-scrollbar.scss","webpack://./node_modules/@coreui/coreui/scss/vendors/tippyjs/animations/fade.scss","webpack://./node_modules/@coreui/coreui/scss/vendors/tippyjs/popover.scss","webpack://./node_modules/@coreui/coreui/scss/variables/_z-index.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_popovers.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_reset-text.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_border-radius.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_shared.scss","webpack://./node_modules/@coreui/coreui/scss/_functions.scss","webpack://./node_modules/@coreui/coreui/scss/vendors/tippyjs/index.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_tooltips.scss","webpack://./node_modules/@coreui/coreui/scss/_alert.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_alerts.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_alert.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_gradients.scss","webpack://./node_modules/@coreui/coreui/scss/_avatars.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_avatars.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_avatars.scss","webpack://./node_modules/@coreui/coreui/scss/variables/_options.scss","webpack://./node_modules/@coreui/coreui/scss/_badge.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_badges.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_transition.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_badge.scss","webpack://./node_modules/@coreui/coreui/scss/_breadcrumb-menu.scss","webpack://./node_modules/@coreui/coreui/scss/_breadcrumb.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_breadcrumb.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_borders.scss","webpack://./node_modules/@coreui/coreui/scss/_button-group.scss","webpack://./node_modules/@coreui/coreui/scss/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/variables/_brand-colors.scss","webpack://./node_modules/@coreui/coreui/scss/_callout.scss","webpack://./node_modules/@coreui/coreui/scss/variables/_spacing.scss","webpack://./node_modules/@coreui/coreui/scss/_card.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_cards.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_breakpoints.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_card-accent.scss","webpack://./node_modules/@coreui/coreui/scss/_carousel.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_clearfix.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_carousel.scss","webpack://./node_modules/@coreui/coreui/scss/_charts.scss","webpack://./node_modules/@coreui/coreui/scss/_close.scss","webpack://./node_modules/@coreui/coreui/scss/_code.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_code.scss","webpack://./node_modules/@coreui/coreui/scss/_custom-forms.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_custom-forms.scss","webpack://./node_modules/@coreui/coreui/scss/_dropdown.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_caret.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_dropdowns.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_nav-divider.scss","webpack://./node_modules/@coreui/coreui/scss/_footer.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_footer.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_themes.scss","webpack://./node_modules/@coreui/coreui/scss/_forms.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_forms.scss","webpack://./node_modules/@coreui/coreui/scss/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/variables/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_grid-framework.scss","webpack://./node_modules/@coreui/coreui/scss/_header.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_header.scss","webpack://./node_modules/@coreui/coreui/scss/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/_input-group.scss","webpack://./node_modules/@coreui/coreui/scss/_images.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_image.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_images.scss","webpack://./node_modules/@coreui/coreui/scss/_jumbotron.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_jumbotron.scss","webpack://./node_modules/@coreui/coreui/scss/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/_media.scss","webpack://./node_modules/@coreui/coreui/scss/_modal.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_modals.scss","webpack://./node_modules/@coreui/coreui/scss/_nav.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_navs.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_sidebar.scss","webpack://./node_modules/@coreui/coreui/scss/_navbar.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_navbar.scss","webpack://./node_modules/@coreui/coreui/scss/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_lists.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/_popover.scss","webpack://./node_modules/@coreui/coreui/scss/_progress.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_progress-bars.scss","webpack://./node_modules/@coreui/coreui/scss/_progress-group.scss","webpack://./node_modules/@coreui/coreui/scss/_sidebar.scss","webpack://./node_modules/@coreui/coreui/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/_spinners.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_spinners.scss","webpack://./node_modules/@coreui/coreui/scss/_subheader.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_subheader.scss","webpack://./node_modules/@coreui/coreui/scss/_switches.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_switches.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_switches.scss","webpack://./node_modules/@coreui/coreui/scss/_tables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_table-row.scss","webpack://./node_modules/@coreui/coreui/scss/_toasts.scss","webpack://./node_modules/@coreui/coreui/scss/variables/components/_toasts.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_toasts.scss","webpack://./node_modules/@coreui/coreui/scss/_tooltip.scss","webpack://./node_modules/@coreui/coreui/scss/_transitions.scss","webpack://./node_modules/@coreui/coreui/scss/_type.scss","webpack://./node_modules/@coreui/coreui/scss/layouts/_default.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_align.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_background-variant.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_background.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_borders.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_center.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_display.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_embed.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_flex.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_float.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_interactions.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_overflow.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_position.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_screenreaders.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_screen-reader.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_shadows.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_sizing.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_spacing.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_stretched-link.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_text.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_text-truncate.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_text-emphasis.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_text-hide.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_typography.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_visibility.scss","webpack://./node_modules/@coreui/coreui/scss/_rtl.scss","webpack://./node_modules/@coreui/coreui/scss/_ie-custom-properties.scss","webpack://./node_modules/@coreui/coreui/scss/_print.scss","webpack://./node_modules/@coreui/coreui/scss/variables/_printing.scss","webpack://./src/scss/_fixes.scss","webpack://./src/scss/_custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;EDOE;AEPF;EAOI,kBAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,eAAc;EAId,kBAAiC;EAAjC,sBAAiC;EAAjC,sBAAiC;EAAjC,sBAAiC;EAAjC,uBAAiC;EAAjC,wBAAiC;EAKnC,+MAAyB;EACzB,6GAAwB,EAAA;;ACjB1B;EAEI,kBAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,eAAc;EAGd,cCEgB;EDDhB,yBCEgB;EDAhB,gBAAQ,EAAA;;AEUZ;;;EAGE,sBAAsB,EAAA;;AAGxB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,8CDvBc,EAAA;;AC6BhB;EACE,cAAc,EAAA;;AAWhB;EACE,SAAS;EAET,kBAAkB;EAClB,kMC7C6M;EC0HzM,mBAtCY;EFrChB,gBCpCwB;EDqCxB,gBChCqB;EDiCrB,gBAAgB;EAEd,cDjDgB;ECkDhB,yBDjDgB,EAAA;;AJyDpB;EKME,qBAAqB,EAAA;;AASvB;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB,EAAA;;AAanB;EACE,aAAa;EACb,qBCpEmC,EAAA;;AD2ErC;EACE,aAAa;EACb,mBC1B6B,EAAA;;ADqC/B;;EAEE,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,sCAA8B;UAA9B,8BAA8B,EAAA;;AAGhC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB;;;EAGE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;;;EAIE,gBAAgB,EAAA;;AAGlB;EACE,gBCnIwB,EAAA;;ADsI1B;EACE,oBAAoB,EAAA;EGpJd;IHsJJ,cAAc,EAAA;EItJV;IJyJJ,eAAe,EAAA;;AAInB;EACE,gBAAgB,EAAA;;AAGlB;;EAEE,mBCrJ2B,EAAA;;ADwJ7B;EElGI,cAAW,EAAA;;AF2Gf;;EAEE,kBAAkB;EE7GhB,cAAW;EF+Gb,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EAAM,cAAc,EAAA;;AACpB;EAAM,UAAU,EAAA;;AAOhB;EACE,qBKhM6C;ELiM7C,6BAA6B;EAE3B,cDxJmB,EAAA;EOnCrB;IACE;MN8LA,0BKtMgD;MLwM9C,cD9JiB,EAAA,EOlCG;;AN0M1B;EACE,cAAc;EACd,qBAAqB,EAAA;EM7MrB;IACE;MN+MA,cAAc;MACd,qBAAqB,EAAA,EMhNC;;ANyN1B;;;;EAIE,iGCpO4G;ECkE1G,cAAW,EAAA;;AFsKf;EAEE,aAAa;EAEb,mBAAmB;EAEnB,cAAc;EAGd,6BAA6B,EAAA;;AAQ/B;EAEE,gBAAgB,EAAA;;AAQlB;EACE,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB;EAGE,gBAAgB;EAChB,sBAAsB,EAAA;;AAQxB;EACE,yBAAyB,EAAA;;AAG3B;EACE,oBO3R8B;EP4R9B,uBO5R8B;EP6R9B,cDnRkB;ECoRlB,gBAAgB;EAChB,oBAAoB,EAAA;;AAGtB;EAGE,mBAAmB,EAAA;;AAQrB;EAEE,qBAAqB;EACrB,qBQzO0B,EAAA;;AR+O5B;EAEE,gBAAgB,EAAA;;AAOlB;EACE,mBAAmB;EACnB,0CAA0C,EAAA;;AAG5C;;;;;EAKE,SAAS;EACT,oBAAoB;EEtQlB,kBAAW;EFwQb,oBAAoB,EAAA;;AAGtB;;EAEE,iBAAiB,EAAA;;AAGnB;;EAEE,oBAAoB,EAAA;;AL5HtB;EKmIE,eAAe,EAAA;;AAMjB;EACE,iBAAiB,EAAA;;AAOnB;;;;EAIE,0BAA0B,EAAA;;AAK1B;;;;EAKI,eAAe,EAAA;;AAMrB;;;;EAIE,UAAU;EACV,kBAAkB,EAAA;;AAGpB;;EAEE,sBAAsB;EACtB,UAAU,EAAA;;AAGZ;EACE,cAAc;EAEd,gBAAgB,EAAA;;AAGlB;EAME,YAAY;EAEZ,UAAU;EACV,SAAS;EACT,SAAS,EAAA;;AAKX;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EE5ShB,iBAtCY;EFoVhB,oBAAoB;EACpB,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB,EAAA;;AL/J1B;;EKqKE,YAAY,EAAA;;ALjKd;EKyKE,oBAAoB;EACpB,wBAAwB,EAAA;;ALtK1B;EK8KE,wBAAwB,EAAA;;AAQ1B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAO5B;EACE,qBAAqB,EAAA;;AAGvB;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,aAAa,EAAA;;ALxLf;EK8LE,wBAAwB,EAAA;;AS1e1B;EACE,2BAA2B;EAE3B,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB,EAAA;;AAGvB;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,UAAU;EACV,2DAA2D,EAAA;;AAG7D;EACE,kBAAkB;EAOlB,aAAa;EACb,WAAW;EACX,UAAU;EACV,2DAA2D,EAAA;ENzBrD;IMiBJ,QAAQ,EAAA;ELjBJ;IKoBJ,OAAO,EAAA;;AAQX;;EAEE,cAAc;EACd,6BAA6B,EAAA;;AAG/B;;;;;;EAME,WAAW,EAAA;;AAGb;;;;EAIE,sBAAsB;EACtB,WAAW,EAAA;;AAGb;;EdySE;ActSF;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,+DAA+D,EAAA;;AAGjE;EACE,kBAAkB;EAOlB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,8DAA8D,EAAA;EN1ExD;IMkEJ,UAAU,EAAA;ELlEN;IKqEJ,SAAS,EAAA;;AAQb;;EAEE,YAAY;EACZ,sBAAsB,EAAA;;AAGxB;;EAEE,WAAW;EACX,sBAAsB,EAAA;;AAGY;EA5FpC;IA8FI,yBAAyB,EAAA,EAC1B;;AAGH;EAlGA;IAoGI,yBAAyB,EAAA,EAC1B;;ACpGH;EAEI,UAAU,EAAA;;ACJd;EACE,aCU2B;EDT3B,cAAc;EACd,gBEC2B;ECH3B,kMbI6M;EaF7M,kBAAkB;EAClB,gBbYwB;EaXxB,gBbgBqB;EafrB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EZgHZ,qBAtCY;ESnFhB,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAmC;EIUjC,qBCMqB;ELXrB,sBZTS;EYUT,iCZTY,EAAA;EYLhB;IAkBI,eAAe;IACf,UAAU;IACV,WAAc;IAAd,cAAc;IACd,gBAAmB;IAAnB,mBAAmB;IACnB,6BAAyB;IAAzB,yBAAyB;IACzB,gBAAsB;IAAtB,sBAAsB,EAAA;EAvB1B;IA2BI,kBAAkB;IAClB,cAAc;IACd,kBAAkB,EAAA;IA7BtB;MAiCM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;EArCzB;IA4DM,aMiEuB;INhEvB,cE3CuB;IF4CvB,iBKtCmB,EAAA;ILxBzB;MAiEQ,UAAU,EAAA;EAjElB;IAyEM,aEvDuB;IFwDvB,cMmDuB;INlDvB,iBAAiC;IACjC,SAAS,EAAA;EA5Ef;IAoFM,2BMgE0D,EAAA;INpJhE;MAuFQ,SAAS;MACT,6BAAgE;MAE9D,sCE5DsD,EAAA;IF9BhE;MA+FQ,WKtFW;MLuFX,6BAAgE;MAE9D,sBZ9FG,EAAA;EYJb;IA2GM,wBMyC0D,EAAA;INpJhE;MA8GQ,MAAM;MACN,oCAA2F;MAEzF,yCEnFsD,EAAA;IF9BhE;MAsHQ,QK7GW;ML8GX,oCAA2F;MAEzF,yBZrHG,EAAA;EYJb;IAkIM,0BMkB0D,EAAA;INpJhE;MAqIQ,QAAQ;MACR,oCEpHqB;MFsHnB,uCE1GsD,EAAA;IF9BhE;MA6IQ,UKpIW;MLqIX,oCE5HqB;MF8HnB,uBZ5IG,EAAA;EYJb;IA0JM,yBMN0D,EAAA;INpJhE;MA6JQ,OAAO;MACP,oCAA2F;MAEzF,wCElIsD,EAAA;IF9BhE;MAqKQ,SK5JW;ML6JX,oCAA2F;MAEzF,wBZpKG,EAAA;;AmBCb;EACE,0BAA0B;EAC1B,wCAAwC,EAAA;;AvBoe1C;EuBheE,6BAA6B,EAAA;;AAG/B;EACE,kBAAkB;EAClB,aNJ2B;EMK3B,cAAc;EACd,SCRwB;ELTxB,kMbI6M;EaF7M,kBAAkB;EAClB,gBbYwB;EaXxB,gBbgBqB;EafrB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EZgHZ,qBAtCY;EgBjEhB,qBAAqB;EACrB,UAAU;EACV,mDAAmD,EAAA;EAZrD;IAeI,SAAS,EAAA;IAfb;MAkBM,eCnBwB;MDoBxB,OAAO;MACP,6BAAgE;MAChE,8BAAyB;MAAzB,yBAAyB,EAAA;EArB/B;IA0BI,MAAM,EAAA;IA1BV;MA6BM,YC9BwB;MD+BxB,OAAO;MACP,6BChCwB;MDiCxB,iCAA4B;MAA5B,4BAA4B,EAAA;EAhClC;IAqCI,QAAQ;IACR,aCvC0B;IDwC1B,cCzC0B,EAAA;IDE9B;MA0CM,cC3CwB;MD4CxB,oCC5CwB;MD6CxB,+BAA0B;MAA1B,0BAA0B,EAAA;EA5ChC;IAiDI,OAAO;IACP,aCnD0B;IDoD1B,cCrD0B,EAAA;IDE9B;MAsDM,aCvDwB;MDwDxB,oCAA2F;MAC3F,gCAA2B;MAA3B,2BAA2B,EAAA;EAxDjC;IA6DI,+DAA+D,EAAA;;AAInE;EACE,kBAAkB;EAClB,cAAc;EACd,aCtE4B;EDuE5B,cCtE4B;EDuE5B,cnB/Ec,EAAA;EmB0EhB;IAQI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,mBAAmB,EAAA;;AAIvB;EACE,gBC7F4B;ED8F5B,uBCxF4B;EDyF5B,WnB9FW;EmB+FX,kBAAkB;EAClB,yBnB/Fc;EgBaZ,sBCKsB,EAAA;;AInB1B;EACE,kBAAkB;EAClB,wBCE+B;EDD/B,mBCE4B;EDD5B,6BAA6C;ELU3C,sBCKsB,EAAA;;AIV1B;EAEE,cAAc,EAAA;;AAIhB;EACE,gBnBHwB,EAAA;;AEblB;EiB0BJ,wBAAsD,EAAA;;AhB1BlD;EgB6BJ,uBAAqD,EAAA;;AALzD;EAUI,kBAAkB;EAClB,MAAM;EAON,wBCtC6B;EDuC7B,cAAc,EAAA;EjB3CV;IiBqCF,QAAQ,EAAA;EhBrCN;IgBwCF,OAAO,EAAA;;AAaX;EExDA,cL6GgE;EMxG9D,yBNwG8D;EK3GhE,qBL2GgE,EAAA;EKzGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;AF+C5B;EExDA,cL6GgE;EMxG9D,yBNwG8D;EK3GhE,qBL2GgE,EAAA;EKzGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;AF+C5B;EExDA,cL6GgE;EMxG9D,yBNwG8D;EK3GhE,qBL2GgE,EAAA;EKzGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;AF+C5B;EExDA,cL6GgE;EMxG9D,yBNwG8D;EK3GhE,qBL2GgE,EAAA;EKzGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;AF+C5B;EExDA,cL6GgE;EMxG9D,yBNwG8D;EK3GhE,qBL2GgE,EAAA;EKzGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;AF+C5B;EExDA,cL6GgE;EMxG9D,yBNwG8D;EK3GhE,qBL2GgE,EAAA;EKzGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;AF+C5B;EExDA,cL6GgE;EMxG9D,yBNwG8D;EK3GhE,qBL2GgE,EAAA;EKzGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;AF+C5B;EExDA,cL6GgE;EMxG9D,yBNwG8D;EK3GhE,qBL2GgE,EAAA;EKzGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;AEV9B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;ECJnB,WCI4B;EDH5B,YCG4B;EDF5B,iBAAuB,EAAA;EAEvB;IACE,WCA0B;IDC1B,YCD0B,EAAA;;AFG9B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,sBzBfW;EyBgBX,mBAAmB,EAAA;ErBhBb;IqBmBJ,QAAQ,EAAA;EpBnBJ;IoBsBJ,OAAO,EAAA;;AAIX;EC7BE,WCC4B;EDA5B,YCA4B;EDC5B,gBAAuB,EAAA;EAEvB;IACE,UCHyB;IDIzB,WCJyB,EAAA;;AF+B7B;ECjCE,WCO4B;EDN5B,YCM4B;EDL5B,iBAAuB,EAAA;EAEvB;IACE,WCG0B;IDF1B,YCE0B,EAAA;;AF6B9B;ECrCE,WCU4B;EDT5B,YCS4B;EDR5B,iBAAuB,EAAA;EAEvB;IACE,WCM0B;IDL1B,YCK0B,EAAA;;AF8B9B;EACE,aAAa,EAAA;EADf;IAII,mBAAkC;IAClC,6BGxB4C,EAAA;IHmBhD;MAQM,eAAe,EAAA;EARrB;IAaI,mBAAqC,EAAA;EAbzC;IAiBI,mBAAqC,EAAA;EAjBzC;IAqBI,mBAAqC,EAAA;;AAIzC;EACE,sBR7CwB,EAAA;;AQgD1B;EACE,gBAAgB,EAAA;;AInElB;EACE,qBAAqB;EACrB,qBCAyB;E3BiEvB,cAAW;E0B/Db,gB3BQwB;E2BPxB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EbKtB,sBCKsB;EcPpB,qItBqDiI,EAAA;EsBjDjI;IFfN;MEgBQ,gBAAgB,EAAA,EFMvB;EtBTC;IsBCI,qBAAqB,EAAA;EAd3B;IAoBI,aAAa,EAAA;;AAKjB;EACE,kBAAkB;EAClB,SAAS,EAAA;;AAOX;EACE,oBC3B0B;ED4B1B,mBC5B0B;EdKxB,oBcF6B,EAAA;;ADkC/B;EGjDA,WhCGW;EgCFX,yBhC6CqB,EAAA;EO7BrB;IyBZI,WhCFO;IgCGP,yBAAkC,EAAA;EAH5B;IAQN,UAAU;IACV,+ChCkCiB,EAAA;;A6BGrB;EGjDA,chCekB;EgCdlB,yBhCiEuB,EAAA;EOjDvB;IyBZI,chCUc;IgCTd,yBAAkC,EAAA;EAH5B;IAQN,UAAU;IACV,iDhCsDmB,EAAA;;A6BjBvB;EGjDA,WhCGW;EgCFX,yBhC+EqB,EAAA;EO/DrB;IyBZI,WhCFO;IgCGP,yBAAkC,EAAA;EAH5B;IAQN,UAAU;IACV,+ChCoEiB,EAAA;;A6B/BrB;EGjDA,WhCGW;EgCFX,sBhC0Ee,EAAA;EO1Df;IyBZI,WhCFO;IgCGP,yBAAkC,EAAA;EAH5B;IAQN,UAAU;IACV,gDhC+DW,EAAA;;A6B1Bf;EGjDA,chCekB;EgCdlB,yBhCoFqB,EAAA;EOpErB;IyBZI,chCUc;IgCTd,yBAAkC,EAAA;EAH5B;IAQN,UAAU;IACV,gDhCyEiB,EAAA;;A6BpCrB;EGjDA,WhCGW;EgCFX,yBhCqEoB,EAAA;EOrDpB;IyBZI,WhCFO;IgCGP,yBAAkC,EAAA;EAH5B;IAQN,UAAU;IACV,+ChC0DgB,EAAA;;A6BrBpB;EGjDA,chCekB;EgCdlB,yBhCMkB,EAAA;EOUlB;IyBZI,chCUc;IgCTd,yBAAkC,EAAA;EAH5B;IAQN,UAAU;IACV,iDhCLc,EAAA;;A6B0ClB;EGjDA,WhCGW;EgCFX,yBhCakB,EAAA;EOGlB;IyBZI,WhCFO;IgCGP,yBAAkC,EAAA;EAH5B;IAQN,UAAU;IACV,gDhCEc,EAAA;;AIXZ;E6BFJ,iBAAiB,EAAA;;A7BEb;E6BCJ,kBAAkB,EAAA;;AALtB;EAUI,aAAa,EAAA;;AAVjB;EAcI,mBAAmB,EAAA;;AAdvB;EAkBI,kBxBZ2B;EwBa3B,mBAAmB;EACnB,SAAS;EAQP,cjCdc,EAAA;EiCdpB;IAwBM,cjCjBc;IiCkBd,uBAAuB,EAAA;;AAzB7B;EAkCM,cjC3Bc;EiC4Bd,uBAAuB,EAAA;;AAnC7B;EAwCI,gBAAgB;EAChB,gB/BpBmB,EAAA;;AgCjBvB;EACE,aAAa;EACb,eAAe;EACf,qBCF6B;EDG7B,qBCAgC;EDEhC,gBAAgB;ElBQd,gBmBNyB;ECGvB,wBDDmC;EDCrC,6BCImC;EDHnC,qBlCPgB,EAAA;;AkCWpB;EACE,aAAa,EAAA;E9BjBP;I8BsBF,oBCpB0B,EAAA;E9BFxB;I6ByBF,qBCvB0B,EAAA;EDchC;IAaM,qBAAqB;IAEnB,clCtBY;IkCwBd,YC3ByB,EAAA;I/BNvB;M8BmCA,qBCjCwB,EAAA;I9BFxB;M6BsCA,oBCpCwB,EAAA;EDchC;IAkCI,0BAA0B,EAAA;EAlC9B;IAsCI,qBAAqB,EAAA;EAtCzB;IA2CM,clClDc,EAAA;;AqCVpB;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc,EAAA;I9BChB;MACE;;Q8BGE,UAAU,EAAA,E9BHU;I8BV1B;;;;MAkBM,UAAU,EAAA;;AAMhB;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AjC7BP;;EiCsCF,iBpBjCa,EAAA;;AZLX;;EgCyCF,kBpBpCa,EAAA;;AbLX;;EY8BJ,0BqBmBgC;ErBlBhC,6BqBkBgC,EAAA;;AjCjD5B;;EY4CJ,yBqBU+B;ErBT/B,4BqBS+B,EAAA;;AhCtD3B;;EW4CJ,yBqBiB+B;ErBhB/B,4BqBgB+B,EAAA;;AhC7D3B;;EW8BJ,0BqBoCgC;ErBnChC,6BqBmCgC,EAAA;;AAiBpC;EACE,wBAAmC;EACnC,uBAAkC,EAAA;EjCrF5B;;;IiC2FF,cAAc,EAAA;EhC3FZ;;;IgC8FF,eAAe,EAAA;EjC9Fb;IiCoGF,eAAe,EAAA;EhCpGb;IgCuGF,cAAc,EAAA;;AAKpB;EACE,uBAAsC;EACtC,sBAAqC,EAAA;;AAGvC;EACE,sBAAsC;EACtC,qBAAqC,EAAA;;AAqBvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;IAYI,gBpB/Ie,EAAA;EoBmInB;;IrBnGI,6BqBqH+B;IrBpH/B,4BqBoH+B,EAAA;EAlBnC;;IrBjHI,yBqBwI4B;IrBvI5B,0BqBuI4B,EAAA;;AAiBhC;;EAGI,gBAAgB,EAAA;EAHpB;;;;IAOM,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB,EAAA;;ACvL1B;EACE,qBAAqB;EAErB,gBpCOwB;EoCNxB,ctCHkB;EsCIlB,kBAAkB;EAGlB,sBAAsB;EACtB,eAAsD;EACtD,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA2C;ECkH3C,yB9B9H6B;ENyHzB,mBAtCY;EoC6ChB,gBrCjHqB;EcHnB,sBCKsB;EcPpB,qItBqDiI,EAAA;E8BqErI;;IAEE,erClIqB;IqCmIrB,gBrCnIqB;IqCoIrB,oBAA0D,EAAA;ER1HxD;IOdN;MPeQ,gBAAgB,EAAA,EOqCvB;E/B9CC;IACE;M+BUA,ctChBgB;MsCiBhB,qBAAqB,EAAA,E/BXC;E+BP1B;IAuBI,UAAU;IACV,gDtCiBmB,EAAA;EsCzCvB;IA8BI,a7BqBwB,EAAA;E6BnD5B;IAmCI,eAAsD,EAAA;ECiGxD;;IDnFE,gBpC7CqB;IoC8CrB,oBAAyE,EAAA;;AAK7E;;EAEE,oBAAoB,EAAA;;AASpB;EClEA,WvCFW;EwBET,yBxByCmB;EuCvCrB,qBvCuCqB,EAAA;EOnCrB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,+CAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBvCamB;IuCZnB,qBvCYmB,EAAA;EuCNrB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,+CAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,+CAAiF,EAAA;;ADAvF;EClEA,cvCUkB;EwBVhB,yBxB6DqB;EuC3DvB,qBvC2DuB,EAAA;EOvDvB;IACE;MgCDA,cvCIgB;MwBVhB,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,cvCHgB;IwBVhB,yBeDoF;IAgBpF,qBAhByH;IAqBvH,iDAAiF,EAAA;EAKrF;IAEE,cvCjBgB;IuCkBhB,yBvCiCqB;IuChCrB,qBvCgCqB,EAAA;EuC1BvB;;IAEE,cvC3BgB;IuC4BhB,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,iDAAiF,EAAA;EAI/E;IACN,cvC5CgB;IuC6ChB,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,iDAAiF,EAAA;;ADAvF;EClEA,WvCFW;EwBET,yBxB2EmB;EuCzErB,qBvCyEqB,EAAA;EOrErB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBvC+CmB;IuC9CnB,qBvC8CmB,EAAA;EuCxCrB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;ADAvF;EClEA,WvCFW;EwBET,sBxBsEa;EuCpEf,kBvCoEe,EAAA;EOhEf;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,sBvC0Ca;IuCzCb,kBvCyCa,EAAA;EuCnCf;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;ADAvF;EClEA,cvCUkB;EwBVhB,yBxBgFmB;EuC9ErB,qBvC8EqB,EAAA;EO1ErB;IACE;MgCDA,cvCIgB;MwBVhB,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,cvCHgB;IwBVhB,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,cvCjBgB;IuCkBhB,yBvCoDmB;IuCnDnB,qBvCmDmB,EAAA;EuC7CrB;;IAEE,cvC3BgB;IuC4BhB,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,cvC5CgB;IuC6ChB,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;ADAvF;EClEA,WvCFW;EwBET,yBxBiEkB;EuC/DpB,qBvC+DoB,EAAA;EO3DpB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,iDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBvCqCkB;IuCpClB,qBvCoCkB,EAAA;EuC9BpB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,iDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,iDAAiF,EAAA;;ADAvF;EClEA,cvCUkB;EwBVhB,yBxBEgB;EuCAlB,qBvCAkB,EAAA;EOIlB;IACE;MgCDA,cvCIgB;MwBVhB,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,cvCHgB;IwBVhB,yBeDoF;IAgBpF,qBAhByH;IAqBvH,iDAAiF,EAAA;EAKrF;IAEE,cvCjBgB;IuCkBhB,yBvC1BgB;IuC2BhB,qBvC3BgB,EAAA;EuCiClB;;IAEE,cvC3BgB;IuC4BhB,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,iDAAiF,EAAA;EAI/E;IACN,cvC5CgB;IuC6ChB,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,iDAAiF,EAAA;;ADAvF;EClEA,WvCFW;EwBET,yBxBSgB;EuCPlB,qBvCOkB,EAAA;EOHlB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,iDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBvCnBgB;IuCoBhB,qBvCpBgB,EAAA;EuC0BlB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,iDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,iDAAiF,EAAA;;ADKzF;EACE,+BAA8B,EAAA;EADhC;IAII,YAA6B,EAAA;;AAK/B;ECPA,cvChCqB;EuCiCrB,qBvCjCqB,EAAA;EOnCrB;IACE;MgCsEA,WvC/ES;MuCgFT,yBvCrCmB;MuCsCnB,qBvCtCmB,EAAA,EOlCG;EgC2ExB;IAEE,+CvC3CmB,EAAA;EuC8CrB;IAEE,cvChDmB;IuCiDnB,6BAA6B,EAAA;EAG/B;IAEE,WvCjGS;IuCkGT,yBvCvDmB;IuCwDnB,qBvCxDmB,EAAA;IuC0DnB;MAKI,+CvC/De,EAAA;EuCmEb;IACN,WvC/GS;IuCgHT,yBvCrEmB;IuCsEnB,qBvCtEmB,EAAA;IuCmEb;MAUF,+CvC7Ee,EAAA;;AsCuCrB;ECPA,cvCZuB;EuCavB,qBvCbuB,EAAA;EOvDvB;IACE;MgCsEA,cvCnEgB;MuCoEhB,yBvCjBqB;MuCkBrB,qBvClBqB,EAAA,EOtDC;EgC2ExB;IAEE,iDvCvBqB,EAAA;EuC0BvB;IAEE,cvC5BqB;IuC6BrB,6BAA6B,EAAA;EAG/B;IAEE,cvCrFgB;IuCsFhB,yBvCnCqB;IuCoCrB,qBvCpCqB,EAAA;IuCsCrB;MAKI,iDvC3CiB,EAAA;EuC+Cf;IACN,cvCnGgB;IuCoGhB,yBvCjDqB;IuCkDrB,qBvClDqB,EAAA;IuC+Cf;MAUF,iDvCzDiB,EAAA;;AsCmBvB;ECPA,cvCEqB;EuCDrB,qBvCCqB,EAAA;EOrErB;IACE;MgCsEA,WvC/ES;MuCgFT,yBvCHmB;MuCInB,qBvCJmB,EAAA,EOpEG;EgC2ExB;IAEE,+CvCTmB,EAAA;EuCYrB;IAEE,cvCdmB;IuCenB,6BAA6B,EAAA;EAG/B;IAEE,WvCjGS;IuCkGT,yBvCrBmB;IuCsBnB,qBvCtBmB,EAAA;IuCwBnB;MAKI,+CvC7Be,EAAA;EuCiCb;IACN,WvC/GS;IuCgHT,yBvCnCmB;IuCoCnB,qBvCpCmB,EAAA;IuCiCb;MAUF,+CvC3Ce,EAAA;;AsCKrB;ECPA,WvCHe;EuCIf,kBvCJe,EAAA;EOhEf;IACE;MgCsEA,WvC/ES;MuCgFT,sBvCRa;MuCSb,kBvCTa,EAAA,EO/DS;EgC2ExB;IAEE,gDvCda,EAAA;EuCiBf;IAEE,WvCnBa;IuCoBb,6BAA6B,EAAA;EAG/B;IAEE,WvCjGS;IuCkGT,sBvC1Ba;IuC2Bb,kBvC3Ba,EAAA;IuC6Bb;MAKI,gDvClCS,EAAA;EuCsCP;IACN,WvC/GS;IuCgHT,sBvCxCa;IuCyCb,kBvCzCa,EAAA;IuCsCP;MAUF,gDvChDS,EAAA;;AsCUf;ECPA,cvCOqB;EuCNrB,qBvCMqB,EAAA;EO1ErB;IACE;MgCsEA,cvCnEgB;MuCoEhB,yBvCEmB;MuCDnB,qBvCCmB,EAAA,EOzEG;EgC2ExB;IAEE,gDvCJmB,EAAA;EuCOrB;IAEE,cvCTmB;IuCUnB,6BAA6B,EAAA;EAG/B;IAEE,cvCrFgB;IuCsFhB,yBvChBmB;IuCiBnB,qBvCjBmB,EAAA;IuCmBnB;MAKI,gDvCxBe,EAAA;EuC4Bb;IACN,cvCnGgB;IuCoGhB,yBvC9BmB;IuC+BnB,qBvC/BmB,EAAA;IuC4Bb;MAUF,gDvCtCe,EAAA;;AsCArB;ECPA,cvCRoB;EuCSpB,qBvCToB,EAAA;EO3DpB;IACE;MgCsEA,WvC/ES;MuCgFT,yBvCbkB;MuCclB,qBvCdkB,EAAA,EO1DI;EgC2ExB;IAEE,+CvCnBkB,EAAA;EuCsBpB;IAEE,cvCxBkB;IuCyBlB,6BAA6B,EAAA;EAG/B;IAEE,WvCjGS;IuCkGT,yBvC/BkB;IuCgClB,qBvChCkB,EAAA;IuCkClB;MAKI,+CvCvCc,EAAA;EuC2CZ;IACN,WvC/GS;IuCgHT,yBvC7CkB;IuC8ClB,qBvC9CkB,EAAA;IuC2CZ;MAUF,+CvCrDc,EAAA;;AsCepB;ECPA,cvCvEkB;EuCwElB,qBvCxEkB,EAAA;EOIlB;IACE;MgCsEA,cvCnEgB;MuCoEhB,yBvC5EgB;MuC6EhB,qBvC7EgB,EAAA,EOKM;EgC2ExB;IAEE,iDvClFgB,EAAA;EuCqFlB;IAEE,cvCvFgB;IuCwFhB,6BAA6B,EAAA;EAG/B;IAEE,cvCrFgB;IuCsFhB,yBvC9FgB;IuC+FhB,qBvC/FgB,EAAA;IuCiGhB;MAKI,iDvCtGY,EAAA;EuC0GV;IACN,cvCnGgB;IuCoGhB,yBvC5GgB;IuC6GhB,qBvC7GgB,EAAA;IuC0GV;MAUF,iDvCpHY,EAAA;;AsC8ElB;ECPA,cvChEkB;EuCiElB,qBvCjEkB,EAAA;EOHlB;IACE;MgCsEA,WvC/ES;MuCgFT,yBvCrEgB;MuCsEhB,qBvCtEgB,EAAA,EOFM;EgC2ExB;IAEE,gDvC3EgB,EAAA;EuC8ElB;IAEE,cvChFgB;IuCiFhB,6BAA6B,EAAA;EAG/B;IAEE,WvCjGS;IuCkGT,yBvCvFgB;IuCwFhB,qBvCxFgB,EAAA;IuC0FhB;MAKI,gDvC/FY,EAAA;EuCmGV;IACN,WvC/GS;IuCgHT,yBvCrGgB;IuCsGhB,qBvCtGgB,EAAA;IuCmGV;MAUF,gDvC7GY,EAAA;;AsCkFpB;EACE,gBpClFwB;EoCmFxB,ctCpDqB;EsCqDrB,qBhChG6C,EAAA;ECQ7C;IACE;M+B0FA,chC3F+D;MgC4F/D,0BhCnGgD,EAAA,ECQ1B;E+BoF1B;IAYI,0BhCxGgD,EAAA;EgC4FpD;IAiBI,ctCrGgB;IsCsGhB,oBAAoB,EAAA;;AAWxB;ECME,oB9B/G8B;EN0G1B,qBAtCY;EoC6ChB,gBtBhImB;EDYjB,qBCMqB,EAAA;EsBkHvB;;;IAEE,iBrCjIoC;IqCkIpC,kBrClIoC;IqCmIpC,oBAA0D,EAAA;;ADZ9D;ECEE,uB9BpH+B;EN+G3B,qBAtCY;EoC6ChB,gBtB/HmB;EDWjB,qBCOqB,EAAA;EsBiHvB;;;IAEE,iBrChIoC;IqCiIpC,kBrCjIoC;IqCkIpC,oBAA0D,EAAA;;ADH9D;EACE,cAAc;EACd,WAAW,EAAA;EAFb;IAMI,kB7BnFuB,EAAA;;A6BwF3B;;;EAII,WAAW,EAAA;;AAIf;EACE,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB,EAAA;;AAQhB;ECtBA,cvCtGqB;EuCuGrB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,WvCvJS;IuCwJT,yBvC7GmB;IuC8GnB,qBvC9GmB,EAAA;EuCiHrB;IAEE,+CvCnHmB,EAAA;EuCsHrB;IAEE,cvCxHmB;IuCyHnB,6BAA6B;IAC7B,yBAAyB,EAAA;EAG3B;IAEE,WvC1KS;IuC2KT,yBvChImB;IuCiInB,qBvCjImB,EAAA;IuCmInB;MAKI,+CvCxIe,EAAA;EuC4Ib;IACN,WvCxLS;IuCyLT,yBvC9ImB;IuC+InB,qBvC/ImB,EAAA;IuC4Ib;MAUF,+CvCtJe,EAAA;;AsC4HrB;ECtBA,cvClFuB;EuCmFvB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,cvC3IgB;IuC4IhB,yBvCzFqB;IuC0FrB,qBvC1FqB,EAAA;EuC6FvB;IAEE,iDvC/FqB,EAAA;EuCkGvB;IAEE,cvCpGqB;IuCqGrB,6BAA6B;IAC7B,yBAAyB,EAAA;EAG3B;IAEE,cvC9JgB;IuC+JhB,yBvC5GqB;IuC6GrB,qBvC7GqB,EAAA;IuC+GrB;MAKI,iDvCpHiB,EAAA;EuCwHf;IACN,cvC5KgB;IuC6KhB,yBvC1HqB;IuC2HrB,qBvC3HqB,EAAA;IuCwHf;MAUF,iDvClIiB,EAAA;;AsCwGvB;ECtBA,cvCpEqB;EuCqErB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,WvCvJS;IuCwJT,yBvC3EmB;IuC4EnB,qBvC5EmB,EAAA;EuC+ErB;IAEE,+CvCjFmB,EAAA;EuCoFrB;IAEE,cvCtFmB;IuCuFnB,6BAA6B;IAC7B,yBAAyB,EAAA;EAG3B;IAEE,WvC1KS;IuC2KT,yBvC9FmB;IuC+FnB,qBvC/FmB,EAAA;IuCiGnB;MAKI,+CvCtGe,EAAA;EuC0Gb;IACN,WvCxLS;IuCyLT,yBvC5GmB;IuC6GnB,qBvC7GmB,EAAA;IuC0Gb;MAUF,+CvCpHe,EAAA;;AsC0FrB;ECtBA,WvCzEe;EuC0Ef,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,WvCvJS;IuCwJT,sBvChFa;IuCiFb,kBvCjFa,EAAA;EuCoFf;IAEE,gDvCtFa,EAAA;EuCyFf;IAEE,WvC3Fa;IuC4Fb,6BAA6B;IAC7B,yBAAyB,EAAA;EAG3B;IAEE,WvC1KS;IuC2KT,sBvCnGa;IuCoGb,kBvCpGa,EAAA;IuCsGb;MAKI,gDvC3GS,EAAA;EuC+GP;IACN,WvCxLS;IuCyLT,sBvCjHa;IuCkHb,kBvClHa,EAAA;IuC+GP;MAUF,gDvCzHS,EAAA;;AsC+Ff;ECtBA,cvC/DqB;EuCgErB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,cvC3IgB;IuC4IhB,yBvCtEmB;IuCuEnB,qBvCvEmB,EAAA;EuC0ErB;IAEE,gDvC5EmB,EAAA;EuC+ErB;IAEE,cvCjFmB;IuCkFnB,6BAA6B;IAC7B,yBAAyB,EAAA;EAG3B;IAEE,cvC9JgB;IuC+JhB,yBvCzFmB;IuC0FnB,qBvC1FmB,EAAA;IuC4FnB;MAKI,gDvCjGe,EAAA;EuCqGb;IACN,cvC5KgB;IuC6KhB,yBvCvGmB;IuCwGnB,qBvCxGmB,EAAA;IuCqGb;MAUF,gDvC/Ge,EAAA;;AsCqFrB;ECtBA,cvC9EoB;EuC+EpB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,WvCvJS;IuCwJT,yBvCrFkB;IuCsFlB,qBvCtFkB,EAAA;EuCyFpB;IAEE,+CvC3FkB,EAAA;EuC8FpB;IAEE,cvChGkB;IuCiGlB,6BAA6B;IAC7B,yBAAyB,EAAA;EAG3B;IAEE,WvC1KS;IuC2KT,yBvCxGkB;IuCyGlB,qBvCzGkB,EAAA;IuC2GlB;MAKI,+CvChHc,EAAA;EuCoHZ;IACN,WvCxLS;IuCyLT,yBvCtHkB;IuCuHlB,qBvCvHkB,EAAA;IuCoHZ;MAUF,+CvC9Hc,EAAA;;AsCoGpB;ECtBA,cvC7IkB;EuC8IlB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,cvC3IgB;IuC4IhB,yBvCpJgB;IuCqJhB,qBvCrJgB,EAAA;EuCwJlB;IAEE,iDvC1JgB,EAAA;EuC6JlB;IAEE,cvC/JgB;IuCgKhB,6BAA6B;IAC7B,yBAAyB,EAAA;EAG3B;IAEE,cvC9JgB;IuC+JhB,yBvCvKgB;IuCwKhB,qBvCxKgB,EAAA;IuC0KhB;MAKI,iDvC/KY,EAAA;EuCmLV;IACN,cvC5KgB;IuC6KhB,yBvCrLgB;IuCsLhB,qBvCtLgB,EAAA;IuCmLV;MAUF,iDvC7LY,EAAA;;AsCmKlB;ECtBA,cvCtIkB;EuCuIlB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB,EAAA;EAEzB;IACE,WvCvJS;IuCwJT,yBvC7IgB;IuC8IhB,qBvC9IgB,EAAA;EuCiJlB;IAEE,gDvCnJgB,EAAA;EuCsJlB;IAEE,cvCxJgB;IuCyJhB,6BAA6B;IAC7B,yBAAyB,EAAA;EAG3B;IAEE,WvC1KS;IuC2KT,yBvChKgB;IuCiKhB,qBvCjKgB,EAAA;IuCmKhB;MAKI,gDvCxKY,EAAA;EuC4KV;IACN,WvCxLS;IuCyLT,yBvC9KgB;IuC+KhB,qBvC/KgB,EAAA;IuC4KV;MAUF,gDvCtLY,EAAA;;AsCsKlB;EC/KA,WvCFW;EwBET,yBgBHqB;EDKvB,qBCLuB,EAAA;EjCSvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBC/BqB;IDgCrB,qBChCqB,EAAA;EDsCvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBFqB;EDIvB,qBCJuB,EAAA;EjCQvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBC9BqB;ID+BrB,qBC/BqB,EAAA;EDqCvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBDqB;EDGvB,qBCHuB,EAAA;EjCOvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBC7BqB;ID8BrB,qBC9BqB,EAAA;EDoCvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBAqB;EDEvB,qBCFuB,EAAA;EjCMvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBC5BqB;ID6BrB,qBC7BqB,EAAA;EDmCvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBCqB;EDCvB,qBCDuB,EAAA;EjCKvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBC3BqB;ID4BrB,qBC5BqB,EAAA;EDkCvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBEqB;EDAvB,qBCAuB,EAAA;EjCIvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBC1BqB;ID2BrB,qBC3BqB,EAAA;EDiCvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBGqB;EDDvB,qBCCuB,EAAA;EjCGvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBCzBqB;ID0BrB,qBC1BqB,EAAA;EDgCvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBIqB;EDFvB,qBCEuB,EAAA;EjCEvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBCxBqB;IDyBrB,qBCzBqB,EAAA;ED+BvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,sBgBKkB;EDHpB,kBCGoB,EAAA;EjCCpB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,+CAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,sBCvBkB;IDwBlB,kBCxBkB,EAAA;ED8BpB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,+CAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,+CAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBMqB;EDJvB,qBCIuB,EAAA;EjCAvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,iDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBCtBqB;IDuBrB,qBCvBqB,EAAA;ED6BvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,iDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,iDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBOqB;EDLvB,qBCKuB,EAAA;EjCDvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,iDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBCrBqB;IDsBrB,qBCtBqB,EAAA;ED4BvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,iDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,iDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBQqB;EDNvB,qBCMuB,EAAA;EjCFvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,+CAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBCpBqB;IDqBrB,qBCrBqB,EAAA;ED2BvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,+CAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,+CAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBSqB;EDPvB,qBCOuB,EAAA;EjCHvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBCnBqB;IDoBrB,qBCpBqB,EAAA;ED0BvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBUqB;EDRvB,qBCQuB,EAAA;EjCJvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,+CAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBClBqB;IDmBrB,qBCnBqB,EAAA;EDyBvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,+CAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,+CAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBWqB;EDTvB,qBCSuB,EAAA;EjCLvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBCjBqB;IDkBrB,qBClBqB,EAAA;EDwBvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AD6GvF;EC/KA,WvCFW;EwBET,yBgBYqB;EDVvB,qBCUuB,EAAA;EjCNvB;IACE;MgCDA,WvCRS;MwBET,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,WvCfS;IwBET,yBeDoF;IAgBpF,qBAhByH;IAqBvH,+CAAiF,EAAA;EAKrF;IAEE,WvC7BS;IuC8BT,yBChBqB;IDiBrB,qBCjBqB,EAAA;EDuBvB;;IAEE,WvCvCS;IuCwCT,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,+CAAiF,EAAA;EAI/E;IACN,WvCxDS;IuCyDT,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,+CAAiF,EAAA;;AD6GvF;EC/KA,cvCUkB;EwBVhB,yBgBaqB;EDXvB,qBCWuB,EAAA;EjCPvB;IACE;MgCDA,cvCIgB;MwBVhB,yBeDoF;MASpF,qBATyH,EAAA,EhCQnG;EgCIxB;IAEE,cvCHgB;IwBVhB,yBeDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,cvCjBgB;IuCkBhB,yBCfqB;IDgBrB,qBChBqB,EAAA;EDsBvB;;IAEE,cvC3BgB;IuC4BhB,yBAvCuK;IA2CvK,qBA3C+M,EAAA;IA6C/M;;MAKI,gDAAiF,EAAA;EAI/E;IACN,cvC5CgB;IuC6ChB,yBAxDuK;IA4DvK,qBA5D+M,EAAA;IAsDzM;MAaF,gDAAiF,EAAA;;AEpEzF;EACE,kBAAkB;EAClB,eCEY;EDDZ,cAAiB;EAUf,sBxBMsB,EAAA;EbnBlB;IqCMJ,8BzCDgB,EAAA;EKLZ;IoCSJ,+BzCJgB,EAAA;;AyCYpB;EACE,yBzCbkB;EyCclB,sBAAsB,EAAA;;AAExB;EACE,sBxBHwB,EAAA;;AwBK1B;EACE,aAAa;EACb,qBAAqB,EAAA;;AAEvB;EACE,gBAAgB,EAAA;;AAElB;EACE,oBAAoB,EAAA;;ArChCd;EqC0CF,0BzCCiB,EAAA;;AK3Cf;EoC6CF,2BzCFiB,EAAA;;AyCHrB;EASI,czCNiB,EAAA;;AI3Cf;EqC0CF,0BzCqBmB,EAAA;;AK/DjB;EoC6CF,2BzCkBmB,EAAA;;AyCvBvB;EASI,czCcmB,EAAA;;AI/DjB;EqC0CF,0BzCmCiB,EAAA;;AK7Ef;EoC6CF,2BzCgCiB,EAAA;;AyCrCrB;EASI,czC4BiB,EAAA;;AI7Ef;EqC0CF,uBzC8BW,EAAA;;AKxET;EoC6CF,wBzC2BW,EAAA;;AyChCf;EASI,WzCuBW,EAAA;;AIxET;EqC0CF,0BzCwCiB,EAAA;;AKlFf;EoC6CF,2BzCqCiB,EAAA;;AyC1CrB;EASI,czCiCiB,EAAA;;AIlFf;EqC0CF,0BzCyBgB,EAAA;;AKnEd;EoC6CF,2BzCsBgB,EAAA;;AyC3BpB;EASI,czCkBgB,EAAA;;AInEd;EqC0CF,0BzCtCc,EAAA;;AKJZ;EoC6CF,2BzCzCc,EAAA;;AyCoClB;EASI,czC7Cc,EAAA;;AIJZ;EqC0CF,0BzC/Bc,EAAA;;AKXZ;EoC6CF,2BzClCc,EAAA;;AyC6BlB;EASI,czCtCc,EAAA;;A2CXpB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EAEZ,qBCCuC;EDAvC,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAgC;E3BK9B,sBCKsB;E0BPtB,sB3CZS;E2CaT,qB3CRgB,EAAA;E2CLpB;IAiBI,eAAe;IACf,cAAc,EAAA;EAlBlB;IAsBI,mBAAmB;IACnB,sBAAsB,EAAA;IAvB1B;MA0BM,mBAAmB;M3BHrB,2CEyH4D;MFxH5D,4CEwH4D,EAAA;IyBhJhE;MA+BM,sBAAsB;M3BMxB,+CE2G4D;MF1G5D,8CE0G4D,EAAA;EyBhJhE;;IAsCI,YAAY,EAAA;;AAKhB;;EAEE,kCAAiC,EAAA;EAFnC;;IAII,qCAAoC;IACpC,kCAAiC,EAAA;;AAIrC;EAGE,cAAc;EAGd,eAAe;EACf,gBCxDiC,EAAA;;AD8DnC;EACE,sBChEgC,EAAA;;ADmElC;EACE,qBAA+B;EAC/B,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;ApCnEhB;EACE;IoCuEA,qBAAqB,EAAA,EpCvEC;;AHTlB;EuCqFF,oBClF6B,EAAA;;AvCH3B;EsCwFF,qBCrF6B,EAAA;;AD8FnC;EACE,wBC/FiC;EDgGjC,gBAAgB;EAChB,wBAAuC;EAGrC,sB3CvGS;E2CwGT,qB3CnGgB,EAAA;E2C4FpB;I3BnFI,0D2B8F8E,EAAA;EAXlF;IAgBM,aAAa,EAAA;EAhBnB;IAoBI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,wBC3HiC;ED4HjC,qBAAoC;EAGlC,sB3ClIS;E2CmIT,qB3C9HgB,EAAA;E2CwHpB;I3B/GI,0DEkI4D,EAAA;;AyBAhE;EACE,uBAAiC;EACjC,uBChJgC;EDiJhC,sBAAgC;EAChC,gBAAgB,EAAA;;AAGlB;EACE,uBAAiC;EACjC,sBAAgC,EAAA;;AAIlC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBC1JiC,EAAA;;AD6JnC;;;EAGE,cAAc;EACd,WAAW,EAAA;;AAGb;;E3BtJI,2CEyH4D;EFxH5D,4CEwH4D,EAAA;;AyBkChE;;E3B7II,+CE2G4D;EF1G5D,8CE0G4D,EAAA;;AyB0ChE;EAEI,mBCjLuC,EAAA;;AC0DvC;EFqHJ;IAMI,aAAa;IACb,mBAAmB;IACnB,mBCvLuC;IDwLvC,kBCxLuC,EAAA;ID+K3C;MAaM,SAAY;MACZ,kBC7LqC;MD8LrC,gBAAgB;MAChB,iBC/LqC,EAAA,EDgMtC;;AASL;EAII,mBC7MuC,EAAA;;AC0DvC;EF+IJ;IAQI,aAAa;IACb,mBAAmB,EAAA;IATvB;MAcM,SAAY;MACZ,gBAAgB,EAAA;MvCnOd;QuCuOE,cAAc;QACd,cAAc,EAAA;MtCxOhB;QsC2OE,eAAe;QACf,eAAe,EAAA;MAxBzB;Q3BtLI,0B2BqNoC;Q3BpNpC,6B2BoNoC,EAAA;QA/BxC;;UAoCY,0BAA0B,EAAA;QApCtC;;UAyCY,6BAA6B,EAAA;MAzCzC;Q3BxKI,yB2BsNmC;Q3BrNnC,4B2BqNmC,EAAA;QA9CvC;;UAmDY,yBAAyB,EAAA;QAnDrC;;UAwDY,4BAA4B,EAAA,EAC7B;;AAYX;EAEI,sBCzR8B,EAAA;;ACmE9B;EFoNJ;IAMI,eCjRoB;IDkRpB,mBCjR0B;IDkR1B,UAAU;IACV,SAAS,EAAA;IATb;MAYM,qBAAqB;MACrB,WAAW,EAAA,EACZ;;AASL;EAEI,gBAAgB,EAAA;EAFpB;IAKM,gBAAgB;I3BhRlB,6B2BiRiC;I3BhRjC,4B2BgRiC,EAAA;EANrC;I3BzRI,yB2BmS8B;I3BlS9B,0B2BkS8B,EAAA;EAVlC;I3BlSI,gB2BgT0B;IACxB,mB1B1Ta,EAAA;;A0B+TnB;EACE,iC3CpUc;E2CqUd,0B3ChUkB,EAAA;;A2CmUpB;EACE,qBAAqB;EACrB,gBAAmE;EACnE,kBAAyB;EACzB,0CC1UiC;ED2UjC,oBAAoB;EACpB,c3C5UkB;E2C6UlB,kBAAkB;EAClB,uBC/T4B;EDgU5B,uBAAsC;EAEpC,qB3C/UgB,EAAA;;A2CmVpB;EACE,qBAAqB,EAAA;EvCzVf;IuC4VJ,YAAY;IACZ,sBAA4B,EAAA;EtC7VxB;IsCgWJ,WAAW;IACX,qBAA2B,EAAA;;AAI/B;EACE,kBAAwB;EACxB,c3C9VkB,EAAA;E2C4VpB;IAKI,c3CvWgB;I2CwWhB,qBAAqB,EAAA;;AAOvB;EGpXA,wCAAuC,EAAA;;AHoXvC;EGpXA,wCAAuC,EAAA;;AHoXvC;EGpXA,wCAAuC,EAAA;;AHoXvC;EGpXA,qCAAuC,EAAA;;AHoXvC;EGpXA,wCAAuC,EAAA;;AHoXvC;EGpXA,wCAAuC,EAAA;;AHoXvC;EGpXA,wCAAuC,EAAA;;AHoXvC;EGpXA,wCAAuC,EAAA;;AHyXzC;EACE,iBDpXY;ECqXZ,mBAAsC;EACtC,kBAAqC;EACrC,SAAS;EACT,gC3CvXkB,EAAA;;A6CgEhB;EF2TF;IAGI,eAAe,EAAA,EAChB;;AI3XL;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;ECvBhB;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAA;;ADwBf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EhBlBvB,sCkBS6E,EAAA;ElBL7E;IgBQN;MhBPQ,gBAAgB,EAAA,EgBevB;;AAED;;;EAGE,cAAc,EAAA;;AAGhB;;EAEE,2BAA2B,EAAA;;AAG7B;;EAEE,4BAA4B,EAAA;;AAQ9B;EAEI,UAAU;EACV,4BAA4B;EAC5B,eAAe,EAAA;;AAJnB;;;EAUI,UAAU;EACV,UAAU,EAAA;;AAXd;;EAgBI,UAAU;EACV,UAAU;EhB5DR,2BkBQ6B,EAAA;ElBJ7B;IgBuCN;;MhBtCQ,gBAAgB,EAAA,EgByDrB;;AAQH;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAEV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UE5FmC;EF6FnC,W/C7FW;E+C8FX,kBAAkB;EAClB,YE9FkC;ElBW9B,8BkBT6C,EAAA;ElBa7C;IgBkEN;;MhBjEQ,gBAAgB,EAAA,EgBwFvB;ExC3FC;;;IwCsFE,W/CpGS;I+CqGT,qBAAqB;IACrB,UAAU;IACV,YErGgC,EAAA;;AFwGpC;EACE,OAAO,EAAA;;AAKT;EACE,QAAQ,EAAA;;AAOV;;EAEE,qBAAqB;EACrB,WE5GiC;EF6GjC,YE7GiC;EF8GjC,qCAAqC,EAAA;;AAEvC;EACE,yD7B1EgF,EAAA;;A6B4ElF;EACE,yD7B7EgF,EAAA;;A6BsFlF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EAQvB,iBE3JmC;EF4JnC,gBE5JmC;EF6JnC,gBAAgB,EAAA;E3C7JV;I2CqJJ,eAAe,EAAA;E1CrJX;I0CwJJ,gBAAgB,EAAA;EAZpB;IAoBI,uBAAuB;IACvB,cAAc;IACd,WE7JsC;IF8JtC,WE7JqC;IF8JrC,iBE5JqC;IF6JrC,gBE7JqC;IF8JrC,mBAAmB;IACnB,eAAe;IACf,sB/CxKS;I+CyKT,4BAA4B;IAE5B,kCAAiE;IACjE,qCAAoE;IACpE,WAAW;IhBjKT,6BkBFgD,EAAA;IlBMhD;MgB4HN;QhB3HQ,gBAAgB,EAAA,EgB8JrB;EAnCH;IAsCI,UAAU,EAAA;;AASd;EACE,kBAAkB;EAClB,UAA2C;EAC3C,YAAY;EACZ,SAA0C;EAC1C,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,W/CnMW;E+CoMX,kBAAkB,EAAA;;AGxMpB;EACE,WAAW,EAAA;;AAGb;EACE,cAAc,EAAA;;AAGhB;EACE,yBAAiB;UAAjB,iBAAiB,EAAA;;ACTnB;EACE,YAAY;EhD8HR,oBAtCY;EgDtFhB,gBjDcwB;EiDbxB,cAAc;EACd,WAAW;EAET,cnDFY;EmDGZ,yBnDJS,EAAA;EOQX;IACE;M4CAA,qBAAqB;MAEnB,cnDVU,EAAA,EOQU;EAKxB;I4CGI,YAAY,EAAA;;AAWlB;EACE,UAAU;EACV,6BAA6B;EAC7B,SAAS,EAAA;;AAMX;EACE,oBAAoB,EAAA;;ACzCtB;EjDuEI,gBAAW;EiDrEb,cpD0Fa;EoDzFb,qBAAqB,EAAA;EAGrB;IACE,cAAc,EAAA;;AAKlB;EACE,sBCNoB;ElDgElB,gBAAW;EiDxDb,WpDZW;EoDaX,yBpDDkB;EgBEhB,qBCOqB,EAAA;EmCZzB;IASI,UAAU;IjDkDV,eAAW;IiDhDX,gBlDPsB,EAAA;;AD6N1B;EmD/ME,cAAc;EjDyCZ,gBAAW;EiDvCb,cpDjBkB,EAAA;EoDcpB;IjD0CI,kBAAW;IiDlCX,cAAc;IACd,kBAAkB,EAAA;;AAKtB;EACE,iBC/BgC;EDgChC,kBAAkB,EAAA;;AErCpB;EACE,kBAAkB;EAClB,cAAc;EACd,qBAA+C,EAAA;ElDRzC;IkDUJ,oBAAqE,EAAA;EjDVjE;IiDaJ,qBAAsE,EAAA;;AAI1E;EACE,oBAAoB;EACpB,kBCpB6B,EAAA;;ADuB/B;EACE,kBAAkB;EAOlB,WAAW;EACX,WC7BmC;ED8BnC,kBAAkF;EAClF,UAAU,EAAA;ElDjCJ;IkDyBJ,OAAO,EAAA;EjDzBH;IiD4BJ,QAAQ,EAAA;EANZ;IAgBM,WtDtCO;IsDuCP,qBtDIiB;IwBzCnB,yBxByCmB,EAAA;EsDrBvB;IA2BM,gDtDNiB,EAAA;EsDrBvB;IAiCM,qB7CgDwD,EAAA;E6CjF9D;IAuCM,WtD7DO;IsD8DP,yBC6C4E;ID5C5E,qBC4C4E,EAAA;EDrFlF;IAmDQ,ctDhEY,EAAA;IsDapB;MAwDU,yBtDzEU,EAAA;;AsDoFpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAA;EAHrB;IAWI,kBAAkB;IAClB,eAA+E;IAO/E,cAAc;IACd,WC3GiC;ID4GjC,YC5GiC;ID6GjC,oBAAoB;IACpB,WAAW;IACX,iBrC5Ge;IqC+Gb,sBtDpHO;IsDqHP,qBtD7Gc,EAAA;IIRZ;MkDuGF,aAA+D,EAAA;IjDvG7D;MiD0GF,cAAgE,EAAA;EAjBtE;IAkCI,kBAAkB;IAClB,eAA+E;IAO/E,cAAc;IACd,WClIiC;IDmIjC,YCnIiC;IDoIjC,WAAW;IACX,mCAAgE,EAAA;IlDvI5D;MkD8HF,aAA+D,EAAA;IjD9H7D;MiDiIF,cAAgE,EAAA;;AAetE;EtClII,sBCKsB,EAAA;;AqC6H1B;EAQQ,yDpClG0E,EAAA;;AoC0FlF;EAgBQ,qBtDrHe;EwBzCnB,yBxByCmB,EAAA;;AsDqGvB;EAsBM,yDpChH4E,EAAA;;AoC0FlF;EA6BQ,wCtDlIe,EAAA;;AsDqGvB;EAkCQ,wCtDvIe,EAAA;;AsDiJvB;EAGI,kBC3KuC,EAAA;;ADwK3C;EASQ,yDpC/I0E,EAAA;;AoCsIlF;EAiBQ,wCtDlKe,EAAA;;AI3Cf;EkD0NJ,qBAA2D,EAAA;;AjD1NvD;EiD6NJ,sBAA4D,EAAA;;AALhE;EAeM,cCjNwE;EDkNxE,mBAAmB;EAEnB,qBCnNqE,EAAA;EnDvBnE;IkDkOA,cAAqD,EAAA;EjDlOrD;IiDqOA,eAAsD,EAAA;;AAb9D;EAsBM,2BpClH0D;EoCyH1D,uBpCrG0D;EoCsG1D,wBpCtG0D;EoCuG1D,yBtD/Oc;EsDiPd,qBClOqE;ExBXrE,yIwBhBiH;EDgQ/G,yBtDpPY,EAAA;EIRZ;IkDgPA,0BpCpHwD,EAAA;Eb5HxD;IiDmPA,2BpCvHwD,EAAA;Ea5G1D;IuBwMN;MvBvMQ,gBAAgB,EAAA,EuB6OnB;;AAtCL;EA4CQ,sBtDpQK;EsDsQP,8BAA4E,EAAA;;AA9ClF;EAqDQ,wCtDlOe,EAAA;;AsD+OvB;EACE,qBAAqB;EACrB,WAAW;EACX,mCpCjK8D;EoCkK9D,0C7C5R6B;ENyHzB,mBAtCY;EmD4MhB,gBpDrRwB;EoDsRxB,gBpDjRqB;EoDkRrB,sBAAsB;EACtB,iBAAyC;EtCtRvC,sBCKsB;EqCoRxB,wBAAgB;UAAhB,gBAAgB;EAEd,ctD/RgB;EsDgShB,gGC9K6I;ED+K7I,qBtDtSgB,EAAA;EsDqRpB;IAsBM,qB7CzMwD;I6C2M1D,UAAU;IAKR,gDtD5QiB,EAAA;IsD+OvB;MAuCQ,ctDvTY;MsDwTZ,sBtDlUK,EAAA;EsD0Rb;IA+CI,YAAY;IAOZ,sBAAsB,EAAA;IlDhVlB;MkD2UF,sB7CzUyB,EAAA;IJFvB;MiD8UF,qB7C5UyB,EAAA;E6CwR/B;IA2DM,ctD5Uc;IsD6Ud,yBtDjVc,EAAA;EsDqRpB;IAkEI,aAAa,EAAA;EAlEjB;IAuEI,kBAAkB;IAClB,0BtDxVgB,EAAA;;AsD4VpB;EACE,kCpC3O8D;EoC4O9D,oB7C7VgC;E6C8VhC,uB7C9VgC;ENgH5B,qBAtCY,EAAA;ECrFV;IkD2WJ,oB7C/V6B,EAAA;EJZzB;IiD8WJ,qB7ClW6B,EAAA;;A6CuWjC;EACE,gCpCxP8D;EoCyP9D,mB7CrW+B;E6CsW/B,sB7CtW+B;EN2G3B,qBAtCY,EAAA;ECrFV;IkDwXJ,kB7CvW4B,EAAA;EJjBxB;IiD2XJ,mB7C1W4B,EAAA;;A6CoXhC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,mCpC7Q8D;EoC8Q9D,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mCpCrR8D;EoCsR9D,SAAS;EACT,UAAU,EAAA;EANZ;IASI,gDtD3WmB;IsD6WjB,qB7CjTwD,EAAA;E6CsS9D;;IAmBM,yBtD3Zc,EAAA;EsDwYpB;IAyBM,iBC/UQ,EAAA;EDsTd;IA8BI,0BAA0B,EAAA;;AAI9B;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,mCpCzT8D;EoC0T9D,yB7Cpb6B;E6Csb7B,gBpD5awB;EoD6axB,gBpDxaqB;EoDyarB,iBAAuC;EtC5arC,sBCKsB;EqC2atB,ctDpbgB;EsDqbhB,sBtD/bS;EsDgcT,qBtD3bgB,EAAA;EsD0apB;IAqBI,kBAAkB;IAClB,MAAM;IAON,SAAS;IACT,UAAU;IACV,cAAc;IACd,6BpCnV4D;IoCoV5D,yB7C9c2B;I6C+c3B,gBpDhcmB;IoDicnB,iBAAiB;IACjB,oBAAoB;ItCrcpB,kCsCscgF;IAE9E,ctD5cc;IwBRhB,yBxBEgB,EAAA;IIJZ;MkDucF,QAAQ,EAAA;IjDvcN;MiD0cF,OAAO,EAAA;;AAwBb;EACE,WAAW;EACX,cpC3W2B;EoC4W3B,UAAU;EACV,6BAA6B;EAC7B,wBAAgB;UAAhB,gBAAgB,EAAA;EALlB;IAQI,aAAa,EAAA;IARjB;MAY8B,mEtDncP,EAAA;IsDubvB;MAa8B,mEtDpcP,EAAA;IsDubvB;MAc8B,mEtDrcP,EAAA;EsDubvB;IAkBI,SAAS,EAAA;EAlBb;IAsBI,WCxb6C;IDyb7C,YCzb6C;ID0b7C,oBAAyE;I9BxfzE,yBxByCmB;IsDmdnB,SC5b0C;IvCpD1C,mBuCqD6C;IxBvD3C,oHwBhBiH;IxBgBjH,4GwBhBiH;IDsgBnH,wBAAgB;YAAhB,gBAAgB,EAAA;IvBlfd;MuBkdN;QvBjdQ,wBAAgB;QAAhB,gBAAgB,EAAA,EuBwfrB;IAvCH;M9BheI,yB+BgIgE,EAAA;EDgWpE;IA0CI,WCldoC;IDmdpC,cCldqC;IDmdrC,kBAAkB;IAClB,eCnduC;IDodvC,yBAAyB;ItClgBzB,mBuC+CoC;IDudlC,yBtD9gBc,EAAA;EsD4dpB;IAuDI,WCzd6C;ID0d7C,YC1d6C;I/B9D7C,yBxByCmB;IsDmfnB,SC5d0C;IvCpD1C,mBuCqD6C;IxBvD3C,iHwBhBiH;IxBgBjH,4GwBhBiH;IDsiBnH,gBAAgB,EAAA;IvBlhBd;MuBkdN;QvBjdQ,qBAAgB;QAAhB,gBAAgB,EAAA,EuBwhBrB;IAvEH;M9BheI,yB+BgIgE,EAAA;EDgWpE;IA0EI,WClfoC;IDmfpC,cClfqC;IDmfrC,kBAAkB;IAClB,eCnfuC;IDqfrC,yBtD3iBc;IsD6iBhB,yBAAyB;ItCriBzB,mBuC+CoC,EAAA;EDqaxC;IAuFI,WCzf6C;ID0f7C,YC1f6C;ID2f7C,aAAa;IACb,oB7CrjB+B;I6CsjB/B,mB7CtjB+B;IeL/B,yBxByCmB;IsDshBnB,SC/f0C;IvCpD1C,mBuCqD6C;IxBvD3C,gHwBhBiH;IxBgBjH,4GwBhBiH;IDykBnH,gBAAgB,EAAA;IvBrjBd;MuBkdN;QvBjdQ,oBAAgB;QAAhB,gBAAgB,EAAA,EuB2jBrB;IA1GH;M9BheI,yB+BgIgE,EAAA;EDgWpE;IA6GI,WCrhBoC;IDshBpC,cCrhBqC;IDshBrC,kBAAkB;IAClB,eCthBuC;IDuhBvC,6BAA6B;IAC7B,yBAAyB;IACzB,oBAA4C,EAAA;EAnHhD;IAyHM,yBtDrlBc;IgBQhB,mBuC+CoC,EAAA;EDqaxC;IA+HI,kBAAkB;IAEhB,yBtD7lBc;IgBQhB,mBuC+CoC,EAAA;EDqaxC;IAyIQ,yBtDnmBY,EAAA;EsD0dpB;IA8IM,eAAe,EAAA;EA9IrB;IAmJQ,yBtD7mBY,EAAA;EsD0dpB;IAwJM,eAAe,EAAA;EAxJrB;IA6JQ,yBtDvnBY,EAAA;;AsD6nBpB;;;EvBznBM,4GwBhBiH,EAAA;ExBoBjH;IuBqnBN;;;MvBpnBQ,gBAAgB,EAAA,EuBwnBvB;;AE5oBD;;;;EAIE,kBAAkB,EAAA;;AnB8CO;EmB1CzB,mBAAmB,EAAA;ECoBjB;IACE,qBAAqB;IAOrB,uBxCGoC;IwCFpC,WAAW;IArCf,uBAA8B;IAC9B,qCAA4C;IAC5C,gBAAgB;IAChB,oCAA2C,EAAA;IrDArC;MqD4BA,oBxCSkC,EAAA;IZrClC;MoD+BA,qBxCMkC,EAAA;EbrClC;IqD4DA,cAAc,EAAA;EpD5Dd;IoD+DA,eAAe,EAAA;;ADnDvB;EACE,kBAAkB;EAClB,SAAS;EAET,a3Cd2B;E2Ce3B,aAAa;EACb,WAAW;EACX,gBEjBmC;EFkBnC,iBAA8B;ErDuG1B,mBAtCY;EqD/DhB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAoC;ExCXlC,sBCKsB;EuCWtB,cxD3BgB;EwD4BhB,sBxD/BS;EwDgCT,qBxD3BgB,EAAA;;AwD+BpB;;;EAGE,oBAA4B,EAAA;;ApDvCtB;;;EoDmDA,WAAW;EACX,OAAO,EAAA;;AnDpDP;;;EmDuDA,QAAQ;EACR,UAAU,EAAA;;ApDxDV;;;EoDgEA,QAAQ;EACR,UAAU,EAAA;;AnDjEV;;;EmDoEA,WAAW;EACX,OAAO,EAAA;;AXAX;EzCrEI;;;IoDmDA,WAAW;IACX,OAAO,EAAA;EnDpDP;;;ImDuDA,QAAQ;IACR,UAAU,EAAA;EpDxDV;;;IoDgEA,QAAQ;IACR,UAAU,EAAA;EnDjEV;;;ImDoEA,WAAW;IACX,OAAO,EAAA,EnDnEN;;AwCmEL;EzCrEI;;;IoDmDA,WAAW;IACX,OAAO,EAAA;EnDpDP;;;ImDuDA,QAAQ;IACR,UAAU,EAAA;EpDxDV;;;IoDgEA,QAAQ;IACR,UAAU,EAAA;EnDjEV;;;ImDoEA,WAAW;IACX,OAAO,EAAA,EnDnEN;;AwCmEL;EzCrEI;;;IoDmDA,WAAW;IACX,OAAO,EAAA;EnDpDP;;;ImDuDA,QAAQ;IACR,UAAU,EAAA;EpDxDV;;;IoDgEA,QAAQ;IACR,UAAU,EAAA;EnDjEV;;;ImDoEA,WAAW;IACX,OAAO,EAAA,EnDnEN;;AwCmEL;EzCrEI;;;IoDmDA,WAAW;IACX,OAAO,EAAA;EnDpDP;;;ImDuDA,QAAQ;IACR,UAAU,EAAA;EpDxDV;;;IoDgEA,QAAQ;IACR,UAAU,EAAA;EnDjEV;;;ImDoEA,WAAW;IACX,OAAO,EAAA,EnDnEN;;AwCmEL;EzCrEI;;;IoDmDA,WAAW;IACX,OAAO,EAAA;EnDpDP;;;ImDuDA,QAAQ;IACR,UAAU,EAAA;EpDxDV;;;IoDgEA,QAAQ;IACR,UAAU,EAAA;EnDjEV;;;ImDoEA,WAAW;IACX,OAAO,EAAA,EnDnEN;;AmD4ET;EAEI,SAAS;EACT,YAAY;EACZ,aAAa;EACb,uBE/EmC,EAAA;;ADqBnC;EACE,qBAAqB;EAOrB,uBxCGoC;EwCFpC,WAAW;EA9Bf,aAAa;EACb,qCAA4C;EAC5C,0BAAiC;EACjC,oCAA2C,EAAA;ErDPrC;IqD4BA,oBxCSkC,EAAA;EZrClC;IoD+BA,qBxCMkC,EAAA;;AbrClC;EqD4DA,cAAc,EAAA;;ApD5Dd;EoD+DA,eAAe,EAAA;;AD4BvB;EAEI,MAAM;EACN,aAAa,EAAA;EpD9FT;IoDgGF,WAAW;IACX,UAAU;IACV,qBE9FiC,EAAA;ErDJ/B;ImDqGF,WAAW;IACX,UAAU;IACV,sBEnGiC,EAAA;;ADqBnC;EACE,qBAAqB;EAOrB,uBxCGoC;EwCFpC,WAAW;EAvBf,mCAA0C;EAC1C,eAAe;EACf,sCAA6C;EAC7C,wBAA+B,EAAA;ErDdzB;IqD4BA,oBxCSkC,EAAA;EZrClC;IoD+BA,qBxCMkC,EAAA;;AbrClC;EqD4DA,cAAc,EAAA;;ApD5Dd;EoD+DA,eAAe,EAAA;;AAtCnB;EDqFE,iBAAiB,EAAA;;AAKvB;EAEI,MAAM;EACN,aAAa,EAAA;EpDtHT;IoDyHF,WAAW;IACX,UAAU;IACV,sBEvHiC,EAAA;ErDJ/B;ImD8HF,WAAW;IACX,UAAU;IACV,qBE5HiC,EAAA;;ADqBnC;EACE,qBAAqB;EAOrB,uBxCGoC;EwCFpC,WAAW,EAAA;ErDlCT;IqD4BA,oBxCSkC,EAAA;EZrClC;IoD+BA,qBxCMkC,EAAA;;AwCZtC;EAqBI,aAAa,EAAA;;AAGf;EACE,qBAAqB;EACrB,qBxCdkC;EwCelC,uBxChBkC;EwCiBlC,WAAW;EAnCjB,mCAA0C;EAC1C,yBAAgC;EAChC,sCAA6C,EAAA;;ArDpBvC;EqD4DA,cAAc,EAAA;;ApD5Dd;EoD+DA,eAAe,EAAA;;AAdjB;EDsFA,iBAAiB,EAAA;;AAMvB;EG5IE,SAAS;EACT,gBAAmB;EACnB,gBAAgB;EAChB,6B3DCkB,EAAA;;AwDiJpB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBE9IqC;EF+IrC,WAAW;EACX,gBtDhJwB;EsDiJxB,mBAAmB;EAEnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EAGP,cxDxJgB,EAAA;EOElB;IiDsKE,qBAAqB;IAInB,cEjK+C;IlCrBjD,yBxBEgB,EAAA;EwDkJpB;IAyCI,qBAAqB;IAInB,WxDnMO;IwBET,yBxByCmB,EAAA;EwD2GvB;IAoDI,oBAAoB;IACpB,6BAA6B;IAO3B,cxDzMc,EAAA;;AwD8MpB;EACE,cAAc,EAAA;;AAIhB;EACE,cAAc;EACd,uBElNqC;EFmNrC,gBAAgB;ErDpGZ,qBAtCY;EqD4IhB,mBAAmB;EAEjB,cxD1NgB,EAAA;;AwD+NpB;EACE,cAAc;EACd,uBE9NqC;EFiOnC,cxDjOgB,EAAA;;A4DhBpB;EACE,aAAa;EACb,cCCmB;EDAnB,eAAe;EACf,mBAAmB;EACnB,YCFmB;EDGnB,elBEY,EAAA;EkBRd;IASI,iC5DJY,EAAA;E4DLhB;IAaI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP,a/CTyB,EAAA;;AiDkHrB;EFpGN,W5DlBW;E4DmBX,mB5DRkB,EAAA;;A4DfpB;EAsBE,c5DfkB;E4DgBlB,mB5DfkB;EoCFd,6BpCGc,EAAA;;A+DHpB;EACE,cAAc;EACd,WAAW;EACX,mC7CuH8D;E6CtH9D,yBtDJ6B;ENyHzB,mBAtCY;E4D5EhB,gB7DGwB;E6DFxB,gB7DOqB;E6DNrB,4BAA4B;EAC5B,iBAAiC;EAE/B,c/DJgB;E+DKhB,sB/DfS;E+DgBT,qB/DXgB;EgBShB,sBCKsB;EcPpB,wEtB6GwE,EAAA;EsBzGxE;IgCdN;MhCeQ,gBAAgB,EAAA,EgC6CvB;EA5DD;IAyBI,6BAA6B;IAC7B,SAAS,EAAA;EA1Bb;IA+BI,kBAAkB;IAClB,0B/DxBgB,EAAA;EgEDlB;IAEI,chEDc;IgEEd,sBhEZO;IgEaP,qBvD0FwD;IuDxF1D,UAAU;IAMR,gDhEsBiB,EAAA;E+DzCvB;IAyCM,c/DlCc;I+DqChB,UAAU,EAAA;EA5Cd;IAuDM,yB/DpDc;I+DuDhB,UAAU,EAAA;;AAId;;;;EAKI,wBAAgB;UAAhB,gBAAgB,EAAA;;AAIpB;EAQM,c/DvEc;E+DwEd,sB/DlFO,EAAA;;A+DyEb;EAgBM,yBtDkDoB,EAAA;;AsD5C1B;;EAEE,cAAc;EACd,WAAW,EAAA;;AAUb;EACE,iC7Ce8D;E6Cd9D,oC7Cc8D;E6Cb9D,gBAAgB;E5D3Cd,kBAAW;E4D6Cb,gB7DhGqB,EAAA;;A6DmGvB;EACE,+B7CO8D;E6CN9D,kC7CM8D;EfD1D,qBAtCY;E4DmChB,gB9CtHmB,EAAA;;A8CyHrB;EACE,gC7CA8D;E6CC9D,mC7CD8D;EfD1D,qBAtCY;E4D0ChB,gB9C5HmB,EAAA;;A8CqIrB;EACE,cAAc;EACd,WAAW;EACX,mBAA2B;EAC3B,gBAAgB;E5DjBZ,mBAtCY;E4DyDhB,gB7D7HqB;E6D8HrB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmC;EAEjC,c/DhJgB,EAAA;E+DqIpB;IAgBI,gBAAgB;IAChB,eAAe,EAAA;;AAYnB;EACE,kC7C1C8D;E6C2C9D,uBtD3J+B;EN+G3B,qBAtCY;E4DoFhB,gB9CtKmB;EDWjB,qBCOqB,EAAA;;A8CwJzB;EACE,gC7ClD8D;E6CmD9D,oBtD9J8B;EN0G1B,qBAtCY;E4D4FhB,gB9C/KmB;EDYjB,qBCMqB,EAAA;;A8CkKzB;EAGI,YAAY,EAAA;;AAIhB;EACE,YAAY,EAAA;;AAQd;EACE,mBtDlE8B,EAAA;;AsDqEhC;EACE,cAAc;EACd,mBtDjF4B,EAAA;;AsDyF9B;EACE,aAAa;EACb,eAAe;EACf,kBAA0C;EAC1C,iBAAyC,EAAA;EAJ3C;;IAQI,kBAA0C;IAC1C,iBAAyC,EAAA;;AAS7C;EACE,kBAAkB;EAClB,cAAc,EAAA;E3DxOR;I2D0OJ,qBtD7GgC,EAAA;EJ7H5B;I0D6OJ,sBtDhHgC,EAAA;;AsDoHpC;EACE,kBAAkB;EAClB,kBtDrHgC,EAAA;EL9H1B;I2DqPJ,qBtDxHgC,EAAA;EJ7H5B;I0DwPJ,sBtD3HgC,EAAA;EsDoHpC;;IAcM,c/DrPc,EAAA;;A+D0PpB;EACE,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,mBAAmB,EAAA;E3D1Qb;I2D4QJ,eAAe;IACf,qBtD5IsC,EAAA;EJjIlC;I0DgRJ,gBAAgB;IAChB,oBtDhJsC,EAAA;EsDuI1C;IAcI,gBAAgB;IAChB,aAAa,EAAA;I3DvRT;M2DyRF,uBtDvJsC;MsDwJtC,cAAc,EAAA;I1D1RZ;M0D6RF,eAAe;MACf,sBtD5JsC,EAAA;;AuDvF1C;EACE,aAAa;EACb,WAAW;EACX,mBvD6E0B;ENvD1B,cAAW;E6DpBX,chE6BmB,EAAA;;AgE1BrB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uB5CpD0B;E4CqD1B,iBAAiB;E7DiEf,qBAtCY;E6DzBd,gB9D3CmB;E8D4CnB,WhE7DS;EgE8DT,wChEemB;EgB/DnB,sBCKsB,EAAA;;A+CYtB;;;;EAsCE,cAAc,EAAA;;AAtChB;EA4CE,qBhEEiB;EgEOf,yD9C9B0E;E8C+B1E,4BAA4B;EAO5B,gE9CgCwD,EAAA;Ed5HxD;I4D+EE,oC9C6CsD,EAAA;Eb5HxD;I2DkFE,mC9C0CsD,EAAA;Ed5HxD;I4DuFE,2DAA6D,EAAA;E3DvF/D;I2D0FE,0DAA4D,EAAA;EA3DlE;IAiEI,qBhEnBe;IgEoBf,gDhEpBe,EAAA;;AI7Ef;E4D2GE,oC9CiBsD;E8ChBtD,kF9CgBsD,EAAA;;Ab5HxD;E2D+GE,mC9CasD;E8CZtD,iF9CYsD,EAAA;;A8C7F5D;EAyFE,qBhE3CiB;EgEoDf,wNAA8J,EAAA;E5DjI9J;I4D4HE,uC9CAsD,EAAA;Eb5HxD;I2D+HE,sC9CHsD,EAAA;E8C7F5D;IAsGI,qBhExDe;IgEyDf,gDhEzDe,EAAA;;AgE9CnB;EA+GI,chEjEe,EAAA;;AgE9CnB;;;EAoHI,cAAc,EAAA;;AApHlB;EA4HI,chE9Ee,EAAA;EgE9CnB;IA+HM,qBhEjFa,EAAA;;AgE9CnB;EAqIM,qBAAkC;ExClKxC,yBwCmK+C,EAAA;;AAtI/C;EA4IM,gDhE9Fa,EAAA;;AgE9CnB;EAgJM,qBhElGa,EAAA;;AgE9CnB;EA0JI,qBhE5Ge,EAAA;;AgE9CnB;EA+JM,qBhEjHa;EgEkHb,gDhElHa,EAAA;;AgElCrB;EACE,aAAa;EACb,WAAW;EACX,mBvD6E0B;ENvD1B,cAAW;E6DpBX,chEmBkB,EAAA;;AgEhBpB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uB5CpD0B;E4CqD1B,iBAAiB;E7DiEf,qBAtCY;E6DzBd,gB9D3CmB;E8D4CnB,WhE7DS;EgE8DT,wChEKkB;EgBrDlB,sBCKsB,EAAA;;A+CYtB;;;;EAsCE,cAAc,EAAA;;AAtChB;EA4CE,qBhERgB;EgEiBd,yD9C9B0E;E8C+B1E,4BAA4B;EAO5B,gE9CgCwD,EAAA;Ed5HxD;I4D+EE,oC9C6CsD,EAAA;Eb5HxD;I2DkFE,mC9C0CsD,EAAA;Ed5HxD;I4DuFE,2DAA6D,EAAA;E3DvF/D;I2D0FE,0DAA4D,EAAA;EA3DlE;IAiEI,qBhE7Bc;IgE8Bd,gDhE9Bc,EAAA;;AInEd;E4D2GE,oC9CiBsD;E8ChBtD,kF9CgBsD,EAAA;;Ab5HxD;E2D+GE,mC9CasD;E8CZtD,iF9CYsD,EAAA;;A8C7F5D;EAyFE,qBhErDgB;EgE8Dd,wNAA8J,EAAA;E5DjI9J;I4D4HE,uC9CAsD,EAAA;Eb5HxD;I2D+HE,sC9CHsD,EAAA;E8C7F5D;IAsGI,qBhElEc;IgEmEd,gDhEnEc,EAAA;;AgEpClB;EA+GI,chE3Ec,EAAA;;AgEpClB;;;EAoHI,cAAc,EAAA;;AApHlB;EA4HI,chExFc,EAAA;EgEpClB;IA+HM,qBhE3FY,EAAA;;AgEpClB;EAqIM,qBAAkC;ExClKxC,yBwCmK+C,EAAA;;AAtI/C;EA4IM,gDhExGY,EAAA;;AgEpClB;EAgJM,qBhE5GY,EAAA;;AgEpClB;EA0JI,qBhEtHc,EAAA;;AgEpClB;EA+JM,qBhE3HY;EgE4HZ,gDhE5HY,EAAA;;A+DqPtB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAA;EAHrB;IASI,WAAW,EAAA;ElB5PX;IkBmPJ;MAeM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB,EAAA;IAlBtB;MAuBM,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB,EAAA;IA3BtB;MAgCM,qBAAqB;MACrB,WAAW;MACX,sBAAsB,EAAA;IAlC5B;MAuCM,qBAAqB,EAAA;IAvC3B;;MA4CM,WAAW,EAAA;IA5CjB;MAkDM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW,EAAA;M3D7WT;Q2D+WA,eAAe,EAAA;M1D/Wf;Q0DkXA,gBAAgB,EAAA;IA1DxB;MA8DM,kBAAkB;MAClB,cAAc;MACd,aAAa,EAAA;M3DxXX;Q2D0XA,qBtD3P2B;QsD4P3B,cAAc,EAAA;M1D3Xd;Q0D8XA,eAAe;QACf,oBtDhQ2B,EAAA;IsDyLnC;MA4EM,mBAAmB;MACnB,uBAAuB,EAAA;IA7E7B;MAgFM,gBAAgB,EAAA,EACjB;;AAIL;EACE,eAAe;EACf,iBtD9Y8B,EAAA;;AsDiZhC;E/CpYI,sBCKsB,EAAA;;A8CmY1B;E/CxYI,sBCKsB,EAAA;;AgDjBxB;ECDA,WAAW;EACX,mBAA0B;EAC1B,kBAAyB;EACzB,kBAAkB;EAClB,iBAAiB,EAAA;ErBgEf;IoBnEF;MCWI,gBCWK,EAAA,EFnBR;EpBgEC;IoBnEF;MCWI,gBCYK,EAAA,EFpBR;EpBgEC;IoBnEF;MCWI,gBCaK,EAAA,EFrBR;EpBgEC;IoBnEF;MCWI,iBCcM,EAAA,EFtBT;EpBgEC;IoBnEF;MCWI,iBCeO,EAAA,EFvBV;;AAGD;ECPA,WAAW;EACX,mBAA0B;EAC1B,kBAAyB;EACzB,kBAAkB;EAClB,iBAAiB,EAAA;;ArBgEf;EoBlDE;IACE,gBEIG,EAAA,EFHJ;;ApBgDH;EoBlDE;IACE,gBEKG,EAAA,EFJJ;;ApBgDH;EoBlDE;IACE,gBEMG,EAAA,EFLJ;;ApBgDH;EoBlDE;IACE,iBEOI,EAAA,EFNL;;ApBgDH;EoBlDE;IACE,iBEQK,EAAA,EFPN;;AA2BL;EC7BA,aAAa;EACb,eAAe;EACf,mBAA0B;EAC1B,kBAAyB,EAAA;;ADgCzB;EACE,eAAe;EACf,cAAc,EAAA;EAFhB;;IAMI,gBAAgB;IAChB,eAAe,EAAA;;AG1DnB;;;;;;;EACE,kBAAkB;EAClB,WAAW;EACX,mBAA0B;EAC1B,kBAAyB,EAAA;;AAsBvB;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,eAAe,EAAA;;AAKb;EFuBN,cAAuB;EACvB,eAAwB,EAAA;;AExBlB;EFuBN,aAAuB;EACvB,cAAwB,EAAA;;AExBlB;EFuBN,mBAAuB;EACvB,oBAAwB,EAAA;;AExBlB;EFuBN,aAAuB;EACvB,cAAwB,EAAA;;AExBlB;EFuBN,aAAuB;EACvB,cAAwB,EAAA;;AExBlB;EFuBN,mBAAuB;EACvB,oBAAwB,EAAA;;AElBtB;EFAJ,cAAc;EACd,WAAW;EACX,eAAe,EAAA;;AEIP;EFdR,kBAAsC;EAItC,mBAAuC,EAAA;;AEU/B;EFdR,mBAAsC;EAItC,oBAAuC,EAAA;;AEU/B;EFdR,aAAsC;EAItC,cAAuC,EAAA;;AEU/B;EFdR,mBAAsC;EAItC,oBAAuC,EAAA;;AEU/B;EFdR,mBAAsC;EAItC,oBAAuC,EAAA;;AEU/B;EFdR,aAAsC;EAItC,cAAuC,EAAA;;AEU/B;EFdR,mBAAsC;EAItC,oBAAuC,EAAA;;AEU/B;EFdR,mBAAsC;EAItC,oBAAuC,EAAA;;AEU/B;EFdR,aAAsC;EAItC,cAAuC,EAAA;;AEU/B;EFdR,mBAAsC;EAItC,oBAAuC,EAAA;;AEU/B;EFdR,mBAAsC;EAItC,oBAAuC,EAAA;;AEU/B;EFdR,cAAsC;EAItC,eAAuC,EAAA;;AEgBnC;EAAwB,SAAS,EAAA;;AAEjC;EAAuB,SDnBN,EAAA;;ACsBf;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,SADZ,EAAA;;AACZ;EAAwB,SADZ,EAAA;;AACZ;EAAwB,SADZ,EAAA;;AAQR;EFjBV,qBAA8C,EAAA;;AEiBpC;EFjBV,sBAA8C,EAAA;;AEiBpC;EFjBV,gBAA8C,EAAA;;AEiBpC;EFjBV,sBAA8C,EAAA;;AEiBpC;EFjBV,sBAA8C,EAAA;;AEiBpC;EFjBV,gBAA8C,EAAA;;AEiBpC;EFjBV,sBAA8C,EAAA;;AEiBpC;EFjBV,sBAA8C,EAAA;;AEiBpC;EFjBV,gBAA8C,EAAA;;AEiBpC;EFjBV,sBAA8C,EAAA;;AEiBpC;EFjBV,sBAA8C,EAAA;;ArBkB5C;EuBxCE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe,EAAA;EAKb;IFuBN,cAAuB;IACvB,eAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EElBtB;IFAJ,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EEIP;IFdR,kBAAsC;IAItC,mBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,cAAsC;IAItC,eAAuC,EAAA;EEgBnC;IAAwB,SAAS,EAAA;EAEjC;IAAuB,SDnBN,EAAA;ECsBf;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EAQR;IFjBV,cAA4B,EAAA;EEiBlB;IFjBV,qBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA,EEmBnC;;AvBDT;EuBxCE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe,EAAA;EAKb;IFuBN,cAAuB;IACvB,eAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EElBtB;IFAJ,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EEIP;IFdR,kBAAsC;IAItC,mBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,cAAsC;IAItC,eAAuC,EAAA;EEgBnC;IAAwB,SAAS,EAAA;EAEjC;IAAuB,SDnBN,EAAA;ECsBf;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EAQR;IFjBV,cAA4B,EAAA;EEiBlB;IFjBV,qBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA,EEmBnC;;AvBDT;EuBxCE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe,EAAA;EAKb;IFuBN,cAAuB;IACvB,eAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EElBtB;IFAJ,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EEIP;IFdR,kBAAsC;IAItC,mBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,cAAsC;IAItC,eAAuC,EAAA;EEgBnC;IAAwB,SAAS,EAAA;EAEjC;IAAuB,SDnBN,EAAA;ECsBf;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EAQR;IFjBV,cAA4B,EAAA;EEiBlB;IFjBV,qBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA,EEmBnC;;AvBDT;EuBxCE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe,EAAA;EAKb;IFuBN,cAAuB;IACvB,eAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EElBtB;IFAJ,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EEIP;IFdR,kBAAsC;IAItC,mBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,cAAsC;IAItC,eAAuC,EAAA;EEgBnC;IAAwB,SAAS,EAAA;EAEjC;IAAuB,SDnBN,EAAA;ECsBf;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EAQR;IFjBV,cAA4B,EAAA;EEiBlB;IFjBV,qBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA,EEmBnC;;AvBDT;EuBxCE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe,EAAA;EAKb;IFuBN,cAAuB;IACvB,eAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,aAAuB;IACvB,cAAwB,EAAA;EExBlB;IFuBN,mBAAuB;IACvB,oBAAwB,EAAA;EElBtB;IFAJ,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EEIP;IFdR,kBAAsC;IAItC,mBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,aAAsC;IAItC,cAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,mBAAsC;IAItC,oBAAuC,EAAA;EEU/B;IFdR,cAAsC;IAItC,eAAuC,EAAA;EEgBnC;IAAwB,SAAS,EAAA;EAEjC;IAAuB,SDnBN,EAAA;ECsBf;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EAQR;IFjBV,cAA4B,EAAA;EEiBlB;IFjBV,qBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,gBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA;EEiBpC;IFjBV,sBAA8C,EAAA,EEmBnC;;AHIb;EACE,oBAAuC;EACvC,mBAAsC;EACtC,mBAAuC;EACvC,kBAAsC,EAAA;EAJxC;IAOI,oBAAuC;IACvC,mBAAsC,EAAA;;AAI1C;EACE,eAAe,EAAA;;AI3FjB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBCHkC,EAAA;EDHpC;IASI,iCrEJY,EAAA;EqELhB;IAaI,eAAe;IACf,QAAQ;IACR,OAAO;IACP,axDRyB,EAAA;EwDR7B;IAoBI,gBAAgB,EAAA;;AAIpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WCxBkC;EDyBlC,gBC1BkC;ED2BlC,sBzCP8C,EAAA;EyCChD;IASI,kBAAkB;IAClB,SC/BgC;IDgChC,iCAAiC,EAAA;IjE/B7B;MiEkCF,SAAS,EAAA;IhElCP;MgEqCF,UAAU,EAAA;ExB6CZ;IwB9DJ;MAwBQ,kBAAkB;MAClB,SC9C4B;MD+C5B,iCAAiC,EAAA;MjE9CjC;QiEgDE,SAAS,EAAA;MhEhDX;QgEmDE,UAAU,EAAA,EhEjDX;EgEkBT;IAqCQ,kBAAkB;IAClB,SC3D4B;ID4D5B,iCAAiC,EAAA;IjE3DjC;MiE6DE,SAAS,EAAA;IhE7DX;MgEgEE,UAAU,EAAA;ExBkBhB;IwB9DJ;MAwBQ,kBAAkB;MAClB,SC9C4B;MD+C5B,iCAAiC,EAAA;MjE9CjC;QiEgDE,SAAS,EAAA;MhEhDX;QgEmDE,UAAU,EAAA,EhEjDX;EwCmEL;IwBjDJ;MAqCQ,kBAAkB;MAClB,SC3D4B;MD4D5B,iCAAiC,EAAA;MjE3DjC;QiE6DE,SAAS,EAAA;MhE7DX;QgEgEE,UAAU,EAAA,EhE9DX;EwCgFL;IwB9DJ;MAwBQ,kBAAkB;MAClB,SC9C4B;MD+C5B,iCAAiC,EAAA;MjE9CjC;QiEgDE,SAAS,EAAA;MhEhDX;QgEmDE,UAAU,EAAA,EhEjDX;EwCmEL;IwBjDJ;MAqCQ,kBAAkB;MAClB,SC3D4B;MD4D5B,iCAAiC,EAAA;MjE3DjC;QiE6DE,SAAS,EAAA;MhE7DX;QgEgEE,UAAU,EAAA,EhE9DX;EwCgFL;IwB9DJ;MAwBQ,kBAAkB;MAClB,SC9C4B;MD+C5B,iCAAiC,EAAA;MjE9CjC;QiEgDE,SAAS,EAAA;MhEhDX;QgEmDE,UAAU,EAAA,EhEjDX;EwCmEL;IwBjDJ;MAqCQ,kBAAkB;MAClB,SC3D4B;MD4D5B,iCAAiC,EAAA;MjE3DjC;QiE6DE,SAAS,EAAA;MhE7DX;QgEgEE,UAAU,EAAA,EhE9DX;EwCgFL;IwB9DJ;MAwBQ,kBAAkB;MAClB,SC9C4B;MD+C5B,iCAAiC,EAAA;MjE9CjC;QiEgDE,SAAS,EAAA;MhEhDX;QgEmDE,UAAU,EAAA,EhEjDX;EwCmEL;IwBjDJ;MAqCQ,kBAAkB;MAClB,SC3D4B;MD4D5B,iCAAiC,EAAA;MjE3DjC;QiE6DE,SAAS,EAAA;MhE7DX;QgEgEE,UAAU,EAAA,EhE9DX;EgEkBT;IAwBQ,kBAAkB;IAClB,SC9C4B;ID+C5B,iCAAiC,EAAA;IjE9CjC;MiEgDE,SAAS,EAAA;IhEhDX;MgEmDE,UAAU,EAAA;ExBkBhB;IwBjDJ;MAqCQ,kBAAkB;MAClB,SC3D4B;MD4D5B,iCAAiC,EAAA;MjE3DjC;QiE6DE,SAAS,EAAA;MhE7DX;QgEgEE,UAAU,EAAA,EhE9DX;;AgEqET;EACE,eAAe;EACf,qBnElEsC;EmEmEtC,6BCzDyC;ED0DzC,SAAS;ErD7DP,sBCKsB,EAAA;EVXxB;IACE;M8DuEA,crE7EgB;MqE8EhB,qBAAqB,EAAA,E9DxEC;E8D8D1B;IAeI,UAAU,EAAA;EAfd;IAoBI,eAAe,EAAA;;AAInB;EACE,cAAc;EACd,kBAAwC;EACxC,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B,EAAA;;AAG5B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBC5GkC;ED6GlC,UAAU;EACV,gBAAgB;EAChB,gBAAgB,EAAA;EAPlB;IAUI,kBAAkB,EAAA;EAVtB;IAcI,6BAA6B;IAC7B,6BAA2C,EAAA;I9D9G7C;MACE;Q8DgHE,qBAAqB,EAAA,E9DhHD;I8D8F1B;MAuBM,UAAU,EAAA;EAvBhB;;IA6BI,aAAa;IACb,mBAAmB;IACnB,qBChI8B;IDiI9B,oBCjI8B,EAAA;IDiGlC;;MAmCM,kBAAkB;MAClB,QAAQ;MACR,iBAAiB,EAAA;MjE5If;;QiE8IA,SAAS;QACT,cAAc,EAAA;MhE/Id;;QgEkJA,UAAU;QACV,eAAe,EAAA;IA5CvB;;MAiDM,qBAAqB,EAAA;EAjD3B;IAsDI,gBAAgB,EAAA;;APvCZ;EOgDN,mBrEnKkB;EoCQd,gCpCAc,EAAA;E8D2GZ;IOoDJ,gBAAgB;IAChB,6BrEhKgB,EAAA;E8D2GZ;IOyDJ,WrE/KS;IqEgLT,6BC7H6C,EAAA;I/DrC/C;M8DsKI,WrEpLO,EAAA;E8DsHL;;IOqEF,gCrE3LO,EAAA;IOcX;;;M8DgLM,+BrE9LK,EAAA;I8DsHL;;MO4EA,gCrElMK,EAAA;E8DsHL;;;;IOoFF,WrE1MO,EAAA;E8DsHL;IOyFJ,gCrE/MS;IqEgNT,sCrEhNS,EAAA;E8DsHL;IO8FJ,yDC5KsS,EAAA;IR8ElS;MOiGF,yDC9K0S,EAAA;ER6ExS;IOsGJ,gCrE5NS,EAAA;I8DsHL;MOwGF,WrE9NO,EAAA;MOcX;Q8DmNM,WrEjOK,EAAA;;AqEJb;EA0KE,gBrEtKW;EoCWP,gCpCNc,EAAA;EqETpB;IA8KI,gBAAgB;IAChB,6BrEtKgB,EAAA;E8D6GZ;IO6DJ,crEnKgB;IqEoKhB,6BCpI8C,EAAA;I/D9BhD;M8DsKI,cCrIuD,EAAA;ERmErD;;IOyEF,0BrE1LU,EAAA;IOad;;;M8DgLM,0BrE7LQ,EAAA;I8DiHR;;MOgFA,0BrEjMQ,EAAA;E8DiHR;;;;IOwFF,0BrEzMU,EAAA;E8DiHR;IO6FJ,0BrE9MY;IqE+MZ,iCrE/MY,EAAA;E8DiHR;IOkGJ,0DCtLwS,EAAA;IRoFpS;MOqGF,0DCxL4S,EAAA;ERmF1S;IO0GJ,0BrE3NY,EAAA;I8DiHR;MO4GF,0BrE7NU,EAAA;MOad;Q8DmNM,0BrEhOQ,EAAA;;AuELhB;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,kBAAkB,EAAA;EAJpB;ICEE,WtEqFoB;IsEpFpB,YtEoFoB;IsEnFpB,etEmFoB,EAAA;IqEvFtB;MCEE,WDSmD;MCRnD,YDQmD;MCPnD,eDOmD,EAAA;IAXrD;MCEE,WDSmD;MCRnD,YDQmD;MCPnD,eDOmD,EAAA;IAXrD;MCEE,WDSmD;MCRnD,YDQmD;MCPnD,eDOmD,EAAA;IAXrD;MCEE,WDSmD;MCRnD,YDQmD;MCPnD,eDOmD,EAAA;IAXrD;MCEE,WDSmD;MCRnD,YDQmD;MCPnD,eDOmD,EAAA;IAXrD;MCEE,WDSmD;MCRnD,YDQmD;MCPnD,eDOmD,EAAA;IAXrD;MCEE,WDSmD;MCRnD,YDQmD;MCPnD,eDOmD,EAAA;IAXrD;MCEE,WDSmD;MCRnD,YDQmD;MCPnD,eDOmD,EAAA;IAXrD;MCEE,atEwFqC;MsEvFrC,ctEuFqC;MsEtFrC,iBtEsFqC,EAAA;IqE1FvC;MCEE,ctEuFsC;MsEtFtC,etEsFsC;MsErFtC,kBtEqFsC,EAAA;IqEzFxC;MCEE,etEsFsC;MsErFtC,gBtEqFsC;MsEpFtC,mBtEoFsC,EAAA;;AuElFxC;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;EALb;;;;IAWI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY;IACZ,gBAAgB,EAAA;IrEjBZ;;;;;;;;;;;;MqEuBA,iBxDlBW,EAAA;IZLX;;;;;;;;;;;;MoE0BA,kBxDrBW,EAAA;EwDHnB;;;IAiCI,UAAU,EAAA;EAjCd;IAsCI,UAAU,EAAA;ErExCN;;IY8BJ,0ByDiBkC;IzDhBlC,6ByDgBkC,EAAA;EpE/C9B;;IW4CJ,yByDMiC;IzDLjC,4ByDKiC,EAAA;ErElD7B;;IY4CJ,yByDWiC;IzDVjC,4ByDUiC,EAAA;EpEvD7B;;IW8BJ,0ByD4BkC;IzD3BlC,6ByD2BkC,EAAA;EAxDtC;IAgEI,aAAa;IACb,mBAAmB,EAAA;IrEnEf;;MY8BJ,0ByD0CkC;MzDzClC,6ByDyCkC,EAAA;IpExE9B;;MW4CJ,yByD+BiC;MzD9BjC,4ByD8BiC,EAAA;IrE3E7B;MY4CJ,yByDoCiC;MzDnCjC,4ByDmCiC,EAAA;IpEhF7B;MW8BJ,0ByDqDkC;MzDpDlC,6ByDoDkC,EAAA;;AAatC;;EAEE,aAAa,EAAA;EAFf;;IAQI,kBAAkB;IAClB,UAAU,EAAA;IATd;;MAYM,UAAU,EAAA;ErE5GR;;;;;;;;IqEqHF,iBxDhHa,EAAA;EZLX;;;;;;;;IoEwHF,kBxDnHa,EAAA;;AwDwHnB;EAOE,mBAAmB;EACnB,sBAAsB,EAAA;ErErIhB;IqE+HJ,kBxD1He,EAAA;EZLX;IoEkIJ,iBxD7He,EAAA;;AwDkInB;EAOE,mBAAmB;EACnB,sBAAsB,EAAA;ErE/IhB;IqEyIJ,iBxDpIe,EAAA;EZLX;IoE4IJ,kBxDvIe,EAAA;;AwDmJnB;EACE,aAAa;EACb,mBAAmB;EACnB,yBhEzJ6B;EgE0J7B,gBAAgB;EtEjCZ,mBAtCY;EsEyEhB,gBvElJwB;EuEmJxB,gBvE9IqB;EuE+IrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiC;EzDpJ/B,sBCKsB;EwDmJtB,czE5JgB;EyE6JhB,yBzEnKgB;EyEoKhB,qBzEnKgB,EAAA;EyEmJpB;;IAsBI,aAAa,EAAA;;AAUjB;;EAEE,gCvD9D8D,EAAA;;AuDiEhE;;;;;;EAME,oBhElL8B;EN0G1B,qBAtCY;EsEgHhB,gBxDnMmB;EDYjB,qBCMqB,EAAA;;AwDqLzB;;EAEE,kCvD/E8D,EAAA;;AuDkFhE;;;;;;EAME,uBhExM+B;EN+G3B,qBAtCY;EsEiIhB,gBxDnNmB;EDWjB,qBCOqB,EAAA;;AbrBjB;;EqE6NJ,sBAA0E,EAAA;;ApE7NtE;;EoEgOJ,qBAAyE,EAAA;;ArEhOrE;;;;;;EY8BJ,0ByDqN8B;EzDpN9B,6ByDoN8B,EAAA;;ApEnP1B;;;;;;EW4CJ,yByD0M6B;EzDzM7B,4ByDyM6B,EAAA;;ArEtPzB;;;;;;EY4CJ,yByDqN6B;EzDpN7B,4ByDoN6B,EAAA;;ApEjQzB;;;;;;EW8BJ,0ByDsO8B;EzDrO9B,6ByDqO8B,EAAA;;ACjQlC;ECIE,eAAe;EAGf,YAAY,EAAA;;ADDd;EACE,gBEX+B;EFY/B,yB1EPkB;E0EQlB,yB1ENkB;EgBQhB,sBCKsB;E0DZxB,eAAe;EAGf,YAAY,EAAA;;ADcd;EAEE,qBAAqB,EAAA;;AAGvB;EACE,qBAA0B;EAC1B,cAAc,EAAA;;AAGhB;EvEkCI,cAAW;EuEhCb,c1E3BkB,EAAA;;A6EbpB;EACE,kBAAoD;EACpD,mBCEuB;E9DcrB,qBCMqB;E4DjBrB,yB7EEgB,EAAA;E6CgEhB;IgCzEJ;MAYI,kBCRqB,EAAA,EDUxB;;AAED;EACE,gBAAgB;EAChB,eAAe;E7DAb,gB6DCsB,EAAA;;AEf1B;EACE,aAAa;EACb,sBAAsB;EAStB,gBAAgB;E/DGd,sBCKsB,EAAA;EbnBlB;I2EMJ,eAAe,EAAA;E1ENX;I0ESJ,gBAAgB,EAAA;;AAYpB;EACE,WAAW;EACX,mBAAmB;EAEjB,c/EfgB,EAAA;EOIlB;IwEgBE,UAAU;IACV,qBAAqB;IAEnB,c/EvBc;I+EwBd,yB/E9Bc,EAAA;E+EiBpB;IAmBM,c/ErCc;I+EsCd,yB/EpCc,EAAA;;A+E8CpB;EACE,kBAAkB;EAClB,cAAc;EACd,wBCnDkC;EDqDlC,iBAAsC;EAGpC,yBClDqC;EDmDrC,mC/E3DY,EAAA;E+EkDhB;I/D5BI,+B+DyCkC;I/DxClC,gC+DwCkC,EAAA;EAbtC;I/DdI,mC+D+BqC;I/D9BrC,kC+D8BqC,EAAA;EAjBzC;IAsBI,oBAAoB;IAElB,c/ElEc;I+EmEd,yBCnEmC,EAAA;ED0CzC;IA+BI,UAAU;IAER,W/EpFO;I+EqFP,yB/E1CiB;I+E2CjB,qB/E3CiB,EAAA;E+EQvB;IAwCI,mBAAmB,EAAA;IAxCvB;MA2CM,gB9DzFa;M8D0Fb,qB9D1Fa,EAAA;;A8DwGf;EACE,mBAAmB,EAAA;EADrB;I/DxCA,kCClDsB;IDsCtB,0B+D0DwC,EAAA;EANxC;I/DpDA,gCCtCsB;IDkDtB,4B+DmD0C,EAAA;EAX1C;IAeM,aAAa,EAAA;EAfnB;IAmBM,qB9D3HS;I8D4HT,oBAAoB,EAAA;IApB1B;MAuBQ,iB9D/HO;M8DgIP,sB9DhIO,EAAA;;A4BgEf;EkCwCA;IACE,mBAAmB,EAAA;IADrB;M/DxCA,kCClDsB;MDsCtB,0B+D0DwC,EAAA;IANxC;M/DpDA,gCCtCsB;MDkDtB,4B+DmD0C,EAAA;IAX1C;MAeM,aAAa,EAAA;IAfnB;MAmBM,qB9D3HS;M8D4HT,oBAAoB,EAAA;MApB1B;QAuBQ,iB9D/HO;Q8DgIP,sB9DhIO,EAAA,E8DiIR;;AlCjEP;EkCwCA;IACE,mBAAmB,EAAA;IADrB;M/DxCA,kCClDsB;MDsCtB,0B+D0DwC,EAAA;IANxC;M/DpDA,gCCtCsB;MDkDtB,4B+DmD0C,EAAA;IAX1C;MAeM,aAAa,EAAA;IAfnB;MAmBM,qB9D3HS;M8D4HT,oBAAoB,EAAA;MApB1B;QAuBQ,iB9D/HO;Q8DgIP,sB9DhIO,EAAA,E8DiIR;;AlCjEP;EkCwCA;IACE,mBAAmB,EAAA;IADrB;M/DxCA,kCClDsB;MDsCtB,0B+D0DwC,EAAA;IANxC;M/DpDA,gCCtCsB;MDkDtB,4B+DmD0C,EAAA;IAX1C;MAeM,aAAa,EAAA;IAfnB;MAmBM,qB9D3HS;M8D4HT,oBAAoB,EAAA;MApB1B;QAuBQ,iB9D/HO;Q8DgIP,sB9DhIO,EAAA,E8DiIR;;AlCjEP;EkCwCA;IACE,mBAAmB,EAAA;IADrB;M/DxCA,kCClDsB;MDsCtB,0B+D0DwC,EAAA;IANxC;M/DpDA,gCCtCsB;MDkDtB,4B+DmD0C,EAAA;IAX1C;MAeM,aAAa,EAAA;IAfnB;MAmBM,qB9D3HS;M8D4HT,oBAAoB,EAAA;MApB1B;QAuBQ,iB9D/HO;Q8DgIP,sB9DhIO,EAAA,E8DiIR;;AlCjEP;EkCwCA;IACE,mBAAmB,EAAA;IADrB;M/DxCA,kCClDsB;MDsCtB,0B+D0DwC,EAAA;IANxC;M/DpDA,gCCtCsB;MDkDtB,4B+DmD0C,EAAA;IAX1C;MAeM,aAAa,EAAA;IAfnB;MAmBM,qB9D3HS;M8D4HT,oBAAoB,EAAA;MApB1B;QAuBQ,iB9D/HO;Q8DgIP,sB9DhIO,EAAA,E8DiIR;;AAaX;E/DrII,gB+DsIsB,EAAA;EAD1B;IAII,qB9DlJe,EAAA;I8D8InB;MAOM,sBAAsB,EAAA;;AE3J1B;EACE,c/D0G8D;E+DzG9D,yB/DyG8D,EAAA;EX5FhE;I0ETM,c/DqG0D;I+DpG1D,yBAAyC,EAAA;EAP/C;IAWM,WjFVK;IiFWL,yB/D+F0D;I+D9F1D,qB/D8F0D,EAAA;;A+D3GhE;EACE,c/D0G8D;E+DzG9D,yB/DyG8D,EAAA;EX5FhE;I0ETM,c/DqG0D;I+DpG1D,yBAAyC,EAAA;EAP/C;IAWM,WjFVK;IiFWL,yB/D+F0D;I+D9F1D,qB/D8F0D,EAAA;;A+D3GhE;EACE,c/D0G8D;E+DzG9D,yB/DyG8D,EAAA;EX5FhE;I0ETM,c/DqG0D;I+DpG1D,yBAAyC,EAAA;EAP/C;IAWM,WjFVK;IiFWL,yB/D+F0D;I+D9F1D,qB/D8F0D,EAAA;;A+D3GhE;EACE,c/D0G8D;E+DzG9D,yB/DyG8D,EAAA;EX5FhE;I0ETM,c/DqG0D;I+DpG1D,yBAAyC,EAAA;EAP/C;IAWM,WjFVK;IiFWL,yB/D+F0D;I+D9F1D,qB/D8F0D,EAAA;;A+D3GhE;EACE,c/D0G8D;E+DzG9D,yB/DyG8D,EAAA;EX5FhE;I0ETM,c/DqG0D;I+DpG1D,yBAAyC,EAAA;EAP/C;IAWM,WjFVK;IiFWL,yB/D+F0D;I+D9F1D,qB/D8F0D,EAAA;;A+D3GhE;EACE,c/D0G8D;E+DzG9D,yB/DyG8D,EAAA;EX5FhE;I0ETM,c/DqG0D;I+DpG1D,yBAAyC,EAAA;EAP/C;IAWM,WjFVK;IiFWL,yB/D+F0D;I+D9F1D,qB/D8F0D,EAAA;;A+D3GhE;EACE,c/D0G8D;E+DzG9D,yB/DyG8D,EAAA;EX5FhE;I0ETM,c/DqG0D;I+DpG1D,yBAAyC,EAAA;EAP/C;IAWM,WjFVK;IiFWL,yB/D+F0D;I+D9F1D,qB/D8F0D,EAAA;;A+D3GhE;EACE,c/D0G8D;E+DzG9D,yB/DyG8D,EAAA;EX5FhE;I0ETM,c/DqG0D;I+DpG1D,yBAAyC,EAAA;EAP/C;IAWM,WjFVK;IiFWL,yB/D+F0D;I+D9F1D,qB/D8F0D,EAAA;;A6DmElE;EAEI,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;E/DpKhB,gB+DqKwB,EAAA;EAN5B;IASM,kBAAkB,EAAA;IATxB;MAYQ,kBAAkB;MAClB,YAAY;MACZ,UAAU;MACV,WAAW;MACX,WAAW;MAST,uC/ErMM,EAAA;MIDR;Q2EgME,QAAQ,EAAA;M1EhMV;Q0EmME,SAAS,EAAA;;AEhLjB;EACE,8BjFuBmB,EAAA;;AiFxBrB;EACE,8BjF2CqB,EAAA;;AiF5CvB;EACE,8BjFyDmB,EAAA;;AiF1DrB;EACE,2BjFoDa,EAAA;;AiFrDf;EACE,8BjF8DmB,EAAA;;AiF/DrB;EACE,8BjF+CkB,EAAA;;AiFhDpB;EACE,8BjFhBgB,EAAA;;AiFelB;EACE,8BjFTgB,EAAA;;AkFfpB;EACE,aAAa;EACb,uBAAuB,EAAA;;AAGzB;EACE,SAAO,EAAA;;ACAT;EAEE,gBAAgB,EAAA;EAFlB;IAKI,kBAAkB;IAClB,gBAAgB,EAAA;;AAKpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,atEX2B;EsEY3B,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAGhB,UAAU,EAAA;;AAOZ;EACE,kBAAkB;EAClB,WAAW;EACX,cC9BkC;EDgClC,oBAAoB,EAAA;EAGpB;IpD3BI,mCqDkByC;IDW3C,8BCbwC,EAAA;IrDZtC;MoDuBJ;QpDtBM,gBAAgB,EAAA,EoDyBrB;EACD;IACE,eCfyB,EAAA;EDmB3B;IACE,sBClBgC,EAAA;;ADsBpC;EACE,aAAa;EACb,6BjEyF8D,EAAA;EiE3FhE;IAKI,8BjEsF4D;IiErF5D,gBAAgB,EAAA;EANpB;;IAWI,cAAc,EAAA;EAXlB;IAeI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EACnB,6BjEqE8D,EAAA;EiExEhE;IAOI,cAAc;IACd,0BjEgE4D;IiE/D5D,mBAAmB;IACnB,WAAW,EAAA;EAVf;IAeI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY,EAAA;IAjBhB;MAoBM,gBAAgB,EAAA;IApBtB;MAwBM,aAAa,EAAA;;AAMnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EAEX,oBAAoB;EACpB,4BAA4B;EAC5B,iBAAyC;EnEhGvC,qBCMqB;EkE8FvB,UAAU;EAGR,sBnFrHS;EmFsHT,iCnFrHY,EAAA;;AmF0HhB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,atE1H2B;EsE2H3B,YAAY;EACZ,aAAa;EACb,yBnFjIc,EAAA;EmF0HhB;IAUW,UAAU,EAAA;EAVrB;IAWW,YCtHoB,EAAA;;AD2H/B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBC7H+B;ED8H/B,wBAA+C;EnEzH7C,0CEyH4D;EFxH5D,2CEwH4D;EiEG5D,qBnF9IgB,EAAA;EmFsIpB;IAYI,kBCrI6B,EAAA;IhFlBzB;M+E0JF,8BAA6F,EAAA;I9E1J3F;M8E8JF,8BC5I2B,EAAA;;ADkJjC;EACE,gBAAgB;EAChB,gBjFrJqB,EAAA;;AiF0JvB;EACE,kBAAkB;EAGlB,cAAc;EACd,aChLwB,EAAA;;ADoL1B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgE;EAChE,qBAA4C;EnErJ1C,8CE2G4D;EF1G5D,6CE0G4D;EiE6C5D,qBnFxLgB,EAAA;EmF+KpB;IAiBI,eAAwC,EAAA;;AAK5C;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAA;;AtC1Id;EsCtCJ;IAuLI,gBC7La;ID8Lb,oBAAyC,EAAA;EAlK7C;IAsKI,+BjE3E4D,EAAA;IiE3FhE;MAyKM,gCjE9E0D,EAAA;EiExEhE;IA2JI,+BjEnF4D,EAAA;IiExEhE;MA8JM,4BjEtF0D;MiEuF1D,mBAAmB,EAAA;EAQvB;IAAY,gBCrNG,EAAA,EDqNqB;;AtC1KlC;EsC8KF;;IAEE,gBC7Na,EAAA,ED8Nd;;AtCjLC;EsCqLF;IAAY,iBCnOI,EAAA,EDmOoB;;AAIpC;EAGI,qBnFtNiB,EAAA;;AmFmNrB;EAOI,WnFrQO;EmFsQP,yBnF3NiB,EAAA;;AmFmNrB;EAGI,qBnFlMmB,EAAA;;AmF+LvB;EAOI,WnFrQO;EmFsQP,yBnFvMmB,EAAA;;AmF+LvB;EAGI,qBnFpLiB,EAAA;;AmFiLrB;EAOI,WnFrQO;EmFsQP,yBnFzLiB,EAAA;;AmFiLrB;EAGI,kBnFzLW,EAAA;;AmFsLf;EAOI,WnFrQO;EmFsQP,sBnF9LW,EAAA;;AmFsLf;EAGI,qBnF/KiB,EAAA;;AmF4KrB;EAOI,WnFrQO;EmFsQP,yBnFpLiB,EAAA;;AmF4KrB;EAGI,qBnF9LgB,EAAA;;AmF2LpB;EAOI,WnFrQO;EmFsQP,yBnFnMgB,EAAA;;AmF2LpB;EAGI,qBnF7Pc,EAAA;;AmF0PlB;EAOI,WnFrQO;EmFsQP,yBnFlQc,EAAA;;AmF0PlB;EAGI,qBnFtPc,EAAA;;AmFmPlB;EAOI,WnFrQO;EmFsQP,yBnF3Pc,EAAA;;AqFVpB;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EjFLV;IiFQJ,eAAe,EAAA;EhFRX;IgFWJ,gBAAgB,EAAA;;AAIpB;EACE,cAAc;EACd,oBCjBwB,EAAA;E/EcxB;I8EOE,qBAAqB,EAAA;EANzB;IAWI,crFjBgB;IqFkBhB,oBAAoB;IACpB,eAAe;IAEb,crFrBc,EAAA;;AqF8BpB;EACE,wBAA2C;EAEzC,qBrFpCgB,EAAA;EqFiCpB;IAOI,mBpEzCe,EAAA;EoEkCnB;IAWI,6BAAgD;IrE3BhD,+BCJsB;IDKtB,gCCLsB,EAAA;IVLxB;M8EyCM,qCrFjDY,EAAA;IqFiCpB;MAqBM,6BAA6B;MAC7B,yBAAyB;MAEvB,crFtDY,EAAA;EqF8BpB;;IAgCM,crF7Dc;IqF8Dd,yBrFpEc;IqFqEd,qCrFrEc,EAAA;EqFmCpB;IAwCI,gBpE1Ee;IDkBf,yBqE0D4B;IrEzD5B,0BqEyD4B,EAAA;;AAchC;EAEI,SAAS,EAAA;EAFb;IAOU,sBrFtGG;IqFuGH,yBrFvGG,EAAA;;AqF+Fb;EAcI,wBCvG0C;EDwG1C,iBAAkD;ErEhGlD,wCCKsB;EoE8FpB,crFvGc;EqFwGd,sBrFlHO;EqFmHP,qBrF9Gc,EAAA;;AqF0FpB;EA0BM,yBAAyB,EAAA;;AA1B/B;ErEjFI,wCCKsB,EAAA;;AoE4E1B;EAmCI,aAAa,EAAA;EAnCjB;IAsCM,UAAU;IACV,YAAY;IACZ,gBAAgB,EAAA;;AhFvId;EgF6IF,2BAA2B,EAAA;;AA9CjC;EAkDM,kBpE5Ia,EAAA;;AoE0FnB;ErEjFI,kCCKsB,EAAA;EoE4E1B;IA0DU,0CrFpJU,EAAA;;AILZ;EiFiKF,2BAA2B,EAAA;;AhFjKzB;EgFoKF,mBAAmB,EAAA;;AjFpKjB;EiFyKA,iBpEpKW,EAAA;;AZLX;EgF4KA,kBpEvKW,EAAA;;AoE0FnB;ErEjFI,kCqEmKwG,EAAA;EAlF5G;IAsFU,0CrFrLG,EAAA;;AqF+Fb;ErEjFI,wCCKsB,EAAA;;AoEkL1B;ErEvLI,sBCKsB,EAAA;;AoEkL1B;;EAQM,WrF7MO;EqF8MP,yBrFnKiB,EAAA;;AqF4KvB;EACE,wBAAiD;EAE/C,qBrFpNgB,EAAA;EqFiNpB;IAOI,mBAA4C,EAAA;EAPhD;IAWI,SAAS;IACT,oCAA6D,EAAA;EAZjE;;IAiBI,uBAAuB,EAAA;;AAKzB;;EAGI,crFrMiB;EqFsMjB,qBrFtMiB,EAAA;;AqFkMrB;;EAGI,crFjLmB;EqFkLnB,qBrFlLmB,EAAA;;AqF8KvB;;EAGI,crFnKiB;EqFoKjB,qBrFpKiB,EAAA;;AqFgKrB;;EAGI,WrFxKW;EqFyKX,kBrFzKW,EAAA;;AqFqKf;;EAGI,crF9JiB;EqF+JjB,qBrF/JiB,EAAA;;AqF2JrB;;EAGI,crF7KgB;EqF8KhB,qBrF9KgB,EAAA;;AqF0KpB;;EAGI,crF5Oc;EqF6Od,qBrF7Oc,EAAA;;AqFyOlB;;EAGI,crFrOc;EqFsOd,qBrFtOc,EAAA;;AqFgPpB;EAEI,cAAc;EACd,kBAAkB,EAAA;;AAItB;EAEI,aAAa;EACb,YAAY;EACZ,kBAAkB,EAAA;;AAStB;EAEI,aAAa,EAAA;;AAFjB;EAKI,cAAc,EAAA;;AAMlB;;EAIM,aAAa;EACb,mBAAmB;EACnB,YE/PsB;EFgQtB,cAAc;EACd,iBAAiB,EAAA;;AGrRvB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,oB9CfY,EAAA;E8CSd;;IAWI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B,EAAA;;AAoBlC;EACE,qBAAqB;EACrB,uBCxCqE;EDyCrE,0BCzCqE;ED0CrE,kB9C/CY;EvCuHR,qBAtCY;EqFhChB,oBAAoB;EACpB,mBAAmB,EAAA;EjFxCnB;IiF2CE,qBAAqB,EAAA;;AASzB;EACE,aAAa;EACb,sBAAsB;EAOtB,gBAAgB;EAChB,gBAAgB,EAAA;EpF5EV;IoFsEJ,eAAe,EAAA;EnFtEX;ImFyEJ,gBAAgB,EAAA;EAPpB;IAaI,gBAAgB;IAChB,eAAe,EAAA;EAdnB;IAkBI,gBAAgB;IAChB,WAAW,EAAA;;AASf;EACE,qBAAqB;EACrB,mBFjGyB;EEkGzB,sBFlGyB,EAAA;;AE8G3B;EACE,gBAAgB;EAChB,YAAY;EAGZ,mBAAmB,EAAA;;AAIrB;EACE,wBC3GoC;EtF+GhC,qBAtCY;EqFoChB,cAAc;EACd,6BAA6B;EAC7B,6BAAuC;ExE7GrC,sBCKsB,EAAA;EVLxB;IiFiHE,qBAAqB,EAAA;;AAMzB;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,0BAA0B,EAAA;;A3C1DxB;E2CoEC;;IAGK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;A3CtFL;E2CiFA;IAoBI,qBAAqB;IACrB,2BAA2B,EAAA;IArB9B;MAwBK,mBAAmB,EAAA;MAxBxB;QA2BO,kBAAkB,EAAA;MA3BzB;QA+BO,qBClLsB;QDmLtB,oBCnLsB,EAAA;IDmJ7B;;MAsCK,iBAAiB,EAAA;IAtCtB;MAqDK,wBAAwB;MAGxB,gBAAgB,EAAA;IAxDrB;MA4DK,aAAa,EAAA,EACd;;A3CjIL;E2CoEC;;IAGK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;A3CtFL;E2CiFA;IAoBI,qBAAqB;IACrB,2BAA2B,EAAA;IArB9B;MAwBK,mBAAmB,EAAA;MAxBxB;QA2BO,kBAAkB,EAAA;MA3BzB;QA+BO,qBClLsB;QDmLtB,oBCnLsB,EAAA;IDmJ7B;;MAsCK,iBAAiB,EAAA;IAtCtB;MAqDK,wBAAwB;MAGxB,gBAAgB,EAAA;IAxDrB;MA4DK,aAAa,EAAA,EACd;;A3CjIL;E2CoEC;;IAGK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;A3CtFL;E2CiFA;IAoBI,qBAAqB;IACrB,2BAA2B,EAAA;IArB9B;MAwBK,mBAAmB,EAAA;MAxBxB;QA2BO,kBAAkB,EAAA;MA3BzB;QA+BO,qBClLsB;QDmLtB,oBCnLsB,EAAA;IDmJ7B;;MAsCK,iBAAiB,EAAA;IAtCtB;MAqDK,wBAAwB;MAGxB,gBAAgB,EAAA;IAxDrB;MA4DK,aAAa,EAAA,EACd;;A3CjIL;E2CoEC;;IAGK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;A3CtFL;E2CiFA;IAoBI,qBAAqB;IACrB,2BAA2B,EAAA;IArB9B;MAwBK,mBAAmB,EAAA;MAxBxB;QA2BO,kBAAkB,EAAA;MA3BzB;QA+BO,qBClLsB;QDmLtB,oBCnLsB,EAAA;IDmJ7B;;MAsCK,iBAAiB,EAAA;IAtCtB;MAqDK,wBAAwB;MAGxB,gBAAgB,EAAA;IAxDrB;MA4DK,aAAa,EAAA,EACd;;A3CjIL;E2CoEC;;IAGK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;A3CtFL;E2CiFA;IAoBI,qBAAqB;IACrB,2BAA2B,EAAA;IArB9B;MAwBK,mBAAmB,EAAA;MAxBxB;QA2BO,kBAAkB,EAAA;MA3BzB;QA+BO,qBClLsB;QDmLtB,oBCnLsB,EAAA;IDmJ7B;;MAsCK,iBAAiB,EAAA;IAtCtB;MAqDK,wBAAwB;MAGxB,gBAAgB,EAAA;IAxDrB;MA4DK,aAAa,EAAA,EACd;;AAlET;EAyBQ,qBAAqB;EACrB,2BAA2B,EAAA;EA1BnC;;IAQU,gBAAgB;IAChB,eAAe,EAAA;EATzB;IA6BU,mBAAmB,EAAA;IA7B7B;MAgCY,kBAAkB,EAAA;IAhC9B;MAoCY,qBClLsB;MDmLtB,oBCnLsB,EAAA;ED8IlC;;IA2CU,iBAAiB,EAAA;EA3C3B;IA0DU,wBAAwB;IAGxB,gBAAgB,EAAA;EA7D1B;IAiEU,aAAa,EAAA;;A1B5Ff;E0BqGJ,WxF3NS,EAAA;EOcX;IiFgNI,WxF9NO,EAAA;;A8DsHL;E0B8GF,+BxFpOO,EAAA;EOcX;IiFyNM,gCxFvOK,EAAA;E8DsHL;I0BqHA,gCxF3OK,EAAA;;A8DsHL;;;;E0B6HF,WxFnPO,EAAA;;A8DsHL;E0BkIJ,+BxFxPS;EwFyPT,sCxFzPS,EAAA;;A8DsHL;E0BuIJ,0DtEvM8E,EAAA;;A4CgE1E;E0B2IJ,+BxFjQS,EAAA;E8DsHL;I0B6IF,WxFnQO,EAAA;IOcX;MiFwPM,WxFtQK,EAAA;;A8DsHL;E0BqGJ,0BxF1NY,EAAA;EOad;IiFgNI,0BxF7NU,EAAA;;A8DqHR;E0B8GF,0BxFnOU,EAAA;EOad;IiFyNM,0BxFtOQ,EAAA;E8DqHR;I0BqHA,0BxF1OQ,EAAA;;A8DqHR;;;;E0B6HF,0BxFlPU,EAAA;;A8DqHR;E0BkIJ,0BxFvPY;EwFwPZ,iCxFxPY,EAAA;;A8DqHR;E0BuIJ,0DtEvM8E,EAAA;;A4CgE1E;E0B2IJ,0BxFhQY,EAAA;E8DqHR;I0B6IF,0BxFlQU,EAAA;IOad;MiFwPM,0BxFrQQ,EAAA;;A0FLhB;EACE,aAAa;ECSb,gBAAgB;E3EQd,sBCKsB,EAAA;EbnBlB;IuFCJ,eAAe,EAAA;EtFDX;IsFIJ,gBAAgB,EAAA;;ADFpB;EACE,kBAAkB;EAClB,cAAc;EACd,uBEJ+B;EFK/B,iBEA6B;EFE7B,iBAAsC;EAQpC,c1F2BmB;E0F1BnB,sB1FjBS;E0FkBT,qB1FbgB,EAAA;EILZ;IsFUJ,iBzELe,EAAA;EZLX;IqFaJ,kBzERe,EAAA;EyEHnB;IAoBI,UAAU;IACV,qBAAqB;IAEnB,cpFjB6D;IoFkB7D,yB1FrBc;I0FsBd,qB1FrBc,EAAA;E0FJpB;IA8BI,UAAU;IACV,UEjBiC;IFkBjC,gD1FSmB,EAAA;;AI3Cf;EsF0CA,cAAc;E1EElB,+BCzBsB;ED0BtB,kCC1BsB,EAAA;;AZnBlB;EqF8CA,eAAe;E1EhBnB,gCCXsB;EDYtB,mCCZsB,EAAA;;AbnBlB;EY8BJ,gCCXsB;EDYtB,mCCZsB,EAAA;;AZnBlB;EW4CJ,+BCzBsB;ED0BtB,kCC1BsB,EAAA;;AyEmB1B;EAyBI,UAAU;EAER,W1FjEO;E0FkEP,yB1FvBiB;E0FwBjB,qB1FxBiB,EAAA;;A0FLvB;EAkCI,oBAAoB;EAEpB,YAAY;EAEV,c1FnEc;E0FoEd,sB1F7EO;E0F8EP,qB1FxEc,EAAA;;A6FPlB;EACE,uBDK6B;EzFsH3B,qBAtCY;E0FnFd,gB5EAiB,EAAA;;AbFb;EY4CJ,8BCxBqB;EDyBrB,iCCzBqB,EAAA;;AZpBjB;EW8BJ,+BCVqB;EDWrB,kCCXqB,EAAA;;AbpBjB;EY8BJ,+BCVqB;EDWrB,kCCXqB,EAAA;;AZpBjB;EW4CJ,8BCxBqB;EDyBrB,iCCzBqB,EAAA;;A4ErBvB;EACE,uBDG4B;EzFwH1B,qBAtCY;E0FnFd,gB5ECiB,EAAA;;AbHb;EY4CJ,8BCvBqB;EDwBrB,iCCxBqB,EAAA;;AZrBjB;EW8BJ,+BCTqB;EDUrB,kCCVqB,EAAA;;AbrBjB;EY8BJ,+BCTqB;EDUrB,kCCVqB,EAAA;;AZrBjB;EW4CJ,8BCvBqB;EDwBrB,iCCxBqB,EAAA;;A6EzBzB;EACE,ajFU2B;EiFT3B,cAAc;EACd,gBhFC2B;ECH3B,kMbI6M;EaF7M,kBAAkB;EAClB,gBbYwB;EaXxB,gBbgBqB;EafrB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EZgHZ,qBAtCY;E2FhFhB,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAmC;E9EOjC,qBCMqB;E6ETrB,sB9FXS;E8FYT,iC9FXY,EAAA;E8FLhB;IAoBI,kBAAkB;IAClB,cAAc,EAAA;IArBlB;MAyBM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAOvB;;EACE,a5EwFyB;E4EvFzB,chFpByB;EgFqBzB,iB7EfqB,EAAA;;A6EqBvB;;EACE,ahF5ByB;EgF6BzB,c5E8EyB;E4E7EzB,iBAAiC;EACjC,SAAS,EAAA;;AAIb;EAEE,gCAA+C,EAAA;EAE/C;IACE,2B5E0F4D,EAAA;I4ExF5D;MACE,SAAS;MACT,6BAAgE;MAE9D,sChFlCwD,EAAA;IgFsC5D;MACE,W7E5Da;M6E6Db,6BAAgE;MAE9D,sB9FpEK,EAAA;;A8F0Eb;EAEE,8BAA6C,EAAA;EAE7C;IACE,yB5EiE4D,EAAA;I4E/D5D;MACE,OAAO;MACP,oCAA2F;MAEzF,wChF3DwD,EAAA;IgF+D5D;MACE,S7ErFa;M6EsFb,oCAA2F;MAEzF,wB9F7FK,EAAA;;A8FmGb;EAEE,6BAA4C,EAAA;EAE5C;IACE,wB5EwC4D,EAAA;I4EtC5D;MACE,MAAM;MACN,oCAA2F;MAEzF,yChFpFwD,EAAA;IgFwF5D;MACE,Q7E9Ga;M6E+Gb,oCAA2F;MAEzF,yB9FtHK,EAAA;E8F4HX;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,WhFpHwB;IgFqHxB,oBAAsC;IACtC,WAAW;IACX,wBAA0C;IAExC,4BhFhH8C,EAAA;;AgFqHpD;EAEE,8BAA6C,EAAA;EAE7C;IACE,0B5EA4D,EAAA;I4EE5D;MACE,QAAQ;MACR,oChFtIuB;MgFwIrB,uChF5HwD,EAAA;IgFgI5D;MACE,U7EtJa;M6EuJb,oChF9IuB;MgFgJrB,uB9F9JK,EAAA;;A8FsLb;EACE,uBhF/KgC;EgFgLhC,gBAAgB;E3F7DZ,mBAtCY;E2FqGhB,wBAA0C;E9EnKxC,0CEyH4D;EFxH5D,2CEwH4D;E4E8C5D,yBhFxKgD;EgFyKhD,4BAAsE,EAAA;EAT1E;IAaI,aAAa,EAAA;;AAIjB;EACE,uBhFhMgC;EgFkM9B,c9FvMgB,EAAA;;A+FLlB;EACE;IAAO,2BAAuC,EAAA;EAC9C;IAAK,wBAAwB,EAAA,EAAA;;AAIjC;EACE,aAAa;EACb,YCPwB;EDQxB,gBAAgB;EAChB,cAAc;E5FmHV,qBAtCY;EavEd,sBCKsB;E8ELtB,yB/FVgB,EAAA;;A+FcpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EhEZf,2BiENyC;EDsB3C,W/F5BS;E+F6BT,yB/FcmB,EAAA;E+B3BjB;IgEEN;MhEDQ,gBAAgB,EAAA,EgEcvB;;AAED;EvEME,qMAA6I;EuEJ7I,0BCpCwB,EAAA;;ADwCxB;EACE,kDCnC+C,EAAA;EDsC7C;IAJJ;MAKM,eAAe,EAAA,EAGpB;;AAGH;EACE,WAAW,EAAA;;AAGb;EACE,WAAW,EAAA;;AAIb;EACE,0CAAyC,EAAA;EAD3C;IAGI,sB/F9DS,EAAA;;AiGHb;EACE,aAAa;EACb,mBAAmB;EACnB,mBvDIY,EAAA;;AuDDd;EACE,eAAe;EACf,kBAAkB,EAAA;;AAGpB;EACE,qB/FFsC,EAAA;EEPhC;I6FYJ,wBAAmC,EAAA;E5FZ/B;I4FeJ,wBvDXU,EAAA;;AuDed;EACE,qB/FZsC;E+FatC,cjGXkB,EAAA;;AiGcpB;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,sBAA8B,EAAA;;AAGhC;EACE,YAAY;EACZ,kBAAkB,EAAA;EAFpB;IAKI,kBAAkB,EAAA;;AAItB;EACE,gBAAgB,EAAA;;AC3ClB;EACE,kBAAkB;EAClB,aAAa;EAEb,eXHuB;EWIvB,sBAAsB;EAEtB,SAAS;EACT,YXPuB;EWQvB,UXG2B;EWF3B,gBAAgB,EAAA;EAVlB;IAaI,SAAS,EAAA;ErDuET;IqDpFJ;MAkBI,iBAAY;MACZ,eAAe;MACf,MAAM;MACN,SAAS;MACT,arFhByB,EAAA;MTJrB;Q8FwBA,OAAO,EAAA;M9FxBP;Q8F2BA,QAAQ,EAAA;M7F3BR;Q6FgCA,QAAQ,EAAA;M7FhCR;Q6FmCA,OAAO,EAAA,EACR;E9FpCC;I8F0CF,mBX3CmB,EAAA;EnFCjB;I8F6CF,oBX9CmB,EAAA;ElFCjB;I6FmDF,oBXpDmB,EAAA;ElFCjB;I6FsDF,mBXvDmB,EAAA;EWDzB;IA6DI,iClG1DY,EAAA;EkGHhB;IAkEM,eX3DK;IW4DL,YX5DK,EAAA;InFLH;M8FqEE,mBXhEC,EAAA;InFLH;M8FwEE,oBXnEC,EAAA;IlFLH;M6F8EE,oBXzEC,EAAA;IlFLH;M6FiFE,mBX5EC,EAAA;EWPX;IAkEM,eX1DK;IW2DL,YX3DK,EAAA;InFNH;M8FqEE,mBX/DC,EAAA;InFNH;M8FwEE,oBXlEC,EAAA;IlFNH;M6F8EE,oBXxEC,EAAA;IlFNH;M6FiFE,mBX3EC,EAAA;EWRX;IAkEM,eXzDK;IW0DL,YX1DK,EAAA;InFPH;M8FqEE,mBX9DC,EAAA;InFPH;M8FwEE,oBXjEC,EAAA;IlFPH;M6F8EE,oBXvEC,EAAA;IlFPH;M6FiFE,mBX1EC,EAAA;E1C8DP;IqDvEJ;MA2FM,eAAe;MACf,MAAM;MACN,SAAS;MACT,arFxFuB,EAAA;MTJrB;Q8FgGE,OAAO,EAAA;M9FhGT;Q8FoGE,QAAQ,EAAA;M7FpGV;Q6F0GE,QAAQ,EAAA;M7F1GV;Q6F8GE,OAAO,EAAA,EACR;EAjHT;IAuHI,eAAe;IACf,MAAM;IACN,SAAS;IACT,arFpHyB,EAAA;ITJrB;M8F4HA,OAAO,EAAA;I9F5HP;M8FgIA,QAAQ,EAAA;I7FhIR;M6FsIA,QAAQ,EAAA;I7FtIR;M6F0IA,OAAO,EAAA;;AAUf;EACE,kBAAkB;EAClB,WXrH0B;EWsH1B,YXtH0B;EWuH1B,uBAAuB;EACvB,SAAS,EAAA;E3FjJT;IACE;M2FmJA,qBAAqB,EAAA,E3FnJC;E2F2I1B;IAaI,UAAU,EAAA;E9FjKN;I8FqKJ,QAAQ,EAAA;E7FrKJ;I6FyKJ,OAAO,EAAA;;AAIX;EACE,aAAa;EACb,cX9I0B;EW+I1B,mBAAmB;EACnB,uBAAuB,EAAA;EAJzB;IAOI,aAAa,EAAA;;AAIjB;EACE,cX3I8B;EW4I9B,qBX1I8B;EW2I9B,kBAAkB;EAClB,gBtEzK8C,EAAA;;AsE8KhD;EACE,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAA;EATlB;IAaI,8BAA8B;IAE9B,wBAAwB,EAAA;IAf5B;MAkBM,mBAAmB,EAAA;;AAKzB;EACE,qBXhJkC;EWiJlC,gBXhJkC;EWiJlC,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBtE3M8C,EAAA;;AsE8MhD;EACE,YAAY;EACZ,uBtEhN8C,EAAA;;AsEmNhD;EACE,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,uBXlKkC;EWmKlC,qBAAqB;EACrB,mBAAmB;EACnB,uCtE9N8C,EAAA;ExBnBxC;I8FwPF,iBAAiB,EAAA;E7FxPf;I6F2PF,kBAAkB,EAAA;EAjBxB;IAsBI,eCxMqB,EAAA;ED0MvB;IAxBF;MA0BM,qBAAqB,EAAA,EACtB;;AAIL;EACE,cX7LkC;EW8LlC,kBAAgC;EAChC,qBAAmC;EACnC,kBAAkB;EAClB,gBtE3P8C;EsE4P9C,kBAAkB,EAAA;E9F/QZ;I8FmRF,kBXvM8B,EAAA;ElF5E5B;I6FsRF,mBX1M8B,EAAA;;AW+MpC;EACE,kBAAkB;EAClB,uCAA2D,EAAA;EAF7D;IASM,kBAAkB,EAAA;E9FpShB;I8FySA,yBAAyB,EAAA;E7FzSzB;I6F4SA,yBAAyB,EAAA;EAjBjC;IAsBM,eAAe,EAAA;;AAKrB;EAEE,eAAe,EAAA;EAFjB;IAKI,cAAc;IACd,aAAW;IACX,WAAW;IACX,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;IAC3B,0BtE9S4C,EAAA;IxBnBxC;M8FoUF,iBAAiB,EAAA;I7FpUf;M6FuUF,kBAAkB;MAClB,yBAAyB,EAAA;E9FxUvB;I8F8UF,kBXlQ8B,EAAA;ElF5E5B;I6FiVF,iBXrQ8B,EAAA;;AW0QpC;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,uCAA2D,EAAA;E9F3VrD;I8F+VF,kBXlR8B,EAAA;ElF7E5B;I6FkWF,mBXrR8B,EAAA;EnF7E5B;I8FuWA,kBX1R4B,EAAA;ElF7E5B;I6F0WA,mBX7R4B,EAAA;;AnF7E5B;E8FuXE,kBAA4E,EAAA;;A7FvX9E;E6F0XE,mBAA6E,EAAA;;A9F1X/E;E8F8XI,kBXjTwB,EAAA;;AlF7E5B;E6FiYI,mBXpTwB,EAAA;;AnF7E5B;E8FuXE,kBAA4E,EAAA;;A7FvX9E;E6F0XE,mBAA6E,EAAA;;A9F1X/E;E8F8XI,kBXjTwB,EAAA;;AlF7E5B;E6FiYI,mBXpTwB,EAAA;;AnF7E5B;E8FuXE,kBAA4E,EAAA;;A7FvX9E;E6F0XE,mBAA6E,EAAA;;A9F1X/E;E8F8XI,kBXjTwB,EAAA;;AlF7E5B;E6FiYI,mBXpTwB,EAAA;;AnF7E5B;E8FuXE,kBAA4E,EAAA;;A7FvX9E;E6F0XE,mBAA6E,EAAA;;A9F1X/E;E8F8XI,kBXjTwB,EAAA;;AlF7E5B;E6FiYI,mBXpTwB,EAAA;;AnF7E5B;E8FuXE,kBAA4E,EAAA;;A7FvX9E;E6F0XE,mBAA6E,EAAA;;A9F1X/E;E8F8XI,kBXjTwB,EAAA;;AlF7E5B;E6FiYI,mBXpTwB,EAAA;;AW6TpC;EACE,aAAa;EACb,wBXhUkC;EWiUlC,gBtE1X8C,EAAA;EsEuXhD;IAMI,qBAAqB,EAAA;EANzB;IAUI,eAAe,EAAA;;AAInB;EACE,cX/O8B;EWgP9B,qBX9O8B;EW+O9B,gBtExY8C,EAAA;;AsE2YhD;EACE,aAAa;EACb,cXvOkD;EWwOlD,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,eAAe;EACf,SAAS,EAAA;ErDnVP;IqD4UJ;MAUI,aAAa,EAAA,EAkChB;EA5CD;IAcI,cAAc;IACd,WXpPgD;IWqPhD,YXrPgD;IWsPhD,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAA8C;IAC9C,gBtEha4C,EAAA;IvBnBxC;M6FsbF,yBAAyB,EAAA;EAxB/B;IA8BI,UAAU,EAAA;EAGZ;IACE,2BAA2B,EAAA;I9FhcvB;M8FmcA,0BAA0B,EAAA;I7Fnc1B;M6FscA,uBAAuB,EAAA;;ArDpX3B;EqD2XJ;IAEI,eAAe;IACf,MAAM;IACN,OAAO;IACP,arF9cyB;IqF+czB,YAAY;IACZ,aAAa;IACb,yBlGpdY;IkGqdZ,gBtEnc4C,EAAA;IsE0bhD;MAYe,UAAU,EAAA;IAZzB;MAae,YX1ce,EAAA,EW0cuB;;ArDrZjD;EqD2ZJ;IAEI,arF9dyB;IqF+dzB,cXxd4B,EAAA;IWqdhC;MAMM,arFleuB;MqFmevB,WX5d0B,EAAA;InFXxB;M8F4eA,kBXjewB,EAAA;IlFXxB;M6F+eA,mBXpewB,EAAA;InFXxB;M8FofA,mBXzewB,EAAA;InFXxB;M8FufA,kBX5ewB,EAAA;IWqdhC;MA4BM,aAAa,EAAA;IA5BnB;MAgCM,cAAc,EAAA;IAhCpB;MAoCM,oBX3U8C;MW4U9C,iBAAiB,EAAA;IArCvB;;;;;;;MA+CM,SAAS;MACT,UAAU;MACV,SAAS;MACT,kBAAkB;MAClB,UAAU,EAAA;IAnDhB;MAyDM,eAAe;MACf,SAAS;MACT,cAAc,EAAA;M9F3hBZ;Q8F+hBE,0BAA0B,EAAA;M7F/hB5B;Q6FkiBE,uBAAuB,EAAA;I9FliBzB;M8FyiBA,uBAAuB,EAAA;I7FziBvB;M6F4iBA,yBAAyB,EAAA;I9F5iBzB;;M8FojBE,mBXrjBe,EAAA;IlFCjB;;M6FujBE,oBXxjBe,EAAA;IWiezB;;MA8FM,gBAAgB;MAChB,mBAAmB;MACnB,cAAc,EAAA;MAhGpB;;QAmGQ,YAAgD,EAAA;IAnGxD;MAwGM,aAAa,EAAA;IAxGnB;MA6GQ,YX9kBiB,EAAA;IWiezB;MAmHM,kBAAkB,EAAA;MAnHxB;QAsHQ,aAAa,EAAA;QAtHrB;UAyHU,aAAa,EAAA;MAzHvB;QA6HQ,kBAAkB,EAAA;MA7H1B;QAmIQ,YAAgD;QAChD,iBAAiB,EAAA;QApIzB;UAuIU,kBAAkB;UAClB,eAAe,EAAA;U9FxmBjB;Y8F2mBI,UXhmBoB,EAAA;UlFXxB;Y6F8mBI,WXnmBoB,EAAA;InFXxB;M8FsnBA,OAAO,EAAA;I7FtnBP;M6FynBA,QAAQ,EAAA,E7FvnBP;;ADFD;;E8FwoBE,cAAc,EAAA;;A7FxoBhB;;E6F2oBE,eAAe,EAAA;;ArDtkBrB;EzCrEI;;I8FipBQ,kBXlpBS,EAAA;ElFCjB;;I6FopBQ,mBXrpBS,EAAA;EnFCjB;;I8F2pBY,kBXtpBT,EAAA;ElFLH;;I6F8pBY,mBXzpBT,EAAA;EnFLH;;I8F2pBY,kBXrpBT,EAAA;ElFNH;;I6F8pBY,mBXxpBT,EAAA;EnFNH;;I8F2pBY,kBXppBT,EAAA;ElFPH;;I6F8pBY,mBXvpBT,EAAA;EnFPH;;I8FsqBU,iBX3pBc,EAAA;ElFXxB;;I6FyqBU,kBX9pBc,EAAA,ElFTvB;;ADFD;;E8FkrBE,eAAe,EAAA;;A7FlrBjB;;E6FqrBE,cAAc,EAAA;;ArDhnBpB;EzCrEI;;I8F2rBQ,mBX5rBS,EAAA;ElFCjB;;I6F8rBQ,kBX/rBS,EAAA;EnFCjB;;I8FqsBY,mBXhsBT,EAAA;ElFLH;;I6FwsBY,kBXnsBT,EAAA;EnFLH;;I8FqsBY,mBX/rBT,EAAA;ElFNH;;I6FwsBY,kBXlsBT,EAAA;EnFNH;;I8FqsBY,mBX9rBT,EAAA;ElFPH;;I6FwsBY,kBXjsBT,EAAA;EnFPH;;I8FgtBU,kBXrsBc,EAAA;ElFXxB;;I6FmtBU,iBXxsBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FwoBE,cAAc,EAAA;E7FxoBhB;;I6F2oBE,eAAe,EAAA,E7FzoBhB;;AwCmEL;EzCrEI;;I8FipBQ,kBXlpBS,EAAA;ElFCjB;;I6FopBQ,mBXrpBS,EAAA;EnFCjB;;I8F2pBY,kBXtpBT,EAAA;ElFLH;;I6F8pBY,mBXzpBT,EAAA;EnFLH;;I8F2pBY,kBXrpBT,EAAA;ElFNH;;I6F8pBY,mBXxpBT,EAAA;EnFNH;;I8F2pBY,kBXppBT,EAAA;ElFPH;;I6F8pBY,mBXvpBT,EAAA;EnFPH;;I8FsqBU,iBX3pBc,EAAA;ElFXxB;;I6FyqBU,kBX9pBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FkrBE,eAAe,EAAA;E7FlrBjB;;I6FqrBE,cAAc,EAAA,E7FnrBf;;AwCmEL;EzCrEI;;I8F2rBQ,mBX5rBS,EAAA;ElFCjB;;I6F8rBQ,kBX/rBS,EAAA;EnFCjB;;I8FqsBY,mBXhsBT,EAAA;ElFLH;;I6FwsBY,kBXnsBT,EAAA;EnFLH;;I8FqsBY,mBX/rBT,EAAA;ElFNH;;I6FwsBY,kBXlsBT,EAAA;EnFNH;;I8FqsBY,mBX9rBT,EAAA;ElFPH;;I6FwsBY,kBXjsBT,EAAA;EnFPH;;I8FgtBU,kBXrsBc,EAAA;ElFXxB;;I6FmtBU,iBXxsBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FwoBE,cAAc,EAAA;E7FxoBhB;;I6F2oBE,eAAe,EAAA,E7FzoBhB;;AwCmEL;EzCrEI;;I8FipBQ,kBXlpBS,EAAA;ElFCjB;;I6FopBQ,mBXrpBS,EAAA;EnFCjB;;I8F2pBY,kBXtpBT,EAAA;ElFLH;;I6F8pBY,mBXzpBT,EAAA;EnFLH;;I8F2pBY,kBXrpBT,EAAA;ElFNH;;I6F8pBY,mBXxpBT,EAAA;EnFNH;;I8F2pBY,kBXppBT,EAAA;ElFPH;;I6F8pBY,mBXvpBT,EAAA;EnFPH;;I8FsqBU,iBX3pBc,EAAA;ElFXxB;;I6FyqBU,kBX9pBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FkrBE,eAAe,EAAA;E7FlrBjB;;I6FqrBE,cAAc,EAAA,E7FnrBf;;AwCmEL;EzCrEI;;I8F2rBQ,mBX5rBS,EAAA;ElFCjB;;I6F8rBQ,kBX/rBS,EAAA;EnFCjB;;I8FqsBY,mBXhsBT,EAAA;ElFLH;;I6FwsBY,kBXnsBT,EAAA;EnFLH;;I8FqsBY,mBX/rBT,EAAA;ElFNH;;I6FwsBY,kBXlsBT,EAAA;EnFNH;;I8FqsBY,mBX9rBT,EAAA;ElFPH;;I6FwsBY,kBXjsBT,EAAA;EnFPH;;I8FgtBU,kBXrsBc,EAAA;ElFXxB;;I6FmtBU,iBXxsBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FwoBE,cAAc,EAAA;E7FxoBhB;;I6F2oBE,eAAe,EAAA,E7FzoBhB;;AwCmEL;EzCrEI;;I8FipBQ,kBXlpBS,EAAA;ElFCjB;;I6FopBQ,mBXrpBS,EAAA;EnFCjB;;I8F2pBY,kBXtpBT,EAAA;ElFLH;;I6F8pBY,mBXzpBT,EAAA;EnFLH;;I8F2pBY,kBXrpBT,EAAA;ElFNH;;I6F8pBY,mBXxpBT,EAAA;EnFNH;;I8F2pBY,kBXppBT,EAAA;ElFPH;;I6F8pBY,mBXvpBT,EAAA;EnFPH;;I8FsqBU,iBX3pBc,EAAA;ElFXxB;;I6FyqBU,kBX9pBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FkrBE,eAAe,EAAA;E7FlrBjB;;I6FqrBE,cAAc,EAAA,E7FnrBf;;AwCmEL;EzCrEI;;I8F2rBQ,mBX5rBS,EAAA;ElFCjB;;I6F8rBQ,kBX/rBS,EAAA;EnFCjB;;I8FqsBY,mBXhsBT,EAAA;ElFLH;;I6FwsBY,kBXnsBT,EAAA;EnFLH;;I8FqsBY,mBX/rBT,EAAA;ElFNH;;I6FwsBY,kBXlsBT,EAAA;EnFNH;;I8FqsBY,mBX9rBT,EAAA;ElFPH;;I6FwsBY,kBXjsBT,EAAA;EnFPH;;I8FgtBU,kBXrsBc,EAAA;ElFXxB;;I6FmtBU,iBXxsBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FwoBE,cAAc,EAAA;E7FxoBhB;;I6F2oBE,eAAe,EAAA,E7FzoBhB;;AwCmEL;EzCrEI;;I8FipBQ,kBXlpBS,EAAA;ElFCjB;;I6FopBQ,mBXrpBS,EAAA;EnFCjB;;I8F2pBY,kBXtpBT,EAAA;ElFLH;;I6F8pBY,mBXzpBT,EAAA;EnFLH;;I8F2pBY,kBXrpBT,EAAA;ElFNH;;I6F8pBY,mBXxpBT,EAAA;EnFNH;;I8F2pBY,kBXppBT,EAAA;ElFPH;;I6F8pBY,mBXvpBT,EAAA;EnFPH;;I8FsqBU,iBX3pBc,EAAA;ElFXxB;;I6FyqBU,kBX9pBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FkrBE,eAAe,EAAA;E7FlrBjB;;I6FqrBE,cAAc,EAAA,E7FnrBf;;AwCmEL;EzCrEI;;I8F2rBQ,mBX5rBS,EAAA;ElFCjB;;I6F8rBQ,kBX/rBS,EAAA;EnFCjB;;I8FqsBY,mBXhsBT,EAAA;ElFLH;;I6FwsBY,kBXnsBT,EAAA;EnFLH;;I8FqsBY,mBX/rBT,EAAA;ElFNH;;I6FwsBY,kBXlsBT,EAAA;EnFNH;;I8FqsBY,mBX9rBT,EAAA;ElFPH;;I6FwsBY,kBXjsBT,EAAA;EnFPH;;I8FgtBU,kBXrsBc,EAAA;ElFXxB;;I6FmtBU,iBXxsBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FwoBE,cAAc,EAAA;E7FxoBhB;;I6F2oBE,eAAe,EAAA,E7FzoBhB;;AwCmEL;EzCrEI;;I8FipBQ,kBXlpBS,EAAA;ElFCjB;;I6FopBQ,mBXrpBS,EAAA;EnFCjB;;I8F2pBY,kBXtpBT,EAAA;ElFLH;;I6F8pBY,mBXzpBT,EAAA;EnFLH;;I8F2pBY,kBXrpBT,EAAA;ElFNH;;I6F8pBY,mBXxpBT,EAAA;EnFNH;;I8F2pBY,kBXppBT,EAAA;ElFPH;;I6F8pBY,mBXvpBT,EAAA;EnFPH;;I8FsqBU,iBX3pBc,EAAA;ElFXxB;;I6FyqBU,kBX9pBc,EAAA,ElFTvB;;AwCmEL;EzCrEI;;I8FkrBE,eAAe,EAAA;E7FlrBjB;;I6FqrBE,cAAc,EAAA,E7FnrBf;;AwCmEL;EzCrEI;;I8F2rBQ,mBX5rBS,EAAA;ElFCjB;;I6F8rBQ,kBX/rBS,EAAA;EnFCjB;;I8FqsBY,mBXhsBT,EAAA;ElFLH;;I6FwsBY,kBXnsBT,EAAA;EnFLH;;I8FqsBY,mBX/rBT,EAAA;ElFNH;;I6FwsBY,kBXlsBT,EAAA;EnFNH;;I8FqsBY,mBX9rBT,EAAA;ElFPH;;I6FwsBY,kBXjsBT,EAAA;EnFPH;;I8FgtBU,kBXrsBc,EAAA;ElFXxB;;I6FmtBU,iBXxsBc,EAAA,ElFTvB;;A6FJT;EAiuBE,WlG/tBW;EkGguBX,mBlG7tBkB,EAAA;EKHZ;I6F6uBF,SAAS,EAAA;EpC3nBP;IoCioBJ,WlGnvBS,EAAA;E8DkHL;IoCqoBJ,WlGvvBS;IkGwvBT,+BlGvvBY,EAAA;E8DiHR;IoC0oBJ,+BlG3vBY,EAAA;E8DiHR;IoC8oBJ,WlGhwBS;IkGiwBT,+BlGhwBY;IkGiwBZ,SXxsBqC,EAAA;IzBwDjC;MoCmpBF,+BlGrwBO,EAAA;E8DkHL;IoCwpBJ,+BlG1wBS,EAAA;E8DkHL;IoC4pBJ,+BlG9wBS;IkG+wBT,uBXzrB2C,EAAA;IzB4BvC;MoCiqBF,+BlGnxBO,EAAA;I8DkHL;MoCqqBF,WlGvxBO;MkGwxBP,qClGxxBO,EAAA;M8DkHL;QoC0qBA,WlG5xBK,EAAA;I8DkHL;MoC+qBF,aAAa,EAAA;IAEf;MpCjrBI;QoCmrBA,WlGryBK;QkGsyBL,mBlG3vBe,EAAA;Q8DuEf;UoCwrBE,WlG1yBG,EAAA;Q8DkHL;UoC4rBE,0DhFpwBiI,EAAA,EgFqwBlI;IpC7rBD;MoCksBF,cX7rB0D;MW8rB1D,uBAAuB,EAAA;MpCnsBrB;QoCusBA,+BlGzzBK,EAAA;M8DkHL;QoC2sBA,cXtsBwD,EAAA;QzBLxD;UoC+sBE,+BlGj0BG,EAAA;Q8DkHL;UoCmtBE,0DhF3xBiI,EAAA;E4CwEnI;IoCytBJ,kBAAkB,EAAA;IpCztBd;MoC4tBF,0DXzsBggB,EAAA;EzBnB9f;IoCiuBJ,8BXjtB8D,EAAA;IzBhB1D;MoCquBF,WlGv1BO,EAAA;M8DkHL;QoCwuBA,cXnuBwD;QWouBxD,uBAAuB,EAAA;QpCzuBvB;UoC4uBE,cXvuBsD,EAAA;UzBLxD;YoC+uBI,+BlGj2BC,EAAA;E8DkHL;IoCuvBJ,+BlGz2BS,EAAA;I8DkHL;MoC0vBF,WlG52BO,EAAA;I8DkHL;MoC8vBF,+BlGh3BO,EAAA;E8DkHL;IoCowBF,oCAAyE,EAAA;EpCpwBvE;IoCywBJ,+BlG13BY,EAAA;E8DiHR;IoC8wBJ,qClG/3BY,EAAA;I8DiHR;MoCkxBF,0DhF11BqI,EAAA;I4CwEnI;MoCuxBF,UAAU,EAAA;IpCvxBR;MoC2xBF,oCX5sB0D,EAAA;MzB/ExD;QoC6xBA,0DhFr2BmI,EAAA;E4CwEnI;IoCwyBE,mBlG/2Ba,EAAA;I8DuEf;MoC2yBI,WlG75BC,EAAA;I8DkHL;MoC+yBI,mBlG95BQ,EAAA;M8D+GZ;QoCkzBM,+BlGp6BD,EAAA;E8DkHL;IoC4zBE,mBlG36BU,EAAA;E8D+GZ;IoCg0BE,mBlGv4Ba,EAAA;;A8D2Ef;EoCymBN,clG5tBkB;EkG6tBlB,gBlGhuBW;EoCQL,gDmDmB0C,EAAA;EnF3B1C;IgCKA,eAAe;IACf,+CmDqB0C,EAAA;ElF3B1C;I+BKA,eAAe;IACf,+CmDqB0C,EAAA;IlF3B1C;M6F6uBF,SAAS;M9DruBP,gDmDmB0C,EAAA;EzB2F1C;IoC6nBJ,clGhvBgB,EAAA;E8DmHZ;IoCioBJ,WlGvvBS;IkGwvBT,mBlG7sBmB,EAAA;E8D2Ef;IoCsoBJ,+BlG3vBY,EAAA;E8DqHR;IoC0oBJ,WlGhwBS;IkGiwBT,+BlGhwBY;IkGiwBZ,SXnsBqC,EAAA;IzBuDjC;MoC+oBF,+BlGrwBO,EAAA;E8DsHL;IoCopBJ,0BlGzwBY,EAAA;E8DqHR;IoCwpBJ,0BlG7wBY;IkG8wBZ,uBXnrB4C,EAAA;IzB0BxC;MoC6pBF,0BlGlxBU,EAAA;I8DqHR;MoCiqBF,0BlGtxBU;MkGuxBV,gClGvxBU,EAAA;M8DqHR;QoCsqBA,clGjvBe,EAAA;I8D2Ef;MoC2qBF,aAAa,EAAA;IAEf;MpC7qBI;QoC+qBA,WlGryBK;QkGsyBL,mBlG3vBe,EAAA;Q8D2Ef;UoCorBE,WlG1yBG,EAAA;Q8DsHL;UoCwrBE,0DhFpwBiI,EAAA,EgFqwBlI;IpCzrBD;MoC8rBF,cXxrB2D;MWyrB3D,uBAAuB,EAAA;MpC/rBrB;QoCmsBA,0BlGxzBQ,EAAA;M8DqHR;QoCusBA,cXjsByD,EAAA;QzBNzD;UoC2sBE,0BlGh0BM,EAAA;Q8DqHR;UoC+sBE,0DhF3xBiI,EAAA;E4C4EnI;IoCqtBJ,kBAAkB,EAAA;IpCrtBd;MoCwtBF,0DXjsBkgB,EAAA;EzBvBhgB;IoC6tBJ,+BXzsBgE,EAAA;IzBpB5D;MoCiuBF,0BlGt1BU,EAAA;M8DqHR;QoCouBA,cX9tByD;QW+tBzD,uBAAuB,EAAA;QpCruBvB;UoCwuBE,cXluBuD,EAAA;UzBNzD;YoC2uBI,0BlGh2BI,EAAA;E8DqHR;IoCmvBJ,0BlGx2BY,EAAA;I8DqHR;MoCsvBF,clGz2Bc,EAAA;I8DmHZ;MoC0vBF,0BlG/2BU,EAAA;E8DqHR;IoCqwBJ,+BlG13BY,EAAA;E8DqHR;IoC0wBJ,qCX1rB+D,EAAA;IzBhF3D;MoC8wBF,0DhF11BqI,EAAA;I4C4EnI;MoCmxBF,UAAU,EAAA;IpCnxBR;MoCuxBF,oCXpsB4D,EAAA;MzBnF1D;QoCyxBA,0DhFr2BmI,EAAA;E4C4EnI;IoCoyBE,mBlG/2Ba,EAAA;I8D2Ef;MoCuyBI,WlG75BC,EAAA;I8DsHL;MoC2yBI,gBlGj6BC,EAAA;M8DsHL;QoC8yBM,0BlGn6BE,EAAA;E8DqHR;IoCwzBE,gBlG96BG,EAAA;E8DsHL;IoC4zBE,mBlGv4Ba,EAAA;;AkG+4BvB;EAIQ,mBlGn5Be,EAAA;EkG+4BvB;IAMU,+BAA8B,EAAA;EANxC;IASU,mBAA8B,EAAA;IATxC;MAWY,WlGr8BC,EAAA;;AkG07Bb;EAIQ,mBlG/3BiB,EAAA;EkG23BzB;IAMU,+BAA8B,EAAA;EANxC;IASU,mBAA8B,EAAA;IATxC;MAWY,WlGr8BC,EAAA;;AkG07Bb;EAIQ,mBlGj3Be,EAAA;EkG62BvB;IAMU,+BAA8B,EAAA;EANxC;IASU,mBAA8B,EAAA;IATxC;MAWY,WlGr8BC,EAAA;;AkG07Bb;EAIQ,gBlGt3BS,EAAA;EkGk3BjB;IAMU,+BAA8B,EAAA;EANxC;IASU,mBAA8B,EAAA;IATxC;MAWY,WlGr8BC,EAAA;;AkG07Bb;EAIQ,mBlG52Be,EAAA;EkGw2BvB;IAMU,+BAA8B,EAAA;EANxC;IASU,mBAA8B,EAAA;IATxC;MAWY,WlGr8BC,EAAA;;AkG07Bb;EAIQ,mBlG33Bc,EAAA;EkGu3BtB;IAMU,+BAA8B,EAAA;EANxC;IASU,mBAA8B,EAAA;IATxC;MAWY,WlGr8BC,EAAA;;AkG07Bb;EAIQ,mBlG17BY,EAAA;EkGs7BpB;IAMU,+BAA8B,EAAA;EANxC;IASU,mBAA8B,EAAA;IATxC;MAWY,WlGr8BC,EAAA;;AkG07Bb;EAIQ,mBlGn7BY,EAAA;EkG+6BpB;IAMU,+BAA8B,EAAA;EANxC;IASU,mBAA8B,EAAA;IATxC;MAWY,WlGr8BC,EAAA;;AoGAb;EACE;IAAK,yBAAyB,EAAA,EAAA;;AAGhC;EACE,qBAAqB;EACrB,WCR0B;EDS1B,YCT0B;EDU1B,2BAA2B;EAC3B,iCAAgD;EAChD,+BAA+B;EAE/B,kBAAkB;EAClB,8CAA8C,EAAA;;AAGhD;EACE,WCf6B;EDgB7B,YChB6B;EDiB7B,mBCf6B,EAAA;;ADsB/B;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAInB;EACE,qBAAqB;EACrB,WCxC0B;EDyC1B,YCzC0B;ED0C1B,2BAA2B;EAC3B,8BAA8B;EAE9B,kBAAkB;EAClB,UAAU;EACV,4CAA4C,EAAA;;AAG9C;EACE,WC/C6B;EDgD7B,YChD6B,EAAA;;ACN/B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBCJ2B,EAAA;EDF7B;IASI,iCtGJY,EAAA;EsGLhB;IAaI,eAAe;IACf,QAAQ;IACR,OAAO;IACP,azFRyB,EAAA;;AyFY7B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBCtB2B;EDuB3B,UAAU;EACV,gBAAgB;EAChB,gBAAgB,EAAA;EAPlB;IAUI,kBAAkB,EAAA;EAVtB;IAcI,6BAA6B;IAC7B,6BAA2C,EAAA;EAf/C;;IAoBI,aAAa;IACb,mBAAmB;IACnB,qBhChC8B;IgCiC9B,oBhCjC8B,EAAA;IgCUlC;;MA0BM,kBAAkB;MAClB,QAAQ;MACR,iBAAiB,EAAA;MlG5Cf;;QkG8CA,SAAS;QACT,cAAc,EAAA;MjG/Cd;;QiGkDA,UAAU;QACV,eAAe,EAAA;IAnCvB;;MAwCM,qBAAqB,EAAA;;AxC8DnB;EwCpDN,mBtG/DkB;EoCQd,gCpCAc,EAAA;E8D2GZ;;IwC9CF,gCtGxEO,EAAA;IOcX;;;M+F6DM,+BtG3EK,EAAA;I8DsHL;;MwCvCA,gCtG/EK,EAAA;E8DsHL;;;;IwC/BF,WtGvFO,EAAA;E8DsHL;IwC1BJ,gCtG5FS,EAAA;I8DsHL;MwCxBF,WtG9FO,EAAA;MOcX;Q+FmFM,WtGjGK,EAAA;;AsGJb;EAsEE,gBtGlEW;EoCWP,gCpCNc,EAAA;E8D6GZ;;IwC1CF,0BtGvEU,EAAA;IOad;;;M+F6DM,0BtG1EQ,EAAA;I8DiHR;;MwCnCA,0BtG9EQ,EAAA;E8DiHR;;;;IwC3BF,0BtGtFU,EAAA;E8DiHR;IwCtBJ,0BtG3FY,EAAA;I8DiHR;MwCpBF,0BtG7FU,EAAA;MOad;Q+FmFM,0BtGhGQ,EAAA;;AwGDhB;EACE,qBAAqB;EACrB,WCJsB;EDKtB,YCJsB,EAAA;;ADOxB;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAA2B;EAC3B,yBAAyB;ExFJvB,sBCKsB;EuFGtB,sBxGtBS;EwGuBT,qBxGlBgB,EAAA;EwGOpB;IAeI,kBAAkB;IAClB,QCduB;IDevB,SCfuB;IDgBvB,sBAAsB;IACtB,WAAyE;IACzE,YAA0E;IAC1E,WAAW;IACX,sBxGlCS;IwGmCT,yBxG9BgB;IwG+BhB,yBAAyB;IxFtBzB,uBwFuByC,EAAA;;AAI7C;EAEI,2BAAqD,EAAA;;AAIzD;EAEI,cxGvCgB;EwGwChB,sBxGlDS;EwGmDT,qB/FoD0D;E+FlD5D,UAAU;EAKR,gDxGfmB,EAAA;;AwGmBvB;EACE,mBAAmB;EACnB,WAAW,EAAA;;AAOb;EE1EE,WDKyB;ECJzB,YDKyB,EAAA;ECHzB;IACE,eDGuB,EAAA;ICDvB;MACE,WAA2D;MAC3D,YAA4D,EAAA;IAE9D;MACE,eDJqB,EAAA;ECSvB;IACE,2BAAuC,EAAA;;AF6D7C;EE9EE,WDSyB;ECRzB,YDSyB,EAAA;ECPzB;IACE,cDOsB,EAAA;ICLtB;MACE,WAA2D;MAC3D,YAA4D,EAAA;IAE9D;MACE,cDAoB,EAAA;ECKtB;IACE,2BAAuC,EAAA;;AFoE7C;EACE,WCzE2B,EAAA;EDwE7B;IAKM,UAAU,EAAA;EALhB;IAQM,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,eC/FkB;IDgGlB,gBAAgB;IAChB,cAAc;IACd,cxG5Fc;IwG6Fd,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB,EAAA;IpGtGjB;MoGyGA,UAAU,EAAA;EAvBlB;IA8BM,2BAA2D,EAAA;EA9BjE;IAiCM,SAAS;IACT,WxGpHO;IwGqHP,2BAA2B,EAAA;EAnCjC;IErFE,WDc2B;ICb3B,YDKyB,EAAA;ICHzB;MACE,eDGuB,EAAA;MCDvB;QACE,WAA2D;QAC3D,YAA4D,EAAA;MAE9D;QACE,eDJqB,EAAA;ICSvB;MACE,2BAAuC,EAAA;EFoE7C;IErFE,WDe2B;ICd3B,YDSyB,EAAA;ICPzB;MACE,cDOsB,EAAA;MCLtB;QACE,WAA2D;QAC3D,YAA4D,EAAA;MAE9D;QACE,cDAoB,EAAA;ICKtB;MACE,2BAAuC,EAAA;;AFyH7C;EAEI,yBxGrIgB;EwGsIhB,mBAAmB,EAAA;EAHvB;IAMM,SAAS;IACT,UAAU;IACV,WChJkB;IDiJlB,YCjJkB;IDkJlB,SAAS;IACT,mBAAmB;IACnB,yCxGlJU,EAAA;;AwGsIhB;EEnHE,WDlByB;ECmBzB,YDlByB,EAAA;ECoBzB;IACE,WDrBuB;ICsBvB,YDtBuB,EAAA;EC0BvB;IACE,2BAAuC,EAAA;;AFyG7C;EEnHE,WDdyB;ECezB,YDdyB,EAAA;ECgBzB;IACE,WDjBuB;ICkBvB,YDlBuB,EAAA;ECsBvB;IACE,2BAAuC,EAAA;;AAY3C;EACE,yB1GAmB;E0GCnB,qBAAiC,EAAA;EAEjC;IACE,qBAAiC,EAAA;;AAXrC;EACE,yB1GMmB,EAAA;;A0GUrB;EACE,yBAAyB;EACzB,qB1GZmB,EAAA;E0GcnB;IACE,qB1GfiB,EAAA;E0GiBnB;IACE,c1GlBiB,EAAA;;A0GwBrB;EACE,yBAAyB;EACzB,qB1G1BmB,EAAA;E0G4BnB;IACE,yB1G7BiB;I0G8BjB,qB1G9BiB,EAAA;E0GgCnB;IACE,c1GjCiB,EAAA;;A0GDrB;EACE,yB1GoBqB;E0GnBrB,qBAAiC,EAAA;EAEjC;IACE,qBAAiC,EAAA;;AAXrC;EACE,yB1G0BqB,EAAA;;A0GVvB;EACE,yBAAyB;EACzB,qB1GQqB,EAAA;E0GNrB;IACE,qB1GKmB,EAAA;E0GHrB;IACE,c1GEmB,EAAA;;A0GIvB;EACE,yBAAyB;EACzB,qB1GNqB,EAAA;E0GQrB;IACE,yB1GTmB;I0GUnB,qB1GVmB,EAAA;E0GYrB;IACE,c1GbmB,EAAA;;A0GrBvB;EACE,yB1GkCmB;E0GjCnB,qBAAiC,EAAA;EAEjC;IACE,qBAAiC,EAAA;;AAXrC;EACE,yB1GwCmB,EAAA;;A0GxBrB;EACE,yBAAyB;EACzB,qB1GsBmB,EAAA;E0GpBnB;IACE,qB1GmBiB,EAAA;E0GjBnB;IACE,c1GgBiB,EAAA;;A0GVrB;EACE,yBAAyB;EACzB,qB1GQmB,EAAA;E0GNnB;IACE,yB1GKiB;I0GJjB,qB1GIiB,EAAA;E0GFnB;IACE,c1GCiB,EAAA;;A0GnCrB;EACE,sB1G6Ba;E0G5Bb,qBAAiC,EAAA;EAEjC;IACE,qBAAiC,EAAA;;AAXrC;EACE,sB1GmCa,EAAA;;A0GnBf;EACE,yBAAyB;EACzB,kB1GiBa,EAAA;E0Gfb;IACE,kB1GcW,EAAA;E0GZb;IACE,W1GWW,EAAA;;A0GLf;EACE,yBAAyB;EACzB,kB1GGa,EAAA;E0GDb;IACE,sB1GAW;I0GCX,kB1GDW,EAAA;E0GGb;IACE,W1GJW,EAAA;;A0G9Bf;EACE,yB1GuCmB;E0GtCnB,qBAAiC,EAAA;EAEjC;IACE,qBAAiC,EAAA;;AAXrC;EACE,yB1G6CmB,EAAA;;A0G7BrB;EACE,yBAAyB;EACzB,qB1G2BmB,EAAA;E0GzBnB;IACE,qB1GwBiB,EAAA;E0GtBnB;IACE,c1GqBiB,EAAA;;A0GfrB;EACE,yBAAyB;EACzB,qB1GamB,EAAA;E0GXnB;IACE,yB1GUiB;I0GTjB,qB1GSiB,EAAA;E0GPnB;IACE,c1GMiB,EAAA;;A0GxCrB;EACE,yB1GwBkB;E0GvBlB,qBAAiC,EAAA;EAEjC;IACE,qBAAiC,EAAA;;AAXrC;EACE,yB1G8BkB,EAAA;;A0GdpB;EACE,yBAAyB;EACzB,qB1GYkB,EAAA;E0GVlB;IACE,qB1GSgB,EAAA;E0GPlB;IACE,c1GMgB,EAAA;;A0GApB;EACE,yBAAyB;EACzB,qB1GFkB,EAAA;E0GIlB;IACE,yB1GLgB;I0GMhB,qB1GNgB,EAAA;E0GQlB;IACE,c1GTgB,EAAA;;A0GzBpB;EACE,yB1GvCgB;E0GwChB,qBAAiC,EAAA;EAEjC;IACE,qBAAiC,EAAA;;AAXrC;EACE,yB1GjCgB,EAAA;;A0GiDlB;EACE,yBAAyB;EACzB,qB1GnDgB,EAAA;E0GqDhB;IACE,qB1GtDc,EAAA;E0GwDhB;IACE,c1GzDc,EAAA;;A0G+DlB;EACE,yBAAyB;EACzB,qB1GjEgB,EAAA;E0GmEhB;IACE,yB1GpEc;I0GqEd,qB1GrEc,EAAA;E0GuEhB;IACE,c1GxEc,EAAA;;A0GsClB;EACE,yB1GhCgB;E0GiChB,qBAAiC,EAAA;EAEjC;IACE,qBAAiC,EAAA;;AAXrC;EACE,yB1G1BgB,EAAA;;A0G0ClB;EACE,yBAAyB;EACzB,qB1G5CgB,EAAA;E0G8ChB;IACE,qB1G/Cc,EAAA;E0GiDhB;IACE,c1GlDc,EAAA;;A0GwDlB;EACE,yBAAyB;EACzB,qB1G1DgB,EAAA;E0G4DhB;IACE,yB1G7Dc;I0G8Dd,qB1G9Dc,EAAA;E0GgEhB;IACE,c1GjEc,EAAA;;AwGiLpB;EAEI,mBAAmB,EAAA;EAFvB;IAKM,mBAAmB,EAAA;;AAKzB;EAEI,gBAAgB,EAAA;EAFpB;IAKM,gBAAgB,EAAA;;AG3MtB;EACE,WAAW;EACX,mBjEEY;EiECV,c3GFgB,EAAA;E2GHpB;;IAWI,gBnGX4B;ImGY5B,mBAAmB;IACnB,qBAAqC;IAGnC,yB3GXc,EAAA;E2GLpB;IAqBI,sBAAsB;IACtB,wBAA8C;IAG5C,4B3GpBc,EAAA;E2GLpB;IA8BI,qBAA2C;IAGzC,yB3G5Bc,EAAA;;A2GsCpB;;EAGI,enG7C2B,EAAA;;AmGsD/B;EACE,iBAAiC;EAG/B,qB3GtDgB,EAAA;E2GkDpB;;IASI,iBAAiC;IAG/B,qB3G9Dc,EAAA;E2GkDpB;;IAmBM,wBAA4C,EAAA;;AAKlD;;;;EAKI,SAAS,EAAA;;AAQb;EAIM,sC3G/FU,EAAA;;AOOd;EACE;IoGqGI,c3G3GY;I2G4GZ,uC3G9GQ,EAAA,EOQU;;AqGRxB;;;EAKM,c5GMY;E4GJd,yB1FkG4D,EAAA;;A0FzGhE;;;;EAeM,qB1F0F0D,EAAA;;AXlGhE;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;AAhCP;;;EAKM,c5GMY;E4GJd,yB1FkG4D,EAAA;;A0FzGhE;;;;EAeM,qB1F0F0D,EAAA;;AXlGhE;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;AAhCP;;;EAKM,c5GMY;E4GJd,yB1FkG4D,EAAA;;A0FzGhE;;;;EAeM,qB1F0F0D,EAAA;;AXlGhE;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;AAhCP;;;EAKM,c5GMY;E4GJd,yB1FkG4D,EAAA;;A0FzGhE;;;;EAeM,qB1F0F0D,EAAA;;AXlGhE;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;AAhCP;;;EAKM,c5GMY;E4GJd,yB1FkG4D,EAAA;;A0FzGhE;;;;EAeM,qB1F0F0D,EAAA;;AXlGhE;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;AAhCP;;;EAKM,c5GMY;E4GJd,yB1FkG4D,EAAA;;A0FzGhE;;;;EAeM,qB1F0F0D,EAAA;;AXlGhE;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;AAhCP;;;EAKM,c5GMY;E4GJd,yB1FkG4D,EAAA;;A0FzGhE;;;;EAeM,qB1F0F0D,EAAA;;AXlGhE;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;AAhCP;;;EAKM,c5GMY;E4GJd,yB1FkG4D,EAAA;;A0FzGhE;;;;EAeM,qB1F0F0D,EAAA;;AXlGhE;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;AAhCP;;;EAKM,c5GMY;E4GJd,yB5GHc,EAAA;;AOGlB;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;AAhCP;;;EAKM,c5GMY;E4GJd,yB5GHc,EAAA;;A4GJlB;;;;EAeM,qB5GXY,EAAA;;AOGlB;EACE;IqGmBI,yBAJsC,EAAA;IAD5C;;MASQ,yBARoC,EAAA,EASrC;;ADoGT;EAGM,UAAU;EAER,c3GvIY;E2GwIZ,uC3G1IQ,EAAA;;A2GsJhB;EAIQ,W3G3JK;E2G4JL,yB3GjJY;E2GkJZ,qBnG/HgD,EAAA;;AmGyHxD;EAcQ,c3G3JY;E2G4JZ,yB3GjKY;E2GkKZ,qB3GlKY,EAAA;;A2GwKpB;EAEI,W3G/KS;E2GgLT,yB3GrKgB,EAAA;E2GkKpB;;;IAUM,qBnGzJkD,EAAA;EmG+IxD;IAeI,SAAS,EAAA;EAfb;IAqBQ,2C3GlMK,EAAA;EOQX;IACE;MoGkMM,W3G3MG;M2G4MH,4C3G5MG,EAAA,EOSa;;AsCyEtB;E8D4IA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAA;IALpC;MASK,SAAS,EAAA,EACV;;A9DtJL;E8D4IA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAA;IALpC;MASK,SAAS,EAAA,EACV;;A9DtJL;E8D4IA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAA;IALpC;MASK,SAAS,EAAA,EACV;;A9DtJL;E8D4IA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAA;IALpC;MASK,SAAS,EAAA,EACV;;A9DtJL;E8D4IA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAA;IALpC;MASK,SAAS,EAAA,EACV;;AAfT;EAOQ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC,EAAA;EAVzC;IAcU,SAAS,EAAA;;AAOnB;EACE,iBAAiB;EAGf,qB3G7OgB,EAAA;E2GyOpB;IAQI,sBAAsB,EAAA;;AAI1B;EAGI,sBAAsB,EAAA;;AAI1B;EAEI,SAAS,EAAA;;AEvQb;EACE,YCCoC;EDApC,gBCAoC;EDCpC,gBAAgB;E1G4HZ,mBAtCY;E0GpFhB,4BAA4B;EAC5B,iBAAiC;EACjC,iD7GFc;E6GGd,mCAA2B;UAA3B,2BAA2B;EAC3B,UAAU;E7FSR,sB8FXmC;EDMnC,2C7GTS;E6GUT,iC7GTY,EAAA;E6GLhB;IAkBI,sBCfmC,EAAA;EDHvC;IAsBI,UAAU,EAAA;EAtBd;IA0BI,cAAc;IACd,UAAU,EAAA;EA3Bd;IA+BI,aAAa,EAAA;;AAIjB;EACE,WAAW;EACX,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,mBAAmB;EACnB,wBCxCqC;EDyCrC,4BAA4B;EAC5B,wBAAwC;EAEtC,c7GlCgB;E6GmChB,2C7G5CS;E6G6CT,kC7G5CY,EAAA;;A6GgDhB;EACE,gBCnDqC,EAAA;;ADsDvC;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,uBAAoC,EAAA;EAEpC;IAQE,eAAe;IACf,ahG3DyB;IgG4DzB,YCvEkC,EAAA;ED0EpC;IAIE,MAAM,EAAA;EAGR;IAIE,SAAS;IACT,sBAAsB,EAAA;EAGxB;IAEE,WAAW,EAAA;EAGb;IAEE,SAAS;IACT,2BAA2B,EAAA;EAG7B;IAIE,QAAQ,EAAA;EAGV;IAIE,OAAO,EAAA;EAxDX;IA4DI,WAAW;IACX,eAAe;IACf,oBAAyB;IACzB,uBAA4B,EAAA;;AAS9B;EEhIA,W/GGW;E+GFX,yB/G6CqB;E+G5CrB,qBAAsC,EAAA;EAEtC;IACE,W/GFS;I+GGT,yBAAyC;IACzC,qBAAsC,EAAA;;AFyHxC;EEhIA,c/GekB;E+GdlB,yB/GiEuB;E+GhEvB,qBAAsC,EAAA;EAEtC;IACE,c/GUgB;I+GThB,yBAAyC;IACzC,qBAAsC,EAAA;;AFyHxC;EEhIA,W/GGW;E+GFX,yB/G+EqB;E+G9ErB,qBAAsC,EAAA;EAEtC;IACE,W/GFS;I+GGT,yBAAyC;IACzC,qBAAsC,EAAA;;AFyHxC;EEhIA,W/GGW;E+GFX,sB/G0Ee;E+GzEf,qBAAsC,EAAA;EAEtC;IACE,W/GFS;I+GGT,yBAAyC;IACzC,qBAAsC,EAAA;;AFyHxC;EEhIA,c/GekB;E+GdlB,yB/GoFqB;E+GnFrB,qBAAsC,EAAA;EAEtC;IACE,c/GUgB;I+GThB,yBAAyC;IACzC,qBAAsC,EAAA;;AFyHxC;EEhIA,W/GGW;E+GFX,yB/GqEoB;E+GpEpB,qBAAsC,EAAA;EAEtC;IACE,W/GFS;I+GGT,yBAAyC;IACzC,qBAAsC,EAAA;;AFyHxC;EEhIA,c/GekB;E+GdlB,yB/GMkB;E+GLlB,qBAAsC,EAAA;EAEtC;IACE,c/GUgB;I+GThB,yBAAyC;IACzC,qBAAsC,EAAA;;AFyHxC;EEhIA,W/GGW;E+GFX,yB/GakB;E+GZlB,qBAAsC,EAAA;EAEtC;IACE,W/GFS;I+GGT,yBAAyC;IACzC,qBAAsC,EAAA;;ACP1C;EACE,kBAAkB;EAClB,anGS2B;EmGR3B,cAAc;EACd,S5FKwB;ELTxB,kMbI6M;EaF7M,kBAAkB;EAClB,gBbYwB;EaXxB,gBbgBqB;EafrB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EZgHZ,qBAtCY;E6G9EhB,qBAAqB;EACrB,UAAU,EAAA;EAXZ;IAaW,Y5FPgB,EAAA;E4FN3B;IAgBI,kBAAkB;IAClB,cAAc,EAAA;IAjBlB;MAoBM,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;;EAEE,iBAAgC,EAAA;EAEhC;;IACE,a5FtB0B;I4FuB1B,c5FtB0B,EAAA;;A4F0B9B;;EAEE,iB5F5B4B,EAAA;E4F8B5B;;IACE,a5F/B0B;I4FgC1B,c5FjC0B,EAAA;;A4FsC5B;EACE,SAAS,EAAA;EAET;IACE,MAAM;IACN,6BAAgE;IAChE,yBhHnDU,EAAA;;AgHyDd;EACE,OAAO,EAAA;EAEP;IACE,QAAQ;IACR,oCAA2F;IAC3F,2BhH/DU,EAAA;;;AgHqEd;EACE,MAAM,EAAA;EAEN;IACE,SAAS;IACT,6B5FlEwB;I4FmExB,4BhH3EU,EAAA;;;AgHiFd;EACE,QAAQ,EAAA;EAER;IACE,OAAO;IACP,oC5F9EwB;I4F+ExB,0BhHvFU,EAAA;;AgH6GhB;EACE,gB5FhH4B;E4FiH5B,uB5F3G4B;E4F4G5B,WhHjHW;EgHkHX,kBAAkB;EAClB,yBhHlHc;EgBaZ,sBCKsB,EAAA;;AgGvB1B;ElFgBM,gCd4BoC,EAAA;EcxBpC;IkFpBN;MlFqBQ,gBAAgB,EAAA,EkFfvB;EAND;IAII,UAAU,EAAA;;AAId;EAEI,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;ElFDZ,6Bd6BiC,EAAA;EczBjC;IkFNN;MlFOQ,gBAAgB,EAAA,EkFFvB;;AAED;EACE;IACE,UAAU,EAAA;EAGZ;IACE,UAAU,EAAA,EAAA;;AAId;EACE,sBAAsB;EACtB,sBAAsB,EAAA;;AAOxB;EACE,uBrFlB8C,EAAA;;AsErBhD;Ee2CE,wHrFtB8C,EAAA;EqFqBhD;IAGI,+FAA+K,EAAA;;AAInL;;EAGI,gBAAgB,EAAA;EAHpB;;;;;;;;;;;;;;;;;;;;;;;;;;IAiBM,gBAAgB,EAAA;;AAKtB;EACE,gBAAgB,EAAA;;ACpElB;;EAEE,qBhHsBmC;EgHpBnC,gBhHsB2B;EgHrB3B,gBhHsB2B,EAAA;;AgHlB7B;E/GgHM,oBAtCY,EAAA;;A+GzElB;E/G+GM,kBAtCY,EAAA;;A+GxElB;E/G8GM,qBAtCY,EAAA;;A+GvElB;E/G6GM,oBAtCY,EAAA;;A+GtElB;E/G4GM,qBAtCY,EAAA;;A+GrElB;E/G2GM,mBAtCY,EAAA;;A+GnElB;E/GyGM,qBAtCY;E+GjEhB,gBhHwBqB,EAAA;;AgHpBvB;E/GmGM,eAtCY;E+G3DhB,gBhHWwB;EgHVxB,gBhHE2B,EAAA;;AgHA7B;E/G8FM,iBAtCY;E+GtDhB,gBhHOwB;EgHNxB,gBhHH2B,EAAA;;AgHK7B;E/GyFM,iBAtCY;E+GjDhB,gBhHGwB;EgHFxB,gBhHR2B,EAAA;;AgHU7B;E/GoFM,iBAtCY;E+G5ChB,gBhHDwB;EgHExB,gBhHb2B,EAAA;;AD+C7B;EiHzBE,gBxE/CY;EwEgDZ,mBxEhDY;EwEiDZ,SAAS;EACT,qBAAkC;EAEhC,iClHvDY,EAAA;;AkH+DhB;EACE,UjG5DiB;EiG8Df,qClHlEY,EAAA;;AkH0EhB;;E/GPI,cAAW;E+GUb,gBhHlEwB,EAAA;;AgHqE1B;;EAEE,chHvBkB;EgHwBlB,yBhHfe,EAAA;;AgHuBjB;EvBtFE,gBAAgB,EAAA;EvFNV;IuFCJ,eAAe,EAAA;EtFDX;IsFIJ,gBAAgB,EAAA;;AuB6FpB;EvB3FE,gBAAgB,EAAA;EvFNV;IuFCJ,eAAe,EAAA;EtFDX;IsFIJ,gBAAgB,EAAA;;AuBgGpB;EACE,qBAAqB,EAAA;EADvB;IAII,oBhHrCwB,EAAA;;AgH+C5B;E/G9CI,cAAW;E+GgDb,yBAAyB,EAAA;;AAI3B;EACE,mBxErHY;EvCuHR,qBAtCY,EAAA;;A+GwClB;EACE,cAAc;E/G1DZ,cAAW;E+G4Db,clHvHkB,EAAA;EkHoHpB;IAMI,qBAAqB,EAAA;;AnHvIzB;EoHKE,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAA;;AAInB;ElHaA;IkHXI,aAAa;IACb,sBAAsB,EAAA,EACvB;;AFyBH;EErBE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,iBAAiB,EAAA;EALnB;IAUM,kBAAkB,EAAA;EAVxB;IAcM,gBAAgB;IAChB,MAAM,EAAA;IAEN;MAjBN;QAkBQ,eAAe;QACf,eAAe,EAAA;QAnBvB;UAsBU,iBAAiB,EAAA,EAClB;EAvBT;IA4BM,gBAAgB;IAChB,SAAS,EAAA;IAET;MA/BN;QAgCQ,eAAe;QACf,eAAe,EAAA;QAjCvB;UAoCU,mBAAmB,EAAA,EACpB;EArCT;IA4CM,aAAa;IACb,sBAAsB;IAGtB,YAAY,EAAA;EAhDlB;IAsDI,iBAAiB,EAAA;IAtDrB;MAyDM,eAAe,EAAA;;AAKrB;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,iBAAwB,EAAA;EtEZtB;IsEOJ;MASM,mBhD7CmB;MgD8CnB,kBhD9CmB,EAAA,EgDgDtB;;AC1FH;EAAqB,mCAAmC,EAAA;;AACxD;EAAqB,8BAA8B,EAAA;;AACnD;EAAqB,iCAAiC,EAAA;;AACtD;EAAqB,iCAAiC,EAAA;;AACtD;EAAqB,sCAAsC,EAAA;;AAC3D;EAAqB,mCAAmC,EAAA;;ACFtD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,iCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AAcpD;EACE,8BAA+C;EAC/C,uEAA0G;EAC1G,gCAAiD,EAAA;;AAHnD;EACE,2BAA+C;EAC/C,oEAA0G;EAC1G,6BAAiD,EAAA;;AAHnD;EACE,8BAA+C;EAC/C,uEAA0G;EAC1G,gCAAiD,EAAA;;AAHnD;EACE,8BAA+C;EAC/C,oEAA0G;EAC1G,gCAAiD,EAAA;;AAHnD;EACE,8BAA+C;EAC/C,uEAA0G;EAC1G,gCAAiD,EAAA;;AAHnD;EACE,8BAA+C;EAC/C,uEAA0G;EAC1G,gCAAiD,EAAA;;AAHnD;EACE,2BAA+C;EAC/C,oEAA0G;EAC1G,6BAAiD,EAAA;;AAHnD;EACE,8BAA+C;EAC/C,uEAA0G;EAC1G,gCAAiD,EAAA;;ACbrD;EACE,iCAAmC,EAAA;;AAGrC;EACE,wCAAwC,EAAA;;A1H0uS1C;E0HtuSE,WtHpBW,EAAA;;AqHCX;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,iCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;A9GYrC;;;E8GPI,oCAAgD,EAAA;;ACwBtD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAsB;EACtB,cAAuB,EAAA;;ACjCvB;EAAkB,oCAAuE,EAAA;;AACzF;EAAkB,wCAA2E,EAAA;;AAC7F;EAAkB,0CAA6E,EAAA;;AAC/F;EAAkB,2CAA8E,EAAA;;AAChG;EAAkB,yCAA4E,EAAA;;AAGhG;EAAmB,oBAAoB,EAAA;;AACvC;EAAmB,wBAAwB,EAAA;;AAC3C;EAAmB,0BAA0B,EAAA;;AAC7C;EAAmB,2BAA2B,EAAA;;AAC9C;EAAmB,yBAAyB,EAAA;;AAG1C;EACE,4BAA4B;EAC5B,gCAA+B,EAAA;;AAFjC;EACE,4BAA4B;EAC5B,gCAA+B,EAAA;;AAFjC;EACE,4BAA4B;EAC5B,gCAA+B,EAAA;;AAFjC;EACE,4BAA4B;EAC5B,6BAA+B,EAAA;;AAFjC;EACE,4BAA4B;EAC5B,gCAA+B,EAAA;;AAFjC;EACE,4BAA4B;EAC5B,gCAA+B,EAAA;;AAFjC;EACE,4BAA4B;EAC5B,gCAA+B,EAAA;;AAFjC;EACE,4BAA4B;EAC5B,gCAA+B,EAAA;;AAInC;EACE,6BAA+B,EAAA;;AAOjC;EACE,gCAA2C,EAAA;;AAG7C;EACE,iCAAwC,EAAA;;AAG1C;EACE,0CAAiD;EACjD,2CAAkD,EAAA;;AAGpD;EACE,2CAAkD;EAClD,8CAAqD,EAAA;;AAGvD;EACE,8CAAqD;EACrD,6CAAoD,EAAA;;AAGtD;EACE,0CAAiD;EACjD,6CAAoD,EAAA;;AAGtD;EACE,gCAA2C,EAAA;;AAG7C;EACE,6BAA6B,EAAA;;AAG/B;EACE,+BAAuC,EAAA;;AAGzC;EACE,2BAA2B,EAAA;;AAMvB;EAAyB,oBAAsB,EAAA;;AAC/C;EAAyB,wBAA8B,EAAA;;AACvD;EAAyB,0BAAkC,EAAA;;AAC3D;EAAyB,2BAAoC,EAAA;;AAC7D;EAAyB,yBAAgC,EAAA;;AAEzD;EAAyB,yBvH/EX,EAAA;;AuHgFd;EAAyB,6BvHhFX,EAAA;;AuHiFd;EAAyB,+BvHjFX,EAAA;;AuHkFd;EAAyB,gCvHlFX,EAAA;;AuHmFd;EAAyB,8BvHnFX,EAAA;;AuH+Ed;EAAyB,yBvH/EX,EAAA;;AuHgFd;EAAyB,6BvHhFX,EAAA;;AuHiFd;EAAyB,+BvHjFX,EAAA;;AuHkFd;EAAyB,gCvHlFX,EAAA;;AuHmFd;EAAyB,8BvHnFX,EAAA;;AwHTpB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB,EAAA;;AxELlB;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAA;;AyEMT;EAAwB,wBAA0B,EAAA;;AAAlD;EAAwB,0BAA0B,EAAA;;AAAlD;EAAwB,gCAA0B,EAAA;;AAAlD;EAAwB,yBAA0B,EAAA;;AAAlD;EAAwB,yBAA0B,EAAA;;AAAlD;EAAwB,6BAA0B,EAAA;;AAAlD;EAAwB,8BAA0B,EAAA;;AAAlD;EAAwB,wBAA0B,EAAA;;AAAlD;EAAwB,+BAA0B,EAAA;;A5E+DpD;E4E/DE;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,0BAA0B,EAAA;EAAlD;IAAwB,gCAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,6BAA0B,EAAA;EAAlD;IAAwB,8BAA0B,EAAA;EAAlD;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,+BAA0B,EAAA,EAAI;;A5E+DxD;E4E/DE;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,0BAA0B,EAAA;EAAlD;IAAwB,gCAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,6BAA0B,EAAA;EAAlD;IAAwB,8BAA0B,EAAA;EAAlD;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,+BAA0B,EAAA,EAAI;;A5E+DxD;E4E/DE;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,0BAA0B,EAAA;EAAlD;IAAwB,gCAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,6BAA0B,EAAA;EAAlD;IAAwB,8BAA0B,EAAA;EAAlD;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,+BAA0B,EAAA,EAAI;;A5E+DxD;E4E/DE;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,0BAA0B,EAAA;EAAlD;IAAwB,gCAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,6BAA0B,EAAA;EAAlD;IAAwB,8BAA0B,EAAA;EAAlD;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,+BAA0B,EAAA,EAAI;;A5E+DxD;E4E/DE;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,0BAA0B,EAAA;EAAlD;IAAwB,gCAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,6BAA0B,EAAA;EAAlD;IAAwB,8BAA0B,EAAA;EAAlD;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,+BAA0B,EAAA,EAAI;;A5E4ExD;E4ErEA;IAAwB,wBAAwB,EAAA,EAAI;;A5EqEpD;E4ErEA;IAAwB,wBAAwB,EAAA,EAAI;;A5EqEpD;E4ErEA;IAAwB,wBAAwB,EAAA,EAAI;;A5EqEpD;E4ErEA;IAAwB,wBAAwB,EAAA,EAAI;;A5EqEpD;E4ErEA;IAAwB,wBAAwB,EAAA,EAAI;;AAApD;EAAwB,wBAAwB,EAAA;;AAKlD;EACwB,wBAAwB,EAAA;;AA2BlD;EAEI;IAAqB,wBAA0B,EAAA;EAA/C;IAAqB,0BAA0B,EAAA;EAA/C;IAAqB,gCAA0B,EAAA;EAA/C;IAAqB,yBAA0B,EAAA;EAA/C;IAAqB,yBAA0B,EAAA;EAA/C;IAAqB,6BAA0B,EAAA;EAA/C;IAAqB,8BAA0B,EAAA;EAA/C;IAAqB,wBAA0B,EAAA;EAA/C;IAAqB,+BAA0B,EAAA,EAAI;;AClDvD;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB,EAAA;EALlB;IAQI,cAAc;IACd,WAAW,EAAA;EATf;;;;;IAiBI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,SAAS,EAAA;;AAQX;EAEI,sBAA4F,EAAA;;AAFhG;EAEI,mBAA4F,EAAA;;AAFhG;EAEI,gBAA4F,EAAA;;AAFhG;EAEI,iBAA4F,EAAA;;AAFhG;EAEI,sBAA4F,EAAA;;AAFhG;EAEI,mBAA4F,EAAA;;AAFhG;EAEI,gBAA4F,EAAA;;AAFhG;EAEI,iBAA4F,EAAA;;ACzB9F;EAAgC,8BAA8B,EAAA;;AAC9D;EAAgC,iCAAiC,EAAA;;AACjE;EAAgC,sCAAsC,EAAA;;AACtE;EAAgC,yCAAyC,EAAA;;AAEzE;EAA8B,0BAA0B,EAAA;;AACxD;EAA8B,4BAA4B,EAAA;;AAC1D;EAA8B,kCAAkC,EAAA;;AAChE;EAA8B,yBAAyB,EAAA;;AACvD;EAA8B,uBAAuB,EAAA;;AACrD;EAA8B,uBAAuB,EAAA;;AACrD;EAA8B,yBAAyB,EAAA;;AACvD;EAA8B,yBAAyB,EAAA;;AAEvD;EAAoC,sCAAsC,EAAA;;AAC1E;EAAoC,oCAAoC,EAAA;;AACxE;EAAoC,kCAAkC,EAAA;;AACtE;EAAoC,yCAAyC,EAAA;;AAC7E;EAAoC,wCAAwC,EAAA;;AAE5E;EAAiC,kCAAkC,EAAA;;AACnE;EAAiC,gCAAgC,EAAA;;AACjE;EAAiC,8BAA8B,EAAA;;AAC/D;EAAiC,gCAAgC,EAAA;;AACjE;EAAiC,+BAA+B,EAAA;;AAEhE;EAAkC,oCAAoC,EAAA;;AACtE;EAAkC,kCAAkC,EAAA;;AACpE;EAAkC,gCAAgC,EAAA;;AAClE;EAAkC,uCAAuC,EAAA;;AACzE;EAAkC,sCAAsC,EAAA;;AACxE;EAAkC,iCAAiC,EAAA;;AAEnE;EAAgC,2BAA2B,EAAA;;AAC3D;EAAgC,iCAAiC,EAAA;;AACjE;EAAgC,+BAA+B,EAAA;;AAC/D;EAAgC,6BAA6B,EAAA;;AAC7D;EAAgC,+BAA+B,EAAA;;AAC/D;EAAgC,8BAA8B,EAAA;;A9EyB9D;E8E/DA;IAAgC,8BAA8B,EAAA;EAC9D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,sCAAsC,EAAA;EACtE;IAAgC,yCAAyC,EAAA;EAEzE;IAA8B,0BAA0B,EAAA;EACxD;IAA8B,4BAA4B,EAAA;EAC1D;IAA8B,kCAAkC,EAAA;EAChE;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,yBAAyB,EAAA;EAEvD;IAAoC,sCAAsC,EAAA;EAC1E;IAAoC,oCAAoC,EAAA;EACxE;IAAoC,kCAAkC,EAAA;EACtE;IAAoC,yCAAyC,EAAA;EAC7E;IAAoC,wCAAwC,EAAA;EAE5E;IAAiC,kCAAkC,EAAA;EACnE;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,8BAA8B,EAAA;EAC/D;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,+BAA+B,EAAA;EAEhE;IAAkC,oCAAoC,EAAA;EACtE;IAAkC,kCAAkC,EAAA;EACpE;IAAkC,gCAAgC,EAAA;EAClE;IAAkC,uCAAuC,EAAA;EACzE;IAAkC,sCAAsC,EAAA;EACxE;IAAkC,iCAAiC,EAAA;EAEnE;IAAgC,2BAA2B,EAAA;EAC3D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,6BAA6B,EAAA;EAC7D;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,8BAA8B,EAAA,EAAI;;A9EyBlE;E8E/DA;IAAgC,8BAA8B,EAAA;EAC9D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,sCAAsC,EAAA;EACtE;IAAgC,yCAAyC,EAAA;EAEzE;IAA8B,0BAA0B,EAAA;EACxD;IAA8B,4BAA4B,EAAA;EAC1D;IAA8B,kCAAkC,EAAA;EAChE;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,yBAAyB,EAAA;EAEvD;IAAoC,sCAAsC,EAAA;EAC1E;IAAoC,oCAAoC,EAAA;EACxE;IAAoC,kCAAkC,EAAA;EACtE;IAAoC,yCAAyC,EAAA;EAC7E;IAAoC,wCAAwC,EAAA;EAE5E;IAAiC,kCAAkC,EAAA;EACnE;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,8BAA8B,EAAA;EAC/D;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,+BAA+B,EAAA;EAEhE;IAAkC,oCAAoC,EAAA;EACtE;IAAkC,kCAAkC,EAAA;EACpE;IAAkC,gCAAgC,EAAA;EAClE;IAAkC,uCAAuC,EAAA;EACzE;IAAkC,sCAAsC,EAAA;EACxE;IAAkC,iCAAiC,EAAA;EAEnE;IAAgC,2BAA2B,EAAA;EAC3D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,6BAA6B,EAAA;EAC7D;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,8BAA8B,EAAA,EAAI;;A9EyBlE;E8E/DA;IAAgC,8BAA8B,EAAA;EAC9D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,sCAAsC,EAAA;EACtE;IAAgC,yCAAyC,EAAA;EAEzE;IAA8B,0BAA0B,EAAA;EACxD;IAA8B,4BAA4B,EAAA;EAC1D;IAA8B,kCAAkC,EAAA;EAChE;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,yBAAyB,EAAA;EAEvD;IAAoC,sCAAsC,EAAA;EAC1E;IAAoC,oCAAoC,EAAA;EACxE;IAAoC,kCAAkC,EAAA;EACtE;IAAoC,yCAAyC,EAAA;EAC7E;IAAoC,wCAAwC,EAAA;EAE5E;IAAiC,kCAAkC,EAAA;EACnE;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,8BAA8B,EAAA;EAC/D;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,+BAA+B,EAAA;EAEhE;IAAkC,oCAAoC,EAAA;EACtE;IAAkC,kCAAkC,EAAA;EACpE;IAAkC,gCAAgC,EAAA;EAClE;IAAkC,uCAAuC,EAAA;EACzE;IAAkC,sCAAsC,EAAA;EACxE;IAAkC,iCAAiC,EAAA;EAEnE;IAAgC,2BAA2B,EAAA;EAC3D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,6BAA6B,EAAA;EAC7D;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,8BAA8B,EAAA,EAAI;;A9EyBlE;E8E/DA;IAAgC,8BAA8B,EAAA;EAC9D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,sCAAsC,EAAA;EACtE;IAAgC,yCAAyC,EAAA;EAEzE;IAA8B,0BAA0B,EAAA;EACxD;IAA8B,4BAA4B,EAAA;EAC1D;IAA8B,kCAAkC,EAAA;EAChE;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,yBAAyB,EAAA;EAEvD;IAAoC,sCAAsC,EAAA;EAC1E;IAAoC,oCAAoC,EAAA;EACxE;IAAoC,kCAAkC,EAAA;EACtE;IAAoC,yCAAyC,EAAA;EAC7E;IAAoC,wCAAwC,EAAA;EAE5E;IAAiC,kCAAkC,EAAA;EACnE;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,8BAA8B,EAAA;EAC/D;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,+BAA+B,EAAA;EAEhE;IAAkC,oCAAoC,EAAA;EACtE;IAAkC,kCAAkC,EAAA;EACpE;IAAkC,gCAAgC,EAAA;EAClE;IAAkC,uCAAuC,EAAA;EACzE;IAAkC,sCAAsC,EAAA;EACxE;IAAkC,iCAAiC,EAAA;EAEnE;IAAgC,2BAA2B,EAAA;EAC3D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,6BAA6B,EAAA;EAC7D;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,8BAA8B,EAAA,EAAI;;A9EyBlE;E8E/DA;IAAgC,8BAA8B,EAAA;EAC9D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,sCAAsC,EAAA;EACtE;IAAgC,yCAAyC,EAAA;EAEzE;IAA8B,0BAA0B,EAAA;EACxD;IAA8B,4BAA4B,EAAA;EAC1D;IAA8B,kCAAkC,EAAA;EAChE;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,yBAAyB,EAAA;EAEvD;IAAoC,sCAAsC,EAAA;EAC1E;IAAoC,oCAAoC,EAAA;EACxE;IAAoC,kCAAkC,EAAA;EACtE;IAAoC,yCAAyC,EAAA;EAC7E;IAAoC,wCAAwC,EAAA;EAE5E;IAAiC,kCAAkC,EAAA;EACnE;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,8BAA8B,EAAA;EAC/D;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,+BAA+B,EAAA;EAEhE;IAAkC,oCAAoC,EAAA;EACtE;IAAkC,kCAAkC,EAAA;EACpE;IAAkC,gCAAgC,EAAA;EAClE;IAAkC,uCAAuC,EAAA;EACzE;IAAkC,sCAAsC,EAAA;EACxE;IAAkC,iCAAiC,EAAA;EAEnE;IAAgC,2BAA2B,EAAA;EAC3D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,6BAA6B,EAAA;EAC7D;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,8BAA8B,EAAA,EAAI;;AvH5C9D;EwHIA,sBAAsB,EAAA;;AvHJtB;EuHOA,uBAAuB,EAAA;;AxHPvB;EwHYA,uBAAuB,EAAA;;AvHZvB;EuHeA,sBAAsB,EAAA;;AAG1B;EAAwB,sBAAsB,EAAA;;A/EmD9C;EzCrEI;IwHIA,sBAAsB,EAAA;EvHJtB;IuHOA,uBAAuB,EAAA;ExHPvB;IwHYA,uBAAuB,EAAA;EvHZvB;IuHeA,sBAAsB,EAAA;EAG1B;IAAwB,sBAAsB,EAAA,EAAI;;A/EmDlD;EzCrEI;IwHIA,sBAAsB,EAAA;EvHJtB;IuHOA,uBAAuB,EAAA;ExHPvB;IwHYA,uBAAuB,EAAA;EvHZvB;IuHeA,sBAAsB,EAAA;EAG1B;IAAwB,sBAAsB,EAAA,EAAI;;A/EmDlD;EzCrEI;IwHIA,sBAAsB,EAAA;EvHJtB;IuHOA,uBAAuB,EAAA;ExHPvB;IwHYA,uBAAuB,EAAA;EvHZvB;IuHeA,sBAAsB,EAAA;EAG1B;IAAwB,sBAAsB,EAAA,EAAI;;A/EmDlD;EzCrEI;IwHIA,sBAAsB,EAAA;EvHJtB;IuHOA,uBAAuB,EAAA;ExHPvB;IwHYA,uBAAuB,EAAA;EvHZvB;IuHeA,sBAAsB,EAAA;EAG1B;IAAwB,sBAAsB,EAAA,EAAI;;A/EmDlD;EzCrEI;IwHIA,sBAAsB,EAAA;EvHJtB;IuHOA,uBAAuB,EAAA;ExHPvB;IwHYA,uBAAuB,EAAA;EvHZvB;IuHeA,sBAAsB,EAAA;EAG1B;IAAwB,sBAAsB,EAAA,EAAI;;ACnBpD;EAAyB,mCAA8B;UAA9B,2BAA8B,EAAA;;AAAvD;EAAyB,oCAA8B;UAA9B,4BAA8B,EAAA;;AAAvD;EAAyB,oCAA8B;UAA9B,4BAA8B,EAAA;;ACAvD;EAAsB,yBAA2B,EAAA;;AAAjD;EAAsB,2BAA2B,EAAA;;ACCjD;EAAyB,2BAA8B,EAAA;;AAAvD;EAAyB,6BAA8B,EAAA;;AAAvD;EAAyB,6BAA8B,EAAA;;AAAvD;EAAyB,0BAA8B,EAAA;;AAAvD;EAAyB,2BAA8B,EAAA;;AAKzD;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,alHN2B,EAAA;;AkHS7B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,alHd2B,EAAA;;AkHkBC;EAD9B;IAEI,gBAAgB;IAChB,MAAM;IACN,alHtByB,EAAA,EkHwB5B;;AC3BD;ECEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS,EAAA;;AAUT;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,mBAAmB,EAAA;;AC7BvB;EAAa,+DAAqC,EAAA;;AAClD;EAAU,yDAAkC,EAAA;;AAC5C;EAAa,wDAAqC,EAAA;;AAClD;EAAe,2BAA2B,EAAA;;ACCtC;EAAuB,qBAA4B,EAAA;;AAAnD;EAAuB,qBAA4B,EAAA;;AAAnD;EAAuB,qBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,uBAA4B,EAAA;;AAAnD;EAAuB,uBAA4B,EAAA;;AAIvD;EAAU,0BAA0B,EAAA;;AACpC;EAAU,2BAA2B,EAAA;;AAIrC;EAAc,2BAA2B,EAAA;;AACzC;EAAc,4BAA4B,EAAA;;AAE1C;EAAU,uBAAuB,EAAA;;AACjC;EAAU,wBAAwB,EAAA;;ACT1B;EAAgC,oBAA4B,EAAA;;AAC5D;;EAEE,wBAAoC,EAAA;;AAEtC;;EAEE,0BAAwC,EAAA;;AAE1C;;EAEE,2BAA0C,EAAA;;AAE5C;;EAEE,yBAAsC,EAAA;;AhIrBxC;EgI0BI,yBAAsC,EAAA;;A/H1B1C;E+H6BI,0BAAwC,EAAA;;AhI7B5C;EgIkCI,0BAAwC,EAAA;;A/HlC5C;E+HqCI,yBAAsC,EAAA;;AA/B1C;EAAgC,0BAA4B,EAAA;;AAC5D;;EAEE,8BAAoC,EAAA;;AAEtC;;EAEE,gCAAwC,EAAA;;AAE1C;;EAEE,iCAA0C,EAAA;;AAE5C;;EAEE,+BAAsC,EAAA;;AhIrBxC;EgI0BI,+BAAsC,EAAA;;A/H1B1C;E+H6BI,gCAAwC,EAAA;;AhI7B5C;EgIkCI,gCAAwC,EAAA;;A/HlC5C;E+HqCI,+BAAsC,EAAA;;AA/B1C;EAAgC,yBAA4B,EAAA;;AAC5D;;EAEE,6BAAoC,EAAA;;AAEtC;;EAEE,+BAAwC,EAAA;;AAE1C;;EAEE,gCAA0C,EAAA;;AAE5C;;EAEE,8BAAsC,EAAA;;AhIrBxC;EgI0BI,8BAAsC,EAAA;;A/H1B1C;E+H6BI,+BAAwC,EAAA;;AhI7B5C;EgIkCI,+BAAwC,EAAA;;A/HlC5C;E+HqCI,8BAAsC,EAAA;;AA/B1C;EAAgC,uBAA4B,EAAA;;AAC5D;;EAEE,2BAAoC,EAAA;;AAEtC;;EAEE,6BAAwC,EAAA;;AAE1C;;EAEE,8BAA0C,EAAA;;AAE5C;;EAEE,4BAAsC,EAAA;;AhIrBxC;EgI0BI,4BAAsC,EAAA;;A/H1B1C;E+H6BI,6BAAwC,EAAA;;AhI7B5C;EgIkCI,6BAAwC,EAAA;;A/HlC5C;E+HqCI,4BAAsC,EAAA;;AA/B1C;EAAgC,yBAA4B,EAAA;;AAC5D;;EAEE,6BAAoC,EAAA;;AAEtC;;EAEE,+BAAwC,EAAA;;AAE1C;;EAEE,gCAA0C,EAAA;;AAE5C;;EAEE,8BAAsC,EAAA;;AhIrBxC;EgI0BI,8BAAsC,EAAA;;A/H1B1C;E+H6BI,+BAAwC,EAAA;;AhI7B5C;EgIkCI,+BAAwC,EAAA;;A/HlC5C;E+HqCI,8BAAsC,EAAA;;AA/B1C;EAAgC,uBAA4B,EAAA;;AAC5D;;EAEE,2BAAoC,EAAA;;AAEtC;;EAEE,6BAAwC,EAAA;;AAE1C;;EAEE,8BAA0C,EAAA;;AAE5C;;EAEE,4BAAsC,EAAA;;AhIrBxC;EgI0BI,4BAAsC,EAAA;;A/H1B1C;E+H6BI,6BAAwC,EAAA;;AhI7B5C;EgIkCI,6BAAwC,EAAA;;A/HlC5C;E+HqCI,4BAAsC,EAAA;;AA/B1C;EAAgC,qBAA4B,EAAA;;AAC5D;;EAEE,yBAAoC,EAAA;;AAEtC;;EAEE,2BAAwC,EAAA;;AAE1C;;EAEE,4BAA0C,EAAA;;AAE5C;;EAEE,0BAAsC,EAAA;;AhIrBxC;EgI0BI,0BAAsC,EAAA;;A/H1B1C;E+H6BI,2BAAwC,EAAA;;AhI7B5C;EgIkCI,2BAAwC,EAAA;;A/HlC5C;E+HqCI,0BAAsC,EAAA;;AA/B1C;EAAgC,2BAA4B,EAAA;;AAC5D;;EAEE,+BAAoC,EAAA;;AAEtC;;EAEE,iCAAwC,EAAA;;AAE1C;;EAEE,kCAA0C,EAAA;;AAE5C;;EAEE,gCAAsC,EAAA;;AhIrBxC;EgI0BI,gCAAsC,EAAA;;A/H1B1C;E+H6BI,iCAAwC,EAAA;;AhI7B5C;EgIkCI,iCAAwC,EAAA;;A/HlC5C;E+HqCI,gCAAsC,EAAA;;AA/B1C;EAAgC,0BAA4B,EAAA;;AAC5D;;EAEE,8BAAoC,EAAA;;AAEtC;;EAEE,gCAAwC,EAAA;;AAE1C;;EAEE,iCAA0C,EAAA;;AAE5C;;EAEE,+BAAsC,EAAA;;AhIrBxC;EgI0BI,+BAAsC,EAAA;;A/H1B1C;E+H6BI,gCAAwC,EAAA;;AhI7B5C;EgIkCI,gCAAwC,EAAA;;A/HlC5C;E+HqCI,+BAAsC,EAAA;;AA/B1C;EAAgC,wBAA4B,EAAA;;AAC5D;;EAEE,4BAAoC,EAAA;;AAEtC;;EAEE,8BAAwC,EAAA;;AAE1C;;EAEE,+BAA0C,EAAA;;AAE5C;;EAEE,6BAAsC,EAAA;;AhIrBxC;EgI0BI,6BAAsC,EAAA;;A/H1B1C;E+H6BI,8BAAwC,EAAA;;AhI7B5C;EgIkCI,8BAAwC,EAAA;;A/HlC5C;E+HqCI,6BAAsC,EAAA;;AA/B1C;EAAgC,0BAA4B,EAAA;;AAC5D;;EAEE,8BAAoC,EAAA;;AAEtC;;EAEE,gCAAwC,EAAA;;AAE1C;;EAEE,iCAA0C,EAAA;;AAE5C;;EAEE,+BAAsC,EAAA;;AhIrBxC;EgI0BI,+BAAsC,EAAA;;A/H1B1C;E+H6BI,gCAAwC,EAAA;;AhI7B5C;EgIkCI,gCAAwC,EAAA;;A/HlC5C;E+HqCI,+BAAsC,EAAA;;AA/B1C;EAAgC,wBAA4B,EAAA;;AAC5D;;EAEE,4BAAoC,EAAA;;AAEtC;;EAEE,8BAAwC,EAAA;;AAE1C;;EAEE,+BAA0C,EAAA;;AAE5C;;EAEE,6BAAsC,EAAA;;AhIrBxC;EgI0BI,6BAAsC,EAAA;;A/H1B1C;E+H6BI,8BAAwC,EAAA;;AhI7B5C;EgIkCI,8BAAwC,EAAA;;A/HlC5C;E+HqCI,6BAAsC,EAAA;;AAS1C;EAAwB,2BAA2B,EAAA;;AACnD;;EAEE,+BAA+B,EAAA;;AAEjC;;EAEE,iCAAiC,EAAA;;AAEnC;;EAEE,kCAAkC,EAAA;;AAEpC;;EAEE,gCAAgC,EAAA;;AhI7DlC;EgIkEI,gCAAgC,EAAA;;A/HlEpC;E+HqEI,iCAAiC,EAAA;;AhIrErC;EgI0EI,iCAAiC,EAAA;;A/H1ErC;E+H6EI,gCAAgC,EAAA;;AA/BpC;EAAwB,0BAA2B,EAAA;;AACnD;;EAEE,8BAA+B,EAAA;;AAEjC;;EAEE,gCAAiC,EAAA;;AAEnC;;EAEE,iCAAkC,EAAA;;AAEpC;;EAEE,+BAAgC,EAAA;;AhI7DlC;EgIkEI,+BAAgC,EAAA;;A/HlEpC;E+HqEI,gCAAiC,EAAA;;AhIrErC;EgI0EI,gCAAiC,EAAA;;A/H1ErC;E+H6EI,+BAAgC,EAAA;;AA/BpC;EAAwB,wBAA2B,EAAA;;AACnD;;EAEE,4BAA+B,EAAA;;AAEjC;;EAEE,8BAAiC,EAAA;;AAEnC;;EAEE,+BAAkC,EAAA;;AAEpC;;EAEE,6BAAgC,EAAA;;AhI7DlC;EgIkEI,6BAAgC,EAAA;;A/HlEpC;E+HqEI,8BAAiC,EAAA;;AhIrErC;EgI0EI,8BAAiC,EAAA;;A/H1ErC;E+H6EI,6BAAgC,EAAA;;AA/BpC;EAAwB,0BAA2B,EAAA;;AACnD;;EAEE,8BAA+B,EAAA;;AAEjC;;EAEE,gCAAiC,EAAA;;AAEnC;;EAEE,iCAAkC,EAAA;;AAEpC;;EAEE,+BAAgC,EAAA;;AhI7DlC;EgIkEI,+BAAgC,EAAA;;A/HlEpC;E+HqEI,gCAAiC,EAAA;;AhIrErC;EgI0EI,gCAAiC,EAAA;;A/H1ErC;E+H6EI,+BAAgC,EAAA;;AA/BpC;EAAwB,wBAA2B,EAAA;;AACnD;;EAEE,4BAA+B,EAAA;;AAEjC;;EAEE,8BAAiC,EAAA;;AAEnC;;EAEE,+BAAkC,EAAA;;AAEpC;;EAEE,6BAAgC,EAAA;;AhI7DlC;EgIkEI,6BAAgC,EAAA;;A/HlEpC;E+HqEI,8BAAiC,EAAA;;AhIrErC;EgI0EI,8BAAiC,EAAA;;A/H1ErC;E+H6EI,6BAAgC,EAAA;;AAOxC;EAAmB,uBAAuB,EAAA;;AAC1C;;EAEE,2BAA2B,EAAA;;AAE7B;;EAEE,6BAA6B,EAAA;;AAE/B;;EAEE,8BAA8B,EAAA;;AAEhC;;EAEE,4BAA4B,EAAA;;AhInG1B;EgIyGA,4BAA4B,EAAA;;A/HzG5B;E+H4GA,6BAA6B,EAAA;;AhI5G7B;EgIiHA,6BAA6B,EAAA;;A/HjH7B;E+HoHA,4BAA4B,EAAA;;AvF/ChC;EuF/DI;IAAgC,oBAA4B,EAAA;EAC5D;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EhIrBxC;IgI0BI,yBAAsC,EAAA;E/H1B1C;I+H6BI,0BAAwC,EAAA;EhI7B5C;IgIkCI,0BAAwC,EAAA;E/HlC5C;I+HqCI,yBAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,qBAA4B,EAAA;EAC5D;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EhIrBxC;IgI0BI,0BAAsC,EAAA;E/H1B1C;I+H6BI,2BAAwC,EAAA;EhI7B5C;IgIkCI,2BAAwC,EAAA;E/HlC5C;I+HqCI,0BAAsC,EAAA;EA/B1C;IAAgC,2BAA4B,EAAA;EAC5D;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EhIrBxC;IgI0BI,gCAAsC,EAAA;E/H1B1C;I+H6BI,iCAAwC,EAAA;EhI7B5C;IgIkCI,iCAAwC,EAAA;E/HlC5C;I+HqCI,gCAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EAS1C;IAAwB,2BAA2B,EAAA;EACnD;;IAEE,+BAA+B,EAAA;EAEjC;;IAEE,iCAAiC,EAAA;EAEnC;;IAEE,kCAAkC,EAAA;EAEpC;;IAEE,gCAAgC,EAAA;EhI7DlC;IgIkEI,gCAAgC,EAAA;E/HlEpC;I+HqEI,iCAAiC,EAAA;EhIrErC;IgI0EI,iCAAiC,EAAA;E/H1ErC;I+H6EI,gCAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EAOxC;IAAmB,uBAAuB,EAAA;EAC1C;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA;EhInG1B;IgIyGA,4BAA4B,EAAA;E/HzG5B;I+H4GA,6BAA6B,EAAA;EhI5G7B;IgIiHA,6BAA6B,EAAA;E/HjH7B;I+HoHA,4BAA4B,EAAA,E/HlH3B;;AwCmEL;EuF/DI;IAAgC,oBAA4B,EAAA;EAC5D;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EhIrBxC;IgI0BI,yBAAsC,EAAA;E/H1B1C;I+H6BI,0BAAwC,EAAA;EhI7B5C;IgIkCI,0BAAwC,EAAA;E/HlC5C;I+HqCI,yBAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,qBAA4B,EAAA;EAC5D;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EhIrBxC;IgI0BI,0BAAsC,EAAA;E/H1B1C;I+H6BI,2BAAwC,EAAA;EhI7B5C;IgIkCI,2BAAwC,EAAA;E/HlC5C;I+HqCI,0BAAsC,EAAA;EA/B1C;IAAgC,2BAA4B,EAAA;EAC5D;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EhIrBxC;IgI0BI,gCAAsC,EAAA;E/H1B1C;I+H6BI,iCAAwC,EAAA;EhI7B5C;IgIkCI,iCAAwC,EAAA;E/HlC5C;I+HqCI,gCAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EAS1C;IAAwB,2BAA2B,EAAA;EACnD;;IAEE,+BAA+B,EAAA;EAEjC;;IAEE,iCAAiC,EAAA;EAEnC;;IAEE,kCAAkC,EAAA;EAEpC;;IAEE,gCAAgC,EAAA;EhI7DlC;IgIkEI,gCAAgC,EAAA;E/HlEpC;I+HqEI,iCAAiC,EAAA;EhIrErC;IgI0EI,iCAAiC,EAAA;E/H1ErC;I+H6EI,gCAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EAOxC;IAAmB,uBAAuB,EAAA;EAC1C;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA;EhInG1B;IgIyGA,4BAA4B,EAAA;E/HzG5B;I+H4GA,6BAA6B,EAAA;EhI5G7B;IgIiHA,6BAA6B,EAAA;E/HjH7B;I+HoHA,4BAA4B,EAAA,E/HlH3B;;AwCmEL;EuF/DI;IAAgC,oBAA4B,EAAA;EAC5D;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EhIrBxC;IgI0BI,yBAAsC,EAAA;E/H1B1C;I+H6BI,0BAAwC,EAAA;EhI7B5C;IgIkCI,0BAAwC,EAAA;E/HlC5C;I+HqCI,yBAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,qBAA4B,EAAA;EAC5D;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EhIrBxC;IgI0BI,0BAAsC,EAAA;E/H1B1C;I+H6BI,2BAAwC,EAAA;EhI7B5C;IgIkCI,2BAAwC,EAAA;E/HlC5C;I+HqCI,0BAAsC,EAAA;EA/B1C;IAAgC,2BAA4B,EAAA;EAC5D;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EhIrBxC;IgI0BI,gCAAsC,EAAA;E/H1B1C;I+H6BI,iCAAwC,EAAA;EhI7B5C;IgIkCI,iCAAwC,EAAA;E/HlC5C;I+HqCI,gCAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EAS1C;IAAwB,2BAA2B,EAAA;EACnD;;IAEE,+BAA+B,EAAA;EAEjC;;IAEE,iCAAiC,EAAA;EAEnC;;IAEE,kCAAkC,EAAA;EAEpC;;IAEE,gCAAgC,EAAA;EhI7DlC;IgIkEI,gCAAgC,EAAA;E/HlEpC;I+HqEI,iCAAiC,EAAA;EhIrErC;IgI0EI,iCAAiC,EAAA;E/H1ErC;I+H6EI,gCAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EAOxC;IAAmB,uBAAuB,EAAA;EAC1C;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA;EhInG1B;IgIyGA,4BAA4B,EAAA;E/HzG5B;I+H4GA,6BAA6B,EAAA;EhI5G7B;IgIiHA,6BAA6B,EAAA;E/HjH7B;I+HoHA,4BAA4B,EAAA,E/HlH3B;;AwCmEL;EuF/DI;IAAgC,oBAA4B,EAAA;EAC5D;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EhIrBxC;IgI0BI,yBAAsC,EAAA;E/H1B1C;I+H6BI,0BAAwC,EAAA;EhI7B5C;IgIkCI,0BAAwC,EAAA;E/HlC5C;I+HqCI,yBAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,qBAA4B,EAAA;EAC5D;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EhIrBxC;IgI0BI,0BAAsC,EAAA;E/H1B1C;I+H6BI,2BAAwC,EAAA;EhI7B5C;IgIkCI,2BAAwC,EAAA;E/HlC5C;I+HqCI,0BAAsC,EAAA;EA/B1C;IAAgC,2BAA4B,EAAA;EAC5D;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EhIrBxC;IgI0BI,gCAAsC,EAAA;E/H1B1C;I+H6BI,iCAAwC,EAAA;EhI7B5C;IgIkCI,iCAAwC,EAAA;E/HlC5C;I+HqCI,gCAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EAS1C;IAAwB,2BAA2B,EAAA;EACnD;;IAEE,+BAA+B,EAAA;EAEjC;;IAEE,iCAAiC,EAAA;EAEnC;;IAEE,kCAAkC,EAAA;EAEpC;;IAEE,gCAAgC,EAAA;EhI7DlC;IgIkEI,gCAAgC,EAAA;E/HlEpC;I+HqEI,iCAAiC,EAAA;EhIrErC;IgI0EI,iCAAiC,EAAA;E/H1ErC;I+H6EI,gCAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EAOxC;IAAmB,uBAAuB,EAAA;EAC1C;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA;EhInG1B;IgIyGA,4BAA4B,EAAA;E/HzG5B;I+H4GA,6BAA6B,EAAA;EhI5G7B;IgIiHA,6BAA6B,EAAA;E/HjH7B;I+HoHA,4BAA4B,EAAA,E/HlH3B;;AwCmEL;EuF/DI;IAAgC,oBAA4B,EAAA;EAC5D;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EhIrBxC;IgI0BI,yBAAsC,EAAA;E/H1B1C;I+H6BI,0BAAwC,EAAA;EhI7B5C;IgIkCI,0BAAwC,EAAA;E/HlC5C;I+HqCI,yBAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EhIrBxC;IgI0BI,8BAAsC,EAAA;E/H1B1C;I+H6BI,+BAAwC,EAAA;EhI7B5C;IgIkCI,+BAAwC,EAAA;E/HlC5C;I+HqCI,8BAAsC,EAAA;EA/B1C;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EhIrBxC;IgI0BI,4BAAsC,EAAA;E/H1B1C;I+H6BI,6BAAwC,EAAA;EhI7B5C;IgIkCI,6BAAwC,EAAA;E/HlC5C;I+HqCI,4BAAsC,EAAA;EA/B1C;IAAgC,qBAA4B,EAAA;EAC5D;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EhIrBxC;IgI0BI,0BAAsC,EAAA;E/H1B1C;I+H6BI,2BAAwC,EAAA;EhI7B5C;IgIkCI,2BAAwC,EAAA;E/HlC5C;I+HqCI,0BAAsC,EAAA;EA/B1C;IAAgC,2BAA4B,EAAA;EAC5D;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EhIrBxC;IgI0BI,gCAAsC,EAAA;E/H1B1C;I+H6BI,iCAAwC,EAAA;EhI7B5C;IgIkCI,iCAAwC,EAAA;E/HlC5C;I+HqCI,gCAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EA/B1C;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EhIrBxC;IgI0BI,+BAAsC,EAAA;E/H1B1C;I+H6BI,gCAAwC,EAAA;EhI7B5C;IgIkCI,gCAAwC,EAAA;E/HlC5C;I+HqCI,+BAAsC,EAAA;EA/B1C;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EhIrBxC;IgI0BI,6BAAsC,EAAA;E/H1B1C;I+H6BI,8BAAwC,EAAA;EhI7B5C;IgIkCI,8BAAwC,EAAA;E/HlC5C;I+HqCI,6BAAsC,EAAA;EAS1C;IAAwB,2BAA2B,EAAA;EACnD;;IAEE,+BAA+B,EAAA;EAEjC;;IAEE,iCAAiC,EAAA;EAEnC;;IAEE,kCAAkC,EAAA;EAEpC;;IAEE,gCAAgC,EAAA;EhI7DlC;IgIkEI,gCAAgC,EAAA;E/HlEpC;I+HqEI,iCAAiC,EAAA;EhIrErC;IgI0EI,iCAAiC,EAAA;E/H1ErC;I+H6EI,gCAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EA/BpC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EhI7DlC;IgIkEI,+BAAgC,EAAA;E/HlEpC;I+HqEI,gCAAiC,EAAA;EhIrErC;IgI0EI,gCAAiC,EAAA;E/H1ErC;I+H6EI,+BAAgC,EAAA;EA/BpC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EhI7DlC;IgIkEI,6BAAgC,EAAA;E/HlEpC;I+HqEI,8BAAiC,EAAA;EhIrErC;IgI0EI,8BAAiC,EAAA;E/H1ErC;I+H6EI,6BAAgC,EAAA;EAOxC;IAAmB,uBAAuB,EAAA;EAC1C;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA;EhInG1B;IgIyGA,4BAA4B,EAAA;E/HzG5B;I+H4GA,6BAA6B,EAAA;EhI5G7B;IgIiHA,6BAA6B,EAAA;E/HjH7B;I+HoHA,4BAA4B,EAAA,E/HlH3B;;AgIFT;EAEI,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EAEV,oBAAoB;EACpB,WAAW;EAEX,mCrIXY,EAAA;;AsIChB;EAAkB,4GAA8C,EAAA;;AAIhE;EAAiB,8BAA8B,EAAA;;AAC/C;EAAiB,8BAA8B,EAAA;;AAC/C;EAAiB,8BAA8B,EAAA;;AAC/C;ECTE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;ADejB;EAAwB,2BAA2B,EAAA;;AACnD;EAAwB,4BAA4B,EAAA;;AACpD;EAAwB,6BAA6B,EAAA;;AzFkDrD;EyFpDA;IAAwB,2BAA2B,EAAA;EACnD;IAAwB,4BAA4B,EAAA;EACpD;IAAwB,6BAA6B,EAAA,EAAI;;AzFkDzD;EyFpDA;IAAwB,2BAA2B,EAAA;EACnD;IAAwB,4BAA4B,EAAA;EACpD;IAAwB,6BAA6B,EAAA,EAAI;;AzFkDzD;EyFpDA;IAAwB,2BAA2B,EAAA;EACnD;IAAwB,4BAA4B,EAAA;EACpD;IAAwB,6BAA6B,EAAA,EAAI;;AzFkDzD;EyFpDA;IAAwB,2BAA2B,EAAA;EACnD;IAAwB,4BAA4B,EAAA;EACpD;IAAwB,6BAA6B,EAAA,EAAI;;AzFkDzD;EyFpDA;IAAwB,2BAA2B,EAAA;EACnD;IAAwB,4BAA4B,EAAA;EACpD;IAAwB,6BAA6B,EAAA,EAAI;;AAM7D;EAAmB,oCAAoC,EAAA;;AACvD;EAAmB,oCAAoC,EAAA;;AACvD;EAAmB,qCAAqC,EAAA;;AAIxD;EAAuB,2BAA0C,EAAA;;AACjE;EAAuB,+BAA4C,EAAA;;AACnE;EAAuB,2BAA2C,EAAA;;AAClE;EAAuB,2BAAyC,EAAA;;AAChE;EAAuB,8BAA2C,EAAA;;AAClE;EAAuB,6BAA6B,EAAA;;AAIpD;EAAc,sBAAwB,EAAA;;AEvCpC;EACE,yBAAwB,EAAA;;AjIY1B;EiIPM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AjIY1B;EiIPM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AjIY1B;EiIPM,yBAA0E,EAAA;;AANhF;EACE,sBAAwB,EAAA;;AjIY1B;EiIPM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AjIY1B;EiIPM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AjIY1B;EiIPM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AjIY1B;EiIPM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AjIY1B;EiIPM,yBAA0E,EAAA;;AFuClF;EAAa,yBAA6B,EAAA;;AAC1C;EAEI,yBAAgD,EAAA;;AAIpD;EAAiB,qCAAkC,EAAA;;AACnD;EAAiB,0CAAkC,EAAA;;AAInD;EG3DE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS,EAAA;;AH2DX;EAAwB,gCAAgC,EAAA;;AAExD;EACE,iCAAiC;EACjC,oCAAoC,EAAA;;AAKtC;EAAc,yBAAyB,EAAA;;ArI7BvC;EyI7CE,kCAAkC;EAClC,mCAAmC,EAAA;;AAIrC;EACE,4BAA4B,EAAA;;AAG9B;EACE,4BAA4B,EAAA;;AAG9B;EACE,0BAA0B,EAAA;;AAG5B;EACE,6BAA6B,EAAA;;AAG/B;EACE,4BAA4B,EAAA;;AAG9B;EACE,6BAA6B,EAAA;;AAG/B;EACE,0BAA0B,EAAA;;AAG5B;EACE,4BAA4B,EAAA;;A9Iqoa9B;E8IjoaE,gBAAgB,EAAA;;AAGlB;EACE,qBAAkC,EAAA;;AAGpC;EACE,qBAAkC,EAAA;;AAGpC;EACE,mBxIzCuB,EAAA;;AwI4CzB;EACE,oBAAkC,EAAA;;AAGpC;EACE,qBAAmC,EAAA;;AAGrC;EACE,0CAAyC,EAAA;;ACzD3C;EACE,8BAA8B,EAAA;;AAGhC;EACE,6BAA6B,EAAA;;AtIDzB;EuINJ,cAAc;EACd,mBAAmB,EAAA;EvIKf;IuIFF,iBAAiB,EAAA;;ACRrB;EAGI,gBAAW;EAAX,kBAAW;EAAX,gBAAW;EAAX,UAAW;EAAX,gBAAW;EAAX,eAAW;EAAX,cAAW;EAAX,aAAW;EAIX,gBAA8B;EAA9B,oBAA8B;EAA9B,oBAA8B;EAA9B,oBAA8B;EAA9B,qBAA8B;EAA9B,sBAA8B,EAAA;;ACIhC;E7IOF;;;I6IDM,4BAA4B;IAE5B,2BAA2B,EAAA;EAG7B;IAEI,0BAA0B,EAAA;EAS9B;IACE,6BAA6B,EAAA;E7I4MnC;I6I7LM,gCAAgC,EAAA;EAElC;;IAEE,yB9IzCc;I8I0Cd,wBAAwB,EAAA;EAQ1B;IACE,2BAA2B,EAAA;EAG7B;;IAEE,wBAAwB,EAAA;EAG1B;;;IAGE,UAAU;IACV,SAAS,EAAA;EAGX;;IAEE,uBAAuB,EAAA;EAQzB;IACE,QCtFoB,EAAA;E9I2C1B;I6I8CM,2BAA2C,EAAA;E7EtF/C;I6EyFI,2BAA2C,EAAA;EtD9EjD;IsDmFM,aAAa,EAAA;EjH/FnB;IiHkGM,yB9IlGU,EAAA;E2GDhB;ImCuGM,oCAAoC,EAAA;IADtC;;MAKI,iCAAmC,EAAA;EnCpD3C;;ImC2DQ,oCAAsC,EAAA;EnC2D9C;ImCtDM,cAAc,EAAA;IlCtHlB;;;;MkC4HM,qB9IxHY,EAAA;E2GkJpB;ImCrBM,cAAc;IACd,qB9I9Hc,EAAA,E8I+Hf;;AEvIL;EAEI,eAAe,EAAA;;AAFnB;EAKI,eAAe,EAAA;;AAKnB;EAEI,wBAAwB,EAAA;;A7BmE5B;E8B9EE,mBAAmB,EAAA;;A5EFrB;E4EKE,mBAAmB;EACnB,gBAAgB,EAAA;;A5ENlB;E4EUE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B,EAAA;;AnFyGvB;;EmFvFN,cAAyB;EACzB,kBAAkB,EAAA;EAhBpB;;IAII,cAAc;IAEd,eAAe;IACf,YAAY,EAAA;EAPhB;;IAUI,cAAc,EAAA;;AnF4FV;;EmF/EN,8BAA8B,EAAA;;AhFjC9B;EgFqCA,kBAAkB,EAAA;;AAIpB;EACE,cAAc;EACd,WAAW,EAAA;;AAIb;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,iFAKC,EAAA;;AAGH;EACE,YAAY,EAAA;;AAGd;EACE,YAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAGT,gCAAgC;EAChC,kBAAkB,EAAA;;AAEpB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB,EAAA;;AAElB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,iBAAiB,EAAA;;AAEnB;EACE,2BAA2B;EAC3B,aAAa;EACb,uBAAuB,EAAA;;AAGvB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB,EAAA;EAVnB;IAYG,cAAc,EAAA;;AAGlB;EACE,kBAAkB;EAElB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;EAXhB;IAaG,cAAc,EAAA;;AAIpB;EACE;IACE,aAAa,EAAA;EAEf;IACE,yBAAyB,EAAA,EAC1B","sourcesContent":["// If you want to override variables do it here\n@import \"variables\";\n\n// Import CoreUI styles\n@import \"~@coreui/coreui/scss/coreui.scss\";\n\n// Some temp fixes\n@import \"fixes\";\n\n// If you want to add something do it here\n@import \"custom\";\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Oxygen:wght@300;400;700&display=swap\");\n","/*!\n * CoreUI - HTML, CSS, and JavaScript UI Components Library\n * @version v3.3.0\n * @link https://coreui.io/\n * Copyright (c) 2020 creativeLabs Łukasz Holeczek\n * License MIT  (https://coreui.io/license/)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"app\";\n@import \"reboot\";\n\n// Vendors\n@import \"vendors\";\n\n// Components\n@import \"alert\";\n@import \"avatars\";\n@import \"badge\";\n@import \"breadcrumb-menu\";\n@import \"breadcrumb\";\n@import \"button-group\";\n@import \"buttons\";\n@import \"callout\";\n@import \"card\";\n@import \"carousel\";\n@import \"charts\";\n@import \"close\";\n@import \"code\";\n@import \"custom-forms\";\n@import \"dropdown\";\n@import \"footer\";\n@import \"forms\";\n@import \"grid\";\n@import \"header\";\n@import \"icon\";\n@import \"input-group\";\n@import \"images\";\n@import \"jumbotron\";\n@import \"list-group\";\n@import \"media\";\n@import \"modal\";\n@import \"nav\";\n@import \"navbar\";\n@import \"pagination\";\n@import \"popover\";\n@import \"progress\";\n@import \"progress-group\";\n@import \"sidebar\";\n@import \"spinners\";\n@import \"subheader\";\n@import \"switches\";\n@import \"tables\";\n@import \"toasts\";\n@import \"tooltip\";\n@import \"transitions\";\n@import \"type\";\n@import \"widgets\";\n\n// Layout Options\n@import \"layouts\";\n\n// Utility classes\n@import \"utilities\";\n\n// Right-to-left\n@import \"rtl\";\n\n// Custom Properties support for Internet Explorer\n@import \"ie-custom-properties\";\n\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  // @each $color, $value in $colors {\n  //   --#{$color}: #{$value};\n  // }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n",".c-app {\n  @include theme-variant(true) {\n    --#{$color}: #{$value};\n  }\n  @include themes($body-theme-map, $create: append) {\n    color: themes-get-value(\"body-color\");\n    background-color: themes-get-value(\"body-bg\");\n\n    --color: #{themes-get-value(\"body-color\")};\n  }\n}\n","//\n// CoreUI default colors\n//\n\n$white:  #fff !default;\n$black:  #000015 !default;\n\n$gray-base:  #3c4b64 !default;\n$gray-100:   #ebedef !default;\n$gray-200:   #d8dbe0 !default;\n$gray-300:   #c4c9d0 !default;\n$gray-400:   #b1b7c1 !default;\n$gray-500:   #9da5b1 !default;\n$gray-600:   #8a93a2 !default;\n$gray-700:   #768192 !default;\n$gray-800:   #636f83 !default;\n$gray-900:   #4f5d73 !default;\n\n$grays: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$grays: map-merge(\n  (\n    \"100\":  $gray-100,\n    \"200\":  $gray-200,\n    \"300\":  $gray-300,\n    \"400\":  $gray-400,\n    \"500\":  $gray-500,\n    \"600\":  $gray-600,\n    \"700\":  $gray-700,\n    \"800\":  $gray-800,\n    \"900\":  $gray-900\n  ),\n  $grays\n);\n\n$primary-base:  #321fdb !default;\n$primary-100:   #eae9fb !default;\n$primary-200:   #d6d2fb !default;\n$primary-300:   #c1bcf4 !default;\n$primary-400:   #ada5f1 !default;\n$primary-500:   #988fed !default;\n$primary-600:   #8478ea !default;\n$primary-700:   #6f62e6 !default;\n$primary-800:   #5b4ce2 !default;\n$primary-900:   #4635df !default;\n\n$primary-dark:  #1f1498 !default;\n$primary:       #321fdb !default;\n$primary-50:    #988fed !default;\n$primary-25:    #ccc7f6 !default;\n\n\n$secondary-base:  #3c4b64 !default;\n\n$secondary-100:   #ebedef !default;\n$secondary-200:   #d8dbe0 !default;\n$secondary-300:   #c4c9d0 !default;\n$secondary-400:   #b1b7c1 !default;\n$secondary-500:   #9da5b1 !default;\n$secondary-600:   #8a93a2 !default;\n$secondary-700:   #768192 !default;\n$secondary-800:   #636f83 !default;\n$secondary-900:   #4f5d73 !default;\n\n$secondary-dark:  #212233 !default;\n$secondary:       #3c4b64 !default;\n$secondary-50:    #9da5b1 !default;\n$secondary-25:    #ced2d8 !default;\n\n\n$danger-dark:  #d93737 !default;\n$danger:       #e55353 !default;\n$danger-50:    #f2a9a9 !default;\n$danger-25:    #f9d4d4 !default;\n\n$info-dark:  #2982cc !default;\n$info:       #39f !default;\n$info-50:    #80c6ff !default;\n$info-25:    #c0e6ff !default;\n\n$success-dark:  #1b9e3e !default;\n$success:       #2eb85c !default;\n$success-50:    #96dbad !default;\n$success-25:    #cbedd6 !default;\n\n$warning-dark:  #f6960b !default;\n$warning:       #f9b115 !default;\n$warning-50:    #fcd88a !default;\n$warning-25:    #feecc5 !default;\n\n$light:  $gray-100 !default;\n$dark:   $gray-800 !default;\n\n$pink:  #e83e8c !default;\n\n// scss-docs-start theme-colors-map\n$theme-colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary-25,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n// scss-docs-end theme-colors-map\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:  8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:   $gray-900 !default;\n$yiq-text-light:  $white !default;\n\n$yiq-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$yiq-theme-map: map-merge(\n  (\n    default: (\n      \"yiq-text-dark\":  $yiq-text-dark,\n      \"yiq-text-light\":  $yiq-text-light\n    )\n  ),\n  $yiq-theme-map\n);\n\n// TODO: Move to better place\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\",\"%3c\"),\n  (\">\",\"%3e\"),\n  (\"#\",\"%23\"),\n  (\"(\",\"%28\"),\n  (\")\",\"%29\"),\n) !default;\n","// stylelint-disable at-rule-no-vendor-prefix, declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n// 4. Disable horizontal scrolling\n\nbody {\n  margin: 0; // 1\n  // TODO: find a better solution to avoid horizontal scroll if a sidebar doesn't have a fixed position.\n  overflow-x: hidden; // 4\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  text-align: left; // 3\n  @include themes($body-theme-map, $create: append) {\n    color: themes-get-value(\"body-color\");\n    background-color: themes-get-value(\"body-bg\"); // 2\n  }\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  @include ltr {\n    margin-left: 0; // Undo browser default\n  }\n  @include rtl {\n    margin-right: 0; // Undo browser default\n  }\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n  @include themes($link-theme-map) {\n    color: themes-get-value(\"link-color\");\n  }\n\n  @include hover() {\n    text-decoration: $link-hover-decoration;\n    @include themes($link-theme-map) {\n      color: themes-get-value(\"link-color\");\n    }\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  // Matches default `<td>` alignment by inheriting from the `<body>`, or the\n  // closest parent with a set `text-align`.\n  text-align: inherit;\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 0;\n}\n\n// Work around a Firefox/IE bug where the transparent `button` background\n// results in a loss of the default `button` focus styles.\n//\n// Credit: https://github.com/suitcss/base/\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:  -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:   SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:        $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:  .875rem !default;\n$font-size-lg:    $font-size-base * 1.25 !default;\n$font-size-sm:    $font-size-base * .875 !default;\n\n$font-weight-lighter:  lighter !default;\n$font-weight-light:    300 !default;\n$font-weight-normal:   400 !default;\n$font-weight-bold:     700 !default;\n$font-weight-bolder:   bolder !default;\n\n$font-weight-base:  $font-weight-normal !default;\n$line-height-base:  1.5 !default;\n\n$h1-font-size:  $font-size-base * 2.5 !default;\n$h2-font-size:  $font-size-base * 2 !default;\n$h3-font-size:  $font-size-base * 1.75 !default;\n$h4-font-size:  $font-size-base * 1.5 !default;\n$h5-font-size:  $font-size-base * 1.25 !default;\n$h6-font-size:  $font-size-base !default;\n\n$headings-margin-bottom:  $spacer / 2 !default;\n$headings-font-family:    null !default;\n$headings-font-weight:    500 !default;\n$headings-line-height:    1.2 !default;\n$headings-color:          null !default;\n\n$display1-size:  6rem !default;\n$display2-size:  5.5rem !default;\n$display3-size:  4.5rem !default;\n$display4-size:  3.5rem !default;\n\n$display1-weight:      300 !default;\n$display2-weight:      300 !default;\n$display3-weight:      300 !default;\n$display4-weight:      300 !default;\n$display-line-height:  $headings-line-height !default;\n\n$lead-font-size:    $font-size-base * 1.25 !default;\n$lead-font-weight:  300 !default;\n\n$small-font-size:  80% !default;\n\n$text-muted:  $gray-700 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:  rgba($black, .2) !default;\n$hr-border-width:  $border-width !default;\n\n$vr-bg:     rgba($black, .2) !default;\n$vr-width:  $border-width !default;\n\n$mark-padding:  .2em !default;\n\n$dt-font-weight:  $font-weight-bold !default;\n\n$kbd-box-shadow:          inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:  $font-weight-bold !default;\n\n$list-inline-padding:  .5rem !default;\n\n$mark-bg: #fcf8e3 !default;\n\n$hr-margin-y:  $spacer !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:  1rem !default;\n\n// Icons\n//\n// Style .c-icon element.\n\n$icon-size-base:  1rem !default;\n$icon-size-sm:    $icon-size-base * .875 !default;\n$icon-size-lg:    $icon-size-base * 1.25 !default;\n$icon-size-xl:    $icon-size-base * 1.5 !default;\n\n\n$typography-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$typography-theme-map: map-merge(\n  (\n    default: (\n      \"hr-border-color\":  $hr-border-color,\n      \"vr-bg\":            $vr-bg,\n      \"text-muted\":       $text-muted\n    )\n  ),\n  $typography-theme-map\n);\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated font-resizing\n//\n// See https://github.com/twbs/rfs\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n// Resize font-size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: $rfs-base-font-size / ($rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: $rfs-base-font-size / ($rfs-base-font-size * 0 + 1 / $rfs-rem-value);\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: $rfs-breakpoint / ($rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: $rfs-breakpoint / ($rfs-breakpoint * 0 + 1 / $rfs-rem-value);\n}\n\n// Responsive font-size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Variables for storing static and fluid rescaling\n    $rfs-static: null;\n    $rfs-fluid: null;\n\n    // Remove px-unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: $fs / ($fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: $fs / ($fs * 0 + 1 / $rfs-rem-value);\n    }\n\n    // Set default font-size\n    @if $rfs-font-size-unit == rem {\n      $rfs-static: #{$fs / $rfs-rem-value}rem#{$rfs-suffix};\n    }\n    @else if $rfs-font-size-unit == px {\n      $rfs-static: #{$fs}px#{$rfs-suffix};\n    }\n    @else {\n      @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n    }\n\n    // Only add media query if font-size is bigger as the minimum font-size\n    // If $rfs-factor == 1, no rescaling will take place\n    @if $fs > $rfs-base-font-size and $enable-responsive-font-sizes {\n      $min-width: null;\n      $variable-unit: null;\n\n      // Calculate minimum font-size for given font-size\n      $fs-min: $rfs-base-font-size + ($fs - $rfs-base-font-size) / $rfs-factor;\n\n      // Calculate difference between given font-size and minimum font-size for given font-size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      // No need to check if the unit is valid, because we did that before\n      $min-width: if($rfs-font-size-unit == rem, #{$fs-min / $rfs-rem-value}rem, #{$fs-min}px);\n\n      // If two-dimensional, use smallest of screen width and height\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{$fs-diff * 100 / $rfs-breakpoint}#{$variable-unit};\n\n      // Set the calculated font-size.\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n    }\n\n    // Rendering\n    @if $rfs-fluid == null {\n      // Only render static font-size if no fluid font-size is available\n      font-size: $rfs-static;\n    }\n    @else {\n      $mq-value: null;\n\n      // RFS breakpoint formatting\n      @if $rfs-breakpoint-unit == em or $rfs-breakpoint-unit == rem {\n        $mq-value: #{$rfs-breakpoint / $rfs-rem-value}#{$rfs-breakpoint-unit};\n      }\n      @else if $rfs-breakpoint-unit == px {\n        $mq-value: #{$rfs-breakpoint}px;\n      }\n      @else {\n        @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n      }\n\n      @if $rfs-class == \"disable\" {\n        // Adding an extra class increases specificity,\n        // which prevents the media query to override the font size\n        &,\n        .disable-responsive-font-size &,\n        &.disable-responsive-font-size {\n          font-size: $rfs-static;\n        }\n      }\n      @else {\n        font-size: $rfs-static;\n      }\n\n      @if $rfs-two-dimensional {\n        @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n          @if $rfs-class == \"enable\" {\n            .enable-responsive-font-size &,\n            &.enable-responsive-font-size {\n              font-size: $rfs-fluid;\n            }\n          }\n          @else {\n            font-size: $rfs-fluid;\n          }\n\n          @if $rfs-safari-iframe-resize-bug-fix {\n            // stylelint-disable-next-line length-zero-no-unit\n            min-width: 0vw;\n          }\n        }\n      }\n      @else {\n        @media (max-width: #{$mq-value}) {\n          @if $rfs-class == \"enable\" {\n            .enable-responsive-font-size &,\n            &.enable-responsive-font-size {\n              font-size: $rfs-fluid;\n            }\n          }\n          @else {\n            font-size: $rfs-fluid;\n          }\n\n          @if $rfs-safari-iframe-resize-bug-fix {\n            // stylelint-disable-next-line length-zero-no-unit\n            min-width: 0vw;\n          }\n        }\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixin uses RFS to rescale font sizes\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","@mixin ltr {\n  @if $enable-ltr {\n    @if & {\n      & {\n        html:not([dir=\"rtl\"]) & {\n          @content;\n        }\n      }\n    }\n    @else {\n      html:not([dir=\"rtl\"]) {\n        @content;\n      }\n    }\n  }\n}\n","@mixin rtl {\n  @if $enable-rtl {\n    @if & {\n      & {\n        *[dir=\"rtl\"] & {\n          @content;\n        }\n      }\n    }\n    @else {\n      *[dir=\"rtl\"] {\n        @content;\n      }\n    }\n  }\n}\n","// Links\n//\n// Style anchor elements.\n// scss-docs-start link\n$link-decoration:                          none !default;\n$link-hover-decoration:                    underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage:  15% !default;\n// scss-docs-end link\n\n// scss-docs-start link-default-theme\n$link-color:                               theme-color(\"primary\") !default;\n$link-hover-color:                         darken($link-color, 15%) !default;\n// scss-docs-end link-default-theme\n\n$link-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$link-theme-map: map-merge(\n  (\n    default: (\n      \"link-color\":        $link-color,\n      \"link-hover-color\":  $link-hover-color\n    )\n  ),\n  $link-theme-map\n);\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  @media (hover: hover), (-ms-high-contrast: none) {\n    &:hover { @content; }\n  }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n// scss-docs-start table\n$table-cell-padding:      .75rem !default;\n$table-cell-padding-sm:   .3rem !default;\n\n$table-border-width:  $border-width !default;\n\n$table-striped-order:  odd !default;\n\n$table-caption-color:  $text-muted !default;\n\n$table-bg-level:     -9 !default;\n$table-border-level: -6 !default;\n// scss-docs-end table\n\n// Default Theme\n// scss-docs-start table-default-theme\n$table-color:         $body-color !default;\n$table-bg:            null !default;\n$table-accent-bg:     rgba($black, .05) !default;\n$table-hover-color:   $table-color !default;\n$table-hover-bg:      rgba($black, .075) !default;\n$table-active-bg:     $gray-200 !default;\n$table-border-color:  $border-color !default;\n$table-head-bg:       $gray-200 !default;\n$table-head-color:    $gray-700 !default;\n\n$table-dark-color:         $white !default;\n$table-dark-bg:            $gray-800 !default;\n$table-dark-accent-bg:     rgba($white, .05) !default;\n$table-dark-hover-color:   $table-dark-color !default;\n$table-dark-hover-bg:      rgba($white, .075) !default;\n$table-dark-border-color:  lighten($table-dark-bg, 7.5%) !default;\n// scss-docs-end table-default-theme\n\n$table-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$table-theme-map: map-merge(\n  (\n    default: (\n      \"table-color\":              $table-color,\n      \"table-bg\":                 $table-bg,\n      \"table-accent-bg\":          $table-accent-bg,\n      \"table-hover-color\":        $table-hover-color,\n      \"table-hover-bg\":           $table-hover-bg,\n      \"table-active-bg\":          $table-active-bg,\n      \"table-border-color\":       $table-border-color,\n      \"table-head-bg\":            $table-head-bg,\n      \"table-head-color\":         $table-head-color,\n      \"table-dark-color\":         $table-dark-color,\n      \"table-dark-bg\":            $table-dark-bg,\n      \"table-dark-accent-bg\":     $table-dark-accent-bg,\n      \"table-dark-hover-color\":   $table-dark-hover-color,\n      \"table-dark-hover-bg\":      $table-dark-hover-bg,\n      \"table-dark-border-color\":  $table-dark-border-color\n    )\n  ),\n  $table-theme-map\n);\n","// Buttons + Forms\n//\n// scss-docs-start buttons-forms\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:    .375rem !default;\n$input-btn-padding-x:    .75rem !default;\n$input-btn-font-family:  null !default;\n$input-btn-font-size:    $font-size-base !default;\n$input-btn-line-height:  $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:    .25rem !default;\n$input-btn-padding-x-sm:    .5rem !default;\n$input-btn-font-size-sm:    $font-size-sm !default;\n$input-btn-line-height-sm:  $line-height-sm !default;\n\n$input-btn-padding-y-lg:    .5rem !default;\n$input-btn-padding-x-lg:    1rem !default;\n$input-btn-font-size-lg:    $font-size-lg !default;\n$input-btn-line-height-lg:  $line-height-lg !default;\n\n$input-btn-border-width:  $border-width !default;\n// scss-docs-end buttons-forms\n\n\n// Buttons\n//\n// scss-docs-start buttons\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:    $input-btn-padding-y !default;\n$btn-padding-x:    $input-btn-padding-x !default;\n$btn-font-family:  $input-btn-font-family !default;\n$btn-font-size:    $input-btn-font-size !default;\n$btn-line-height:  $input-btn-line-height !default;\n$btn-white-space:  null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:    $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:    $input-btn-padding-x-sm !default;\n$btn-font-size-sm:    $input-btn-font-size-sm !default;\n$btn-line-height-sm:  $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:    $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:    $input-btn-padding-x-lg !default;\n$btn-font-size-lg:    $input-btn-font-size-lg !default;\n$btn-line-height-lg:  $input-btn-line-height-lg !default;\n\n$btn-border-width:  $input-btn-border-width !default;\n\n$btn-font-weight:        $font-weight-normal !default;\n$btn-box-shadow:         inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:        $input-btn-focus-width !default;\n$btn-focus-box-shadow:   $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:   .65 !default;\n$btn-active-box-shadow:  inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:  $gray-600 !default;\n\n$btn-block-spacing-y: .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:     $border-radius !default;\n$btn-border-radius-lg:  $border-radius-lg !default;\n$btn-border-radius-sm:  $border-radius-sm !default;\n\n$btn-transition:  color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end buttons\n\n// Forms\n\n// scss-docs-start forms\n$label-margin-bottom:  .5rem !default;\n\n$input-padding-y:    $input-btn-padding-y !default;\n$input-padding-x:    $input-btn-padding-x !default;\n$input-font-family:  $input-btn-font-family !default;\n$input-font-size:    $input-btn-font-size !default;\n$input-font-weight:  $font-weight-base !default;\n$input-line-height:  $input-btn-line-height !default;\n\n$input-padding-y-sm:    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:    $input-btn-padding-x-sm !default;\n$input-font-size-sm:    $input-btn-font-size-sm !default;\n$input-line-height-sm:  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:    $input-btn-padding-x-lg !default;\n$input-font-size-lg:    $input-btn-font-size-lg !default;\n$input-line-height-lg:  $input-btn-line-height-lg !default;\n\n$input-bg:           $white !default;\n$input-disabled-bg:  $gray-200 !default;\n\n$input-color:         $gray-700 !default;\n$input-border-color:  $gray-200 !default;\n$input-border-width:  $input-btn-border-width !default;\n$input-box-shadow:    inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:     $border-radius !default;\n$input-border-radius-lg:  $border-radius-lg !default;\n$input-border-radius-sm:  $border-radius-sm !default;\n\n$input-focus-bg:            $input-bg !default;\n$input-focus-border-color:  lighten($component-active-bg, 25%) !default;\n$input-focus-color:         $input-color !default;\n$input-focus-width:         $input-btn-focus-width !default;\n$input-focus-box-shadow:    $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:  $gray-600 !default;\n$input-plaintext-color:    $body-color !default;\n\n$input-height-border:  $input-border-width * 2 !default;\n\n$input-height-inner:          add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:     add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:  add($input-line-height * .25em, $input-padding-y / 2) !default;\n\n$input-height:     add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:  add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:  add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:  border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:  .25rem !default;\n\n$form-check-input-gutter:    1.25rem !default;\n$form-check-input-margin-y:  .3rem !default;\n$form-check-input-margin-x:  .25rem !default;\n\n$form-check-inline-margin-x:        .75rem !default;\n$form-check-inline-input-margin-x:  .3125rem !default;\n\n$form-grid-gutter-width:    10px !default;\n$form-group-margin-bottom:  1rem !default;\n\n$input-group-addon-color:         $input-color !default;\n$input-group-addon-bg:            $gray-100 !default;\n$input-group-addon-border-color:  $input-border-color !default;\n\n$select-option-bg: inherit !default;\n// scss-docs-end forms\n\n$form-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$form-theme-map: map-merge(\n  (\n    default: (\n      \"input-bg\":                        $input-bg,\n      \"input-disabled-bg\":               $input-disabled-bg,\n      \"input-color\":                     $input-color,\n      \"input-border-color\":              $input-border-color,\n      \"input-focus-bg\":                  $input-focus-bg,\n      \"input-focus-border-color\":        $input-focus-border-color,\n      \"input-focus-color\":               $input-focus-color,\n      \"input-placeholder-color\":         $input-placeholder-color,\n      \"input-plaintext-color\":           $input-plaintext-color,\n      \"input-group-addon-color\":         $input-group-addon-color,\n      \"input-group-addon-bg\":            $input-group-addon-bg,\n      \"input-group-addon-border-color\":  $input-group-addon-border-color,\n      \"select-option-bg\":                $select-option-bg\n    )\n  ),\n  $form-theme-map\n);\n\n// Form validation\n\n$form-feedback-margin-top:     $form-text-margin-top !default;\n$form-feedback-font-size:      $small-font-size !default;\n$form-feedback-valid-color:    theme-color(\"success\") !default;\n$form-feedback-invalid-color:  theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\":  $form-feedback-valid-color,\n      \"icon\":   $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\":  $form-feedback-invalid-color,\n      \"icon\":   $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n","// stylelint-disable declaration-no-important, property-no-vendor-prefix\n.ps {\n  overflow: hidden !important;\n  -ms-touch-action: auto;\n  touch-action: auto;\n  -ms-overflow-style: none;\n  overflow-anchor: none;\n}\n\n.ps__rail-x {\n  position: absolute;\n  bottom: 0;\n  display: none;\n  height: 15px;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n}\n\n.ps__rail-y {\n  position: absolute;\n  @include ltr {\n    right: 0;\n  }\n  @include rtl {\n    left: 0;\n  }\n  display: none;\n  width: 15px;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: .6;\n}\n\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus {\n  background-color: #eee;\n  opacity: .9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  position: absolute;\n  bottom: 2px;\n  height: 6px;\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, height .2s ease-in-out;\n}\n\n.ps__thumb-y {\n  position: absolute;\n  @include ltr {\n    right: 2px;\n  }\n  @include rtl {\n    left: 2px;\n  }\n  width: 6px;\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, width .2s ease-in-out;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x {\n  height: 11px;\n  background-color: #999;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y {\n  width: 11px;\n  background-color: #999;\n}\n\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n","@import '../_vars.scss';\n\n.#{$namespace-prefix}-box {\n  &[data-animation='fade'][data-state='hidden'] {\n    opacity: 0;\n  }\n}\n",".#{$namespace-prefix}-box[data-theme~='cpopover'] {\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  @include reset-text();\n  @include font-size($popover-font-size);\n  word-wrap: break-word;\n  background-clip: padding-box;\n  border: $popover-border-width solid;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  @include themes($popover-theme-map) {\n    background-color: themes-get-value(\"popover-bg\");\n    border-color: themes-get-value(\"popover-border-color\");\n  }\n\n  >.#{$namespace-prefix}-content {\n    max-width: auto;\n    padding: 0;\n    color: initial;\n    text-align: initial;\n    background-color: initial;\n    border-radius: initial;\n  }\n\n  >.#{$namespace-prefix}-arrow {\n    position: absolute;\n    display: block;\n    color: transparent;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n\n  // .#{$namespace-prefix}-arrow {\n  //   @include themes($popover-theme-map) {\n  //     border-color: themes-get-value(\"popover-arrow-outer-color\");\n  //     color: themes-get-value(\"popover-arrow-color\");\n  //   }\n\n  //   &::after {\n  //     content: '';\n  //     z-index: -1;\n  //     position: absolute;\n  //     border-color: transparent;\n  //     border-style: solid;\n  //     border-width: 8px;\n  //   }\n  // }\n\n  &[data-placement^='top'],\n  &[data-placement^='bottom'] {\n    > .#{$namespace-prefix}-arrow {\n      width: add($popover-arrow-width, (2 * $popover-border-radius));\n      height: $popover-arrow-height;\n      padding: 0 $popover-border-radius; // make sure the arrow does not touch the popover's rounded corners\n\n      &::before {\n        left: auto;\n      }\n    }\n  }\n\n  &[data-placement^='right'],\n  &[data-placement^='left'] {\n    > .#{$namespace-prefix}-arrow {\n      width: $popover-arrow-height;\n      height: add($popover-arrow-width, (2 * $popover-border-radius));\n      padding: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n      margin: 0;\n    }\n  }\n\n\n  &[data-placement^='top'] {\n\n    > .#{$namespace-prefix}-arrow {\n      bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n      &::before {\n        bottom: 0;\n        border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n        @include themes($popover-theme-map) {\n          border-top-color: themes-get-value(\"popover-arrow-outer-color\");\n        }\n      }\n\n      &::after {\n        bottom: $popover-border-width;\n        border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n        @include themes($popover-theme-map) {\n          border-top-color: themes-get-value(\"popover-arrow-color\");\n        }\n      }\n    }\n  }\n\n  &[data-placement^='bottom'] {\n\n    > .#{$namespace-prefix}-arrow {\n      top: subtract(-$popover-arrow-height, $popover-border-width);\n\n      &::before {\n        top: 0;\n        border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n        @include themes($popover-theme-map) {\n          border-bottom-color: themes-get-value(\"popover-arrow-outer-color\");\n        }\n      }\n\n      &::after {\n        top: $popover-border-width;\n        border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n        @include themes($popover-theme-map) {\n          border-bottom-color: themes-get-value(\"popover-arrow-color\");\n        }\n      }\n    }\n  }\n\n  &[data-placement^='left'] {\n\n    > .#{$namespace-prefix}-arrow {\n      right: subtract(-$popover-arrow-height, $popover-border-width);\n\n      &::before {\n        right: 0;\n        border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n        @include themes($popover-theme-map) {\n          border-left-color: themes-get-value(\"popover-arrow-outer-color\");\n        }\n      }\n\n      &::after {\n        right: $popover-border-width;\n        border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n        @include themes($popover-theme-map) {\n          border-left-color: themes-get-value(\"popover-arrow-color\");\n        }\n      }\n    }\n  }\n\n\n  &[data-placement^='right'] {\n\n    > .#{$namespace-prefix}-arrow {\n      left: subtract(-$popover-arrow-height, $popover-border-width);\n\n      &::before {\n        left: 0;\n        border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n        @include themes($popover-theme-map) {\n          border-right-color: themes-get-value(\"popover-arrow-outer-color\");\n        }\n      }\n\n      &::after {\n        left: $popover-border-width;\n        border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n        @include themes($popover-theme-map) {\n          border-right-color: themes-get-value(\"popover-arrow-color\");\n        }\n      }\n    }\n  }\n}\n","// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:        1000 !default;\n$zindex-sticky:          1020 !default;\n$zindex-fixed:           1030 !default;\n$zindex-modal-backdrop:  1040 !default;\n$zindex-modal:           1050 !default;\n$zindex-popover:         1060 !default;\n$zindex-tooltip:         1070 !default;\n$zindex-toaster:         1080 !default;\n// scss-docs-end zindex-stack\n","// Popovers\n\n// scss-docs-start popover\n$popover-font-size:     $font-size-sm !default;\n$popover-max-width:     276px !default;\n$popover-border-width:  $border-width !default;\n\n$popover-border-radius:        $border-radius-lg !default;\n$popover-inner-border-radius:  subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:           0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-padding-y:  .5rem !default;\n$popover-header-padding-x:  .75rem !default;\n\n$popover-body-padding-y:  $popover-header-padding-y !default;\n$popover-body-padding-x:  $popover-header-padding-x !default;\n\n$popover-arrow-width:   1rem !default;\n$popover-arrow-height:  .5rem !default;\n// scss-docs-end popover\n\n\n// Default Theme\n// scss-docs-start popover-default-theme\n$popover-bg:                 $white !default;\n$popover-border-color:       rgba($black, .2) !default;\n$popover-header-bg:          darken($popover-bg, 3%) !default;\n$popover-header-color:       $headings-color !default;\n$popover-body-color:         $body-color !default;\n$popover-arrow-color:        $popover-bg !default;\n$popover-arrow-outer-color:  fade-in($popover-border-color, .05) !default;\n// scss-docs-end popover-default-theme\n\n$popover-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$popover-theme-map: map-merge(\n  (\n    default: (\n      \"popover-bg\":                 $popover-bg,\n      \"popover-border-color\":       $popover-border-color,\n      \"popover-header-bg\":          $popover-header-bg,\n      \"popover-header-color\":       $popover-header-color,\n      \"popover-body-color\":         $popover-body-color,\n      \"popover-arrow-color\":        $popover-arrow-color,\n      \"popover-arrow-outer-color\":  $popover-arrow-outer-color\n    )\n  ),\n  $popover-theme-map\n);\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n}\n","// stylelint-disable property-blacklist\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:  1.5 !default;\n$line-height-sm:  1.5 !default;\n\n$border-width:  1px !default;\n$border-color:  $gray-200 !default;\n\n$border-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$border-theme-map: map-merge(\n  (\n    default: (\n      \"border-color\": $border-color\n    )\n  ),\n  $border-theme-map\n);\n\n$border-radius:     .25rem !default;\n$border-radius-lg:  .3rem !default;\n$border-radius-sm:  .2rem !default;\n\n$rounded-pill:  50rem !default;\n\n$box-shadow-sm:  0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:     0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:  0 1rem 3rem rgba($black, .175) !default;\n\n$component-color:  $body-color !default;\n$component-bg:     $white !default;\n\n$component-active-color:  $white !default;\n$component-active-bg:     theme-color(\"primary\") !default;\n\n$caret-width:           .3em !default;\n$caret-vertical-align:  $caret-width * .85 !default;\n$caret-spacing:         $caret-width * .85 !default;\n\n$transition-base:      all .2s ease-in-out !default;\n$transition-fade:      opacity .15s linear !default;\n$transition-collapse:  height .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Hugo Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n@function color-yiq($color, $dark: $yiq-text-dark, $light: $yiq-text-light) {\n  $r: red($color);\n  $g: green($color);\n  $b: blue($color);\n\n  $yiq: (($r * 299) + ($g * 587) + ($b * 114)) / 1000;\n\n  @if ($yiq >= $yiq-contrasted-threshold) {\n    @return $dark;\n  } @else {\n    @return $light;\n  }\n}\n\n// Retrieve color Sass maps\n@function color($key: \"blue\") {\n  @return map-get($colors, $key);\n}\n\n@function theme-color($key: \"primary\") {\n  @return map-get($theme-colors, $key);\n}\n\n@function gray($key: \"100\") {\n  @return map-get($grays, $key);\n}\n\n// Request a theme color level\n// @function theme-color-level($color-name: \"primary\", $level: 0) {\n//   $color: theme-color($color-name);\n//   $color-base: if($level > 0, $black, $white);\n//   $level: abs($level);\n\n//   @return mix($color-base, $color, $level * $theme-color-interval);\n// }\n\n// scss-docs-start color-level\n@function theme-color-level($color, $level: 0) {\n  $color-base: if($level > 0, $black, $white);\n  $level: abs($level);\n\n  @return mix($color-base, $color, $level * $theme-color-interval);\n}\n// scss-docs-end color-level\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n","@import './_vars.scss';\n@import './animations/fade.scss';\n@import './../../variables';\n@import './popover.scss';\n\n.#{$namespace-prefix}-iOS {\n  cursor: pointer !important;\n  -webkit-tap-highlight-color: transparent;\n}\n\n[data-#{$namespace-prefix}-root] {\n  max-width: calc(100vw - 10px);\n}\n\n.#{$namespace-prefix}-box {\n  position: relative;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // background-color: $color;\n  // color: white;\n  // border-radius: 4px;\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  word-wrap: break-word;\n  outline: 0;\n  transition-property: transform, visibility, opacity;\n\n  &[data-placement^='top'] > .#{$namespace-prefix}-arrow {\n    bottom: 0;\n\n    &::before {\n      bottom: - $tooltip-arrow-height;\n      left: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-top-color: initial;\n    }\n  }\n\n  &[data-placement^='bottom'] > .#{$namespace-prefix}-arrow {\n    top: 0;\n\n    &::before {\n      top: - $tooltip-arrow-height;\n      left: 0;\n      border-width: 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-bottom-color: initial;\n    }\n  }\n\n  &[data-placement^='left'] > .#{$namespace-prefix}-arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: - $tooltip-arrow-height;\n      border-width: ($tooltip-arrow-width / 2) 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-left-color: initial;\n    }\n  }\n\n  &[data-placement^='right'] > .#{$namespace-prefix}-arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: - $tooltip-arrow-height;\n      border-width: ($tooltip-arrow-width / 2) $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-right-color: initial;\n    }\n  }\n\n  &[data-inertia][data-state='visible'] {\n    transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11);\n  }\n}\n\n.#{$namespace-prefix}-arrow {\n  position: absolute;\n  display: block;\n  width: $tooltip-arrow-width;\n  height: $tooltip-arrow-height;\n  color: $tooltip-arrow-color;\n\n  &::before {\n    position: absolute;\n    display: block;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n  }\n}\n\n.#{$namespace-prefix}-content {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","// Tooltips\n\n$tooltip-font-size:      $font-size-sm !default;\n$tooltip-max-width:      200px !default;\n$tooltip-color:          $white !default;\n$tooltip-bg:             $black !default;\n$tooltip-border-radius:  $border-radius !default;\n$tooltip-opacity:        .9 !default;\n$tooltip-padding-y:      .25rem !default;\n$tooltip-padding-x:      .5rem !default;\n$tooltip-margin:         0 !default;\n\n$tooltip-arrow-width:    .8rem !default;\n$tooltip-arrow-height:   .4rem !default;\n$tooltip-arrow-color:    $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:      $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:      $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:      $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:    $line-height-base !default;\n$form-feedback-tooltip-opacity:        $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius:  $tooltip-border-radius !default;\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  @include ltr {\n    padding-right: $close-font-size + $alert-padding-x * 2;\n  }\n  @include rtl {\n    padding-left: $close-font-size + $alert-padding-x * 2;\n  }\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    @include ltr {\n      right: 0;\n    }\n    @include rtl {\n      left: 0;\n    }\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@include theme-variant() {\n  .alert-#{$color} {\n    @include alert-variant( theme-color-level($value, $alert-bg-level),  theme-color-level($value, $alert-border-level),  theme-color-level($value, $alert-color-level));\n  }\n}\n// scss-docs-end alert-modifiers\n","\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert\n$alert-padding-y:         .75rem !default;\n$alert-padding-x:         1.25rem !default;\n$alert-margin-bottom:     1rem !default;\n$alert-border-radius:     $border-radius !default;\n$alert-link-font-weight:  $font-weight-bold !default;\n$alert-border-width:      $border-width !default;\n\n$alert-bg-level:          -10 !default;\n$alert-border-level:      -9 !default;\n$alert-color-level:       6 !default;\n// scss-docs-end alert\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n",".c-avatar {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50em;\n  @include avatar($avatar-width,$avatar-status-width);\n}\n\n.c-avatar-img {\n  width: 100%;\n  height: auto;\n  border-radius: 50em;\n}\n\n.c-avatar-status {\n  position: absolute;\n  bottom: 0;\n  display: block;\n  border: 1px solid $white;\n  border-radius: 50em;\n\n  @include ltr {\n    right: 0;\n  }\n  @include rtl {\n    left: 0;\n  }\n}\n\n.c-avatar-sm {\n  @include avatar($avatar-sm-width,$avatar-sm-status-width);\n}\n\n.c-avatar-lg {\n  @include avatar($avatar-lg-width,$avatar-lg-status-width);\n}\n\n.c-avatar-xl {\n  @include avatar($avatar-xl-width,$avatar-xl-status-width);\n}\n\n.c-avatars-stack {\n  display: flex;\n\n  .c-avatar {\n    margin-right: - ($avatar-width / 2);\n    transition: margin-right $layout-transition-speed;\n\n    &:hover {\n      margin-right: 0;\n    }\n  }\n\n  .c-avatar-sm {\n    margin-right: - ($avatar-sm-width / 2);\n  }\n\n  .c-avatar-lg {\n    margin-right: - ($avatar-lg-width / 2);\n  }\n\n  .c-avatar-xl {\n    margin-right: - ($avatar-xl-width / 2);\n  }\n}\n\n.c-avatar-rounded {\n  border-radius: $border-radius;\n}\n\n.c-avatar-square {\n  border-radius: 0;\n}\n","@mixin avatar($width, $status-width) {\n  width: $width;\n  height: $width;\n  font-size: $width / 2.5;\n\n  .c-avatar-status {\n    width: $status-width;\n    height: $status-width;\n  }\n}\n","// Avatars\n// scss-docs-start avatars\n$avatar-sm-width:         24px !default;\n$avatar-sm-status-width:  8px !default;\n\n$avatar-width:            36px !default;\n$avatar-status-width:     10px !default;\n\n$avatar-lg-width:         48px !default;\n$avatar-lg-status-width:  12px !default;\n\n$avatar-xl-width:         64px !default;\n$avatar-xl-status-width:  14px !default;\n// scss-docs-end avatars\n","\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$theme-suffix:                               -theme !default;\n$mobile-breakpoint:                          lg !default;\n$enable-ltr:                                 true !default;\n$enable-rtl:                                 true !default;\n$enable-caret:                               true !default;\n$enable-rounded:                             true !default;\n$enable-shadows:                             false !default;\n$enable-gradients:                           false !default;\n$enable-transitions:                         true !default;\n$enable-prefers-reduced-motion-media-query:  true !default;\n$enable-hover-media-query:                   false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                        true !default;\n$enable-pointer-cursor-for-buttons:          true !default;\n$enable-print-styles:                        true !default;\n$enable-responsive-font-sizes:               false !default;\n$enable-validation-icons:                    true !default;\n$enable-deprecation-messages:                false !default;\n$enable-sidebar-nav-rounded:                 false !default;\n$layout-transition-speed:                    .3s !default;\n$enable-elevations:                          true !default;\n$enable-prefers-color-scheme:                false !default;\n\n$options: () !default;\n\n$default-themes: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$default-themes: map-merge(\n  (\n    default: (\n      \"default\":       true,\n      \"theme-colors\":  $theme-colors,\n      \"grays\":         $grays,\n      \"gradients\":     $theme-gradients\n    )\n  ),\n  $default-themes\n);\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@include theme-variant() {\n  .badge-#{$color} {\n    @include badge-variant($value, $color);\n  }\n}\n","\n// Badges\n\n// scss-docs-start badges\n$badge-font-size:      75% !default;\n$badge-font-weight:    $font-weight-bold !default;\n$badge-padding-y:      .25em !default;\n$badge-padding-x:      .4em !default;\n$badge-border-radius:  $border-radius !default;\n\n$badge-transition:   $btn-transition !default;\n$badge-focus-width:  $input-btn-focus-width !default;\n\n$badge-pill-padding-x:  .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:  10rem !default;\n// scss-docs-end badges\n\n","// stylelint-disable property-blacklist\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","@mixin badge-variant($bg, $color) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root #{str-replace(#{&}, \".badge-#{$color}\", \" \")} a.badge-#{$color} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".breadcrumb-menu {\n  @include ltr {\n    margin-left: auto;\n  }\n  @include ltr {\n    margin-right: auto;\n  }\n\n\n  &::before {\n    display: none;\n  }\n\n  .btn-group {\n    vertical-align: top;\n  }\n\n  .btn {\n    padding: 0 $input-btn-padding-x;\n    vertical-align: top;\n    border: 0;\n\n    &:hover,\n    &.active {\n      color: $body-color;\n      background: transparent;\n    }\n    @include themes($typography-theme-map, $create: parent) {\n      color: themes-get-value(\"text-muted\");\n    }\n  }\n\n  .show {\n    .btn {\n      color: $body-color;\n      background: transparent;\n    }\n  }\n\n  .dropdown-menu {\n    min-width: 180px;\n    line-height: $line-height-base;\n  }\n}\n","//\n// Base styles\n//\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  @include border-radius($breadcrumb-border-radius);\n  @include borders($breadcrumb-borders);\n\n  @include themes($breadcrumb-theme-map, $create: parent) {\n    background-color: themes-get-value(\"breadcrumb-bg\");\n    border-color: themes-get-value(\"breadcrumb-border-color\");\n  }\n}\n\n.breadcrumb-item {\n  display: flex;\n\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    @include ltr {\n      padding-left: $breadcrumb-item-padding;\n    }\n    @include rtl {\n      padding-right: $breadcrumb-item-padding;\n    }\n\n    &::before {\n      display: inline-block; // Suppress underlining of the separator in modern browsers\n      @include themes($breadcrumb-theme-map, $create: parent) {\n        color: themes-get-value(\"breadcrumb-divider-color\");\n      }\n      content: escape-svg($breadcrumb-divider);\n      @include ltr {\n        padding-right: $breadcrumb-item-padding;\n      }\n      @include rtl {\n        padding-left: $breadcrumb-item-padding;\n      }\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    @include themes($breadcrumb-theme-map, $create: parent) {\n      color: themes-get-value(\"breadcrumb-active-color\");\n    }\n  }\n}\n","// Breadcrumbs\n\n// scss-docs-start breadcrumb\n$breadcrumb-font-size:     null !default;\n$breadcrumb-padding-y:     .75rem !default;\n$breadcrumb-padding-x:     1rem !default;\n$breadcrumb-item-padding:  .5rem !default;\n\n$breadcrumb-margin-bottom:  1.5rem !default;\n\n$breadcrumb-divider:  quote(\"/\") !default;\n\n$breadcrumb-border-radius:  0 !default;\n\n$breadcrumb-borders:  ( bottom: 1px solid ) !default;\n// scss-docs-end breadcrumb\n\n// Default theme\n// scss-docs-start breadcrumb-default-theme\n$breadcrumb-bg:             transparent !default;\n$breadcrumb-border-color:   $border-color !default;\n$breadcrumb-divider-color:  $gray-600 !default;\n$breadcrumb-active-color:   $gray-600 !default;\n// scss-docs-end breadcrumb-default-theme\n\n$breadcrumb-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$breadcrumb-theme-map: map-merge(\n  (\n    default: (\n      \"breadcrumb-bg\":             $breadcrumb-bg,\n      \"breadcrumb-border-color\":   $breadcrumb-border-color,\n      \"breadcrumb-divider-color\":  $breadcrumb-divider-color,\n      \"breadcrumb-active-color\":   $breadcrumb-active-color\n    )\n  ),\n  $breadcrumb-theme-map\n);\n","@mixin borders($borders, $reverse: false) {\n  @each $border in $borders {\n    $direction: nth($border, 1);\n    @if $direction == \"all\" {\n      border: map-get($borders, $direction);\n    } @else if $direction == \"top\" {\n      border-top: map-get($borders, $direction);\n    } @else if $direction == \"right\" {\n      @if $reverse {\n        border-right: 0;\n        border-left: map-get($borders, $direction);\n      } @else {\n        border-right: map-get($borders, $direction);\n      }\n    } @else if $direction == \"bottom\" {\n      border-bottom: map-get($borders, $direction);\n    } @else if $direction == \"left\" {\n      border-left: map-get($borders, $direction);\n      @if $reverse {\n        border-right: map-get($borders, $direction);\n        border-left: 0;\n      } @else {\n        border-left: map-get($borders, $direction);\n      }\n    }\n  }\n}\n\n@mixin borders-shadow($borders, $reverse: false) {\n  @each $border in $borders {\n    $direction: nth($border, 1);\n    @if $direction == \"all\" {\n      $size: map-get(map-get($borders, $direction), size);\n      $color: map-get(map-get($borders, $direction), color);\n      box-shadow: $size $style $color inset;\n    } @else if $direction == \"top\" {\n      $size: map-get(map-get($borders, $direction), size);\n      $color: map-get(map-get($borders, $direction), color);\n      box-shadow: 0 - $size $size - $size $color inset;\n    } @else if $direction == \"right\" {\n      $size: map-get(map-get($borders, $direction), size);\n      $color: map-get(map-get($borders, $direction), color);\n      @if $reverse {\n        box-shadow: $size 0 $size - $size $color inset;\n      } @else {\n        box-shadow: - $size 0 $size - $size $color inset;\n      }\n    } @else if $direction == \"bottom\" {\n      $size: map-get(map-get($borders, $direction), size);\n      $color: map-get(map-get($borders, $direction), color);\n      box-shadow: 0 $size $size - $size $color inset;\n    } @else if $direction == \"left\" {\n      $size: map-get(map-get($borders, $direction), size);\n      $color: map-get(map-get($borders, $direction), color);\n      box-shadow: $size 0 $size - $size $color inset;\n      @if $reverse {\n        box-shadow: - $size 0 $size - $size $color inset;\n      } @else {\n        box-shadow: $size 0 $size - $size $color inset;\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    @include ltr {\n      margin-left: -$btn-border-width;\n    }\n    @include rtl {\n      margin-right: -$btn-border-width;\n    }\n  }\n\n  // Reset rounded corners\n  @include ltr {\n    > .btn:not(:last-child):not(.dropdown-toggle),\n    > .btn-group:not(:last-child) > .btn {\n      @include border-right-radius(0);\n    }\n\n    > .btn:not(:first-child),\n    > .btn-group:not(:first-child) > .btn {\n      @include border-left-radius(0);\n    }\n  }\n\n  @include rtl {\n    > .btn:not(:last-child):not(.dropdown-toggle),\n    > .btn-group:not(:last-child) > .btn {\n      @include border-left-radius(0);\n    }\n\n    > .btn:not(:first-child),\n    > .btn-group:not(:first-child) > .btn {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    @include ltr {\n      margin-left: 0;\n    }\n    @include rtl {\n      margin-right: 0;\n    }\n  }\n\n  .dropleft &::before {\n    @include ltr {\n      margin-right: 0;\n    }\n    @include rtl {\n      margin-left: 0;\n    }\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n\n  i,\n  .c-icon {\n    height: $btn-font-size;\n    margin: ((($font-size-base * $line-height-base) - $font-size-base) / 2) 0;\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@include theme-variant() {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n.btn-transparent {\n  color: rgba(255, 255, 255, .8);\n\n  &:hover {\n    color: rgba(255, 255, 255, 1);\n  }\n}\n\n@include theme-variant() {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n\n.btn-pill {\n  border-radius: 50em;\n}\n\n.btn-square {\n  border-radius: 0;\n}\n\n//\n// Ghost button\n//\n\n@include theme-variant() {\n  .btn-ghost-#{$color} {\n    @include button-ghost-variant($value);\n  }\n}\n\n//\n// Brand button\n//\n\n@each $color, $value in $brands-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n// @each $color, $value in $brands-colors {\n//   .btn-outline-#{$color} {\n//     @include button-outline-variant($value);\n//   }\n// }\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n  &:not(:disabled):not(.disabled):active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n  @at-root #{str-replace(#{&}, \".btn-\", \".show > .btn-\")}.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n  @at-root #{str-replace(#{&}, \".btn-\", \".show > .btn-\")}.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n\n  i,\n  .c-icon {\n    width: $font-size;\n    height: $font-size;\n    margin: ((($font-size * $line-height) - $font-size) / 2) 0;\n  }\n}\n\n// Button Ghost\n\n@mixin button-ghost-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  background-color: transparent;\n  background-image: none;\n  border-color: transparent;\n\n  &:hover {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n    border-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n  @at-root #{str-replace(#{&}, \".btn-\", \".show > .btn-\")}.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n","\n// Brand Colors\n\n$facebook:        #3b5998 !default;\n$twitter:         #00aced !default;\n$linkedin:        #4875b4 !default;\n$flickr:          #ff0084 !default;\n$tumblr:          #32506d !default;\n$xing:            #026466 !default;\n$github:          #4183c4 !default;\n$stack-overflow:  #fe7a15 !default;\n$youtube:         #b00 !default;\n$dribbble:        #ea4c89 !default;\n$instagram:       #517fa4 !default;\n$pinterest:       #cb2027 !default;\n$vk:              #45668e !default;\n$yahoo:           #400191 !default;\n$behance:         #1769ff !default;\n$reddit:          #ff4500 !default;\n$vimeo:           #aad450 !default;\n\n$brands-colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$brands-colors: map-merge(\n  (\n    \"facebook\":        $facebook,\n    \"twitter\":         $twitter,\n    \"linkedin\":        $linkedin,\n    \"flickr\":          $flickr,\n    \"tumblr\":          $tumblr,\n    \"xing\":            $xing,\n    \"github\":          $github,\n    \"stack-overflow\":  $stack-overflow,\n    \"youtube\":         $youtube,\n    \"dribbble\":        $dribbble,\n    \"instagram\":       $instagram,\n    \"pinterest\":       $pinterest,\n    \"vk\":              $vk,\n    \"yahoo\":           $yahoo,\n    \"behance\":         $behance,\n    \"reddit\":          $reddit,\n    \"vimeo\":           $vimeo\n  ),\n  $brands-colors\n);\n","//\n// Base styles\n//\n\n.c-callout {\n  position: relative;\n  padding: 0 $spacer;\n  margin: $spacer 0;\n\n  @include ltr {\n    border-left: 4px solid $border-color;\n  }\n  @include rtl {\n    border-right: 4px solid $border-color;\n  }\n\n  @if $enable-rounded {\n    border-radius: $border-radius;\n  }\n}\n\n.c-callout-bordered {\n  border: 1px solid $border-color;\n  border-left-width: 4px;\n}\n.c-callout code {\n  border-radius: $border-radius;\n}\n.c-callout h4 {\n  margin-top: 0;\n  margin-bottom: .25rem;\n}\n.c-callout p:last-child {\n  margin-bottom: 0;\n}\n.c-callout + .c-callout {\n  margin-top: - .25rem;\n}\n\n//\n// Variants\n//\n\n@include theme-variant() {\n  .c-callout-#{$color} {\n    @include ltr {\n      border-left-color: $value;\n    }\n    @include rtl {\n      border-right-color: $value;\n    }\n\n    h4 {\n      color: $value;\n    }\n  }\n}\n","\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer:  1rem !default;\n$spacers:  () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$spacers: map-merge(\n  (\n    0:  0,\n    1:  ($spacer * .25),\n    2:  ($spacer * .5),\n    3:  $spacer,\n    4:  ($spacer * 1.5),\n    5:  ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$sizes: map-merge(\n  (\n    25:    25%,\n    50:    50%,\n    75:    75%,\n    100:   100%,\n    auto:  auto\n  ),\n  $sizes\n);\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  margin-bottom: $card-margin-bottom;\n  word-wrap: break-word;\n  background-clip: border-box;\n  border: $card-border-width solid;\n  @include border-radius($card-border-radius);\n  @include themes($card-theme-map, $create: parent) {\n    background-color: themes-get-value(\"card-bg\");\n    border-color: themes-get-value(\"card-border-color\");\n  }\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  &.drag,\n  .drag {\n    cursor: move;\n  }\n}\n\n// Cards with color accent\n.card[class^=\"bg-\"],\n.card[class*=\" bg-\"] {\n  border-color: rgba(0, 0, 0, .125); //darken($value, 12.5%);\n  .card-header {\n    background-color: rgba(0, 0, 0, .05); //darken($value, 3%);\n    border-color: rgba(0, 0, 0, .125); //darken($value, 12.5%);\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  @include themes($card-theme-map, $create: parent) {\n    color: themes-get-value(\"card-color\");\n  }\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y / 2;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    @include ltr {\n      margin-left: $card-spacer-x;\n    }\n    @include rtl {\n      margin-right: $card-spacer-x;\n    }\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  border-bottom: $card-border-width solid;\n  @include themes($card-theme-map, $create: parent) {\n    color: themes-get-value(\"card-cap-color\");\n    background-color: themes-get-value(\"card-cap-bg\");\n    border-color: themes-get-value(\"card-border-color\");\n  }\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n\n  + .list-group {\n    .list-group-item:first-child {\n      border-top: 0;\n    }\n  }\n  .c-chart-wrapper {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  border-top: $card-border-width solid;\n  @include themes($card-theme-map, $create: parent) {\n    color: themes-get-value(\"card-cap-color\");\n    background-color: themes-get-value(\"card-cap-bg\");\n    border-color: themes-get-value(\"card-border-color\");\n  }\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x / 2;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x / 2;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x / 2;\n  margin-left: -$card-spacer-x / 2;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        @include ltr {\n          margin-left: 0;\n          border-left: 0;\n        }\n        @include rtl {\n          margin-right: 0;\n          border-right: 0;\n        }\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-blacklist\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-blacklist\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-blacklist\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-blacklist\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n\n.card-placeholder {\n  background: rgba($black, .025);\n  border: 1px dashed $gray-300;\n}\n\n.card-header-icon-bg {\n  display: inline-block;\n  width: ($card-spacer-y * 2) + ($font-size-base * $line-height-base);\n  padding: $card-spacer-y 0;\n  margin: (- $card-spacer-y) $card-spacer-x (- $card-spacer-y) (- $card-spacer-x);\n  line-height: inherit;\n  color: $card-icon-color;\n  text-align: center;\n  background: $card-icon-bg;\n  border-right: $card-border-width solid;\n  @include themes($card-theme-map, $create: parent) {\n    border-right: themes-get-value(\"card-border-color\");\n  }\n}\n\n.card-header-actions {\n  display: inline-block;\n\n  @include ltr {\n    float: right;\n    margin-right: - ($spacer / 4);\n  }\n  @include rtl {\n    float: left;\n    margin-left: - ($spacer / 4);\n  }\n}\n\n.card-header-action {\n  padding: 0 ($spacer / 4);\n  color: $gray-600;\n\n  &:hover {\n    color: $body-color;\n    text-decoration: none;\n  }\n}\n\n\n// Cards with color accent\n@include theme-variant() {\n  .card-accent-#{$color} {\n    @include card-accent-variant($value);\n  }\n}\n\n.card-full {\n  margin-top: - $spacer;\n  margin-right: - $grid-gutter-width / 2;\n  margin-left: - $grid-gutter-width / 2;\n  border: 0;\n  border-bottom: $card-border-width solid $border-color;\n}\n\n@include media-breakpoint-up(sm) {\n  .card-columns {\n\n    &.cols-2 {\n      column-count: 2;\n    }\n  }\n}\n","\n//\n// Cards\n//\n\n// scss-docs-start cards\n$card-spacer-y:             .75rem !default;\n$card-spacer-x:             1.25rem !default;\n$card-border-width:         $border-width !default;\n$card-border-radius:        $border-radius !default;\n$card-inner-border-radius:  subtract($card-border-radius, $card-border-width) !default;\n$card-margin-bottom:        $spacer * 1.5 !default;\n\n$card-img-overlay-padding:  1.25rem !default;\n\n$card-group-margin:  $grid-gutter-width / 2 !default;\n$card-deck-margin:   $card-group-margin !default;\n\n$card-columns-count:   3 !default;\n$card-columns-gap:     1.25rem !default;\n$card-columns-margin:  $card-spacer-y !default;\n\n$card-icon-bg:     transparent !default;\n$card-icon-color:  $body-color !default;\n// scss-docs-end cards\n\n// Default theme\n// scss-docs-start cards-default-theme\n$card-border-color:  $border-color !default;\n$card-cap-bg:        $white !default;\n$card-cap-color:     null !default;\n$card-height:        null !default;\n$card-color:         null !default;\n$card-bg:            $white !default;\n// scss-docs-end cards-default-theme\n\n$card-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$card-theme-map: map-merge(\n  (\n    default: (\n      \"card-border-color\":  $card-border-color,\n      \"card-cap-bg\":        $card-cap-bg,\n      \"card-cap-color\":     $card-cap-color,\n      \"card-color\":         $card-color,\n      \"card-bg\":            $card-bg\n    )\n  ),\n  $card-theme-map\n);\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Name of the previous breakpoint, or null for the first breakpoint.\n//\n//    >> breakpoint-before(lg)\n//    md\n//    >> breakpoint-next(lg, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(lg, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-before($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n - 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","@mixin card-accent-variant($color) {\n  // stylelint-disable-next-line declaration-no-important\n  border-top: 2px solid $color !important;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  color: $carousel-control-color;\n  text-align: center;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: no-repeat 50% / 100% 100%;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  @include ltr {\n    padding-left: 0; // override <ol> default\n  }\n  @include rtl {\n    padding-right: 0; // override <ol> default\n  }\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) / 2;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) / 2;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","// Carousel\n\n// scss-docs-start carousel\n$carousel-control-color:          $white !default;\n$carousel-control-width:          15% !default;\n$carousel-control-opacity:        .5 !default;\n$carousel-control-hover-opacity:  .9 !default;\n$carousel-control-transition:     opacity .15s ease !default;\n\n$carousel-indicator-width:            30px !default;\n$carousel-indicator-height:           3px !default;\n$carousel-indicator-hit-area-height:  10px !default;\n$carousel-indicator-spacer:           3px !default;\n$carousel-indicator-active-bg:        $white !default;\n$carousel-indicator-transition:       opacity .6s ease !default;\n\n$carousel-caption-width:  70% !default;\n$carousel-caption-color:  $white !default;\n\n$carousel-control-icon-width:  20px !default;\n\n$carousel-control-prev-icon-bg:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:  .6s !default;\n$carousel-transition:           transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel\n",".c-chart-wrapper canvas {\n  width: 100%;\n}\n// stylelint-disable selector-no-qualifying-type, selector-type-no-unknown\nbase-chart.chart {\n  display: block;\n}\n\ncanvas {\n  user-select: none;\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  opacity: .5;\n  @include themes($close-theme-map, $create: parent) {\n    color: themes-get-value(\"close-color\");\n    text-shadow: themes-get-value(\"close-text-shadow\");\n  }\n\n  // Override <a>'s hover style\n  @include hover() {\n    text-decoration: none;\n    @include themes($close-theme-map, $create: parent) {\n      color: themes-get-value(\"close-color\");\n    }\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","\n\n// Code\n\n$code-font-size:  87.5% !default;\n$code-color:      $pink !default;\n\n$kbd-padding-y:  .2rem !default;\n$kbd-padding-x:  .4rem !default;\n$kbd-font-size:  $code-font-size !default;\n$kbd-color:      $white !default;\n$kbd-bg:         $gray-900 !default;\n\n$pre-color:                  $gray-900 !default;\n$pre-scrollable-max-height:  340px !default;\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  @include ltr {\n    padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  }\n  @include rtl {\n    padding-right: $custom-control-gutter + $custom-control-indicator-size;\n  }\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  @include ltr {\n    left: 0;\n  }\n  @include rtl {\n    right: 0;\n  }\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) / 2;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n    @include themes($custom-forms-theme-map, $create: parent) {\n      color: themes-get-value(\"custom-control-indicator-checked-color\");\n      border-color: themes-get-value(\"custom-control-indicator-checked-border-color\");\n      @include gradient-bg(themes-get-value(\"custom-control-indicator-checked-bg\"));\n    }\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    @include themes($custom-forms-theme-map, $create: parent) {\n      border-color: themes-get-value(\"custom-control-indicator-focus-border-color\");\n    }\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    @include themes($custom-forms-theme-map, $create: parent) {\n      color: themes-get-value(\"custom-control-indicator-active-color\");\n      background-color: themes-get-value(\"custom-control-indicator-active-bg\");\n      border-color: themes-get-value(\"custom-control-indicator-active-border-color\");\n    }\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        color: themes-get-value(\"custom-control-label-disabled-color\");\n      }\n\n      &::before {\n        @include themes($custom-forms-theme-map, $create: parent) {\n          background-color: themes-get-value(\"custom-control-indicator-disabled-bg\");\n        }\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n  @include themes($custom-forms-theme-map, $create: parent) {\n    background-color: themes-get-value(\"custom-control-label-color\");\n  }\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) / 2;\n    @include ltr {\n      left: -($custom-control-gutter + $custom-control-indicator-size);\n    }\n    @include rtl {\n      right: -($custom-control-gutter + $custom-control-indicator-size);\n    }\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    border: solid $custom-control-indicator-border-width;\n    @include box-shadow($custom-control-indicator-box-shadow);\n    @include themes($custom-forms-theme-map, $create: parent) {\n      background-color: themes-get-value(\"custom-control-indicator-bg\");\n      border-color: themes-get-value(\"custom-control-indicator-border-color\");\n    }\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) / 2;\n    @include ltr {\n      left: -($custom-control-gutter + $custom-control-indicator-size);\n    }\n    @include rtl {\n      right: -($custom-control-gutter + $custom-control-indicator-size);\n    }\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: no-repeat 50% / #{$custom-control-indicator-bg-size};\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-image: escape-svg(themes-get-value(\"custom-checkbox-indicator-icon-checked\"));\n      }\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        border-color: themes-get-value(\"custom-checkbox-indicator-indeterminate-border-color\");\n      }\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-color: themes-get-value(\"custom-control-indicator-checked-disabled-bg\");\n      }\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-color: themes-get-value(\"custom-control-indicator-checked-disabled-bg\");\n      }\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-blacklist\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-image: escape-svg(themes-get-value(\"custom-radio-indicator-icon-checked\"));\n      }\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-color: themes-get-value(\"custom-control-indicator-checked-disabled-bg\");\n      }\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  @include ltr {\n    padding-left: $custom-switch-width + $custom-control-gutter;\n  }\n  @include rtl {\n    padding-right: $custom-switch-width + $custom-control-gutter;\n  }\n  .custom-control-label {\n    &::before {\n      @include ltr {\n        left: -($custom-switch-width + $custom-control-gutter);\n      }\n      @include rtl {\n        right: -($custom-switch-width + $custom-control-gutter);\n      }\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-blacklist\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) / 2, $custom-control-indicator-border-width * 2);\n      @include ltr {\n        left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      }\n      @include rtl {\n        right: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      }\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-blacklist\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-color: themes-get-value(\"custom-control-indicator-border-color\");\n      }\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-color: themes-get-value(\"custom-control-indicator-bg\");\n      }\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-color: themes-get-value(\"custom-control-indicator-checked-disabled-bg\");\n      }\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  vertical-align: middle;\n  border: $custom-select-border-width solid;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n  @include themes($custom-forms-theme-map, $create: parent) {\n    color: themes-get-value(\"custom-select-color\");\n    background: themes-get-value(\"custom-select-bg\") themes-get-value(\"custom-select-background\");\n    border-color: themes-get-value(\"custom-select-border-color\");\n  }\n\n  &:focus {\n    @include themes($custom-forms-theme-map, $create: parent) {\n      border-color: themes-get-value(\"custom-select-focus-border-color\");\n    }\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      @include themes($form-theme-map, $create: parent) {\n        color: themes-get-value(\"input-color\");\n        background-color: themes-get-value(\"input-bg\");\n      }\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    @include ltr {\n      padding-right: $custom-select-padding-x;\n    }\n    @include rtl {\n      padding-left: $custom-select-padding-x;\n    }\n    background-image: none;\n  }\n\n  &:disabled {\n    @include themes($custom-forms-theme-map, $create: parent) {\n      color: themes-get-value(\"custom-select-disabled-color\");\n      background-color: themes-get-value(\"custom-select-disabled-bg\");\n    }\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  @include ltr {\n    padding-left: $custom-select-padding-x-sm;\n  }\n  @include rtl {\n    padding-right: $custom-select-padding-x-sm;\n  }\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  @include ltr {\n    padding-left: $custom-select-padding-x-lg;\n  }\n  @include rtl {\n    padding-right: $custom-select-padding-x-lg;\n  }\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    box-shadow: $custom-file-focus-box-shadow;\n    @include themes($custom-forms-theme-map, $create: parent) {\n      border-color: themes-get-value(\"custom-file-focus-border-color\");\n    }\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    @include themes($custom-forms-theme-map, $create: parent) {\n      background-color: themes-get-value(\"custom-file-disabled-bg\");\n    }\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  border: $custom-file-border-width solid;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n  @include themes($custom-forms-theme-map, $create: parent) {\n    color: themes-get-value(\"custom-file-color\");\n    background-color: themes-get-value(\"custom-file-bg\");\n    border-color: themes-get-value(\"custom-file-border-color\");\n  }\n\n  &::after {\n    position: absolute;\n    top: 0;\n    @include ltr {\n      right: 0;\n    }\n    @include rtl {\n      left: 0;\n    }\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    content: \"Browse\";\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n    @include themes($custom-forms-theme-map, $create: parent) {\n      color: themes-get-value(\"custom-file-button-color\");\n      @include gradient-bg(themes-get-value(\"custom-file-button-bg\"));\n    }\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: none;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) / 2; // Webkit specific\n    @include themes($custom-forms-theme-map, $create: parent) {\n      @include gradient-bg(themes-get-value(\"custom-range-thumb-bg\"));\n    }\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        @include gradient-bg(themes-get-value(\"custom-range-thumb-active-bg\"));\n      }\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n    @include themes($custom-forms-theme-map, $create: parent) {\n      background-color: themes-get-value(\"custom-range-track-bg\");\n    }\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include themes($custom-forms-theme-map, $create: parent) {\n      @include gradient-bg(themes-get-value(\"custom-range-thumb-bg\"));\n    }\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        @include gradient-bg(themes-get-value(\"custom-range-thumb-active-bg\"));\n      }\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    @include themes($custom-forms-theme-map, $create: parent) {\n      background-color: themes-get-value(\"custom-range-track-bg\");\n    }\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include themes($custom-forms-theme-map, $create: parent) {\n      @include gradient-bg(themes-get-value(\"custom-range-thumb-bg\"));\n    }\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        @include gradient-bg(themes-get-value(\"custom-range-thumb-active-bg\"));\n      }\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height / 2;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    @include themes($custom-forms-theme-map, $create: parent) {\n      background-color: themes-get-value(\"custom-range-track-bg\");\n    }\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    @include themes($custom-forms-theme-map, $create: parent) {\n      background-color: themes-get-value(\"custom-range-track-bg\");\n    }\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-color: themes-get-value(\"custom-range-thumb-disabled-bg\");\n      }\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-color: themes-get-value(\"custom-range-thumb-disabled-bg\");\n      }\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      @include themes($custom-forms-theme-map, $create: parent) {\n        background-color: themes-get-value(\"custom-range-thumb-disabled-bg\");\n      }\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","$custom-forms-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:    .5rem !default;\n$custom-control-spacer-x:  1rem !default;\n$custom-control-cursor:    null !default;\n\n$custom-control-indicator-size:  1rem !default;\n\n$custom-control-indicator-bg-size:       50% 50% !default;\n$custom-control-indicator-box-shadow:    $input-box-shadow !default;\n$custom-control-indicator-border-width:  $input-border-width !default;\n\n$custom-control-label-color:  null !default;\n\n$custom-control-indicator-checked-box-shadow:    none !default;\n\n$custom-control-indicator-focus-box-shadow:    $input-focus-box-shadow !default;\n\n$custom-control-indicator-active-box-shadow:    none !default;\n\n$custom-checkbox-indicator-border-radius:  $border-radius !default;\n\n$custom-checkbox-indicator-indeterminate-box-shadow:    none !default;\n\n$custom-radio-indicator-border-radius:  50% !default;\n\n$custom-switch-width:                    $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:  $custom-control-indicator-size / 2 !default;\n$custom-switch-indicator-size:           subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:          $input-padding-y !default;\n$custom-select-padding-x:          $input-padding-x !default;\n$custom-select-font-family:        $input-font-family !default;\n$custom-select-font-size:          $input-font-size !default;\n$custom-select-height:             $input-height !default;\n$custom-select-indicator-padding:  1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:        $input-font-weight !default;\n$custom-select-line-height:        $input-line-height !default;\n\n$custom-select-bg-size:            8px 10px !default; // In pixels because image dimensions\n\n$custom-select-feedback-icon-padding-right:  add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:       center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:           $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:   $input-border-width !default;\n$custom-select-border-radius:  $border-radius !default;\n$custom-select-box-shadow:     inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:  $input-padding-y-sm !default;\n$custom-select-padding-x-sm:  $input-padding-x-sm !default;\n$custom-select-font-size-sm:  $input-font-size-sm !default;\n$custom-select-height-sm:     $input-height-sm !default;\n\n$custom-select-padding-y-lg:  $input-padding-y-lg !default;\n$custom-select-padding-x-lg:  $input-padding-x-lg !default;\n$custom-select-font-size-lg:  $input-font-size-lg !default;\n$custom-select-height-lg:     $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n\n$custom-file-height:              $input-height !default;\n$custom-file-height-inner:        $input-height-inner !default;\n$custom-file-focus-box-shadow:    $input-focus-box-shadow !default;\n\n$custom-file-padding-y:      $input-padding-y !default;\n$custom-file-padding-x:      $input-padding-x !default;\n$custom-file-line-height:    $input-line-height !default;\n$custom-file-font-family:    $input-font-family !default;\n$custom-file-font-weight:    $input-font-weight !default;\n\n$custom-file-border-width:   $input-border-width !default;\n\n$custom-file-border-radius:  $input-border-radius !default;\n$custom-file-box-shadow:     $input-box-shadow !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Default Theme\n\n$custom-control-indicator-bg:            $input-bg !default;\n$custom-control-indicator-border-color:  $gray-500 !default;\n$custom-control-indicator-disabled-bg:   $input-disabled-bg !default;\n\n$custom-control-label-disabled-color:  $gray-600 !default;\n\n$custom-control-indicator-checked-color:         $component-active-color !default;\n$custom-control-indicator-checked-bg:            $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:   rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-border-color:  $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-border-color:  $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-icon-checked:                url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-bg:            $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:         $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-indeterminate-border-color:  $custom-checkbox-indicator-indeterminate-bg !default;\n$custom-checkbox-indicator-icon-indeterminate:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n\n$custom-radio-indicator-icon-checked:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) no-repeat right $custom-select-padding-x center / $custom-select-bg-size !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n\n$custom-range-track-bg:           $gray-300 !default;\n$custom-range-thumb-bg:           $component-active-bg !default;\n$custom-range-thumb-active-bg:    lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:  $gray-500 !default;\n\n$custom-file-focus-border-color:  $input-focus-border-color !default;\n$custom-file-disabled-bg:         $input-disabled-bg !default;\n$custom-file-color:               $input-color !default;\n$custom-file-bg:                  $input-bg !default;\n$custom-file-border-color:        $input-border-color !default;\n$custom-file-button-color:        $custom-file-color !default;\n$custom-file-button-bg:           $input-group-addon-bg !default;\n\n\n$custom-forms-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$custom-forms-theme-map: map-merge(\n  (\n    default: (\n      \"custom-control-indicator-bg\":                           $custom-control-indicator-bg,\n      \"custom-control-indicator-border-color\":                 $custom-control-indicator-border-color,\n      \"custom-control-indicator-disabled-bg\":                  $custom-control-indicator-disabled-bg,\n      \"custom-control-label-disabled-color\":                   $custom-control-label-disabled-color,\n      \"custom-control-indicator-checked-color\":                $custom-control-indicator-checked-color,\n      \"custom-control-indicator-checked-bg\":                   $custom-control-indicator-checked-bg,\n      \"custom-control-indicator-checked-disabled-bg\":          $custom-control-indicator-checked-disabled-bg,\n      \"custom-control-indicator-checked-border-color\":         $custom-control-indicator-checked-border-color,\n      \"custom-control-indicator-focus-border-color\":           $custom-control-indicator-focus-border-color,\n      \"custom-control-indicator-active-color\":                 $custom-control-indicator-active-color,\n      \"custom-control-indicator-active-bg\":                    $custom-control-indicator-active-bg,\n      \"custom-control-indicator-active-border-color\":          $custom-control-indicator-active-border-color,\n      \"custom-checkbox-indicator-icon-checked\":                $custom-checkbox-indicator-icon-checked,\n      \"custom-checkbox-indicator-indeterminate-bg\":            $custom-checkbox-indicator-indeterminate-bg,\n      \"custom-checkbox-indicator-indeterminate-color\":         $custom-checkbox-indicator-indeterminate-color,\n      \"custom-checkbox-indicator-indeterminate-border-color\":  $custom-checkbox-indicator-indeterminate-border-color,\n      \"custom-checkbox-indicator-icon-indeterminate\":          $custom-checkbox-indicator-icon-indeterminate,\n      \"custom-radio-indicator-icon-checked\":                   $custom-radio-indicator-icon-checked,\n      \"custom-select-color\":                                   $custom-select-color,\n      \"custom-select-disabled-color\":                          $custom-select-disabled-color,\n      \"custom-select-bg\":                                      $custom-select-bg,\n      \"custom-select-disabled-bg\":                             $custom-select-disabled-bg,\n      \"custom-select-indicator-color\":                         $custom-select-indicator-color,\n      \"custom-select-indicator\":                               $custom-select-indicator,\n      \"custom-select-background\":                              $custom-select-background,\n      \"custom-select-border-color\":                            $custom-select-border-color,\n      \"custom-select-focus-border-color\":                      $custom-select-focus-border-color,\n      \"custom-range-track-bg\":                                 $custom-range-track-bg,\n      \"custom-range-thumb-bg\":                                 $custom-range-thumb-bg,\n      \"custom-range-thumb-active-bg\":                          $custom-range-thumb-active-bg,\n      \"custom-range-thumb-disabled-bg\":                        $custom-range-thumb-disabled-bg,\n      \"custom-file-focus-border-color\":                        $custom-file-focus-border-color,\n      \"custom-file-disabled-bg\":                               $custom-file-disabled-bg,\n      \"custom-file-color\":                                     $custom-file-color,\n      \"custom-file-bg\":                                        $custom-file-bg,\n      \"custom-file-border-color\":                              $custom-file-border-color,\n      \"custom-file-button-color\":                              $custom-file-button-color,\n      \"custom-file-button-bg\":                                 $custom-file-button-bg\n    )\n  ),\n  $custom-forms-theme-map\n);\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  // left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y 0;\n  @include font-size($dropdown-font-size);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n\n  @include themes($dropdown-theme-map, $create: parent) {\n    color: themes-get-value(\"dropdown-color\");\n    background-color: themes-get-value(\"dropdown-bg\");\n    border-color: themes-get-value(\"dropdown-border-color\");\n  }\n}\n\n.c-header .dropdown-menu,\n.navbar .dropdown-menu,\n[data-display^=\"static\"] ~ .dropdown-menu {\n  margin: $dropdown-spacer 0 0; // override default ul\n}\n\n// scss-docs-start responsive-breakpoints\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .c-header .dropdown-menu#{$infix}-left,\n    .navbar .dropdown-menu#{$infix}-left,\n    [data-display^=\"static\"] ~ .dropdown-menu#{$infix}-left {\n      @include ltr {\n        right: auto;\n        left: 0;\n      }\n      @include rtl {\n        right: 0;\n        left: auto;\n      }\n    }\n\n    .c-header .dropdown-menu#{$infix}-right,\n    .navbar .dropdown-menu#{$infix}-right,\n    [data-display^=\"static\"] ~ .dropdown-menu#{$infix}-right {\n      @include ltr {\n        right: 0;\n        left: auto;\n      }\n      @include rtl {\n        right: auto;\n        left: 0;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you\"re set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    margin-top: 0;\n    @include ltr {\n      right: auto;\n      left: 100%;\n      margin-left: $dropdown-spacer;\n    }\n    @include rtl {\n      right: 100%;\n      left: auto;\n      margin-right: $dropdown-spacer;\n    }\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    margin-top: 0;\n\n    @include ltr {\n      right: 100%;\n      left: auto;\n      margin-right: $dropdown-spacer;\n    }\n    @include rtl {\n      right: auto;\n      left: 100%;\n      margin-left: $dropdown-spacer;\n    }\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include themes($dropdown-theme-map, $create: parent) {\n    @include nav-divider(themes-get-value(\"dropdown-divider-bg\"), $dropdown-divider-margin-y, true);\n  }\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  @include themes($dropdown-theme-map, $create: parent) {\n    color: themes-get-value(\"dropdown-link-color\");\n  }\n\n  // Prevent dropdown overflow if there\"s no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    text-decoration: none;\n    // @include gradient-bg($dropdown-link-hover-bg);\n\n    @include themes($dropdown-theme-map, $create: parent) {\n      color: themes-get-value(\"dropdown-link-hover-color\");\n      @include gradient-bg(themes-get-value(\"dropdown-link-hover-bg\"));\n    }\n  }\n\n  &.active,\n  &:active {\n    text-decoration: none;\n    // @include gradient-bg($dropdown-link-active-bg);\n\n    @include themes($dropdown-theme-map, $create: parent) {\n      color: themes-get-value(\"dropdown-link-active-color\");\n      @include gradient-bg(themes-get-value(\"dropdown-link-active-bg\"));\n    }\n  }\n\n  &.disabled,\n  &:disabled {\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n\n    @include themes($dropdown-theme-map, $create: parent) {\n      color: themes-get-value(\"dropdown-link-disabled-color\");\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  white-space: nowrap; // as with > li > a\n  @include themes($dropdown-theme-map, $create: parent) {\n    color: themes-get-value(\"dropdown-header-color\");\n  }\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n\n  @include themes($dropdown-theme-map, $create: parent) {\n    color: themes-get-value(\"dropdown-link-color\");\n  }\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      @include ltr {\n        margin-left: $caret-spacing;\n      }\n      @include rtl {\n        margin-right: $caret-spacing;\n      }\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      @include ltr {\n        margin-left: 0;\n      }\n      @include rtl {\n        margin-right: 0;\n      }\n    }\n  }\n}\n","\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdowns\n$dropdown-min-width:            10rem !default;\n$dropdown-padding-y:            .5rem !default;\n$dropdown-spacer:               .125rem !default;\n$dropdown-font-size:            $font-size-base !default;\n$dropdown-border-radius:        $border-radius !default;\n$dropdown-border-width:         $border-width !default;\n$dropdown-inner-border-radius:  subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-margin-y:     $nav-divider-margin-y !default;\n$dropdown-box-shadow:           0 .5rem 1rem rgba($black, .175) !default;\n$dropdown-item-padding-y:       .5rem !default;\n$dropdown-item-padding-x:       1.25rem !default;\n$dropdown-header-padding:       $dropdown-padding-y $dropdown-item-padding-x !default;\n// scss-docs-end dropdowns\n\n// Default theme\n// scss-docs-start dropdowns-default-theme\n$dropdown-color:                $body-color !default;\n$dropdown-bg:                   $white !default;\n$dropdown-border-color:         $border-color !default;\n$dropdown-divider-bg:           $gray-200 !default;\n$dropdown-link-color:           $gray-900 !default;\n$dropdown-link-hover-color:     darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:        $gray-100 !default;\n$dropdown-link-active-color:    $component-active-color !default;\n$dropdown-link-active-bg:       $component-active-bg !default;\n$dropdown-link-disabled-color:  $gray-600 !default;\n$dropdown-header-color:         $gray-600 !default;\n// scss-docs-end dropdowns-default-theme\n\n\n$dropdown-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$dropdown-theme-map: map-merge(\n  (\n    default: (\n      \"dropdown-color\":                $dropdown-color,\n      \"dropdown-border-color\":         $dropdown-border-color,\n      \"dropdown-bg\":                   $dropdown-bg,\n      \"dropdown-divider-bg\":           $dropdown-divider-bg,\n      \"dropdown-link-color\":           $dropdown-link-color,\n      \"dropdown-link-hover-color\":     $dropdown-link-hover-color,\n      \"dropdown-link-hover-bg\":        $dropdown-link-hover-bg,\n      \"dropdown-link-active-color\":    $dropdown-link-active-color,\n      \"dropdown-link-active-bg\":       $dropdown-link-active-bg,\n      \"dropdown-link-disabled-color\":  $dropdown-link-disabled-color,\n      \"dropdown-header-color\":         $dropdown-header-color\n    )\n  ),\n  $dropdown-theme-map\n);\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n",".c-footer {\n  display: flex;\n  flex: 0 0 $footer-height;\n  flex-wrap: wrap;\n  align-items: center;\n  height: $footer-height;\n  padding: 0 $spacer;\n\n  &[class*=\"bg-\"] {\n    border-color: rgba($black, .1);\n  }\n\n  &.c-footer-fixed {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $zindex-fixed;\n  }\n}\n\n@include themes($footer-theme-map, $parent: \".c-footer\") {\n  color: themes-get-value(\"footer-color\");\n  background: themes-get-value(\"footer-bg\");\n  @include borders(themes-get-value(\"footer-borders\"));\n}\n","// Footer\n\n// scss-docs-start footer\n$footer-height:  50px !default;\n// scss-docs-end footer\n\n\n// Default Theme\n// scss-docs-start footer-default-theme\n$footer-dark-bg:       $gray-800 !default;\n$footer-dark-color:    $white !default;\n$footer-dark-borders:  0 !default;\n\n$footer-light-bg:       $gray-100 !default;\n$footer-light-color:    $body-color !default;\n$footer-light-borders:  ( top: 1px solid $border-color ) !default;\n// scss-docs-end footer-default-theme\n\n$footer-variants-map:  () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$footer-variants-map: map-merge(\n  (\n    dark: (\n      \"footer-bg\":       $footer-dark-bg,\n      \"footer-color\":    $footer-dark-color,\n      \"footer-borders\":  $footer-dark-borders\n    ),\n    light: (\n      \"footer-bg\":       $footer-light-bg,\n      \"footer-color\":    $footer-light-color,\n      \"footer-borders\":  $footer-light-borders\n    )\n  ),\n  $footer-variants-map\n);\n\n$footer-default-variant: \"light\" !default;\n$footer-variants: (\n  \"default\": $footer-default-variant,\n  \"map\":     $footer-variants-map\n) !default;\n\n\n$footer-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$footer-theme-map: map-merge(\n  (\n    default: $footer-variants,\n  ),\n  $footer-theme-map\n);\n","@charset 'UTF-8';\n// When creating a theme's class, script will use this postfix.\n//\n// @type String\n$themes-default-post-class: \"-theme\" !default;\n\n// @type String\n$current-variant: \"\" !default;\n\n/// Current _map_ during the loop. Can be used in custom creation.\n///\n// @type Map\n$themes-map: \"\" !default;\n\n// @type Boolean\n$theme-has-variants: false !default;\n\n// Gets a value from a theme-like map using the current entity and map withing the theme scope.\n//\n// @param {String} $key - Name of the variable you want to get\n// @param {String} $entity - Name of the entity you want to access\n//\n// @example scss\n//   theme-get('color-primary', user);\n//   // -> #333\n//\n// @returns {String} Value of key for that entity\n@function themes-get-value($key, $theme: $current-theme, $variant: $current-variant, $map: $themes-map) {\n\n  $current-theme-map: map-get($map, $theme);\n\n  // @if not $entity-map {\n  //   @error 'There is no `#{$entity}` entity in your variations list.';\n  // }\n\n  @if $theme-has-variants {\n    $current-variant-map: map-get(map-get($current-theme-map, \"map\"), $variant);\n    $value: map-get($current-variant-map, $key);\n    @return $value;\n  } @else {\n    @if map-has-key($current-theme-map, $key) {\n      $value: map-get($current-theme-map, $key);\n      @return $value;\n    } @else {\n      $value: map-get(map-get($map, $default-theme), $key);\n      @return $value;\n    }\n  }\n\n  //TODO: find solution when $key is `null`\n  // @if not $ret {\n  //   @warn 'The entity `#{$entity}` doesn\\'t have a value for `#{$key}`.';\n  // }\n}\n\n@function default-theme() {\n  @each $key in map-keys($default-themes) {\n    // Check if the theme is default\n    @if map-get(map-get($default-themes, $key), \"default\") == true {\n      @return $key;\n    }\n  }\n}\n\n@mixin property($property, $key, $theme: $current-theme, $variant: $current-variant, $map: $themes-map) {\n  $current-theme-map: map-get($map, $theme);\n\n  @if $theme-has-variants {\n    $current-variant-map: map-get(map-get($current-theme-map, \"map\"), $variant);\n    $value: map-get($current-variant-map, $key);\n\n    // @return $value;\n    #{$property}: $value;\n  } @else {\n    @if map-has-key($current-theme-map, $key) {\n      $value: map-get($current-theme-map, $key);\n      // @return $value;\n      #{$property}: $value;\n    } @else {\n      $value: map-get(map-get($map, $default-theme), $key);\n      // @return $value;\n      #{$property}: $value;\n    }\n  }\n}\n\n@function themes-get-option($key, $fallback: null, $theme: $current-theme, $variant: $current-variant, $map: $themes-map) {\n\n  $current-theme-map: map-get($map, $theme);\n\n  @if map-has-key($current-theme-map, $key) {\n    $value: map-get($current-theme-map, $key);\n    @return $value;\n  } @else {\n    @return $fallback;\n  }\n}\n\n@mixin themes-append-variables($theme) {\n  // Update global variables\n  $current-theme: $theme !global;\n  @if $current-theme == \"dark\" and $enable-prefers-color-scheme {\n    @media (prefers-color-scheme: dark) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n@mixin themes-create-parent($theme, $variant) {\n  // Update global variables\n  $current-theme: $theme !global;\n  $current-variant: $variant !global;\n\n  @if map-get(map-get($default-themes, $current-theme), \"default\") {\n    @at-root{\n      @if $variant == $default-variant {\n        #{$parent-element} {\n          @content;\n        }\n      } @else {\n        #{$parent-element}#{$parent-element}-#{$variant} {\n          @content;\n        }\n      }\n    }\n  } @else {\n    @at-root{\n      @if $variant == $default-variant {\n        @if $current-theme == \"dark\" and $enable-prefers-color-scheme {\n          @media (prefers-color-scheme: dark) {\n            #{$parent-element} {\n              @content;\n            }\n          }\n        } @else {\n          .c-#{$theme}#{$themes-default-post-class} #{$parent-element} {\n            @content;\n          }\n        }\n      } @else {\n        @if $current-theme == \"dark\" and $enable-prefers-color-scheme {\n          @media (prefers-color-scheme: dark) {\n            #{$parent-element}#{$parent-element}-#{$variant} {\n              @content;\n            }\n          }\n        } @else {\n          .c-#{$theme}#{$themes-default-post-class} #{$parent-element}#{$parent-element}-#{$variant} {\n            @content;\n          }\n        }\n      }\n    }\n  }\n}\n\n@mixin theme-single-append($theme) {\n  // Update global variables\n  $current-theme: $theme !global;\n\n  @if not & {\n    @error \"No selector found. I need a selector to append the class to.\";\n  }\n\n  @if $current-theme == \"dark\" and $enable-prefers-color-scheme {\n    @media (prefers-color-scheme: dark) {\n      @content;\n    }\n  } @else {\n    &.c-#{$theme}#{$themes-default-post-class} {\n      @content;\n    }\n  }\n}\n\n@mixin themes-single-parent($theme) {\n  // Update global variables\n  $current-theme: $theme !global;\n\n  @at-root{\n    @if $current-theme == \"dark\" and $enable-prefers-color-scheme {\n      @media (prefers-color-scheme: dark) {\n        @if & {\n          & {\n            @content;\n          }\n        } @else {\n          @content;\n        }\n      }\n    } @else {\n      @if & {\n        .c-#{$theme}#{$themes-default-post-class} & {\n          @content;\n        }\n      } @else {\n        .c-#{$theme}#{$themes-default-post-class} {\n          @content;\n        }\n      }\n    }\n  }\n}\n\n@mixin themes($loop: $themes-map, $parent: false, $create: false) {\n  $themes-map: $loop !global;\n  $parent-element: $parent !global;\n  $default-theme: null !global;\n\n  @each $key in map-keys($default-themes) {\n\n    // Check if the theme is default\n    @if map-get(map-get($default-themes, $key), \"default\") == true {\n      $default-theme: $key !global;\n    }\n  }\n\n  // Get list of themes\n  $themes: map-keys($themes-map);\n\n  @each $theme in $themes {\n    $current-theme: $theme !global;\n\n    @if map-has-key($default-themes, $theme) {\n      $theme-map: map-get($themes-map, $theme);\n      // Check if $theme-map has variants\n      @if map-has-key($theme-map, \"map\") {\n        $theme-has-variants: true !global;\n        // Get list of variants\n        $variants: map-keys(map-get($theme-map, \"map\"));\n        $default-variant: map-get($theme-map, \"default\") !global;\n        @each $variant in $variants {\n          @include themes-create-parent($theme, $variant) {\n            @content;\n          }\n        }\n      } @else {\n        $theme-has-variants: false !global;\n        @if map-get(map-get($default-themes, $theme), \"default\") {\n          @include themes-append-variables($theme) {\n            @content;\n          }\n        } @else {\n          @if $create == \"parent\" {\n            @include themes-single-parent($theme) {\n              @content;\n            }\n          } @else if $create == \"append\" {\n            @include theme-single-append($theme) {\n              @content;\n            }\n          } @else {\n            @include themes-single-parent($theme) {\n              @content;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@mixin theme-variant($extend-class: false) {\n  @each $theme in map-keys($default-themes) {\n    $get-colors: map-get(map-get($default-themes, $theme), \"theme-colors\");\n    $get-default: map-get(map-get($default-themes, $theme), \"default\");\n    $get-grays: map-get(map-get($default-themes, $theme), \"grays\");\n    @each $color, $value in $get-colors {\n      $color: $color !global;\n      $value: $value !global;\n      @if $get-default {\n        @content;\n      } @else {\n        $default-color: map-get(map-get(map-get($default-themes, default-theme()), \"theme-colors\"), $color);\n        @if $default-color != $value {\n          @if $extend-class {\n            &.c-#{$theme}#{$theme-suffix} {\n              @content;\n            }\n          } @else {\n            @at-root{\n              .c-#{$theme}#{$theme-suffix} {\n                @content;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@mixin theme-gradients() {\n  @each $theme in map-keys($default-themes) {\n    $get-default: map-get(map-get($default-themes, $theme), \"default\");\n    $get-gradients: map-get(map-get($default-themes, $theme), \"gradients\");\n    @each $gradient, $value in $get-gradients {\n      $gradient: $gradient !global;\n      $value: $value !global;\n      @if $get-default {\n        @content;\n      } @else {\n        $default-gradient: map-get(map-get(map-get($default-themes, default-theme()), \"gradients\"), $gradient);\n        @if $default-gradient != $value {\n          @at-root{\n            .c-#{$theme}#{$theme-suffix} {\n              @content;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@mixin theme-get-color($color) {\n  @each $theme in map-keys($default-themes) {\n    $get-color: map-get(map-get(map-get($default-themes, $theme), \"theme-colors\"), $color);\n    $get-default: map-get(map-get($default-themes, $theme), \"default\");\n    $color: $get-color !global;\n    @if $get-default {\n      @content;\n    } @else {\n      @at-root{\n        .c-#{$theme}#{$theme-suffix} & {\n          @content;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  background-clip: padding-box;\n  border: $input-border-width solid;\n  @include themes($form-theme-map, $create: parent) {\n    color: themes-get-value(\"input-color\");\n    background-color: themes-get-value(\"input-bg\");\n    border-color: themes-get-value(\"input-border-color\");\n  }\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    @include themes($form-theme-map, $create: parent) {\n      color: themes-get-value(\"input-placeholder-color\");\n    }\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    @include themes($form-theme-map, $create: parent) {\n      background-color: themes-get-value(\"input-disabled-bg\");\n    }\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    @include themes($form-theme-map, $create: parent) {\n      color: themes-get-value(\"input-color\");\n      background-color: themes-get-value(\"input-bg\");\n    }\n  }\n\n  option {\n    // Add background-color for option elements\n    @include themes($form-theme-map, $create: parent) {\n      background-color: themes-get-value(\"select-option-bg\");\n    }\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n  @include themes($form-theme-map, $create: parent) {\n    color: themes-get-value(\"input-plaintext-color\");\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width / 2;\n  margin-left: -$form-grid-gutter-width / 2;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width / 2;\n    padding-left: $form-grid-gutter-width / 2;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  @include ltr {\n    padding-left: $form-check-input-gutter;\n  }\n  @include rtl {\n    padding-right: $form-check-input-gutter;\n  }\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  @include ltr {\n    margin-left: -$form-check-input-gutter;\n  }\n  @include rtl {\n    margin-right: -$form-check-input-gutter;\n  }\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    @include themes($typography-theme-map, $create: parent) {\n      color: themes-get-value(\"text-muted\");\n    }\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  @include ltr {\n    padding-left: 0; // Override base .form-check\n    margin-right: $form-check-inline-margin-x;\n  }\n  @include rtl {\n    padding-right: 0; // Override base .form-check\n    margin-left: $form-check-inline-margin-x;\n  }\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    @include ltr {\n      margin-right: $form-check-inline-input-margin-x;\n      margin-left: 0;\n    }\n    @include rtl {\n      margin-right: 0;\n      margin-left: $form-check-inline-input-margin-x;\n    }\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      @include ltr {\n        padding-left: 0;\n      }\n      @include rtl {\n        padding-right: 0;\n      }\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      @include ltr {\n        margin-right: $form-check-input-margin-x;\n        margin-left: 0;\n      }\n      @include rtl {\n        margin-right: 0;\n        margin-left: $form-check-input-margin-x;\n      }\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.form-control-color {\n  max-width: 3rem;\n  padding: $input-padding-y;\n}\n\n.form-control-color::-moz-color-swatch {\n  @include border-radius($input-border-radius);\n}\n\n.form-control-color::-webkit-color-swatch {\n  @include border-radius($input-border-radius);\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    @include themes($form-theme-map) {\n      color: themes-get-value(\"input-focus-color\");\n      background-color: themes-get-value(\"input-focus-bg\");\n      border-color: themes-get-value(\"input-focus-border-color\");\n    }\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        @include ltr {\n          padding-right: $input-height-inner;\n        }\n        @include rtl {\n          padding-left: $input-height-inner;\n        }\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        @include ltr {\n          background-position: right $input-height-inner-quarter center;\n        }\n        @include rtl {\n          background-position: left $input-height-inner-quarter center;\n        }\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        @include ltr {\n          padding-right: $input-height-inner;\n          background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n        }\n        @include rtl {\n          padding-left: $input-height-inner;\n          background-position: top $input-height-inner-quarter left $input-height-inner-quarter;\n        }\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        @include ltr {\n          padding-right: $custom-select-feedback-icon-padding-right;\n        }\n        @include rtl {\n          padding-left: $custom-select-feedback-icon-padding-right;\n        }\n        background: $custom-select-background, escape-svg($icon) $custom-select-bg no-repeat $custom-select-feedback-icon-position / $custom-select-feedback-icon-size;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container {\n    @include make-container();\n    @include make-container-max-widths();\n  }\n\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n\n.row.row-equal {\n  padding-right: ($grid-gutter-width / 4);\n  padding-left: ($grid-gutter-width / 4);\n  margin-right: ($grid-gutter-width / -2);\n  margin-left: ($grid-gutter-width / -2);\n\n  [class*=\"col-\"] {\n    padding-right: ($grid-gutter-width / 4);\n    padding-left: ($grid-gutter-width / 4);\n  }\n}\n\n.main .container-fluid {\n  padding: 0 30px;\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter / 2;\n  padding-left: $gutter / 2;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter / 2;\n  margin-left: -$gutter / 2;\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter / 2;\n  padding-left: $gutter / 2;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage($size / $columns);\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage($size / $columns);\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: $size / $columns;\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  & > * {\n    flex: 0 0 100% / $count;\n    max-width: 100% / $count;\n  }\n}\n","\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:       12 !default;\n$grid-gutter-width:  30px !default;\n$grid-row-columns:   6 !default;\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter / 2;\n    padding-left: $gutter / 2;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        min-width: 0; // See https://github.com/twbs/bootstrap/issues/25410\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".c-header {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  min-height: $header-height;\n\n  &[class*=\"bg-\"]  {\n    border-color: rgba($black, .1);\n  }\n\n  &.c-header-fixed {\n    position: fixed;\n    right: 0;\n    left: 0;\n    z-index: $zindex-fixed - 1;\n  }\n\n  .c-subheader {\n    border-bottom: 0;\n  }\n}\n\n.c-header-brand {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: $header-brand-width;\n  min-height: $header-height;\n  transition: width $layout-transition-speed;\n\n  &.c-header-brand-center {\n    position: absolute;\n    top: $header-height;\n    transform: translate(-50%, -100%);\n\n    @include ltr {\n      left: 50%;\n    }\n    @include rtl {\n      right: 50%;\n    }\n  }\n\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-down($breakpoint) {\n      &.c-header-brand-#{$breakpoint}-down-center {\n        position: absolute;\n        top: $header-height;\n        transform: translate(-50%, -100%);\n        @include ltr {\n          left: 50%;\n        }\n        @include rtl {\n          right: 50%;\n        }\n      }\n    }\n    @include media-breakpoint-up($breakpoint) {\n      &.c-header-brand-#{$breakpoint}-up-center {\n        position: absolute;\n        top: $header-height;\n        transform: translate(-50%, -100%);\n        @include ltr {\n          left: 50%;\n        }\n        @include rtl {\n          right: 50%;\n        }\n      }\n    }\n  }\n}\n\n.c-header-toggler {\n  min-width: 50px;\n  font-size: $header-toggler-font-size;\n  background-color: $header-toggler-bg;\n  border: 0; // remove default button style\n  @include borders($header-toggler-border);\n  @include border-radius($header-toggler-border-radius);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\n  &:not(:disabled):not(.c-disabled) {\n    cursor: pointer;\n  }\n}\n\n.c-header-toggler-icon {\n  display: block;\n  height: $header-toggler-font-size * 1.25;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 100% 100%;\n}\n\n.c-header-nav {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-height: $header-height;\n  padding: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .c-header-nav-item {\n    position: relative;\n  }\n\n  .c-header-nav-btn {\n    background-color: transparent;\n    border: $btn-border-width solid transparent;\n\n    @include hover() {\n      text-decoration: none;\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n    }\n  }\n\n  .c-header-nav-link,\n  .c-header-nav-btn {\n    display: flex;\n    align-items: center;\n    padding-right: $header-nav-link-padding-x;\n    padding-left: $header-nav-link-padding-x;\n\n    .badge {\n      position: absolute;\n      top: 50%;\n      margin-top: -16px;\n      @include ltr {\n        left: 50%;\n        margin-left: 0;\n      }\n      @include rtl {\n        right: 50%;\n        margin-right: 0;\n      }\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n\n  .dropdown-item {\n    min-width: 180px;\n  }\n}\n\n//\n// Header variants\n//\n\n@include themes($header-theme-map, $create: append, $parent: \".c-header\") {\n  background: themes-get-value(\"header-bg\");\n  @include borders(themes-get-value(\"header-border\"));\n\n  .c-subheader {\n    margin-top: -1px;\n    border-top: themes-get-value(\"subheader-separator\");\n  }\n\n  .c-header-brand {\n    color: themes-get-value(\"header-brand-color\");\n    background-color: themes-get-value(\"header-brand-bg\");\n    @include borders(themes-get-value(\"header-brand-border\"));\n\n    @include hover-focus {\n      color: themes-get-value(\"header-brand-hover-color\");\n    }\n  }\n\n  .c-header-nav {\n    .c-header-nav-link,\n    .c-header-nav-btn {\n      color: themes-get-value(\"header-color\");\n\n      @include hover-focus {\n        color: themes-get-value(\"header-hover-color\");\n      }\n\n      &.c-disabled {\n        color: themes-get-value(\"header-disabled-color\");\n      }\n    }\n\n    .c-show > .c-header-nav-link,\n    .c-active > .c-header-nav-link,\n    .c-header-nav-link.c-show,\n    .c-header-nav-link.c-active {\n      color: themes-get-value(\"header-active-color\");\n    }\n  }\n\n  .c-header-toggler {\n    color: themes-get-value(\"header-color\");\n    border-color: themes-get-value(\"header-toggler-border-color\");\n  }\n\n  .c-header-toggler-icon {\n    background-image: themes-get-value(\"header-toggler-icon-bg\");\n\n    &:hover {\n      background-image: themes-get-value(\"header-toggler-hover-icon-bg\");\n    }\n  }\n\n  .c-header-text {\n    color: themes-get-value(\"header-color\");\n    a {\n      color: themes-get-value(\"header-active-color\");\n\n      @include hover-focus {\n        color: themes-get-value(\"header-active-color\");\n      }\n    }\n  }\n}\n","// Header\n\n// scss-docs-start header\n$header-height:                 56px !default;\n$header-brand-width:            auto !default;\n$header-brand-minimized-width:  56px !default;\n\n$header-padding-y:  $spacer / 2 !default;\n$header-padding-x:  $spacer !default;\n\n$header-nav-link-padding-x:  .5rem !default;\n\n$header-brand-font-size:  $font-size-lg !default;\n$header-brand-height:     $header-brand-font-size * $line-height-base !default;\n$header-brand-padding-y:  ($nav-link-height - $header-brand-height) / 2 !default;\n// scss-docs-end header\n\n\n// Default theme\n\n// scss-docs-start header-default-theme\n$header-toggler-bg:             transparent !default;\n$header-toggler-padding-y:      .25rem !default;\n$header-toggler-padding-x:      .75rem !default;\n$header-toggler-font-size:      $font-size-lg !default;\n$header-toggler-border:         0 !default;\n$header-toggler-border-radius:  $btn-border-radius !default;\n\n$header-light-bg:                     $white !default;\n$header-light-color:                  rgba($black, .5) !default;\n$header-light-border:                 ( bottom: 1px solid $border-color ) !default;\n$header-light-hover-color:            rgba($black, .7) !default;\n$header-light-active-color:           rgba($black, .9) !default;\n$header-light-disabled-color:         rgba($black, .3) !default;\n$header-light-toggler-icon-bg:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-light-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$header-light-toggler-hover-icon-bg:  str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-light-hover-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$header-light-toggler-border-color:   rgba($black, .1) !default;\n\n$header-dark-bg:                     $gray-base !default;\n$header-dark-color:                  rgba($white, .75) !default;\n$header-dark-border:                 ( bottom: 1px solid $gray-800 ) !default;\n$header-dark-hover-color:            rgba($white, .9) !default;\n$header-dark-active-color:           $white !default;\n$header-dark-disabled-color:         rgba($white, .25) !default;\n$header-dark-toggler-icon-bg:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-dark-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$header-dark-toggler-hover-icon-bg:  str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-dark-hover-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$header-dark-toggler-border-color:   rgba($white, .1) !default;\n\n$header-light-brand-bg:                transparent !default;\n$header-light-brand-border:            0 !default;\n$header-light-brand-color:             $gray-900 !default;\n$header-light-brand-hover-color:       darken($gray-900, 10%) !default;\n$header-light-brand-minimized-bg:      transparent !default;\n$header-light-brand-minimized-border:  0 !default;\n\n$header-dark-brand-bg:                transparent !default;\n$header-dark-brand-border:            0 !default;\n$header-dark-brand-color:             $header-dark-active-color !default;\n$header-dark-brand-hover-color:       $header-dark-active-color !default;\n$header-dark-brand-minimized-bg:      transparent !default;\n$header-dark-brand-minimized-border:  0 !default;\n\n$subheader-light-separator:  1px solid $border-color !default;\n\n$subheader-dark-separator:  1px solid $gray-800 !default;\n// scss-docs-end header-default-theme\n\n\n$header-variants-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$header-variants-map: map-merge(\n  (\n    dark: (\n      \"header-bg\":                      $header-dark-bg,\n      \"header-color\":                   $header-dark-color,\n      \"header-border\":                  $header-dark-border,\n      \"header-hover-color\":             $header-dark-hover-color,\n      \"header-active-color\":            $header-dark-active-color,\n      \"header-disabled-color\":          $header-dark-disabled-color,\n      \"header-toggler-icon-bg\":         $header-dark-toggler-icon-bg,\n      \"header-toggler-hover-icon-bg\":   $header-dark-toggler-hover-icon-bg,\n      \"header-toggler-border-color\":    $header-dark-toggler-border-color,\n      \"header-brand-bg\":                $header-dark-brand-bg,\n      \"header-brand-border\":            $header-dark-brand-border,\n      \"header-brand-color\":             $header-dark-brand-color,\n      \"header-brand-hover-color\":       $header-dark-brand-hover-color,\n      \"header-brand-minimized-bg\":      $header-dark-brand-minimized-bg,\n      \"header-brand-minimized-border\":  $header-dark-brand-minimized-border,\n      \"subheader-separator\":            $subheader-dark-separator\n    ),\n    light: (\n      \"header-bg\":                      $header-light-bg,\n      \"header-color\":                   $header-light-color,\n      \"header-border\":                  $header-light-border,\n      \"header-hover-color\":             $header-light-hover-color,\n      \"header-active-color\":            $header-light-active-color,\n      \"header-disabled-color\":          $header-light-disabled-color,\n      \"header-toggler-icon-bg\":         $header-light-toggler-icon-bg,\n      \"header-toggler-hover-icon-bg\":   $header-light-toggler-hover-icon-bg,\n      \"header-toggler-border-color\":    $header-light-toggler-border-color,\n      \"header-brand-bg\":                $header-light-brand-bg,\n      \"header-brand-border\":            $header-light-brand-border,\n      \"header-brand-color\":             $header-light-brand-color,\n      \"header-brand-hover-color\":       $header-light-brand-hover-color,\n      \"header-brand-minimized-bg\":      $header-light-brand-minimized-bg,\n      \"header-brand-minimized-border\":  $header-light-brand-minimized-border,\n      \"subheader-separator\":            $subheader-light-separator\n    )\n  ),\n  $header-variants-map\n);\n\n$header-default-variant: \"light\" !default;\n$header-variants: (\n  default:  $header-default-variant,\n  map:      $header-variants-map\n) !default;\n\n$header-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$header-theme-map: map-merge(\n  (\n    default:  $header-variants\n  ),\n  $header-theme-map\n);\n",".c-icon {\n  display: inline-block;\n  color: inherit;\n  text-align: center;\n  fill: currentColor;\n  &:not(.c-icon-c-s):not(.c-icon-custom-size) {\n    @include icon-size($icon-size-base);\n\n    // TODO: create variable with a range\n    @for $i from 2 through 9 {\n      &.c-icon-#{$i}xl {\n        @include icon-size($i * ($icon-size-xl / 1.5));\n      }\n    }\n\n    &.c-icon-xl {\n      @include icon-size($icon-size-xl);\n    }\n\n    &.c-icon-lg {\n      @include icon-size($icon-size-lg);\n    }\n\n    &.c-icon-sm {\n      @include icon-size($icon-size-sm);\n    }\n  }\n}\n","// Icon sizes\n@mixin icon-size($icon-size) {\n  width: $icon-size;\n  height: $icon-size;\n  font-size: $icon-size;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      @include ltr {\n        margin-left: -$input-border-width;\n      }\n      @include rtl {\n        margin-right: -$input-border-width;\n      }\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:last-child) {\n      @include ltr {\n        @include border-right-radius(0);\n      }\n      @include rtl {\n        @include border-left-radius(0);\n      }\n    }\n    &:not(:first-child) {\n      @include ltr {\n        @include border-left-radius(0);\n      }\n      @include rtl {\n        @include border-right-radius(0);\n      }\n    }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after {\n      @include ltr {\n        @include border-right-radius(0);\n      }\n      @include rtl {\n        @include border-left-radius(0);\n      }\n    }\n    &:not(:first-child) .custom-file-label {\n      @include ltr {\n        @include border-left-radius(0);\n      }\n      @include rtl {\n        @include border-right-radius(0);\n      }\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    @include ltr {\n      margin-left: -$input-border-width;\n    }\n    @include rtl {\n      margin-right: -$input-border-width;\n    }\n  }\n}\n\n.input-group-prepend {\n  @include ltr {\n    margin-right: -$input-border-width;\n  }\n  @include rtl {\n    margin-left: -$input-border-width;\n  }\n  white-space: nowrap;\n  vertical-align: middle; // Match the inputs\n}\n.input-group-append {\n  @include ltr {\n    margin-left: -$input-border-width;\n  }\n  @include rtl {\n    margin-right: -$input-border-width;\n  }\n  white-space: nowrap;\n  vertical-align: middle; // Match the inputs\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  text-align: center;\n  white-space: nowrap;\n  border: $input-border-width solid;\n  @include border-radius($input-border-radius);\n\n  @include themes($form-theme-map, $create: parent) {\n    color: themes-get-value(\"input-group-addon-color\");\n    background-color: themes-get-value(\"input-group-addon-bg\");\n    border-color: themes-get-value(\"input-group-addon-border-color\");\n  }\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  @include ltr {\n    padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n  }\n  @include rtl {\n    padding-left: $custom-select-padding-x + $custom-select-indicator-padding;\n  }\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include ltr {\n    @include border-right-radius(0);\n  }\n  @include rtl {\n    @include border-left-radius(0);\n  }\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include ltr {\n    @include border-left-radius(0);\n  }\n  @include rtl {\n    @include border-right-radius(0);\n  }\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer / 2;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/#feat=css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// Image thumbnails\n\n// scss-docs-start thumbnail\n$thumbnail-padding:        .25rem !default;\n$thumbnail-bg:             $body-bg !default;\n$thumbnail-border-width:   $border-width !default;\n$thumbnail-border-color:   $gray-300 !default;\n$thumbnail-border-radius:  $border-radius !default;\n$thumbnail-box-shadow:     0 1px 2px rgba($black, .075) !default;\n// scss-docs-end thumbnail\n\n\n// Figures\n\n// scss-docs-start figure\n$figure-caption-font-size:  90% !default;\n$figure-caption-color:      $gray-600 !default;\n// scss-docs-end figure\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding / 2);\n  margin-bottom: $jumbotron-padding;\n  @include border-radius($border-radius-lg);\n\n  @include themes($jumbotron-theme-map, $create: parent) {\n    color: themes-get-value(\"jumbotron-color\");\n    background-color: themes-get-value(\"jumbotron-bg\");\n  }\n\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","\n// Jumbotron\n\n// scss-docs-start jumbotron\n$jumbotron-padding:  2rem !default;\n// scss-docs-end jumbotron\n\n// Default theme\n// scss-docs-start jumbotron-default-theme\n$jumbotron-color:  null !default;\n$jumbotron-bg:     $gray-200 !default;\n// scss-docs-end jumbotron-default-theme\n\n$jumbotron-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$jumbotron-theme-map: map-merge(\n  (\n    default: (\n      \"jumbotron-color\":  $jumbotron-color,\n      \"jumbotron-bg\":     $jumbotron-bg\n    )\n  ),\n  $jumbotron-theme-map\n);\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  @include ltr {\n    padding-left: 0; // reset padding because ul and ol\n  }\n  @include rtl {\n    padding-right: 0; // reset padding because ul and ol\n  }\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  text-align: inherit; // For `<button>`s (anchors inherit)\n  @include themes($list-group-theme-map, $create: parent) {\n    color: themes-get-value(\"list-group-action-color\");\n  }\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    text-decoration: none;\n    @include themes($list-group-theme-map, $create: parent) {\n      color: themes-get-value(\"list-group-action-hover-color\");\n      background-color: themes-get-value(\"list-group-hover-bg\");\n    }\n  }\n\n  &:active {\n    @include themes($list-group-theme-map, $create: parent) {\n      color: themes-get-value(\"list-group-action-active-color\");\n      background-color: themes-get-value(\"list-group-action-active-bg\");\n    }\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n  border: $list-group-border-width solid;\n  @include themes($list-group-theme-map, $create: parent) {\n    color: themes-get-value(\"list-group-color\");\n    background-color: themes-get-value(\"list-group-bg\");\n    border-color: themes-get-value(\"list-group-border-color\");\n  }\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    pointer-events: none;\n    @include themes($list-group-theme-map, $create: parent) {\n      color: themes-get-value(\"list-group-disabled-color\");\n      background-color: themes-get-value(\"list-group-disabled-bg\");\n    }\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    @include themes($list-group-theme-map, $create: parent) {\n      color: themes-get-value(\"list-group-active-color\");\n      background-color: themes-get-value(\"list-group-active-bg\");\n      border-color: themes-get-value(\"list-group-active-border-color\");\n    }\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        & + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n// scss-docs-start list-group-modifiers\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@include theme-variant() {\n  @include list-group-item-variant($color,  theme-color-level($value, -9),  theme-color-level($value, 6));\n}\n// scss-docs-end list-group-modifiers\n// List items with accent\n//\n// Remove top, bottome and right borders and border-radius.\n\n.list-group-accent {\n  .list-group-item {\n    margin-bottom: 1px;\n    border-top: 0;\n    border-right: 0;\n    border-bottom: 0;\n    @include border-radius(0);\n\n    &.list-group-item-divider {\n      position: relative;\n\n      &::before {\n        position: absolute;\n        bottom: -1px;\n        width: 90%;\n        height: 1px;\n        content: \"\";\n\n        @include ltr {\n          left: 5%;\n        }\n        @include rtl {\n          right: 5%;\n        }\n        @include themes($list-group-theme-map) {\n          background-color: themes-get-value(\"list-group-border-color\");\n        }\n      }\n    }\n  }\n  // Contextual variants\n  //\n  // Add modifier classes to change border color on individual items.\n  @include theme-variant() {\n    @include list-group-item-accent-variant($color, $value);\n  }\n}\n","// List group\n\n// scss-docs-start list-group\n$list-group-border-width:   $border-width !default;\n$list-group-border-radius:  $border-radius !default;\n\n$list-group-item-padding-y:  .75rem !default;\n$list-group-item-padding-x:  1.25rem !default;\n// scss-docs-end list-group\n\n// Default theme\n// scss-docs-start list-group-default-theme\n$list-group-color:                null !default;\n$list-group-bg:                   inherit !default;\n$list-group-border-color:         rgba($black, .125) !default;\n$list-group-hover-bg:             $gray-100 !default;\n$list-group-active-color:         $component-active-color !default;\n$list-group-active-bg:            $component-active-bg !default;\n$list-group-active-border-color:  $list-group-active-bg !default;\n$list-group-disabled-color:       $gray-600 !default;\n$list-group-disabled-bg:          $list-group-bg !default;\n$list-group-action-color:         $gray-700 !default;\n$list-group-action-hover-color:   $list-group-action-color !default;\n$list-group-action-active-color:  $body-color !default;\n$list-group-action-active-bg:     $gray-200 !default;\n// scss-docs-end list-group-default-theme\n\n$list-group-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$list-group-theme-map: map-merge(\n  (\n    default: (\n      \"list-group-color\":                $list-group-color,\n      \"list-group-bg\":                   $list-group-bg,\n      \"list-group-border-color\":         $list-group-border-color,\n      \"list-group-hover-bg\":             $list-group-hover-bg,\n      \"list-group-active-color\":         $list-group-active-color,\n      \"list-group-active-bg\":            $list-group-active-bg,\n      \"list-group-active-border-color\":  $list-group-active-border-color,\n      \"list-group-disabled-color\":       $list-group-disabled-color,\n      \"list-group-disabled-bg\":          $list-group-disabled-bg,\n      \"list-group-action-color\":         $list-group-action-color,\n      \"list-group-action-hover-color\":   $list-group-action-hover-color,\n      \"list-group-action-active-color\":  $list-group-action-active-color,\n      \"list-group-action-active-bg\":     $list-group-action-active-bg,\n    )\n  ),\n  $list-group-theme-map\n);\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n\n@mixin list-group-item-accent-variant($state, $color) {\n  .list-group-item-accent-#{$state} {\n    border-left: 4px solid $color;\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  pointer-events: auto;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n  @include themes($modal-theme-map) {\n    color: themes-get-value(\"modal-content-color\");\n    background-color: themes-get-value(\"modal-content-bg\");\n    border-color: themes-get-value(\"modal-content-border-color\");\n  }\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid;\n  @include border-top-radius($modal-content-inner-border-radius);\n  @include themes($modal-theme-map) {\n    border-color: themes-get-value(\"modal-header-border-color\");\n  }\n\n  .close {\n    padding: $modal-header-padding;\n    @include ltr {\n      // auto on the left force icon to the right even when there is no .modal-title\n      margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n    }\n    @include rtl {\n      // auto on the left force icon to the left even when there is no .modal-title\n      margin: (-$modal-header-padding-y) auto (-$modal-header-padding-y) (-$modal-header-padding-x);\n    }\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between / 2;\n  border-top: $modal-footer-border-width solid;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n  @include themes($modal-theme-map) {\n    border-color: themes-get-value(\"modal-footer-border-color\");\n  }\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  // stylelint-disable-next-line selector-max-universal\n  > * {\n    margin: $modal-footer-margin-between / 2;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n\n@include theme-variant() {\n  .modal-#{$color} {\n\n    .modal-content {\n      border-color: $value;\n    }\n\n    .modal-header {\n      color: $white;\n      background-color: $value;\n    }\n  }\n}\n","// Modals\n\n// scss-docs-start modal\n// Padding applied to the modal body\n$modal-inner-padding: 1rem !default;\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:  .5rem !default;\n\n$modal-dialog-margin:          .5rem !default;\n$modal-dialog-margin-y-sm-up:  1.75rem !default;\n\n$modal-title-line-height:  $line-height-base !default;\n\n$modal-content-border-width:         $border-width !default;\n$modal-content-border-radius:        $border-radius-lg !default;\n$modal-content-inner-border-radius:  subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:        0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:     0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:          $black !default;\n$modal-backdrop-opacity:     .5 !default;\n$modal-header-padding-y:     1rem !default;\n$modal-header-padding-x:     1rem !default;\n$modal-header-padding:       $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n$modal-header-border-width:  $modal-content-border-width !default;\n$modal-footer-border-width:  $modal-header-border-width !default;\n\n$modal-xl:  1140px !default;\n$modal-lg:  800px !default;\n$modal-md:  500px !default;\n$modal-sm:  300px !default;\n\n$modal-fade-transform:   translate(0, -50px) !default;\n$modal-show-transform:   none !default;\n$modal-transition:       transform .3s ease-out !default;\n$modal-scale-transform:  scale(1.02) !default;\n// scss-docs-end modal\n\n// Default theme\n// scss-docs-start modal-default-theme\n$modal-content-color:         null !default;\n$modal-content-bg:            $white !default;\n$modal-content-border-color:  rgba($black, .2) !default;\n$modal-header-border-color:   $border-color !default;\n$modal-footer-border-color:   $modal-header-border-color !default;\n// scss-docs-end modal-default-theme\n\n$modal-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$modal-theme-map: map-merge(\n  (\n    default: (\n      \"modal-content-color\":         $modal-content-color,\n      \"modal-content-bg\":            $modal-content-bg,\n      \"modal-content-border-color\":  $modal-content-border-color,\n      \"modal-header-border-color\":   $modal-header-border-color,\n      \"modal-footer-border-color\":   $modal-footer-border-color,\n    )\n  ),\n  $modal-theme-map\n);\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s or `<ul>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 0;\n  list-style: none;\n\n  @include ltr {\n    padding-left: 0;\n  }\n  @include rtl {\n    padding-right: 0;\n  }\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n    @include themes($nav-theme-map, $create: parent) {\n      color: themes-get-value(\"nav-link-disabled-color\");\n    }\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid;\n  @include themes($nav-theme-map, $create: parent) {\n    border-color: themes-get-value(\"nav-tabs-border-color\");\n  }\n\n  .nav-item {\n    margin-bottom: -$nav-tabs-border-width;\n  }\n\n  .nav-link {\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      @include themes($nav-theme-map, $create: parent) {\n        border-color: themes-get-value(\"nav-tabs-link-hover-border-color\");\n      }\n    }\n\n    &.disabled {\n      background-color: transparent;\n      border-color: transparent;\n      @include themes($nav-theme-map, $create: parent) {\n        color: themes-get-value(\"nav-link-disabled-color\");\n      }\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    @include themes($nav-theme-map, $create: parent) {\n      color: themes-get-value(\"nav-tabs-link-active-color\");\n      background-color: themes-get-value(\"nav-tabs-link-active-bg\");\n      border-color: themes-get-value(\"nav-tabs-link-active-border-color\");\n    }\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n\n  // &.nav-tabs-boxed {\n  //   border-color: $nav-tabs-boxed-border-color;\n  //   + .tab-content {\n\n  //     border: $nav-tabs-border-width solid;\n  //     border-color: $nav-tabs-boxed-border-color;\n\n  //   }\n  // }\n}\n\n.nav-tabs-boxed {\n  .nav-tabs {\n    border: 0;\n\n    .nav-link {\n      &.active {\n        @include themes($nav-theme-map, $create: parent) {\n          background-color: themes-get-value(\"nav-tabs-boxed-link-active-bg\");\n          border-bottom-color: themes-get-value(\"nav-tabs-boxed-link-active-bg\");\n        }\n      }\n    }\n  }\n  .tab-content {\n    padding: $nav-tabs-boxed-content-padding-y $nav-tabs-boxed-content-padding-x;\n    border: $nav-tabs-boxed-content-border-width solid;\n    @include border-radius(0 $nav-tabs-boxed-content-border-radius $nav-tabs-boxed-content-border-radius $nav-tabs-boxed-content-border-radius);\n    @include themes($nav-theme-map) {\n      color: themes-get-value(\"nav-tabs-link-active-color\");\n      background-color: themes-get-value(\"nav-tabs-boxed-content-bg\");\n      border-color: themes-get-value(\"nav-tabs-boxed-content-border-color\");\n    }\n  }\n\n  &.nav-tabs-boxed-top-right {\n    .nav-tabs {\n      justify-content: flex-end;\n    }\n    .tab-content {\n      @include border-radius($nav-tabs-boxed-content-border-radius 0 $nav-tabs-boxed-content-border-radius $nav-tabs-boxed-content-border-radius);\n    }\n  }\n\n  &.nav-tabs-boxed-left,\n  &.nav-tabs-boxed-right {\n    display: flex;\n\n    .nav-item {\n      z-index: 1;\n      flex-grow: 1;\n      margin-bottom: 0;\n    }\n  }\n\n  &.nav-tabs-boxed-left {\n    @include rtl {\n      flex-direction: row-reverse;\n    }\n\n    .nav-item {\n      margin-right: -$nav-tabs-border-width;\n    }\n\n    .nav-link {\n      @include border-radius($nav-tabs-boxed-content-border-radius 0 0 $nav-tabs-boxed-content-border-radius);\n\n      &.active {\n        @include themes($nav-theme-map) {\n          border-color: themes-get-value(\"nav-tabs-boxed-left-active-border-color\");\n        }\n      }\n    }\n  }\n\n  &.nav-tabs-boxed-right {\n    @include ltr {\n      flex-direction: row-reverse;\n    }\n    @include rtl {\n      flex-direction: row;\n    }\n\n    .nav-item {\n      @include ltr {\n        margin-left: -$nav-tabs-border-width;\n      }\n      @include rtl {\n        margin-right: -$nav-tabs-border-width;\n      }\n    }\n\n    .nav-link {\n      @include border-radius(0 $nav-tabs-boxed-content-border-radius $nav-tabs-boxed-content-border-radius 0);\n\n      &.active {\n        @include themes($nav-theme-map) {\n          border-color: themes-get-value(\"nav-tabs-boxed-right-active-border-color\");\n        }\n      }\n    }\n\n    .tab-content {\n      @include border-radius($nav-tabs-boxed-content-border-radius 0 $nav-tabs-boxed-content-border-radius $nav-tabs-boxed-content-border-radius);\n    }\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    @include themes($nav-theme-map, $create: parent) {\n      color: themes-get-value(\"nav-pills-link-active-color\");\n      background-color: themes-get-value(\"nav-pills-link-active-bg\");\n    }\n  }\n}\n\n//\n// Underline\n//\n\n.nav-underline {\n  border-bottom: (2 * $nav-tabs-border-width) solid;\n  @include themes($nav-theme-map, $create: parent) {\n    border-color: themes-get-value(\"nav-tabs-border-color\");\n  }\n\n  .nav-item {\n    margin-bottom: - (2 * $nav-tabs-border-width);\n  }\n\n  .nav-link {\n    border: 0;\n    border-bottom: (2 * $nav-tabs-border-width) solid transparent;\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    background: transparent;\n  }\n}\n\n@include theme-variant() {\n  .nav-underline-#{$color} {\n    .nav-link.active,\n    .show > .nav-link {\n      color: $value;\n      border-color: $value;\n    }\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n\n// Tabs in Sidebar\n\n.c-sidebar {\n  .nav-tabs:first-child,\n  .c-sidebar-close + .nav-tabs {\n    .nav-link {\n      display: flex;\n      align-items: center;\n      height: $sidebar-brand-height;\n      padding-top: 0;\n      padding-bottom: 0;\n    }\n  }\n}\n","// Navs\n\n// scss-docs-start nav\n$nav-link-padding-y:  .5rem !default;\n$nav-link-padding-x:  1rem !default;\n\n$nav-tabs-border-width:   $border-width !default;\n$nav-tabs-border-radius:  $border-radius !default;\n\n$nav-tabs-boxed-content-padding-y:     .75rem !default;\n$nav-tabs-boxed-content-padding-x:     1.25rem !default;\n$nav-tabs-boxed-content-border-width:  $border-width !default;\n\n$nav-pills-border-radius:  $border-radius !default;\n\n$nav-divider-margin-y:  $spacer / 2 !default;\n// scss-docs-end nav\n\n// Light Theme\n// scss-docs-start nav-default-theme\n$nav-link-disabled-color:            $gray-600 !default;\n$nav-tabs-border-color:              $gray-300 !default;\n$nav-tabs-link-hover-border-color:   $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:         $gray-700 !default;\n$nav-tabs-link-active-bg:            $body-bg !default;\n$nav-tabs-link-active-border-color:  $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-tabs-boxed-link-active-bg:         $white !default;\n$nav-tabs-boxed-content-bg:             $white !default;\n$nav-tabs-boxed-content-border-color:   $border-color !default;\n$nav-tabs-boxed-content-border-radius:  $border-radius !default;\n\n$nav-tabs-boxed-left-active-border-color:   $border-color $white $border-color $border-color !default;\n$nav-tabs-boxed-right-active-border-color:  $border-color $border-color $border-color $white !default;\n\n$nav-pills-link-active-color:  $component-active-color !default;\n$nav-pills-link-active-bg:     $component-active-bg !default;\n$nav-divider-color:            $gray-200 !default;\n// scss-docs-end nav-default-theme\n\n$nav-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$nav-theme-map: map-merge(\n  (\n    default: (\n      \"nav-link-disabled-color\":                   $nav-link-disabled-color,\n      \"nav-tabs-border-color\":                     $nav-tabs-border-color,\n      \"nav-tabs-link-hover-border-color\":          $nav-tabs-link-hover-border-color,\n      \"nav-tabs-link-active-color\":                $nav-tabs-link-active-color,\n      \"nav-tabs-link-active-bg\":                   $nav-tabs-link-active-bg,\n      \"nav-tabs-link-active-border-color\":         $nav-tabs-link-active-border-color,\n      \"nav-pills-link-active-color\":               $nav-pills-link-active-color,\n      \"nav-pills-link-active-bg\":                  $nav-pills-link-active-bg,\n      \"nav-divider-color\":                         $nav-divider-color,\n      \"nav-tabs-boxed-link-active-bg\":             $nav-tabs-boxed-link-active-bg,\n      \"nav-tabs-boxed-content-bg\":                 $nav-tabs-boxed-content-bg,\n      \"nav-tabs-boxed-content-border-color\":       $nav-tabs-boxed-content-border-color,\n      \"nav-tabs-boxed-left-active-border-color\":   $nav-tabs-boxed-left-active-border-color,\n      \"nav-tabs-boxed-right-active-border-color\":  $nav-tabs-boxed-right-active-border-color\n    )\n  ),\n  $nav-theme-map\n);\n","\n// Sidebar\n// scss-docs-start sidebar\n$sidebar-width:     256px !default;\n$sidebar-sm-width:  192px !default;\n$sidebar-lg-width:  320px !default;\n$sidebar-xl-width:  384px !default;\n\n$sidebar-widths: (\n  sm: 192px,\n  lg: 320px,\n  xl: 384px\n) !default;\n\n$sidebar-padding:           0 !default;\n$sidebar-minimized-width:   56px !default;\n$sidebar-minimized-height:  $sidebar-minimized-width !default;\n$sidebar-compact-width:     150px !default;\n\n$sidebar-backdrop-bg:       $black !default;\n$sidebar-backdrop-opacity:  .5 !default;\n// scss-docs-end sidebar\n\n// scss-docs-start sidebar-default-theme\n$sidebar-dark-color:    $white !default;\n$sidebar-dark-bg:       $gray-base !default;\n$sidebar-dark-borders:  none !default;\n\n$sidebar-light-color:    $body-color !default;\n$sidebar-light-bg:       $white !default;\n$sidebar-light-borders:  (\n  right: 1px solid rgba(darken($border-color, 20%), .5)\n) !default;\n// scss-docs-end sidebar-default-theme\n\n// Sidebar Brand\n// scss-docs-start sidebar-brand\n$sidebar-brand-height:  56px !default;\n// scss-docs-end sidebar-brand\n\n// scss-docs-start sidebar-brand-default-theme\n$sidebar-dark-brand-color:  $white !default;\n$sidebar-dark-brand-bg:     rgba($black, .2) !default;\n\n$sidebar-light-brand-color:  $white !default;\n$sidebar-light-brand-bg:     $primary !default;\n// scss-docs-end sidebar-brand-default-theme\n\n// Sidebar Header\n// scss-docs-start sidebar-header\n$sidebar-header-height:     auto !default;\n$sidebar-header-padding-y:  .75rem !default;\n$sidebar-header-padding-x:  1rem !default;\n// scss-docs-end sidebar-header\n\n// scss-docs-start sidebar-header-default-theme\n$sidebar-dark-header-bg:  rgba($black, .2) !default;\n$sidebar-light-header-bg: rgba($black, .2) !default;\n// scss-docs-end sidebar-header-default-theme\n\n// Sidebar Form\n// scss-docs-start sidebar-form-default-theme\n$sidebar-dark-form-border:              0 !default;\n$sidebar-dark-form-bg:                  rgba($black, .1) !default;\n$sidebar-dark-form-color:               $white !default;\n$sidebar-dark-form-placeholder-color:   rgba($white, .7) !default;\n\n$sidebar-light-form-border:             0 !default;\n$sidebar-light-form-bg:                 rgba($black, .1) !default;\n$sidebar-light-form-color:              $white !default;\n$sidebar-light-form-placeholder-color:  rgba($white, .7) !default;\n// scss-docs-end sidebar-form-default-theme\n\n\n// Sidebar Navigation\n// scss-docs-start sidebar-nav\n$sidebar-nav-title-padding-y:   .75rem !default;\n$sidebar-nav-title-padding-x:   1rem !default;\n$sidebar-nav-title-margin-top:  1rem !default;\n$sidebar-nav-link-padding-y:    .8445rem !default;\n$sidebar-nav-link-padding-x:    1rem !default;\n$sidebar-nav-icon-width:        56px !default;\n\n$sidebar-nav-indentation-levels: 5 !default;\n$sidebar-nav-indentation-size:   8px !default;\n// scss-docs-end sidebar-nav\n\n// scss-docs-start sidebar-nav-default-theme\n$sidebar-dark-nav-title-color:      rgba($white, .6) !default;\n$sidebar-dark-nav-link-color:       rgba($white, .8) !default;\n$sidebar-dark-nav-link-bg:          transparent !default;\n$sidebar-dark-nav-link-icon-color:  rgba($white, .5) !default;\n$sidebar-dark-nav-link-borders:     0 !default;\n\n$sidebar-light-nav-title-color:      rgba($black, .4) !default;\n$sidebar-light-nav-link-color:       rgba($black, .8) !default;\n$sidebar-light-nav-link-bg:          transparent !default;\n$sidebar-light-nav-link-icon-color:  rgba($black, .5) !default;\n$sidebar-light-nav-link-borders:     0 !default;\n\n\n$sidebar-dark-nav-link-hover-color:       $white !default;\n$sidebar-dark-nav-link-hover-bg:          theme-color(\"primary\") !default;\n$sidebar-dark-nav-link-hover-icon-color:  $white !default;\n$sidebar-dark-nav-link-hover-borders:     0 !default;\n\n$sidebar-light-nav-link-hover-color:       $white !default;\n$sidebar-light-nav-link-hover-bg:          theme-color(\"primary\") !default;\n$sidebar-light-nav-link-hover-icon-color:  $white !default;\n$sidebar-light-nav-link-hover-borders:     0 !default;\n\n\n$sidebar-dark-nav-link-active-color:       $white !default;\n$sidebar-dark-nav-link-active-bg:          rgba($white, .05) !default;\n$sidebar-dark-nav-link-active-icon-color:  $white !default;\n$sidebar-dark-nav-link-active-borders:     0 !default;\n\n$sidebar-light-nav-link-active-color:       rgba($black, .8) !default;\n$sidebar-light-nav-link-active-bg:          rgba($black, .05) !default;\n$sidebar-light-nav-link-active-icon-color:  $primary !default;\n$sidebar-light-nav-link-active-borders:     0 !default;\n\n\n$sidebar-dark-nav-link-disabled-color:       darken($white, 30%) !default;\n$sidebar-dark-nav-link-disabled-bg:          $sidebar-dark-bg !default;\n$sidebar-dark-nav-link-disabled-icon-color:  $sidebar-dark-nav-link-icon-color !default;\n$sidebar-dark-nav-link-disabled-borders:     0 !default;\n\n$sidebar-light-nav-link-disabled-color:       darken($white, 30%) !default;\n$sidebar-light-nav-link-disabled-bg:          $sidebar-light-bg !default;\n$sidebar-light-nav-link-disabled-icon-color:  $sidebar-light-nav-link-icon-color !default;\n$sidebar-light-nav-link-disabled-borders:     0 !default;\n\n$sidebar-dark-nav-dropdown-color:                  $white !default;\n$sidebar-dark-nav-dropdown-bg:                   rgba(0, 0, 0, .2) !default;\n$sidebar-dark-nav-dropdown-borders:                0 !default;\n$sidebar-dark-nav-dropdown-indicator-color:        rgba($white, .5) !default;\n$sidebar-dark-nav-dropdown-indicator:              str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-dark-nav-dropdown-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$sidebar-dark-nav-dropdown-indicator-hover-color:  $sidebar-dark-nav-link-hover-color !default;\n$sidebar-dark-nav-dropdown-indicator-hover:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-dark-nav-dropdown-indicator-hover-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$sidebar-light-nav-dropdown-color:                  rgba($black, .8) !default;\n$sidebar-light-nav-dropdown-bg:                   rgba(0, 0, 0, .05) !default;\n$sidebar-light-nav-dropdown-borders:                0 !default;\n$sidebar-light-nav-dropdown-indicator-color:        rgba($black, .5) !default;\n$sidebar-light-nav-dropdown-indicator:              str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-light-nav-dropdown-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$sidebar-light-nav-dropdown-indicator-hover-color:  $sidebar-dark-nav-link-hover-color !default;\n$sidebar-light-nav-dropdown-indicator-hover:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-light-nav-dropdown-indicator-hover-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n// scss-docs-end sidebar-nav-default-theme\n\n// Sidebar Tabs\n// scss-docs-start sidebar-nav-tabs\n$sidebar-nav-tabs-link-padding-y:  .75rem !default;\n$sidebar-nav-tabs-link-padding-x:  1rem !default;\n// scss-docs-end sidebar-nav-tabs\n\n// scss-docs-start sidebar-nav-tabs-default-theme\n$sidebar-dark-nav-tabs-border-color:              rgba($black, .2) !default;\n$sidebar-dark-nav-tabs-link-active-bg:            rgba($white, .05) !default;\n$sidebar-dark-nav-tabs-link-active-border-color:  rgba($black, .2) rgba($black, .2) theme-color(\"primary\") !default;\n$sidebar-dark-nav-tabs-link-hover-bg:             rgba($black, .2) !default;\n$sidebar-dark-nav-tabs-link-hover-border-color:   rgba($black, .2) rgba($black, .2) $gray-200 !default;\n$sidebar-dark-tab-content-borders:                ( top: 1px solid rgba($black, .2)) !default;\n\n$sidebar-light-nav-tabs-border-color:              rgba(darken($border-color, 20%), .5) !default;\n$sidebar-light-nav-tabs-link-active-bg:            $white !default;\n$sidebar-light-nav-tabs-link-active-border-color:  rgba(darken($border-color, 20%), .5) rgba(darken($border-color, 20%), .5) $white !default;\n$sidebar-light-nav-tabs-link-hover-bg:             $white !default;\n$sidebar-light-nav-tabs-link-hover-border-color:   rgba(darken($border-color, 20%), .5) rgba(darken($border-color, 20%), .5) $white !default;\n$sidebar-light-tab-content-borders:                ( top: 1px solid rgba(darken($border-color, 20%), .5)) !default;\n// scss-docs-end sidebar-nav-tabs-default-theme\n\n// Sidebar Footer\n// scss-docs-start sidebar-footer\n$sidebar-footer-height:     auto !default;\n$sidebar-footer-padding-y:  .75rem !default;\n$sidebar-footer-padding-x:  1rem !default;\n// scss-docs-end sidebar-footer\n\n// scss-docs-start sidebar-footer-default-theme\n$sidebar-dark-footer-bg:        rgba($black, .2) !default;\n$sidebar-dark-footer-borders:   0 !default;\n\n$sidebar-light-footer-bg:       rgba($black, .2) !default;\n$sidebar-light-footer-borders:  0 !default;\n// scss-docs-end sidebar-footer-default-theme\n\n// Sidebar Minimizer\n// scss-docs-start sidebar-minimizer\n$sidebar-minimizer-height:                      50px !default;\n// scss-docs-end sidebar-minimizer\n\n// scss-docs-start sidebar-minimizer-default-theme\n$sidebar-dark-minimizer-borders:                0 !default;\n$sidebar-dark-minimizer-bg:                     rgba($black, .2) !default;\n$sidebar-dark-minimizer-indicator-color:        $gray-600 !default;\n$sidebar-dark-minimizer-indicator:              str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-dark-minimizer-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$sidebar-dark-minimizer-hover-bg:              rgba(0, 0, 0, .3) !default;\n$sidebar-dark-minimizer-hover-indicator-color:  $sidebar-dark-nav-link-hover-color !default;\n$sidebar-dark-minimizer-hover-indicator:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-dark-minimizer-hover-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$sidebar-light-minimizer-borders:                0 !default;\n$sidebar-light-minimizer-bg:                     rgba(0, 0, 0, .05) !default;\n$sidebar-light-minimizer-indicator-color:        $gray-600 !default;\n$sidebar-light-minimizer-indicator:              str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-light-minimizer-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$sidebar-light-minimizer-hover-bg:               rgba(0, 0, 0, .1) !default;\n$sidebar-light-minimizer-hover-indicator-color:  $gray-700 !default;\n$sidebar-light-minimizer-hover-indicator:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-light-minimizer-hover-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n// scss-docs-end sidebar-minimizer-default-theme\n\n$sidebar-variants-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$sidebar-variants-map: map-merge(\n  (\n    dark: (\n      \"sidebar-color\":                               $sidebar-dark-color,\n      \"sidebar-bg\":                                  $sidebar-dark-bg,\n      \"dark-theme-sidebar-bg\":                       0,\n      \"sidebar-borders\":                             $sidebar-dark-borders,\n      \"dark-theme-sidebar-borders\":                  0,\n      \"sidebar-brand-color\":                         $sidebar-dark-brand-color,\n      \"sidebar-brand-bg\":                            $sidebar-dark-brand-bg,\n      \"sidebar-header-bg\":                           $sidebar-dark-header-bg,\n      \"sidebar-form-border\":                         $sidebar-dark-form-border,\n      \"sidebar-form-bg\":                             $sidebar-dark-form-bg,\n      \"sidebar-form-color\":                          $sidebar-dark-form-color,\n      \"sidebar-form-placeholder-color\":              $sidebar-dark-form-placeholder-color,\n      \"sidebar-nav-title-color\":                     $sidebar-dark-nav-title-color,\n      \"sidebar-nav-link-color\":                      $sidebar-dark-nav-link-color,\n      \"sidebar-nav-link-bg\":                         $sidebar-dark-nav-link-bg,\n      \"sidebar-nav-link-icon-color\":                 $sidebar-dark-nav-link-icon-color,\n      \"sidebar-nav-link-borders\":                    $sidebar-dark-nav-link-borders,\n      \"sidebar-nav-link-hover-color\":                $sidebar-dark-nav-link-hover-color,\n      \"sidebar-nav-link-hover-bg\":                   $sidebar-dark-nav-link-hover-bg,\n      \"sidebar-nav-link-hover-icon-color\":           $sidebar-dark-nav-link-hover-icon-color,\n      \"sidebar-nav-link-hover-borders\":              $sidebar-dark-nav-link-hover-borders,\n      \"sidebar-nav-link-active-color\":               $sidebar-dark-nav-link-active-color,\n      \"sidebar-nav-link-active-bg\":                  $sidebar-dark-nav-link-active-bg,\n      \"sidebar-nav-link-active-icon-color\":          $sidebar-dark-nav-link-active-icon-color,\n      \"sidebar-nav-link-active-borders\":             $sidebar-dark-nav-link-active-borders,\n      \"sidebar-nav-link-disabled-color\":             $sidebar-dark-nav-link-disabled-color,\n      \"sidebar-nav-link-disabled-bg\":                $sidebar-dark-nav-link-disabled-bg,\n      \"sidebar-nav-link-disabled-icon-color\":        $sidebar-dark-nav-link-disabled-icon-color,\n      \"sidebar-nav-link-disabled-borders\":           $sidebar-dark-nav-link-disabled-borders,\n      \"sidebar-nav-dropdown-color\":                  $sidebar-dark-nav-dropdown-color,\n      \"sidebar-nav-dropdown-bg\":                     $sidebar-dark-nav-dropdown-bg,\n      \"sidebar-nav-dropdown-borders\":                $sidebar-dark-nav-dropdown-borders,\n      \"sidebar-nav-dropdown-indicator-color\":        $sidebar-dark-nav-dropdown-indicator-color,\n      \"sidebar-nav-dropdown-indicator\":              $sidebar-dark-nav-dropdown-indicator,\n      \"sidebar-nav-dropdown-indicator-hover-color\":  $sidebar-dark-nav-dropdown-indicator-hover-color,\n      \"sidebar-nav-dropdown-indicator-hover\":        $sidebar-dark-nav-dropdown-indicator-hover,\n      \"sidebar-nav-tabs-border-color\":               $sidebar-dark-nav-tabs-border-color,\n      \"sidebar-nav-tabs-link-active-bg\":             $sidebar-dark-nav-tabs-link-active-bg,\n      \"sidebar-nav-tabs-link-active-border-color\":   $sidebar-dark-nav-tabs-link-active-border-color,\n      \"sidebar-nav-tabs-link-hover-bg\":              $sidebar-dark-nav-tabs-link-hover-bg,\n      \"sidebar-nav-tabs-link-hover-border-color\":    $sidebar-dark-nav-tabs-link-hover-border-color,\n      \"sidebar-tab-content-borders\":                 $sidebar-dark-tab-content-borders,\n      \"sidebar-footer-bg\":                           $sidebar-dark-footer-bg,\n      \"sidebar-footer-borders\":                      $sidebar-dark-footer-borders,\n      \"sidebar-minimizer-borders\":                   $sidebar-dark-minimizer-borders,\n      \"sidebar-minimizer-bg\":                        $sidebar-dark-minimizer-bg,\n      \"sidebar-minimizer-indicator-color\":           $sidebar-dark-minimizer-indicator-color,\n      \"sidebar-minimizer-indicator\":                 $sidebar-dark-minimizer-indicator,\n      \"sidebar-minimizer-hover-bg\":                  $sidebar-dark-minimizer-hover-bg,\n      \"sidebar-minimizer-hover-indicator-color\":     $sidebar-dark-minimizer-hover-indicator-color,\n      \"sidebar-minimizer-hover-indicator\":           $sidebar-dark-minimizer-hover-indicator\n    ),\n    light: (\n      \"sidebar-color\":                               $sidebar-light-color,\n      \"sidebar-bg\":                                  $sidebar-light-bg,\n      \"dark-theme-sidebar-bg\":                       0,\n      \"sidebar-borders\":                             $sidebar-light-borders,\n      \"dark-theme-sidebar-borders\":                  0,\n      \"sidebar-brand-color\":                         $sidebar-light-brand-color,\n      \"sidebar-brand-bg\":                            $sidebar-light-brand-bg,\n      \"sidebar-header-bg\":                           $sidebar-light-header-bg,\n      \"sidebar-form-border\":                         $sidebar-light-form-border,\n      \"sidebar-form-bg\":                             $sidebar-light-form-bg,\n      \"sidebar-form-color\":                          $sidebar-light-form-color,\n      \"sidebar-form-placeholder-color\":              $sidebar-light-form-placeholder-color,\n      \"sidebar-nav-title-color\":                     $sidebar-light-nav-title-color,\n      \"sidebar-nav-link-color\":                      $sidebar-light-nav-link-color,\n      \"sidebar-nav-link-bg\":                         $sidebar-light-nav-link-bg,\n      \"sidebar-nav-link-icon-color\":                 $sidebar-light-nav-link-icon-color,\n      \"sidebar-nav-link-borders\":                    $sidebar-light-nav-link-borders,\n      \"sidebar-nav-link-hover-color\":                $sidebar-light-nav-link-hover-color,\n      \"sidebar-nav-link-hover-bg\":                   $sidebar-light-nav-link-hover-bg,\n      \"sidebar-nav-link-hover-icon-color\":           $sidebar-light-nav-link-hover-icon-color,\n      \"sidebar-nav-link-hover-borders\":              $sidebar-light-nav-link-hover-borders,\n      \"sidebar-nav-link-active-color\":               $sidebar-light-nav-link-active-color,\n      \"sidebar-nav-link-active-bg\":                  $sidebar-light-nav-link-active-bg,\n      \"sidebar-nav-link-active-icon-color\":          $sidebar-light-nav-link-active-icon-color,\n      \"sidebar-nav-link-active-borders\":             $sidebar-light-nav-link-active-borders,\n      \"sidebar-nav-link-disabled-color\":             $sidebar-light-nav-link-disabled-color,\n      \"sidebar-nav-link-disabled-bg\":                $sidebar-light-nav-link-disabled-bg,\n      \"sidebar-nav-link-disabled-icon-color\":        $sidebar-light-nav-link-disabled-icon-color,\n      \"sidebar-nav-link-disabled-borders\":           $sidebar-light-nav-link-disabled-borders,\n      \"sidebar-nav-dropdown-color\":                  $sidebar-light-nav-dropdown-color,\n      \"sidebar-nav-dropdown-bg\":                     $sidebar-light-nav-dropdown-bg,\n      \"sidebar-nav-dropdown-borders\":                $sidebar-light-nav-dropdown-borders,\n      \"sidebar-nav-dropdown-indicator-color\":        $sidebar-light-nav-dropdown-indicator-color,\n      \"sidebar-nav-dropdown-indicator\":              $sidebar-light-nav-dropdown-indicator,\n      \"sidebar-nav-dropdown-indicator-hover-color\":  $sidebar-light-nav-dropdown-indicator-hover-color,\n      \"sidebar-nav-dropdown-indicator-hover\":        $sidebar-light-nav-dropdown-indicator-hover,\n      \"sidebar-nav-tabs-border-color\":               $sidebar-light-nav-tabs-border-color,\n      \"sidebar-nav-tabs-link-active-bg\":             $sidebar-light-nav-tabs-link-active-bg,\n      \"sidebar-nav-tabs-link-active-border-color\":   $sidebar-light-nav-tabs-link-active-border-color,\n      \"sidebar-nav-tabs-link-hover-bg\":              $sidebar-light-nav-tabs-link-hover-bg,\n      \"sidebar-nav-tabs-link-hover-border-color\":    $sidebar-light-nav-tabs-link-hover-border-color,\n      \"sidebar-tab-content-borders\":                 $sidebar-light-tab-content-borders,\n      \"sidebar-footer-bg\":                           $sidebar-light-footer-bg,\n      \"sidebar-footer-borders\":                      $sidebar-light-footer-borders,\n      \"sidebar-minimizer-borders\":                   $sidebar-light-minimizer-borders,\n      \"sidebar-minimizer-bg\":                        $sidebar-light-minimizer-bg,\n      \"sidebar-minimizer-indicator-color\":           $sidebar-light-minimizer-indicator-color,\n      \"sidebar-minimizer-indicator\":                 $sidebar-light-minimizer-indicator,\n      \"sidebar-minimizer-hover-bg\":                  $sidebar-light-minimizer-hover-bg,\n      \"sidebar-minimizer-hover-indicator-color\":     $sidebar-light-minimizer-hover-indicator-color,\n      \"sidebar-minimizer-hover-indicator\":           $sidebar-light-minimizer-hover-indicator,\n    )\n  ),\n  $sidebar-variants-map\n);\n\n$sidebar-default-variant: \"dark\" !default;\n$sidebar-variants: (\n  map: $sidebar-variants-map,\n  default: $sidebar-default-variant\n) !default;\n\n$sidebar-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$sidebar-theme-map: map-merge(\n  (\n    default: $sidebar-variants,\n  ),\n  $sidebar-theme-map\n);\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  @include ltr {\n    padding-left: 0; // reset padding because ul and ol\n  }\n  @include rtl {\n    padding-right: 0; // reset padding because ul and ol\n  }\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n@include themes($navbar-theme-map, $create: append, $parent: \".navbar\") {\n  .navbar-brand {\n    color: themes-get-value(\"navbar-brand-color\");\n\n    @include hover-focus() {\n      color: themes-get-value(\"navbar-brand-hover-color\");\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: themes-get-value(\"navbar-color\");\n\n      @include hover-focus() {\n        color: themes-get-value(\"navbar-hover-color\");\n      }\n\n      &.disabled {\n        color: themes-get-value(\"navbar-disabled-color\");\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: themes-get-value(\"navbar-active-color\");\n    }\n  }\n\n  .navbar-toggler {\n    color: themes-get-value(\"navbar-color\");\n    border-color: themes-get-value(\"navbar-toggler-border-color\");\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg(themes-get-value(\"navbar-toggler-icon-bg\"));\n  }\n\n  .navbar-text {\n    color: themes-get-value(\"navbar-color\");\n    a {\n      color: themes-get-value(\"navbar-active-color\");\n\n      @include hover-focus() {\n        color: themes-get-value(\"navbar-active-color\");\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n// .navbar-light {\n//   .navbar-brand {\n//     color: $navbar-light-brand-color;\n\n//     @include hover-focus() {\n//       color: $navbar-light-brand-hover-color;\n//     }\n//   }\n\n//   .navbar-nav {\n//     .nav-link {\n//       color: $navbar-light-color;\n\n//       @include hover-focus() {\n//         color: $navbar-light-hover-color;\n//       }\n\n//       &.disabled {\n//         color: $navbar-light-disabled-color;\n//       }\n//     }\n\n//     .show > .nav-link,\n//     .active > .nav-link,\n//     .nav-link.show,\n//     .nav-link.active {\n//       color: $navbar-light-active-color;\n//     }\n//   }\n\n//   .navbar-toggler {\n//     color: $navbar-light-color;\n//     border-color: $navbar-light-toggler-border-color;\n//   }\n\n//   .navbar-toggler-icon {\n//     background-image: escape-svg($navbar-light-toggler-icon-bg);\n//   }\n\n//   .navbar-text {\n//     color: $navbar-light-color;\n//     a {\n//       color: $navbar-light-active-color;\n\n//       @include hover-focus() {\n//         color: $navbar-light-active-color;\n//       }\n//     }\n//   }\n// }\n\n// // White links against a dark background\n// .navbar-dark {\n//   .navbar-brand {\n//     color: $navbar-dark-brand-color;\n\n//     @include hover-focus() {\n//       color: $navbar-dark-brand-hover-color;\n//     }\n//   }\n\n//   .navbar-nav {\n//     .nav-link {\n//       color: $navbar-dark-color;\n\n//       @include hover-focus() {\n//         color: $navbar-dark-hover-color;\n//       }\n\n//       &.disabled {\n//         color: $navbar-dark-disabled-color;\n//       }\n//     }\n\n//     .show > .nav-link,\n//     .active > .nav-link,\n//     .nav-link.show,\n//     .nav-link.active {\n//       color: $navbar-dark-active-color;\n//     }\n//   }\n\n//   .navbar-toggler {\n//     color: $navbar-dark-color;\n//     border-color: $navbar-dark-toggler-border-color;\n//   }\n\n//   .navbar-toggler-icon {\n//     background-image: escape-svg($navbar-dark-toggler-icon-bg);\n//   }\n\n//   .navbar-text {\n//     color: $navbar-dark-color;\n//     a {\n//       color: $navbar-dark-active-color;\n\n//       @include hover-focus() {\n//         color: $navbar-dark-active-color;\n//       }\n//     }\n//   }\n// }\n","\n// Navbar\n\n// scss-docs-start navbar\n$navbar-padding-y:  $spacer / 2 !default;\n$navbar-padding-x:  $spacer !default;\n\n$navbar-nav-link-padding-x:  .5rem !default;\n\n$navbar-brand-font-size:  $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:         $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:     $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:  ($nav-link-height - $navbar-brand-height) / 2 !default;\n\n$navbar-toggler-padding-y:      .25rem !default;\n$navbar-toggler-padding-x:      .75rem !default;\n$navbar-toggler-font-size:      $font-size-lg !default;\n$navbar-toggler-border-radius:  $btn-border-radius !default;\n// scss-docs-end navbar\n\n// scss-docs-start navbar-default-theme\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                 rgba($black, .5) !default;\n$navbar-light-hover-color:           rgba($black, .7) !default;\n$navbar-light-active-color:          rgba($black, .9) !default;\n$navbar-light-disabled-color:        rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color:  rgba($black, .1) !default;\n\n$navbar-light-brand-color:        $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:  $navbar-light-active-color !default;\n$navbar-dark-brand-color:         $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:   $navbar-dark-active-color !default;\n// scss-docs-end navbar-default-theme\n\n$navbar-variants-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$navbar-variants-map: map-merge(\n  (\n    dark: (\n      \"navbar-color\":                 $navbar-dark-color,\n      \"navbar-hover-color\":           $navbar-dark-hover-color,\n      \"navbar-active-color\":          $navbar-dark-active-color,\n      \"navbar-disabled-color\":        $navbar-dark-disabled-color,\n      \"navbar-toggler-icon-bg\":       $navbar-dark-toggler-icon-bg,\n      \"navbar-toggler-border-color\":  $navbar-dark-toggler-border-color,\n      \"navbar-brand-color\":           $navbar-dark-brand-color,\n      \"navbar-brand-hover-color\":     $navbar-dark-brand-hover-color\n    ),\n    light: (\n      \"navbar-color\":                 $navbar-light-color,\n      \"navbar-hover-color\":           $navbar-light-hover-color,\n      \"navbar-active-color\":          $navbar-light-active-color,\n      \"navbar-disabled-color\":        $navbar-light-disabled-color,\n      \"navbar-toggler-icon-bg\":       $navbar-light-toggler-icon-bg,\n      \"navbar-toggler-border-color\":  $navbar-light-toggler-border-color,\n      \"navbar-brand-color\":           $navbar-light-brand-color,\n      \"navbar-brand-hover-color\":     $navbar-light-brand-hover-color\n    )\n  ),\n  $navbar-variants-map\n);\n\n$navbar-default-variant: null !default;\n$navbar-variants: (\n  default:  $navbar-default-variant,\n  map:      $navbar-variants-map\n) !default;\n\n$navbar-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$navbar-theme-map: map-merge(\n  (\n    default:  $navbar-variants\n  ),\n  $navbar-theme-map\n);\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  line-height: $pagination-line-height;\n  text-decoration: if($link-decoration == none, null, none);\n  border: $pagination-border-width solid;\n  @include ltr {\n    margin-left: -$pagination-border-width;\n  }\n  @include rtl {\n    margin-right: -$pagination-border-width;\n  }\n  @include themes($pagination-theme-map, $create: parent) {\n    color: themes-get-value(\"pagination-color\");\n    background-color: themes-get-value(\"pagination-bg\");\n    border-color: themes-get-value(\"pagination-border-color\");\n  }\n\n  &:hover {\n    z-index: 2;\n    text-decoration: none;\n    @include themes($pagination-theme-map, $create: parent) {\n      color: themes-get-value(\"pagination-hover-color\");\n      background-color: themes-get-value(\"pagination-hover-bg\");\n      border-color: themes-get-value(\"pagination-hover-border-color\");\n    }\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      @include ltr {\n        margin-left: 0;\n        @include border-left-radius($border-radius);\n      }\n      @include rtl {\n        margin-right: 0;\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include ltr {\n        @include border-right-radius($border-radius);\n      }\n      @include rtl {\n        @include border-left-radius($border-radius);\n      }\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    @include themes($pagination-theme-map, $create: parent) {\n      color: themes-get-value(\"pagination-active-color\");\n      background-color: themes-get-value(\"pagination-active-bg\");\n      border-color: themes-get-value(\"pagination-active-border-color\");\n    }\n  }\n\n  &.disabled .page-link {\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    @include themes($pagination-theme-map, $create: parent) {\n      color: themes-get-value(\"pagination-disabled-color\");\n      background-color: themes-get-value(\"pagination-disabled-bg\");\n      border-color: themes-get-value(\"pagination-disabled-border-color\");\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $border-radius-sm);\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  @include ltr {\n    padding-left: 0; // reset padding because ul and ol\n  }\n  @include rtl {\n    padding-right: 0; // reset padding because ul and ol\n  }\n  list-style: none;\n}\n","\n// Pagination\n\n// scss-docs-start pagination\n$pagination-padding-y:     .5rem !default;\n$pagination-padding-x:     .75rem !default;\n$pagination-padding-y-sm:  .25rem !default;\n$pagination-padding-x-sm:  .5rem !default;\n$pagination-padding-y-lg:  .75rem !default;\n$pagination-padding-x-lg:  1.5rem !default;\n$pagination-line-height:   1.25 !default;\n$pagination-border-width:  $border-width !default;\n// scss-docs-end pagination\n\n// Default theme\n// scss-docs-start pagination-default-theme\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-color:           $border-color !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n// scss-docs-end pagination-default-theme\n\n$pagination-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$pagination-theme-map: map-merge(\n  (\n    default: (\n      \"pagination-color\":                  $pagination-color,\n      \"pagination-bg\":                     $pagination-bg,\n      \"pagination-border-color\":           $pagination-border-color,\n      \"pagination-focus-box-shadow\":       $pagination-focus-box-shadow,\n      \"pagination-focus-outline\":          $pagination-focus-outline,\n      \"pagination-hover-color\":            $pagination-hover-color,\n      \"pagination-hover-bg\":               $pagination-hover-bg,\n      \"pagination-hover-border-color\":     $pagination-hover-border-color,\n      \"pagination-active-color\":           $pagination-active-color,\n      \"pagination-active-bg\":              $pagination-active-bg,\n      \"pagination-active-border-color\":    $pagination-active-border-color,\n      \"pagination-disabled-color\":         $pagination-disabled-color,\n      \"pagination-disabled-bg\":            $pagination-disabled-bg,\n      \"pagination-disabled-border-color\":  $pagination-disabled-border-color\n    )\n  ),\n  $pagination-theme-map\n);\n\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include ltr {\n          @include border-left-radius($border-radius);\n        }\n        @include rtl {\n          @include border-right-radius($border-radius);\n        }\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include ltr {\n          @include border-right-radius($border-radius);\n        }\n        @include rtl {\n          @include border-left-radius($border-radius);\n        }\n      }\n    }\n  }\n}\n",".popover {\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-clip: padding-box;\n  border: $popover-border-width solid;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n  @include themes($popover-theme-map) {\n    background-color: themes-get-value(\"popover-bg\");\n    border-color: themes-get-value(\"popover-border-color\");\n  }\n\n  .popover-arrow {\n    position: absolute;\n    display: block;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n%bs-popover-top,\n%bs-popover-bottom {\n  .popover-arrow {\n    width: add($popover-arrow-width, (2 * $popover-border-radius));\n    height: $popover-arrow-height;\n    padding: 0 $popover-border-radius; // make sure the arrow does not touch the popover's rounded corners\n  }\n}\n\n%bs-popover-right,\n%bs-popover-left {\n  .popover-arrow {\n    width: $popover-arrow-height;\n    height: add($popover-arrow-width, (2 * $popover-border-radius));\n    padding: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n    margin: 0;\n  }\n}\n\n%bs-popover-top {\n  // stylelint-disable-next-line declaration-no-important\n  margin-bottom: $popover-arrow-height !important; // Overwrite Popper 2 margins.\n\n  > .popover-arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n      @include themes($popover-theme-map) {\n        border-top-color: themes-get-value(\"popover-arrow-outer-color\");\n      }\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n      @include themes($popover-theme-map) {\n        border-top-color: themes-get-value(\"popover-arrow-color\");\n      }\n    }\n  }\n}\n\n%bs-popover-right {\n  // stylelint-disable-next-line declaration-no-important\n  margin-left: $popover-arrow-height !important; // Overwrite Popper 2 margins.\n\n  > .popover-arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n      @include themes($popover-theme-map) {\n        border-right-color: themes-get-value(\"popover-arrow-outer-color\");\n      }\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n      @include themes($popover-theme-map) {\n        border-right-color: themes-get-value(\"popover-arrow-color\");\n      }\n    }\n  }\n}\n\n%bs-popover-bottom {\n  // stylelint-disable-next-line declaration-no-important\n  margin-top: $popover-arrow-height !important; // Overwrite Popper 2 margins.\n\n  > .popover-arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n      @include themes($popover-theme-map) {\n        border-bottom-color: themes-get-value(\"popover-arrow-outer-color\");\n      }\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n      @include themes($popover-theme-map) {\n        border-bottom-color: themes-get-value(\"popover-arrow-color\");\n      }\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width / 2;\n    content: \"\";\n    border-bottom: $popover-border-width solid;\n    @include themes($popover-theme-map) {\n      border-bottom-color: themes-get-value(\"popover-header-bg\");\n    }\n  }\n}\n\n%bs-popover-left {\n  // stylelint-disable-next-line declaration-no-important\n  margin-left: $popover-arrow-height !important; // Overwrite Popper 2 margins.\n\n  > .popover-arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n      @include themes($popover-theme-map) {\n        border-left-color: themes-get-value(\"popover-arrow-outer-color\");\n      }\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n      @include themes($popover-theme-map) {\n        border-left-color: themes-get-value(\"popover-arrow-color\");\n      }\n    }\n  }\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\n.popover {\n  &[data-popper-placement^=\"top\"] {\n    @extend %bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend %bs-popover-right;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend %bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend %bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  border-bottom: $popover-border-width solid;\n  @include border-top-radius($popover-inner-border-radius);\n  @include themes($popover-theme-map) {\n    color: themes-get-value(\"popover-header-color\");\n    background-color: themes-get-value(\"popover-header-bg\");\n    border-bottom-color: darken(themes-get-value(\"popover-header-bg\"), 5%);\n  }\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  @include themes($popover-theme-map) {\n    color: themes-get-value(\"popover-body-color\");\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n\n  @include themes($progress-theme-map, $create: parent) {\n    background-color: themes-get-value(\"progress-bg\");\n  }\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  text-align: center;\n  white-space: nowrap;\n  @include transition($progress-bar-transition);\n\n  @include themes($progress-theme-map, $create: parent) {\n    color: themes-get-value(\"progress-bar-color\");\n    background-color: themes-get-value(\"progress-bar-bg\");\n  }\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: progress-bar-stripes $progress-bar-animation-timing;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n\n.progress-xs {\n  height: 4px;\n}\n\n.progress-sm {\n  height: 8px;\n}\n\n// White progress bar\n.progress.progress-white {\n  background-color: rgba(255, 255, 255, .2);\n  .progress-bar {\n    background-color: $white;\n  }\n}\n","// Progress bars\n\n// scss-docs-start progress-bar\n$progress-height:     1rem !default;\n$progress-font-size:  $font-size-base * .75 !default;\n\n$progress-border-radius:  $border-radius !default;\n$progress-box-shadow:     inset 0 .1rem .1rem rgba($black, .1) !default;\n\n$progress-bar-animation-timing:  1s linear infinite !default;\n$progress-bar-transition:        width .6s ease !default;\n// scss-docs-end progress-bar\n\n// Default theme\n// scss-docs-start progress-bar-default-theme\n$progress-bg:         $gray-100 !default;\n$progress-bar-color:  $white !default;\n$progress-bar-bg:     theme-color(\"primary\") !default;\n// scss-docs-end progress-bar-default-theme\n\n$progress-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$progress-theme-map: map-merge(\n  (\n    default: (\n      \"progress-bg\":         $progress-bg,\n      \"progress-bar-color\":  $progress-bar-color,\n      \"progress-bar-bg\":     $progress-bar-bg\n    )\n  ),\n  $progress-theme-map\n);\n","//TODO: move all values to variables.scss\n.progress-group {\n  display: flex;\n  flex-flow: row wrap;\n  margin-bottom: $spacer;\n}\n\n.progress-group-prepend {\n  flex: 0 0 100px;\n  align-self: center;\n}\n\n.progress-group-icon {\n  font-size: $font-size-lg;\n\n  @include ltr {\n    margin: 0 $spacer 0 ($spacer * .25);\n  }\n  @include rtl {\n    margin: 0 ($spacer * .25) 0 $spacer;\n  }\n}\n\n.progress-group-text {\n  font-size: $font-size-sm;\n  color: $gray-700;\n}\n\n.progress-group-header {\n  display: flex;\n  flex-basis: 100%;\n  align-items: flex-end;\n  margin-bottom: ($spacer * .25);\n}\n\n.progress-group-bars {\n  flex-grow: 1;\n  align-self: center;\n\n  .progress:not(:last-child) {\n    margin-bottom: 2px;\n  }\n}\n\n.progress-group-header + .progress-group-bars {\n  flex-basis: 100%;\n}\n","\n// stylelint-disable selector-max-class, declaration-no-important, selector-max-compound-selectors, function-url-quotes, selector-max-combinators\n.c-sidebar {\n  position: relative;\n  display: flex;\n  // $sidebar-width is the width of the columns\n  flex: 0 0 $sidebar-width;\n  flex-direction: column;\n  // put the nav on the left\n  order: -1;\n  width: $sidebar-width;\n  padding: $sidebar-padding;\n  box-shadow: none;\n\n  &.c-sidebar-right {\n    order: 99;\n  }\n\n  @include media-breakpoint-down(breakpoint-before($mobile-breakpoint)) {\n    // Some of our components use this property to detect if the sidebar has mobile behavior.\n    --is-mobile: true;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 1;\n\n    @include ltr {\n      &:not(.c-sidebar-right){\n        left: 0;\n      }\n      &.c-sidebar-right {\n        right: 0;\n      }\n    }\n    @include rtl {\n      &:not(.c-sidebar-right){\n        right: 0;\n      }\n      &.c-sidebar-right {\n        left: 0;\n      }\n    }\n  }\n\n  @include ltr {\n    &:not(.c-sidebar-right){\n      margin-left: - $sidebar-width;\n    }\n    &.c-sidebar-right {\n      margin-right: - $sidebar-width;\n    }\n  }\n\n  @include rtl {\n    &:not(.c-sidebar-right){\n      margin-right: - $sidebar-width;\n    }\n    &.c-sidebar-right {\n      margin-left: - $sidebar-width;\n    }\n  }\n\n  &[class*=\"bg-\"]  {\n    border-color: rgba($black, .1);\n  }\n\n  @each $width, $value in $sidebar-widths {\n    &.c-sidebar-#{$width} {\n      flex: 0 0 $value;\n      width: $value;\n\n      @include ltr {\n        &:not(.c-sidebar-right){\n          margin-left: - $value;\n        }\n        &.c-sidebar-right {\n          margin-right: - $value;\n        }\n      }\n\n      @include rtl {\n        &:not(.c-sidebar-right){\n          margin-right: - $value;\n        }\n        &.c-sidebar-right {\n          margin-left: - $value;\n        }\n      }\n    }\n  }\n\n  &.c-sidebar-fixed {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      z-index: $zindex-fixed;\n\n      @include ltr {\n        &:not(.c-sidebar-right) {\n          left: 0;\n        }\n\n        &.c-sidebar-right {\n          right: 0;\n        }\n      }\n\n      @include rtl {\n        &:not(.c-sidebar-right) {\n          right: 0;\n        }\n\n        &.c-sidebar-right {\n          left: 0;\n        }\n      }\n    }\n  }\n\n  &.c-sidebar-overlaid {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 2;\n\n    @include ltr {\n      &:not(.c-sidebar-right) {\n        left: 0;\n      }\n\n      &.c-sidebar-right {\n        right: 0;\n      }\n    }\n\n    @include rtl {\n      &:not(.c-sidebar-right) {\n        right: 0;\n      }\n\n      &.c-sidebar-right {\n        left: 0;\n      }\n    }\n  }\n}\n\n//\n// Sidebar components\n//\n\n.c-sidebar-close {\n  position: absolute;\n  width: $sidebar-brand-height;\n  height: $sidebar-brand-height;\n  background: transparent;\n  border: 0;\n\n  @include hover() {\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n  }\n\n  @include ltr {\n    right: 0;\n  }\n\n  @include rtl {\n    left: 0;\n  }\n}\n\n.c-sidebar-brand {\n  display: flex;\n  flex: 0 0 $sidebar-brand-height;\n  align-items: center;\n  justify-content: center;\n\n  .c-sidebar-brand-minimized {\n    display: none;\n  }\n}\n\n.c-sidebar-header {\n  flex: 0 0 $sidebar-header-height;\n  padding: $sidebar-header-padding-y $sidebar-header-padding-x;\n  text-align: center;\n  transition: $layout-transition-speed;\n}\n\n// Sidebar navigation\n\n.c-sidebar-nav {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 0;\n  margin-bottom: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  list-style: none;\n\n  &.ps {\n    // Firefox\n    overflow: -moz-scrollbars-none;\n    // IE 10+\n    -ms-overflow-style: none;\n    // Chrome, Edge, Safari, Opera\n    &::-webkit-scrollbar {\n      width: 0 !important;\n    }\n  }\n}\n\n.c-sidebar-nav-title {\n  padding: $sidebar-nav-title-padding-y $sidebar-nav-title-padding-x;\n  margin-top: $sidebar-nav-title-margin-top;\n  font-size: 80%;\n  font-weight: 700;\n  text-transform: uppercase;\n  transition: $layout-transition-speed;\n}\n\n.c-sidebar-nav-divider {\n  height: 10px;\n  transition: height $layout-transition-speed;\n}\n\n.c-sidebar-nav-item {\n  width: inherit;\n}\n\n.c-sidebar-nav-link {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  padding: $sidebar-nav-link-padding-y $sidebar-nav-link-padding-x;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: background $layout-transition-speed, color $layout-transition-speed;\n  @if $enable-sidebar-nav-rounded {\n    border-radius: $border-radius;\n  }\n\n  .badge {\n    @include ltr {\n      margin-left: auto;\n    }\n    @include rtl {\n      margin-right: auto;\n    }\n  }\n\n  &.c-disabled {\n    cursor: $cursor-disabled;\n  }\n  @media (hover: hover), (-ms-high-contrast: none) {\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n\n.c-sidebar-nav-icon {\n  flex: 0 0 $sidebar-nav-icon-width;\n  height: ($font-size-base * 1.25);\n  font-size: ($font-size-base * 1.25);\n  text-align: center;\n  transition: $layout-transition-speed;\n  fill: currentColor;\n\n  &:first-child {\n    @include ltr {\n      margin-left: - $sidebar-nav-link-padding-x;\n    }\n    @include rtl {\n      margin-right: - $sidebar-nav-link-padding-x;\n    }\n  }\n}\n\n.c-sidebar-nav-dropdown {\n  position: relative;\n  transition: background $layout-transition-speed ease-in-out;\n\n  &.c-show {\n    @if $enable-sidebar-nav-rounded {\n      border-radius: $border-radius;\n    }\n    > .c-sidebar-nav-dropdown-items {\n      max-height: 1500px;\n    }\n\n    > .c-sidebar-nav-dropdown-toggle::after {\n      @include ltr {\n        transform: rotate(-90deg);\n      }\n      @include rtl {\n        transform: rotate(270deg);\n      }\n    }\n\n    + .c-sidebar-nav-dropdown.c-show {\n      margin-top: 1px;\n    }\n  }\n}\n\n.c-sidebar-nav-dropdown-toggle {\n  @extend .c-sidebar-nav-link;\n  cursor: pointer;\n\n  &::after {\n    display: block;\n    flex: 0 8px;\n    height: 8px;\n    content: \"\";\n    background-repeat: no-repeat;\n    background-position: center;\n    transition: transform $layout-transition-speed;\n\n    @include ltr {\n      margin-left: auto;\n    }\n    @include rtl {\n      margin-right: auto;\n      transform: rotate(180deg);\n    }\n  }\n\n  .badge {\n    @include ltr {\n      margin-right: $sidebar-nav-link-padding-x;\n    }\n    @include rtl {\n      margin-left: $sidebar-nav-link-padding-x;\n    }\n  }\n}\n\n.c-sidebar-nav-dropdown-items {\n  max-height: 0;\n  padding: 0;\n  overflow-y: hidden;\n  list-style: none;\n  transition: max-height $layout-transition-speed ease-in-out;\n\n  .c-sidebar-nav-link {\n    @include ltr {\n      padding-left: $sidebar-nav-icon-width;\n    }\n    @include rtl {\n      padding-right: $sidebar-nav-icon-width;\n    }\n\n    .c-sidebar-nav-icon {\n      @include ltr {\n        margin-left: - $sidebar-nav-icon-width;\n      }\n      @include rtl {\n        margin-right: - $sidebar-nav-icon-width;\n      }\n    }\n  }\n}\n\n\n.c-sidebar-nav[data-indentation=\"true\"] {\n  $wrapper-class-name: \".c-sidebar-nav-dropdown-items\";\n  @for $i from 1 through $sidebar-nav-indentation-levels {\n    #{$wrapper-class-name} {\n      .c-sidebar-nav-link {\n        @include ltr {\n          padding-left: $sidebar-nav-icon-width + ($i * $sidebar-nav-indentation-size);\n        }\n        @include rtl {\n          padding-right: $sidebar-nav-icon-width + ($i * $sidebar-nav-indentation-size);\n        }\n        .c-sidebar-nav-icon {\n          @include ltr {\n            margin-left: - $sidebar-nav-icon-width;\n          }\n          @include rtl {\n            margin-right: - $sidebar-nav-icon-width;\n          }\n        }\n      }\n    }\n    $wrapper-class-name: selector-nest($wrapper-class-name, $wrapper-class-name);\n  }\n}\n\n.c-sidebar-nav-label {\n  display: flex;\n  padding: ($sidebar-nav-link-padding-y / 4) $sidebar-nav-link-padding-x;\n  transition: $layout-transition-speed;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  .c-sidebar-nav-icon {\n    margin-top: 1px;\n  }\n}\n\n.c-sidebar-footer {\n  flex: 0 0 $sidebar-footer-height;\n  padding: $sidebar-footer-padding-y $sidebar-footer-padding-x;\n  transition: $layout-transition-speed;\n}\n\n.c-sidebar-minimizer {\n  display: flex;\n  flex: 0 0 $sidebar-minimizer-height;\n  justify-content: flex-end;\n  width: inherit;\n  padding: 0;\n  cursor: pointer;\n  border: 0;\n\n  @include media-breakpoint-down(breakpoint-before($mobile-breakpoint)) {\n    display: none;\n  }\n\n  &::before {\n    display: block;\n    width: $sidebar-minimizer-height;\n    height: $sidebar-minimizer-height;\n    content: \"\";\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: $sidebar-minimizer-height / 4;\n    transition: $layout-transition-speed;\n\n    @include rtl {\n      transform: rotate(180deg);\n    }\n  }\n\n  &:focus,\n  &.c-focus {\n    outline: 0;\n  }\n\n  .c-sidebar-right & {\n    justify-content: flex-start;\n    &::before {\n      @include ltr {\n        transform: rotate(-180deg);\n      }\n      @include rtl {\n        transform: rotate(0deg);\n      }\n    }\n  }\n}\n\n// Modal background\n.c-sidebar-backdrop {\n  @include media-breakpoint-down(breakpoint-before($mobile-breakpoint)) {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: $zindex-fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: $sidebar-backdrop-bg;\n    transition: $layout-transition-speed;\n\n    // Fade for backdrop\n    &.c-fade { opacity: 0; }\n    &.c-show { opacity: $sidebar-backdrop-opacity; }\n  }\n}\n\n// Minimized Sidebar\n\n.c-sidebar-minimized {\n  @include media-breakpoint-up($mobile-breakpoint) {\n    z-index: $zindex-fixed + 1;\n    flex: 0 0 $sidebar-minimized-width;\n\n    &.c-sidebar-fixed {\n      z-index: $zindex-fixed + 1;\n      width: $sidebar-minimized-width;\n    }\n\n    &:not(.c-sidebar-right){\n      @include ltr {\n        margin-left: - $sidebar-minimized-width;\n      }\n      @include rtl {\n        margin-right: - $sidebar-minimized-width;\n      }\n    }\n    &.c-sidebar-right {\n      @include ltr {\n        margin-right: - $sidebar-minimized-width;\n      }\n      @include ltr {\n        margin-left: - $sidebar-minimized-width;\n      }\n    }\n\n    .c-sidebar-brand-full {\n      display: none;\n    }\n\n    .c-sidebar-brand-minimized {\n      display: block;\n    }\n\n    .c-sidebar-nav {\n      padding-bottom: $sidebar-minimizer-height;\n      overflow: visible;\n    }\n\n    .c-d-minimized-none,\n    .c-sidebar-nav-divider,\n    .c-sidebar-nav-label,\n    .c-sidebar-nav-title,\n    .c-sidebar-footer,\n    .c-sidebar-form,\n    .c-sidebar-header {\n      height: 0;\n      padding: 0;\n      margin: 0;\n      visibility: hidden;\n      opacity: 0;\n    }\n\n    // Temporary fix for this issue: https://github.com/coreui/coreui-free-bootstrap-admin-template/issues/404\n    // TODO: find better solution\n    .c-sidebar-minimizer {\n      position: fixed;\n      bottom: 0;\n      width: inherit;\n\n      &::before {\n        @include ltr {\n          transform: rotate(-180deg);\n        }\n        @include rtl {\n          transform: rotate(0deg);\n        }\n      }\n    }\n\n    &.c-sidebar-right .c-sidebar-minimizer::before {\n      @include ltr {\n        transform: rotate(0deg);\n      }\n      @include rtl {\n        transform: rotate(180deg);\n      }\n    }\n\n    &.c-sidebar-right .c-sidebar-nav {\n      > .c-sidebar-nav-item:hover,\n      > .c-sidebar-nav-dropdown:hover {\n        @include ltr {\n          margin-left: - $sidebar-width;\n        }\n        @include rtl {\n          margin-right: - $sidebar-width;\n        }\n      }\n    }\n\n    .c-sidebar-nav-link,\n    .c-sidebar-nav-dropdown-toggle {\n      overflow: hidden;\n      white-space: nowrap;\n      border-left: 0;\n\n      &:hover {\n        width: $sidebar-width + $sidebar-minimized-width;\n      }\n    }\n\n    .c-sidebar-nav-dropdown-toggle::after {\n      display: none;\n    }\n\n    .c-sidebar-nav-dropdown-items {\n      .c-sidebar-nav-link {\n        width: $sidebar-width;\n      }\n    }\n\n    // stylelint-disable-next-line no-duplicate-selectors\n    .c-sidebar-nav > .c-sidebar-nav-dropdown {\n      position: relative;\n\n      > .c-sidebar-nav-dropdown-items {\n        display: none;\n\n        .c-sidebar-nav-dropdown:not(.c-show) > .c-sidebar-nav-dropdown-items {\n          display: none;\n        }\n      }\n      .c-sidebar-nav-dropdown-items {\n        max-height: 1500px;\n      }\n\n\n      // stylelint-disable-next-line no-duplicate-selectors\n      &:hover {\n        width: $sidebar-width + $sidebar-minimized-width;\n        overflow: visible;\n\n        > .c-sidebar-nav-dropdown-items {\n          position: absolute;\n          display: inline;\n\n          @include ltr {\n            left: $sidebar-minimized-width;\n          }\n          @include rtl {\n            right: $sidebar-minimized-width;\n          }\n        }\n      }\n    }\n\n    &.c-sidebar-right > .c-sidebar-nav-dropdown:hover > .c-sidebar-nav-dropdown-items {\n      @include ltr {\n        left: 0;\n      }\n      @include rtl {\n        right: 0;\n      }\n    }\n  }\n}\n\n// Responsive behavior\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n    .c-sidebar.c-sidebar#{$infix}-show,\n    .c-sidebar.c-sidebar-show {\n      &:not(.c-sidebar-right){\n        @include ltr {\n          margin-left: 0;\n        }\n        @include rtl {\n          margin-right: 0;\n        }\n        @include media-breakpoint-up($mobile-breakpoint) {\n          &.c-sidebar-fixed {\n            ~ .c-wrapper {\n              @include ltr {\n                margin-left: $sidebar-width;\n              }\n              @include rtl {\n                margin-right: $sidebar-width;\n              }\n            }\n            @each $width, $value in $sidebar-widths {\n              &.c-sidebar-#{$width} {\n                ~ .c-wrapper {\n                  @include ltr {\n                    margin-left: $value;\n                  }\n                  @include rtl {\n                    margin-right: $value;\n                  }\n                }\n              }\n            }\n            &.c-sidebar-minimized {\n              ~ .c-wrapper {\n                @include ltr {\n                  margin-left: $sidebar-minimized-width;\n                }\n                @include rtl {\n                  margin-right: $sidebar-minimized-width;\n                }\n              }\n            }\n          }\n        }\n      }\n      &.c-sidebar-right {\n        @include ltr {\n          margin-right: 0;\n        }\n        @include rtl {\n          margin-left: 0;\n        }\n        @include media-breakpoint-up($mobile-breakpoint) {\n          &.c-sidebar-fixed {\n            ~ .c-wrapper {\n              @include ltr {\n                margin-right: $sidebar-width;\n              }\n              @include rtl {\n                margin-left: $sidebar-width;\n              }\n            }\n            @each $width, $value in $sidebar-widths {\n              &.c-sidebar-#{$width} {\n                ~ .c-wrapper {\n                  @include ltr {\n                    margin-right: $value;\n                  }\n                  @include rtl {\n                    margin-left: $value;\n                  }\n                }\n              }\n            }\n            &.c-sidebar-minimized {\n              ~ .c-wrapper {\n                @include ltr {\n                  margin-right: $sidebar-minimized-width;\n                }\n                @include rtl {\n                  margin-left: $sidebar-minimized-width;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@include themes($sidebar-theme-map, $create: append, $parent: \".c-sidebar\") {\n  color: themes-get-value(\"sidebar-color\");\n  background: themes-get-value(\"sidebar-bg\");\n\n  @include borders(themes-get-value(\"sidebar-borders\"));\n\n  @include ltr {\n    &.c-sidebar-right {\n      @include borders(themes-get-value(\"sidebar-borders\"),true);\n    }\n  }\n\n  @include rtl {\n    @include borders(themes-get-value(\"sidebar-borders\"),true);\n    &.c-sidebar-right {\n      border: 0;\n      @include borders(themes-get-value(\"sidebar-borders\"));\n    }\n  }\n\n  .c-sidebar-close {\n    color: themes-get-value(\"sidebar-color\");\n  }\n\n  .c-sidebar-brand {\n    color: themes-get-value(\"sidebar-brand-color\");\n    background: themes-get-value(\"sidebar-brand-bg\");\n  }\n\n  .c-sidebar-header {\n    background: themes-get-value(\"sidebar-header-bg\");\n  }\n\n  .c-sidebar-form .c-form-control {\n    color: themes-get-value(\"sidebar-form-color\");\n    background: themes-get-value(\"sidebar-form-bg\");\n    border: themes-get-value(\"sidebar-form-border\");\n\n    &::placeholder {\n      color: themes-get-value(\"sidebar-form-placeholder-color\");\n    }\n  }\n\n  .c-sidebar-nav-title {\n    color: themes-get-value(\"sidebar-nav-title-color\");\n  }\n\n  .c-sidebar-nav-link {\n    color: themes-get-value(\"sidebar-nav-link-color\");\n    background: themes-get-value(\"sidebar-nav-link-bg\");\n    @include borders(themes-get-value(\"sidebar-nav-link-borders\"));\n\n    .c-sidebar-nav-icon {\n      color: themes-get-value(\"sidebar-nav-link-icon-color\");\n    }\n\n    &.c-active {\n      color: themes-get-value(\"sidebar-nav-link-active-color\");\n      background: themes-get-value(\"sidebar-nav-link-active-bg\");\n      @include borders(themes-get-value(\"sidebar-nav-link-active-borders\"));\n\n      .c-sidebar-nav-icon {\n        color: themes-get-value(\"sidebar-nav-link-active-icon-color\");\n      }\n    }\n\n    &:focus {\n      outline: none;\n    }\n    @media (hover: hover), (-ms-high-contrast: none) {\n      &:hover {\n        color: themes-get-value(\"sidebar-nav-link-hover-color\");\n        background: themes-get-value(\"sidebar-nav-link-hover-bg\");\n        @include borders(themes-get-value(\"sidebar-nav-link-hover-borders\"));\n\n        .c-sidebar-nav-icon {\n          color: themes-get-value(\"sidebar-nav-link-hover-icon-color\");\n        }\n\n        &.c-sidebar-nav-dropdown-toggle::after {\n          background-image: themes-get-value(\"sidebar-nav-dropdown-indicator-hover\");\n        }\n      }\n    }\n\n    &.c-disabled {\n      color: themes-get-value(\"sidebar-nav-link-disabled-color\");\n      background: transparent;\n      @include borders(themes-get-value(\"sidebar-nav-link-disabled-borders\"));\n\n      .c-sidebar-nav-icon {\n        color: themes-get-value(\"sidebar-nav-link-disabled-icon-color\");\n      }\n\n      &:hover {\n        color: themes-get-value(\"sidebar-nav-link-disabled-color\");\n        @include borders(themes-get-value(\"sidebar-nav-link-hover-borders\"));\n\n        .c-sidebar-nav-icon {\n          color: themes-get-value(\"sidebar-nav-link-disabled-icon-color\");\n        }\n\n        &.c-sidebar-nav-dropdown-toggle::after {\n          background-image: themes-get-value(\"sidebar-nav-dropdown-indicator-hover\");\n        }\n      }\n    }\n  }\n  .c-sidebar-nav-dropdown-toggle {\n    position: relative;\n\n    &::after {\n      background-image: themes-get-value(\"sidebar-nav-dropdown-indicator\");\n    }\n  }\n\n  .c-sidebar-nav-dropdown.c-show {\n    background: themes-get-value(\"sidebar-nav-dropdown-bg\");\n    @include borders(themes-get-value(\"sidebar-nav-dropdown-borders\"));\n\n    .c-sidebar-nav-link {\n      color: themes-get-value(\"sidebar-nav-dropdown-color\");\n\n      &.c-disabled {\n        color: themes-get-value(\"sidebar-nav-link-disabled-color\");\n        background: transparent;\n\n        &:hover {\n          color: themes-get-value(\"sidebar-nav-link-disabled-color\");\n\n          .c-sidebar-nav-icon {\n            color: themes-get-value(\"sidebar-nav-link-disabled-icon-color\");\n          }\n        }\n      }\n    }\n  }\n\n  .c-sidebar-nav-label {\n    color: themes-get-value(\"sidebar-nav-title-color\");\n\n    &:hover {\n      color: themes-get-value(\"sidebar-color\");\n    }\n\n    .c-sidebar-nav-icon {\n      color: themes-get-value(\"sidebar-nav-link-icon-color\");\n    }\n  }\n\n  @if (lightness(themes-get-value(\"sidebar-bg\")) < 40) {\n    .c-progress {\n      background-color: lighten(themes-get-value(\"sidebar-bg\"), 15%) !important;\n    }\n  }\n\n  .c-sidebar-footer {\n    background: themes-get-value(\"sidebar-footer-bg\");\n    @include borders(themes-get-value(\"sidebar-footer-borders\"));\n  }\n\n  .c-sidebar-minimizer {\n    background-color: themes-get-value(\"sidebar-minimizer-bg\");\n    @include borders(themes-get-value(\"sidebar-minimizer-borders\"));\n\n    &::before {\n      background-image: themes-get-value(\"sidebar-minimizer-indicator\");\n    }\n\n    &:focus,\n    &.c-focus {\n      outline: 0;\n    }\n\n    &:hover {\n      background-color: themes-get-value(\"sidebar-minimizer-hover-bg\");\n      &::before {\n        background-image: themes-get-value(\"sidebar-minimizer-hover-indicator\");\n      }\n    }\n  }\n  &.c-sidebar-minimized {\n\n    .c-sidebar-nav-item {\n\n      &:hover {\n\n        > .c-sidebar-nav-link, {\n          background: themes-get-value(\"sidebar-nav-link-hover-bg\");\n\n          .c-sidebar-nav-icon {\n            color: themes-get-value(\"sidebar-nav-link-hover-color\");\n          }\n\n          &.c-disabled {\n            background: themes-get-value(\"sidebar-nav-link-disabled-bg\");\n\n            .c-sidebar-nav-icon {\n              color: themes-get-value(\"sidebar-nav-link-disabled-icon-color\");\n            }\n          }\n        }\n      }\n    }\n\n    .c-sidebar-nav {\n      > .c-sidebar-nav-dropdown {\n        > .c-sidebar-nav-dropdown-items {\n          background: themes-get-value(\"sidebar-bg\");\n        }\n\n        &:hover {\n          background: themes-get-value(\"sidebar-nav-link-hover-bg\");\n        }\n      }\n    }\n  }\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\n.c-sidebar {\n  @include theme-variant() {\n    .c-sidebar-nav-link {\n      &.c-sidebar-nav-link-#{$color} {\n        background: $value;\n        .c-sidebar-nav-icon {\n          color: rgba(255, 255, 255, .7);\n        }\n        &:hover {\n          background: darken($value, 5%);\n          .c-sidebar-nav-icon {\n            color: $white;\n          }\n        }\n      }\n    }\n  }\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n@import \"variables/colors\";\n@import \"variables/brand-colors\";\n@import \"variables/gradients\";\n\n// Options\n@import \"variables/options\";\n@import \"variables/spacing\";\n@import \"variables/z-index\";\n\n@import \"variables/body\";\n@import \"variables/components/shared\";\n@import \"variables/typography\";\n@import \"variables/grid\";\n\n// Components\n@import \"variables/components/links\";\n@import \"variables/components/tables\";\n@import \"variables/components/buttons-forms\";\n@import \"variables/components/custom-forms\";\n@import \"variables/components/navs\";\n@import \"variables/components/navbar\";\n@import \"variables/components/header\";\n@import \"variables/components/subheader\";\n@import \"variables/components/sidebar\";\n@import \"variables/components/footer\";\n@import \"variables/components/dropdowns\";\n@import \"variables/components/pagination\";\n@import \"variables/components/cards\";\n@import \"variables/components/jumbotron\";\n@import \"variables/components/tooltips\";\n@import \"variables/components/popovers\";\n@import \"variables/components/toasts\";\n@import \"variables/components/badges\";\n@import \"variables/components/modals\";\n@import \"variables/components/alerts\";\n@import \"variables/components/progress-bars\";\n@import \"variables/components/list-group\";\n@import \"variables/components/images\";\n@import \"variables/components/breadcrumb\";\n@import \"variables/components/carousel\";\n@import \"variables/components/spinners\";\n@import \"variables/components/avatars\";\n@import \"variables/components/switches\";\n@import \"variables/components/close\";\n@import \"variables/components/code\";\n\n// Utilities\n@import \"variables/utilities\";\n\n\n// Printing\n@import \"variables/printing\";\n\n// Cursor\n$cursor-disabled: default !default;\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 50%;\n  animation: spinner-border .75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 50%;\n  opacity: 0;\n  animation: spinner-grow .75s linear infinite;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n","// Spinners\n// scss-docs-start spinner\n$spinner-width:         2rem !default;\n$spinner-height:        $spinner-width !default;\n$spinner-border-width:  .25em !default;\n\n$spinner-width-sm:         1rem !default;\n$spinner-height-sm:        $spinner-width-sm !default;\n$spinner-border-width-sm:  .2em !default;\n// scss-docs-end spinner\n",".c-subheader {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  min-height: $subheader-height;\n\n  &[class*=\"bg-\"]  {\n    border-color: rgba($black, .1);\n  }\n\n  &.c-subheader-fixed {\n    position: fixed;\n    right: 0;\n    left: 0;\n    z-index: $zindex-fixed;\n  }\n}\n\n.c-subheader-nav {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-height: $subheader-height;\n  padding: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .c-subheader-nav-item {\n    position: relative;\n  }\n\n  .c-subheader-nav-btn {\n    background-color: transparent;\n    border: $btn-border-width solid transparent;\n  }\n\n  .c-subheader-nav-link,\n  .c-subheader-nav-btn {\n    display: flex;\n    align-items: center;\n    padding-right: $header-nav-link-padding-x;\n    padding-left: $header-nav-link-padding-x;\n\n    .badge {\n      position: absolute;\n      top: 50%;\n      margin-top: -16px;\n      @include ltr {\n        left: 50%;\n        margin-left: 0;\n      }\n      @include rtl {\n        right: 50%;\n        margin-right: 0;\n      }\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n\n//\n// Subheader variants\n//\n\n@include themes($subheader-theme-map, $create: append, $parent: \".c-subheader\") {\n  background: themes-get-value(\"subheader-bg\");\n  @include borders(themes-get-value(\"subheader-border\"));\n\n  .c-subheader-nav {\n    .c-subheader-nav-link,\n    .c-subheader-nav-btn {\n      color: themes-get-value(\"subheader-color\");\n\n      @include hover-focus {\n        color: themes-get-value(\"subheader-hover-color\");\n      }\n\n      &.c-disabled {\n        color: themes-get-value(\"subheader-disabled-color\");\n      }\n    }\n\n    .c-show > .c-subheader-nav-link,\n    .c-active > .c-subheader-nav-link,\n    .c-subheader-nav-link.c-show,\n    .c-subheader-nav-link.c-active {\n      color: themes-get-value(\"subheader-active-color\");\n    }\n  }\n\n  .c-subheader-text {\n    color: themes-get-value(\"subheader-color\");\n    a {\n      color: themes-get-value(\"subheader-active-color\");\n\n      @include hover-focus {\n        color: themes-get-value(\"subheader-active-color\");\n      }\n    }\n  }\n}\n","// Subheader\n// scss-docs-start subheader\n$subheader-height:       48px !default;\n\n$subheader-padding-y:  $spacer / 2 !default;\n$subheader-padding-x:  $spacer !default;\n\n$subheader-nav-link-padding-x:  .5rem !default;\n// scss-docs-end subheader\n\n// Default theme\n// scss-docs-start subheader-default-themes\n$subheader-dark-bg:                     $gray-base !default;\n$subheader-dark-color:                  rgba($white, .75) !default;\n$subheader-dark-border:                 ( bottom: 1px solid $gray-800 ) !default;\n$subheader-dark-hover-color:            rgba($white, .9) !default;\n$subheader-dark-active-color:           $white !default;\n$subheader-dark-disabled-color:         rgba($white, .25) !default;\n\n$subheader-light-bg:                     $white !default;\n$subheader-light-color:                  rgba($black, .5) !default;\n$subheader-light-border:                 ( bottom: 1px solid $border-color ) !default;\n$subheader-light-hover-color:            rgba($black, .7) !default;\n$subheader-light-active-color:           rgba($black, .9) !default;\n$subheader-light-disabled-color:         rgba($black, .3) !default;\n// scss-docs-end subheader-default-themes\n\n\n$subheader-variants-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$subheader-variants-map: map-merge(\n  (\n    dark: (\n      \"subheader-bg\":                      $subheader-dark-bg,\n      \"subheader-color\":                   $subheader-dark-color,\n      \"subheader-border\":                  $subheader-dark-border,\n      \"subheader-hover-color\":             $subheader-dark-hover-color,\n      \"subheader-active-color\":            $subheader-dark-active-color,\n      \"subheader-disabled-color\":          $subheader-dark-disabled-color,\n    ),\n    light: (\n      \"subheader-bg\":                      $subheader-light-bg,\n      \"subheader-color\":                   $subheader-light-color,\n      \"subheader-border\":                  $subheader-light-border,\n      \"subheader-hover-color\":             $subheader-light-hover-color,\n      \"subheader-active-color\":            $subheader-light-active-color,\n      \"subheader-disabled-color\":          $subheader-light-disabled-color,\n    )\n  ),\n  $subheader-variants-map\n);\n\n$subheader-default-variant: \"light\" !default;\n$subheader-variants: (\n  default:  $subheader-default-variant,\n  map:      $subheader-variants-map\n) !default;\n\n$subheader-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$subheader-theme-map: map-merge(\n  (\n    default:  $subheader-variants\n  ),\n  $subheader-theme-map\n);\n","//\n// Base styles\n//\n\n.c-switch {\n  display: inline-block;\n  width: $switch-width;\n  height: $switch-height;\n}\n\n.c-switch-input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n\n.c-switch-slider {\n  position: relative;\n  display: block;\n  height: inherit;\n  cursor: pointer;\n  border: $border-width solid;\n  transition: .15s ease-out;\n  @include border-radius($border-radius);\n\n  @include themes($form-theme-map) {\n    background-color: themes-get-value(\"input-bg\");\n    border-color: themes-get-value(\"input-border-color\");\n  }\n\n  &::before {\n    position: absolute;\n    top: $switch-handle-margin;\n    left: $switch-handle-margin;\n    box-sizing: border-box;\n    width: $switch-height - ($switch-handle-margin * 2) - ($border-width * 2);\n    height: $switch-height - ($switch-handle-margin * 2) - ($border-width * 2);\n    content: \"\";\n    background-color: $white;\n    border: 1px solid $border-color;\n    transition: .15s ease-out;\n    @include border-radius($border-radius / 2);\n  }\n}\n\n.c-switch-input:checked ~ .c-switch-slider {\n  &::before {\n    transform: translateX($switch-width - $switch-height);\n  }\n}\n\n.c-switch-input:focus ~ .c-switch-slider {\n  @include themes($form-theme-map) {\n    color: themes-get-value(\"input-focus-color\");\n    background-color: themes-get-value(\"input-focus-bg\");\n    border-color: themes-get-value(\"input-focus-border-color\");\n  }\n  outline: 0;\n  // Avoid using mixin so we can pass custom focus shadow properly\n  @if $enable-shadows {\n    box-shadow: $input-box-shadow, $input-focus-box-shadow;\n  } @else {\n    box-shadow: $input-focus-box-shadow;\n  }\n}\n\n.c-switch-input:disabled ~ .c-switch-slider {\n  cursor: not-allowed;\n  opacity: .5;\n}\n\n//\n// Switch Sizes\n//\n\n.c-switch-lg {\n  @include switch-size($switch-lg-width, $switch-lg-height, $switch-lg-font-size, $switch-handle-margin);\n}\n\n.c-switch-sm {\n  @include switch-size($switch-sm-width, $switch-sm-height, $switch-sm-font-size, $switch-handle-margin);\n}\n\n//\n// Switch with label\n//\n.c-switch-label {\n  width: $switch-label-width;\n\n  .c-switch-slider {\n    &::before {\n      z-index: 2;\n    }\n    &::after {\n      position: absolute;\n      top: 50%;\n      z-index: 1;\n      width: 50%;\n      margin-top: -.5em;\n      font-size: $switch-font-size;\n      font-weight: 600;\n      line-height: 1;\n      color: $gray-300;\n      text-align: center;\n      text-transform: uppercase;\n      content: attr(data-unchecked);\n      transition: inherit;\n\n      @include ltr {\n        right: 1px;\n      }\n    }\n  }\n\n  .c-switch-input:checked ~ .c-switch-slider {\n    &::before {\n      transform: translateX($switch-label-width - $switch-height);\n    }\n    &::after {\n      left: 1px;\n      color: $white;\n      content: attr(data-checked);\n    }\n  }\n\n  // Sizes\n  &.c-switch-lg {\n    @include switch-size($switch-label-lg-width, $switch-lg-height, $switch-lg-font-size, $switch-handle-margin);\n  }\n\n  &.c-switch-sm {\n    @include switch-size($switch-label-sm-width, $switch-sm-height, $switch-sm-font-size, $switch-handle-margin);\n  }\n}\n\n//\n// Switch 3d\n//\n\n.c-switch[class*=\"-3d\"] {\n  .c-switch-slider {\n    background-color: $gray-100;\n    border-radius: 50em;\n\n    &::before {\n      top: -1px;\n      left: -1px;\n      width: $switch-height;\n      height: $switch-height;\n      border: 0;\n      border-radius: 50em;\n      box-shadow: 0 2px 5px rgba($black, .3);\n    }\n  }\n\n  // Sizes\n  &.c-switch-lg {\n    @include switch-3d-size($switch-lg-width, $switch-lg-height);\n  }\n\n  &.c-switch-sm {\n    @include switch-3d-size($switch-sm-width, $switch-sm-height);\n  }\n}\n\n//\n// Switch Variants\n//\n\n@include theme-variant() {\n  //normal style\n  .c-switch-#{$color} {\n    @include switch-variant($value);\n  }\n  // 3s style\n  .c-switch-3d-#{$color} {\n    @include switch-3d-variant($value);\n  }\n  // outline style\n  .c-switch-outline-#{$color} {\n    @include switch-outline-variant($value);\n  }\n  // oposite\n  .c-switch-opposite-#{$color} {\n    @include switch-opposite-variant($value);\n  }\n}\n\n//\n// Pill Style\n//\n\n.c-switch-pill {\n  .c-switch-slider {\n    border-radius: 50em;\n\n    &::before {\n      border-radius: 50em;\n    }\n  }\n}\n\n.c-switch-square {\n  .c-switch-slider {\n    border-radius: 0;\n\n    &::before {\n      border-radius: 0;\n    }\n  }\n}\n","// Switches\n// scss-docs-start switch\n$switch-width:      40px !default;\n$switch-height:     26px !default;\n$switch-font-size:  10px !default;\n\n$switch-lg-width:      48px !default;\n$switch-lg-height:     30px !default;\n$switch-lg-font-size:  12px !default;\n\n$switch-sm-width:      32px !default;\n$switch-sm-height:     22px !default;\n$switch-sm-font-size:  8px !default;\n\n$switch-label-width:     48px !default;\n$switch-label-lg-width:  56px !default;\n$switch-label-sm-width:  40px !default;\n\n$switch-handle-margin:  2px !default;\n// scss-docs-end switch\n","@mixin switch-size($width, $height, $font-size, $handle-margin) {\n  width: $width;\n  height: $height;\n\n  .c-switch-slider {\n    font-size: $font-size;\n\n    &::before {\n      width: $height - ($handle-margin * 2) - ($border-width * 2);\n      height: $height - ($handle-margin * 2) - ($border-width * 2);\n    }\n    &::after {\n      font-size: $font-size;\n    }\n  }\n\n  .c-switch-input:checked ~ .c-switch-slider {\n    &::before {\n      transform: translateX($width - $height);\n    }\n  }\n}\n\n@mixin switch-3d-size($width, $height) {\n  width: $width;\n  height: $height;\n\n  .c-switch-slider::before {\n    width: $height;\n    height: $height;\n  }\n\n  .c-switch-input:checked ~ .c-switch-slider {\n    &::before {\n      transform: translateX($width - $height);\n    }\n  }\n}\n\n@mixin switch-3d-variant($color) {\n  .c-switch-input:checked + .c-switch-slider {\n    background-color: $color;\n  }\n}\n\n@mixin switch-variant($color) {\n  .c-switch-input:checked + .c-switch-slider {\n    background-color: $color;\n    border-color: darken($color, 10%);\n\n    &::before {\n      border-color: darken($color, 10%);\n    }\n  }\n}\n\n@mixin switch-outline-variant($color) {\n  .c-switch-input:checked + .c-switch-slider {\n    background-color: inherit;\n    border-color: $color;\n\n    &::before {\n      border-color: $color;\n    }\n    &::after {\n      color: $color;\n    }\n  }\n}\n\n@mixin switch-opposite-variant($color) {\n  .c-switch-input:checked + .c-switch-slider {\n    background-color: inherit;\n    border-color: $color;\n\n    &::before {\n      background-color: $color;\n      border-color: $color;\n    }\n    &::after {\n      color: $color;\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n\n  @include themes($table-theme-map, $create: parent) {\n    color: themes-get-value(\"table-color\");\n    background-color: themes-get-value(\"table-bg\");\n  }\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid;\n\n    @include themes($table-theme-map, $create: parent) {\n      border-top-color: themes-get-value(\"table-border-color\");\n    }\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid;\n\n    @include themes($table-theme-map, $create: parent) {\n      border-bottom-color: themes-get-value(\"table-border-color\");\n    }\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid;\n\n    @include themes($table-theme-map, $create: parent) {\n      border-top-color: themes-get-value(\"table-border-color\");\n    }\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid;\n\n  @include themes($table-theme-map, $create: parent) {\n    border-color: themes-get-value(\"table-border-color\");\n  }\n\n  th,\n  td {\n    border: $table-border-width solid;\n\n    @include themes($table-theme-map, $create: parent) {\n      border-color: themes-get-value(\"table-border-color\");\n    }\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n\n    @include themes($table-theme-map, $create: parent) {\n      background-color: themes-get-value(\"table-accent-bg\");\n    }\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      @include themes($table-theme-map, $create: parent) {\n        color: themes-get-value(\"table-hover-color\");\n        background-color: themes-get-value(\"table-hover-bg\");\n      }\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@include theme-variant() {\n  @include table-row-variant($color,  theme-color-level($value, $table-bg-level),  theme-color-level($value, $table-border-level));\n}\n\n@include themes($table-theme-map, $create: parent) {\n  @include table-row-variant(active, themes-get-value(\"table-active-bg\"));\n  @include table-row-variant(selected, themes-get-value(\"table-active-bg\"), themes-get-value(\"table-active-bg\"));\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  tbody tr {\n    &:focus {\n      outline: 0;\n      @include themes($table-theme-map, $create: parent) {\n        color: themes-get-value(\"table-hover-color\");\n        background-color: themes-get-value(\"table-hover-bg\");\n      }\n    }\n  }\n}\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      @include themes($table-theme-map) {\n        color: themes-get-value(\"table-dark-color\");\n        background-color: themes-get-value(\"table-dark-bg\");\n        border-color: themes-get-value(\"table-dark-border-color\");\n      }\n    }\n  }\n\n  .thead-light {\n    th {\n      @include themes($table-theme-map) {\n        color: themes-get-value(\"table-head-color\");\n        background-color: themes-get-value(\"table-head-bg\");\n        border-color: themes-get-value(\"table-border-color\");\n      }\n    }\n  }\n}\n\n.table-dark {\n  @include themes($table-theme-map) {\n    color: themes-get-value(\"table-dark-color\");\n    background-color: themes-get-value(\"table-dark-bg\");\n  }\n\n  th,\n  td,\n  thead th {\n    @include themes($table-theme-map) {\n      border-color: themes-get-value(\"table-dark-border-color\");\n    }\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      @include themes($table-theme-map) {\n        background-color: themes-get-value(\"table-dark-accent-bg\");\n      }\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        @include themes($table-theme-map) {\n          color: themes-get-value(\"table-dark-hover-color\");\n          background-color: themes-get-value(\"table-dark-hover-bg\");\n        }\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n\n.table-outline {\n  border: 1px solid;\n\n  @include themes($table-theme-map, $create: parent) {\n    border-color: themes-get-value(\"table-border-color\");\n  }\n\n  td {\n    vertical-align: middle;\n  }\n}\n\n.table-align-middle {\n\n  td {\n    vertical-align: middle;\n  }\n}\n\n.table-clear {\n  td {\n    border: 0;\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      @if map-has-key($yiq-theme-map, $current-theme) {\n        color: color-yiq($background, map-get(map-get($yiq-theme-map, $current-theme), \"yiq-text-dark\"), map-get(map-get($yiq-theme-map, $current-theme), \"yiq-text-light\"));\n      }\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n",".toast {\n  width: $toast-max-width;\n  max-width: $toast-max-width;\n  overflow: hidden; // cheap rounded corners on nested items\n  @include font-size($toast-font-size);\n  background-clip: padding-box;\n  border: $toast-border-width solid;\n  box-shadow: $toast-box-shadow;\n  backdrop-filter: blur(10px);\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n  @include themes($toast-theme-map, $create: parent) {\n    color: themes-get-value(\"toast-color\");\n    background-color: themes-get-value(\"toast-background-color\");\n    border-color: themes-get-value(\"toast-border-color\");\n  }\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-full {\n  width: 100%;\n  max-width: 100%;\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid;\n  @include themes($toast-theme-map, $create: parent) {\n    color: themes-get-value(\"toast-header-color\");\n    background-color: themes-get-value(\"toast-header-background-color\");\n    border-color: themes-get-value(\"toast-header-border-color\");\n  }\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n\n.toaster {\n  display: flex;\n  flex-direction: column-reverse;\n  width: 100%;\n  padding: ($spacer / 4) ($spacer / 2);\n\n  &-top-full,\n  &-top-center,\n  &-top-right,\n  &-top-left,\n  &-bottom-full,\n  &-bottom-center,\n  &-bottom-right,\n  &-bottom-left {\n    position: fixed;\n    z-index: $zindex-toaster;\n    width: $toast-max-width;\n  }\n\n  &-top-full,\n  &-top-center,\n  &-top-right,\n  &-top-left {\n    top: 0;\n  }\n\n  &-bottom-full,\n  &-bottom-center,\n  &-bottom-right,\n  &-bottom-left {\n    bottom: 0;\n    flex-direction: column;\n  }\n\n  &-top-full,\n  &-bottom-full {\n    width: auto;\n  }\n\n  &-top-center,\n  &-bottom-center {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  &-top-full,\n  &-bottom-full,\n  &-top-right,\n  &-bottom-right {\n    right: 0;\n  }\n\n  &-top-full,\n  &-bottom-full,\n  &-top-left,\n  &-bottom-left {\n    left: 0;\n  }\n\n  .toast {\n    width: 100%;\n    max-width: 100%;\n    margin-top: ($spacer / 8);\n    margin-bottom: ($spacer / 8);\n  }\n}\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the toast.\n\n@include theme-variant() {\n  .toast-#{$color} {\n    @include toast-variant($value);\n  }\n}\n\n","// Toasts\n// scss-docs-start toast\n$toast-max-width:                350px !default;\n$toast-padding-x:                .75rem !default;\n$toast-padding-y:                .25rem !default;\n$toast-font-size:                .875rem !default;\n$toast-border-width:             1px !default;\n$toast-border-radius:            .25rem !default;\n$toast-box-shadow:               0 .25rem .75rem rgba($black, .1) !default;\n// scss-docs-end toast\n\n// Default theme\n// scss-docs-start toast-default-theme\n$toast-background-color:  rgba($white, .85) !default;\n$toast-color:             null !default;\n$toast-border-color:      rgba($black, .1) !default;\n\n$toast-header-color:             $gray-600 !default;\n$toast-header-background-color:  rgba($white, .85) !default;\n$toast-header-border-color:      rgba($black, .05) !default;\n// scss-docs-end toast-default-theme\n\n$toast-theme-map: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$toast-theme-map: map-merge(\n  (\n    default: (\n      \"toast-background-color\":         $toast-background-color,\n      \"toast-color\":                    $toast-color,\n      \"toast-border-color\":             $toast-border-color,\n      \"toast-header-color\":             $toast-header-color,\n      \"toast-header-background-color\":  $toast-header-background-color,\n      \"toast-header-border-color\":      $toast-header-border-color\n    )\n  ),\n  $toast-theme-map\n);\n","@mixin toast-variant($background) {\n  color: color-yiq($background);\n  background-color: $background;\n  border-color: darken($background, 10%);\n\n  .toast-header {\n    color: color-yiq($background);\n    background-color: darken($background, 5%);\n    border-color: darken($background, 10%);\n  }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .tooltip-arrow {\n    position: absolute;\n    display: block;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n%bs-tooltip-top,\n%bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .tooltip-arrow {\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n  }\n}\n\n%bs-tooltip-right,\n%bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .tooltip-arrow {\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n  }\n}\n\n%bs-tooltip-top {\n  .tooltip-arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n%bs-tooltip-right {\n  .tooltip-arrow {\n    left: 0;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width / 2) $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n%bs-tooltip-bottom {\n  .tooltip-arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n%bs-tooltip-left {\n  .tooltip-arrow {\n    right: 0;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width / 2) 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\n.tooltip {\n  &[data-popper-placement^=\"top\"] {\n    @extend %bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend %bs-tooltip-right;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend %bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend %bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.fade-in {\n  animation-name: fadeIn;\n  animation-duration: 1s;\n}\n\n//\n// Components\n//\n\n.c-wrapper {\n  transition: margin $layout-transition-speed;\n}\n\n.c-sidebar {\n  transition: box-shadow $layout-transition-speed $layout-transition-speed / 2, transform $layout-transition-speed, margin-left $layout-transition-speed, margin-right $layout-transition-speed, width $layout-transition-speed, z-index 0s ease $layout-transition-speed;\n  &.c-sidebar-unfoldable {\n    transition: transform $layout-transition-speed, margin-left $layout-transition-speed, margin-right $layout-transition-speed, width $layout-transition-speed, z-index 0s ease 0s;\n  }\n}\n\n.c-no-layout-transition {\n  .c-wrapper,\n  .c-sidebar {\n    transition: none;\n\n    .c-sidebar-header,\n    .c-sidebar-nav-title,\n    .c-sidebar-nav-divider,\n    .c-sidebar-nav-link,\n    .c-sidebar-nav-icon,\n    .c-sidebar-nav-dropdown,\n    .c-sidebar-nav-dropdown-toggle,\n    .c-sidebar-nav-dropdown-toggle::after,\n    .c-sidebar-nav-dropdown-items,\n    .c-sidebar-nav-label,\n    .c-sidebar-footer,\n    .c-sidebar-minimizer  {\n      transition: none;\n    }\n  }\n}\n\n.c-no-transition {\n  transition: none;\n}\n","// stylelint-disable declaration-no-important, selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid;\n  @include themes($typography-theme-map, $create: parent) {\n    border-color: themes-get-value(\"hr-border-color\");\n  }\n}\n\n//\n// Vertical rules\n//\n\n.c-vr {\n  width: $vr-width;\n  @include themes($typography-theme-map, $create: parent) {\n    background-color: themes-get-value(\"vr-bg\");\n  }\n}\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","//\n// CoreUI default layout\n//\n\n.c-app {\n  display: flex;\n  flex-direction: row;\n  min-height: 100vh;\n}\n\n// IE10&11 Flexbox fix\n@media all and (-ms-high-contrast: none) {\n  html {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.c-wrapper {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 100vh;\n\n  &:not(.c-wrapper-fluid) {\n\n    .c-subheader-fixed {\n      position: relative;\n    }\n\n    .c-header-fixed {\n      position: sticky;\n      top: 0;\n\n      @media all and (-ms-high-contrast: none) {\n        position: fixed;\n        margin: inherit;\n\n        ~ .c-body {\n          margin-top: 104px;\n        }\n      }\n    }\n\n    .c-footer-fixed {\n      position: sticky;\n      bottom: 0;\n\n      @media all and (-ms-high-contrast: none) {\n        position: fixed;\n        margin: inherit;\n\n        ~ .c-body {\n          margin-bottom: 49px;\n        }\n      }\n    }\n\n    .c-body {\n      // deprecate v4\n      // fix footer position to avoid breaking change.\n      display: flex;\n      flex-direction: column;\n      // ---\n\n      flex-grow: 1;\n    }\n  }\n\n  // deprecate v4\n  &.c-wrapper-fluid {\n    min-height: 100vh;\n\n    .c-header-fixed {\n      margin: inherit;\n    }\n  }\n}\n\n.c-main {\n  flex-basis: auto;\n  flex-shrink: 0;\n  flex-grow: 1;\n  min-width: 0;\n  padding-top: 2 * $spacer;\n\n  > .container-fluid {\n    @include media-breakpoint-up(md) {\n      padding-right: $grid-gutter-width;\n      padding-left: $grid-gutter-width;\n    }\n  }\n}\n\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n\n@mixin coreui-bg-gradient-variant($parent, $colors) {\n  #{$parent} {\n    background: map-get($colors, \"stop\") !important;\n    background: linear-gradient(45deg, map-get($colors, \"start\") 0%, map-get($colors, \"stop\") 100%) !important;\n    border-color: map-get($colors, \"stop\") !important;\n  }\n}\n","// stylelint-disable declaration-no-important\n@include theme-variant() {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n// @if $enable-gradients {\n//   @include theme-variant() {\n//     @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n//   }\n// }\n\n@include theme-gradients() {\n  @include coreui-bg-gradient-variant(\".bg-gradient-#{$gradient}\", $value);\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n[class^=\"bg-\"] {\n  color: $white;\n}\n\n@each $color, $value in $brands-colors {\n  @include bg-variant(\".bg-#{$color}\", $value);\n}\n\n@each $color, $value in $grays {\n  @include bg-variant(\".bg-gray-#{$color}\", $value);\n}\n\n.bg-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ($spacer * 2.5);\n  height: ($spacer * 2.5);\n}\n","// stylelint-disable property-blacklist, declaration-no-important\n\n//\n// Border\n//\n\n@include themes($border-theme-map) {\n  .border         { border: $border-width solid themes-get-value(\"border-color\") !important; }\n  .border-top     { border-top: $border-width solid themes-get-value(\"border-color\") !important; }\n  .border-right   { border-right: $border-width solid themes-get-value(\"border-color\") !important; }\n  .border-bottom  { border-bottom: $border-width solid themes-get-value(\"border-color\") !important; }\n  .border-left    { border-left: $border-width solid themes-get-value(\"border-color\") !important; }\n}\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@include theme-variant() {\n  .border-#{$color} {\n    border: 1px solid !important;\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n@each $prop, $abbrev in (border: b) {\n  @each $size in (0,1,2) {\n    @if $size == 0 {\n      .#{$abbrev}-a-#{$size} { #{$prop}: 0 !important; } // a = All sides\n      .#{$abbrev}-t-#{$size} { #{$prop}-top: 0 !important; }\n      .#{$abbrev}-r-#{$size} { #{$prop}-right: 0 !important; }\n      .#{$abbrev}-b-#{$size} { #{$prop}-bottom: 0 !important; }\n      .#{$abbrev}-l-#{$size} { #{$prop}-left: 0 !important; }\n    } @else {\n      .#{$abbrev}-a-#{$size} { #{$prop}: $size * $border-width solid $border-color; } // a = All sides\n      .#{$abbrev}-t-#{$size} { #{$prop}-top: $size * $border-width solid $border-color; }\n      .#{$abbrev}-r-#{$size} { #{$prop}-right: $size * $border-width solid $border-color; }\n      .#{$abbrev}-b-#{$size} { #{$prop}-bottom: $size * $border-width solid $border-color; }\n      .#{$abbrev}-l-#{$size} { #{$prop}-left: $size * $border-width solid $border-color; }\n    }\n  }\n}\n",".content-center {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-down($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n    .d#{$infix}-down-none { display: none !important; }\n  }\n}\n\n@each $theme in map-keys($default-themes) {\n  .c-#{$theme}#{$theme-suffix} {\n    .c-d-#{$theme}-none { display: none !important; }\n  }\n  @if map-get(map-get($default-themes, $theme), \"default\") {\n    $other-themes: map-remove($default-themes, $theme);\n\n    $selector: selector-append(\".c-app\");\n    @each $other-theme in map-keys($other-themes) {\n      $selector: selector-append($selector, \":not(.c-#{$other-theme}#{$theme-suffix})\");\n      // .c-app {\n      //   &:not(.c-#{$other-theme}#{$theme-suffix}) {\n      //     .c-d-#{$theme}-none { display: none !important; }\n      //   }\n      // }\n    }\n    @if ($selector != selector-append(\".c-app\")) {\n      #{$selector} {\n        .c-d-#{$theme}-none { display: none !important; }\n      }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage($embed-responsive-aspect-ratio-y / $embed-responsive-aspect-ratio-x);\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  {\n      @include ltr {\n        float: left !important;\n      }\n      @include rtl {\n        float: right !important;\n      }\n    }\n    .float#{$infix}-right {\n      @include ltr {\n        float: right !important;\n      }\n      @include rtl {\n        float: left !important;\n      }\n    }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://a11yproject.com/posts/how-to-hide-content/\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n\n        .#{$abbrev}fs#{$infix}-#{$size} {\n          @include ltr {\n            #{$prop}-left: $length !important;\n          }\n          @include rtl {\n            #{$prop}-right: $length !important;\n          }\n        }\n        .#{$abbrev}fe#{$infix}-#{$size} {\n          @include ltr {\n            #{$prop}-right: $length !important;\n          }\n          @include rtl {\n            #{$prop}-left: $length !important;\n          }\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if $size != 0 {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n\n        .mfs#{$infix}-n#{$size} {\n          @include ltr {\n            margin-left: -$length !important;\n          }\n          @include rtl {\n            margin-right: -$length !important;\n          }\n        }\n        .mfe#{$infix}-n#{$size} {\n          @include ltr {\n            margin-right: -$length !important;\n          }\n          @include rtl {\n            margin-left: -$length !important;\n          }\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n\n    // Some special margin utils for flex, work only with flex-direction: row\n    .mfs#{$infix}-auto {\n      @include ltr {\n        margin-left: auto !important;\n      }\n      @include rtl {\n        margin-right: auto !important;\n      }\n    }\n    .mfe#{$infix}-auto {\n      @include ltr {\n        margin-right: auto !important;\n      }\n      @include rtl {\n        margin-left: auto !important;\n      }\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba($black, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@include theme-variant() {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted {\n  @include themes($typography-theme-map, $create: parent) {\n    color: themes-get-value(\"text-muted\") !important;\n  }\n}\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // IE & < Edge 18\n  overflow-wrap: break-word !important;\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","body {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\n// stylelint-disable declaration-no-important\n.font-xs {\n  font-size: .75rem !important;\n}\n\n.font-sm {\n  font-size: .85rem !important;\n}\n\n.font-lg {\n  font-size: 1rem !important;\n}\n\n.font-xl {\n  font-size: 1.25rem !important;\n}\n\n.font-2xl {\n  font-size: 1.5rem !important;\n}\n\n.font-3xl {\n  font-size: 1.75rem !important;\n}\n\n.font-4xl {\n  font-size: 2rem !important;\n}\n\n.font-5xl {\n  font-size: 2.5rem !important;\n}\n\n[class^=\"text-value\"] {\n  font-weight: 600;\n}\n\n.text-value-xs {\n  font-size: ($font-size-base * .75);\n}\n\n.text-value-sm {\n  font-size: ($font-size-base * .85);\n}\n\n.text-value {\n  font-size: $font-size-base;\n}\n\n.text-value-lg {\n  font-size: ($font-size-base * 1.5);\n}\n\n.text-value-xl {\n  font-size: ($font-size-base * 1.75);\n}\n\n.text-white .text-muted {\n  color: rgba(255, 255, 255, .6) !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","//\n// RTL Support\n//\n@include rtl {\n  direction: rtl;\n  unicode-bidi: embed;\n\n  body {\n    text-align: right;\n  }\n}\n",".ie-custom-properties {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $theme-colors {\n    #{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    breakpoint-#{$bp}: #{$value};\n  }\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    //\n    // Printing Tables:\n    // http://css-discuss.incutio.com/wiki/Printing_Tables\n    //\n\n    thead {\n      display: table-header-group;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","\n// Printing\n\n$print-page-size:       a3 !default;\n$print-body-min-width:  map-get($grid-breakpoints, \"lg\") !default;\n","// todo: disabled button styles\nbutton {\n  &:disabled {\n    cursor: default;\n  }\n  &.disabled {\n    cursor: default;\n  }\n}\n\n// todo: brand button icon margin\n.btn-brand:not(:only-child) {\n  .c-icon {\n    margin-top: 0 !important;\n  }\n}\n","// Here you can add other styles\n.c-main {\n  background: #000000;\n}\n.c-header {\n  background: #2c2c34;\n  border-bottom: 0;\n}\n\n.c-header .c-subheader {\n  border-bottom: 0;\n  background: #2c2c34;\n  margin-top: -1px;\n  border-top: 1px solid #000000;\n}\n\n.c-header .c-header-nav .c-header-nav-link,\n.c-header .c-header-nav .c-header-nav-btn {\n  &:hover {\n    // background-color: lighten(green, 5%);\n    color: #9be5ee;\n\n    cursor: pointer;\n    cursor: hand;\n  }\n  &:focus {\n    color: #9be5ee;\n  }\n  // width: 100px;\n  // height: 50px;\n  // background-color: rgb(1, 12, 1);\n  color: rgb(245, 238, 238);\n  text-align: center;\n  // line-height:50px;\n  // border-radius: 30px;\n}\n\n.c-subheader .c-subheader-nav .c-subheader-nav-link,\n.c-subheader .c-subheader-nav .c-subheader-nav-btn {\n  color: rgba(26, 228, 26, 0.75);\n}\n\n.container {\n  position: relative;\n  //width: 50%;\n}\n\n.image {\n  display: block;\n  width: 100%;\n  //height: auto;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  transition: 0.5s ease;\n  background-image: linear-gradient(\n    to right,\n    #46c7fe 0,\n    #a069ff 51%,\n    #46c7fe 100%\n  );\n}\n\n.container:hover .overlay {\n  opacity: 0.8;\n}\n\n.text {\n  color: rgb(255, 255, 255);\n  font-size: 13px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n.passkey__modal__title {\n  font-family: Inter;\n  font-size: 22px;\n  font-weight: 700;\n  text-align: left;\n  color: \"#000000\";\n}\n.passkey__title {\n  font-family: Inter;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 21.78px;\n  text-align: left;\n  color: #1e1e1e;\n}\n.passkey__subtitle {\n  font-family: Inter;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 21.78px;\n  text-align: left;\n  color: #897c7c;\n  padding-top: 49px;\n}\n.passkey__modal__footer {\n  border-top: none !important;\n  display: flex;\n  justify-content: center;\n}\n.passkey__modal__btn {\n  &--primary {\n    background-color: #364ee8;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    padding-left: 59px;\n    padding-right: 59px;\n    color: #ffffff;\n    font-family: Inter;\n    font-weight: 500;\n    font-size: 18px;\n    border-radius: 8px;\n    &:hover {\n      color: #ffffff;\n    }\n  }\n  &--secondary {\n    border-radius: 8px;\n\n    background-color: #d9d9d9;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    padding-left: 59px;\n    padding-right: 59px;\n    color: #897c7c;\n    font-family: Inter;\n    font-weight: 500;\n    font-size: 18px;\n    &:hover {\n      color: #897c7c;\n    }\n  }\n}\n@media (max-width: 767px) {\n  .img-responsive {\n    display: none;\n  }\n  .img-mobile-image {\n    display: block !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
